{
 " ao(à) paciente {nome}{cpf}": " an den/die Patient(in) {nome}{cpf}",
 " junto ao plano de saúde {c}": " bei der Krankenversicherung {c}",
 " às {h}": " um {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" oder \"Seite 1 von 10\", in einer Ecke deiner Wahl.",
 "\"{nome}\" está no {provedor}.": "„{nome}“ ist in {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" ist kein JPG oder PNG. Wandle es in JPG um und versuch es noch mal.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" ist kein PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "„{nova}“ um {hora} überschneidet sich mit: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "„{n}“ gehört jetzt der Gruppe. Innerhalb von 1 Minute sehen die anderen Mitglieder alles.",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" wurde mit denselben Daten erstellt.",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" wurde bereits am {data} hinzugefügt.",
 "% ao mês": "% pro Monat",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(Auf dem Computer des Admins: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(Kopie)",
 "(sem título)": "(ohne Titel)",
 "+ Adicionar alerta": "+ Alarm hinzufügen",
 "+ Adicionar outra OAB": "+ Weitere OAB hinzufügen",
 "+ Adicionar pausa": "+ Pause hinzufügen",
 "+ Adicionar subtarefa": "+ Unteraufgabe hinzufügen",
 "+ Matéria em {nome}": "+ Fach in {nome}",
 "+ Perfil": "+ Profil",
 "+ Subtarefa": "+ Unteraufgabe",
 "+5 min": "+5 Min.",
 "+{n} acompanhante(s)": "+{n} Begleitperson(en)",
 "+{n} páginas acima da meta": "+{n} Seiten über dem Ziel",
 ", carteirinha nº {n},": ", Versichertennr. {n},",
 ", pago em {d}{f}": ", bezahlt am {d}{f}",
 "1 cápsula": "1 Kapsel",
 "1 dose": "1 Portion",
 "1 dose (30 g)": "1 Portion (30 g)",
 "1 pessoa": "1 Person",
 "1 publicação nova": "1 neue Veröffentlichung",
 "1 página": "1 Seite",
 "1 tarja no documento": "1 Schwärzung im Dokument",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Installiere My Planner und erstelle dein Konto.  2. Öffne diesen Link erneut (oder gib den Code unter Einstellungen › Gruppen & Einladungen ein).",
 "1. Quais dados tratamos": "1. Welche Daten wir verarbeiten",
 "1. Sobre o app": "1. Über die App",
 "1ª dose": "1. Dosis",
 "2 por folha": "2 pro Blatt",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 Tassen Mehl\n3 Eier\n1 Löffel Backpulver",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 oder 9 Seiten auf jedem Blatt (zum Drucken).",
 "2. Para que usamos": "2. Wofür wir sie nutzen",
 "2. Sua conta": "2. Dein Konto",
 "2ª dose": "2. Dosis",
 "3 a 5 g": "3 bis 5 g",
 "3. Bases legais (LGPD)": "3. Rechtsgrundlagen (LGPD)",
 "3. Uso correto": "3. Richtige Nutzung",
 "3ª dose": "3. Dosis",
 "4 por folha": "4 pro Blatt",
 "4. Com quem compartilhamos": "4. Mit wem wir sie teilen",
 "4. Planos e testes": "4. Tarife und Testphasen",
 "5. Limites": "5. Grenzen",
 "5. Segurança": "5. Sicherheit",
 "6 por folha": "6 pro Blatt",
 "6. Por quanto tempo": "6. Wie lange",
 "7. Seus direitos (art. 18 da LGPD)": "7. Deine Rechte (art. 18 LGPD)",
 "8. Crianças e adolescentes": "8. Kinder und Jugendliche",
 "9 por folha": "9 pro Blatt",
 "9. Mudanças": "9. Änderungen",
 "@letra-dom": "S",
 "@letra-qua": "M",
 "@letra-qui": "D",
 "@letra-sab": "S",
 "@letra-seg": "M",
 "@letra-sex": "F",
 "@letra-ter": "D",
 "A IA está classificando...": "KI ordnet Kategorien zu...",
 "A IA está lendo a caixa...": "Die KI liest die Box...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "Die KI liest die Seiten, danach ist das PDF durchsuchbar und kopierbar.",
 "A IA lê o PDF e sugere um nome claro.": "Die KI liest das PDF und schlägt einen klaren Namen vor.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "Die KI hat keine Antwort im erwarteten Format geliefert. Versuch es noch einmal.",
 "A IA não encontrou dados para esta ficha no arquivo.": "Die KI hat in der Datei keine Daten für diesen Eintrag gefunden.",
 "A IA não encontrou tarefas nesta caixa.": "Die KI hat in dieser Box keine Aufgaben gefunden.",
 "A IA resume o PDF e responde perguntas.": "Die KI fasst das PDF zusammen und beantwortet Fragen.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "Die SEFAZ vermerkt, dass dir die Rechnung bekannt ist (bestätigt oder lehnt den Kauf nicht ab), und gibt das vollständige XML bei der nächsten Suche frei, innerhalb von 1 Stunde.",
 "A VENCER (7 DIAS)": "BALD FÄLLIG (7 TAGE)",
 "A aba inteira": "Den ganzen Tab",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "Der Tab {aba} ist fast voll. Archiviere oder lösche alte Einträge darin.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "Der Tab {aba} ist nicht abonniert. Die Verknüpfung bleibt gespeichert und kehrt beim Abonnieren zurück.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "Die Suche nach \"{nome}\" ist zu breit. Verwende den vollständigen Namen.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "Die GIF-Suche ist in dieser App noch nicht aktiviert. Nutze solange die animierten Sticker (🎉).",
 "A cada": "Alle",
 "A cada N páginas": "Alle N Seiten",
 "A cada quantos dias": "Alle wie viele Tage",
 "A cada {n} dia(s)": "Alle {n} Tag(e)",
 "A cada {n} mês(es)": "Alle {n} Monat(e)",
 "A cada {n} mês(es) · dia {d}": "Alle {n} Monat(e) · Tag {d}",
 "A cada {n} semana(s)": "Alle {n} Woche(n)",
 "A cada {n} semana(s) · {dia}": "Alle {n} Woche(n) · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "Die Box ist in {aba}, unter \"Empfangene Notizen\".",
 "A caixa foi para {destino}.": "Die Box ist jetzt in {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "Der Schlüssel wird nur auf diesem Gerät im Systemtresor gespeichert. Auf einem anderen Gerät musst du ihn neu eingeben.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "Der Schlüssel wird nur in diesem Browser gespeichert. Nutze einen persönlichen Computer.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "Die Verbindung ist verschlüsselt. Der Tresor nutzt Ende-zu-Ende-Verschlüsselung (AES-256): Nicht einmal der Support kann ihn lesen. Die App lässt sich mit Passwort, Muster oder Biometrie sperren.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "Die Bestätigung per WhatsApp ist auf dem Server noch nicht aktiviert.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "Das Konto und alle in der Cloud gespeicherten Daten: Aufgaben, Notizen, Tabs, Karteikarten, Nachrichten, an die App gesendete Dateien und Einstellungen. Auch die Daten auf diesem Gerät werden gelöscht. Das lässt sich nicht rückgängig machen.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "Die Farbe erscheint in der Leiste, in den Titeln und bei den Aufgaben, die mit diesem Tab verknüpft sind.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "Die Farbe von My Planner ist die Akzentfarbe der App. Jede Aufgabe kann im Detailblatt eine eigene Farbe haben.",
 "A data de fim é anterior à de início.": "Das Enddatum liegt vor dem Startdatum.",
 "A data inicial precisa ser antes da final.": "Das Startdatum muss vor dem Enddatum liegen.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "Das Team sieht sich den Fehler an und behebt ihn in einem kommenden Update.",
 "A equipe vê e altera conforme o papel de cada um": "Das Team sieht und ändert je nach Rolle",
 "A fazer": "Zu erledigen",
 "A foto passa de 8 MB.": "Das Foto ist größer als 8 MB.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "Das Foto ist zu groß. Installiere die neue App-Version, um das Foto zuzuschneiden.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "Die Funktion „nuvem“ wurde noch nicht auf dem Server veröffentlicht. Führe 32-LIGAR-DRIVE-ONEDRIVE.bat aus.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "Die Funktion „nuvem“ wurde noch nicht auf dem Server veröffentlicht. Führe 9-LIGAR-DRIVE-ONEDRIVE.bat aus (siehe COMO RODAR, Version 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "Die Aufnahme wird noch vorbereitet. Versuch es in ein paar Minuten noch einmal.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "Die Uhrzeit gilt in dieser Zeitzone. In einer anderen Zeitzone zeigt die App die umgerechnete Zeit an und erinnert dich dann.",
 "A imagem original não está neste dispositivo.": "Das Originalbild ist nicht auf diesem Gerät.",
 "A pagar": "Zu zahlen",
 "A pagar: {v}": "Zu zahlen: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "Die Kalenderberechtigung wurde entzogen. Erlaube sie wieder in den Einstellungen deines Handys.",
 "A pessoa sai do grupo e deixa de receber os envios.": "Die Person verlässt die Gruppe und erhält keine Sendungen mehr.",
 "A receber": "Ausstehend",
 "A receber: {v}": "Zu erhalten: {v}",
 "A reunião ainda está sendo gravada.": "Die Besprechung wird noch aufgenommen.",
 "A senha atual não confere.": "Das aktuelle Passwort stimmt nicht.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "Das Tresor-Passwort muss mindestens 6 Zeichen haben.",
 "A senha precisa ter 8 caracteres ou mais.": "Das Passwort muss 8 oder mehr Zeichen haben.",
 "A senha precisa ter pelo menos 8 caracteres.": "Das Passwort muss mindestens 8 Zeichen haben.",
 "A senha é a mesma no celular e no My Planner Web.": "Das Passwort ist auf dem Handy und im My Planner Web dasselbe.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "Die Synchronisierung läuft beim Öffnen der App und nach jeder Änderung. Mit dem Kalender verknüpfte Aufgaben zeigen 📆.",
 "A sua equipe num lugar só": "Dein Team an einem Ort",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "Haushaltsaufgaben landen nicht von selbst in My Planner. \"An My Planner senden\" öffnet das vollständige Formular, in dem du Tag, Uhrzeit, Häufigkeit, Pausen und Alarme wählst.",
 "A validade não pode ser antes da emissão.": "Das Ablaufdatum darf nicht vor dem Ausstellungsdatum liegen.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "Die iPhone-Version kommt bald in den App Store. Nutze bis dahin My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "Die iPhone-Version kommt bald in den App Store. Nutze bis dahin My Planner Web: Tippe in Safari auf Teilen > Zum Home-Bildschirm, um es als Symbol auf dein Handy zu legen.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Letter, A5 oder Legal, ohne etwas abzuschneiden.",
 "ADICIONAR AMIGO": "FREUND HINZUFÜGEN",
 "AGUARDANDO RESPOSTA": "WARTET AUF ANTWORT",
 "AMIGOS": "FREUNDE",
 "ANOTAÇÕES": "NOTIZEN",
 "ANOTAÇÕES RECEBIDAS · {aba}": "EMPFANGENE NOTIZEN · {aba}",
 "ATIVIDADE": "AKTIVITÄT",
 "ATIVIDADE FÍSICA": "KÖRPERLICHE AKTIVITÄT",
 "ATRASADAS": "ÜBERFÄLLIG",
 "Aba": "Tab",
 "Aba bloqueada": "Tab gesperrt",
 "Aba {nome}": "Tab {nome}",
 "Abas": "Tabs",
 "Abas liberadas pelo suporte": "Vom Support freigeschaltete Tabs",
 "Abas para comprar": "Tabs zum Kaufen",
 "Abas que você já tem": "Tabs, die du schon hast",
 "Abastecimento": "Tankfüllung",
 "Abastecimentos": "Tankfüllungen",
 "Abdominal": "Crunches",
 "Abertura do prazo da declaração do IR": "Beginn der Frist für die IR-Erklärung",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Öffne das Unternehmen und tippe auf „Rechnungen suchen“, um das Tresor-Passwort einzugeben.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Öffne My Planner Anne und melde dich mit deiner Ausweisnummer und deinem Passwort an.",
 "Abra o My Planner no celular.": "Öffne My Planner auf dem Handy.",
 "Abra o cofre": "Öffne den Tresor",
 "Abra um PDF para começar.": "Öffne ein PDF, um zu starten.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Öffne ein Fach und tippe auf \"Jetzt lernen\", um die Zeit zu stoppen. Lege in jedem Fach Wochenziele fest.",
 "Abraço": "Umarmung",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Öffnet das Teilen-Menü des Handys: WhatsApp, E-Mail, Google Drive, OneDrive, In Dateien sichern und mehr.",
 "Abre o PDF para ler aqui mesmo.": "Öffnet das PDF zum Lesen direkt hier.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Öffnet den PDF-Scanner (Ränder und Schatten korrigiert).",
 "Abrir": "Öffnen",
 "Abrir Ajustes": "Einstellungen öffnen",
 "Abrir PDF": "PDF öffnen",
 "Abrir PDF do celular, Drive ou OneDrive": "PDF vom Handy, Drive oder OneDrive öffnen",
 "Abrir a aba": "Tab öffnen",
 "Abrir a cópia guardada": "Gespeicherte Kopie öffnen",
 "Abrir a pasta no Drive": "Ordner in Drive öffnen",
 "Abrir com outro app": "Mit anderer App öffnen",
 "Abrir configurações": "Einstellungen öffnen",
 "Abrir em outro app": "In anderer App öffnen",
 "Abrir no DJEN": "Im DJEN öffnen",
 "Abrir no modo seguro": "Im abgesicherten Modus öffnen",
 "Abrir normalmente": "Normal öffnen",
 "Abrir nota fiscal": "Rechnung öffnen",
 "Abrir o PDF": "PDF öffnen",
 "Abrir o PDF no {nome}": "PDF in {nome} öffnen",
 "Abrir o XML": "XML öffnen",
 "Abrir o app": "App öffnen",
 "Abrir o app My Planner": "My Planner-App öffnen",
 "Abrir o cartão": "Karte öffnen",
 "Abrir o cofre": "Tresor öffnen",
 "Abrir o cofre para ver": "Zum Ansehen Tresor öffnen",
 "Abrir o diário oficial": "Amtsblatt öffnen",
 "Abrir ou baixar": "Öffnen oder herunterladen",
 "Abrir página": "Seite öffnen",
 "Abrir site": "Website öffnen",
 "Abrir {nome}": "{nome} öffnen",
 "Acabamento": "Ausbau",
 "Acabou": "Leer",
 "Academia": "Fitnessstudio",
 "Aceitar": "Annehmen",
 "Aceitar, editar ou recusar": "Annehmen, bearbeiten oder ablehnen",
 "Aceite os termos para continuar.": "Akzeptiere die Bedingungen, um fortzufahren.",
 "Aceito": "Angenommen",
 "Aceito com alterações": "Mit Änderungen angenommen",
 "Acerto de contas": "Abrechnung",
 "Acerto de contas: {v}": "Abrechnung: {v}",
 "Acessibilidade": "Barrierefreiheit",
 "Acesso ilimitado": "Unbegrenzter Zugriff",
 "Acesso ilimitado a todas as funções, sem prazo": "Unbegrenzter Zugriff auf alle Funktionen, ohne Frist",
 "Achatar": "Reduzieren",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Verfolgt alles, auch die Ausgaben, und schreibt ins Tagebuch.",
 "Acompanhamento": "Beilage",
 "Acompanhantes": "Begleitpersonen",
 "Acrescentar no fim da página": "Am Ende der Seite hinzufügen",
 "Adaptador de tomada": "Steckdosenadapter",
 "Adestramento": "Hundeschule",
 "Adicionar": "Hinzufügen",
 "Adicionar amigo": "Freund hinzufügen",
 "Adicionar amigos do app": "App-Freunde hinzufügen",
 "Adicionar ao Planner?": "Zum Planner hinzufügen?",
 "Adicionar arquivo": "Datei hinzufügen",
 "Adicionar cômodo": "Raum hinzufügen",
 "Adicionar fotos e vídeos": "Fotos und Videos hinzufügen",
 "Adicionar imagem": "Bild hinzufügen",
 "Adicionar item (ex.: 2 ovos mexidos)": "Eintrag hinzufügen (z. B. 2 Rühreier)",
 "Adicionar na página": "Zur Seite hinzufügen",
 "Adicionar passo": "Schritt hinzufügen",
 "Adicionar país": "Land hinzufügen",
 "Adicionar página": "Seite hinzufügen",
 "Adicionar texto": "Text hinzufügen",
 "Adicionar {nome}": "{nome} hinzufügen",
 "Adicionar à equipe": "Zum Team hinzufügen",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Füge einen Freund mit seinem Code hinzu oder schick deinen Code an wen du willst.",
 "Admin": "Admin",
 "Administração": "Betriebswirtschaft",
 "Adubar a cada quantos dias": "Alle wie viele Tage düngen",
 "Adubar: {p}": "Düngen: {p}",
 "Adubei hoje": "Heute gedüngt",
 "Advogado": "Anwalt",
 "Advogados": "Anwälte",
 "Afundo": "Ausfallschritte",
 "Agachamento": "Kniebeugen",
 "Agenda do Google": "Google Kalender",
 "Agenda limpa": "Kalender geleert",
 "Agenda não liberada": "Kalender nicht freigegeben",
 "Agenda sincronizada ✓": "Kalender synchronisiert ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Kalender, Notizen, Finanzen, Lernen, Nachrichten und vieles mehr in einer App.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Termine, Patientendaten und Zahlungen, ohne die Krankenakte.",
 "Agendado": "Geplant",
 "Agendado no My Planner": "In My Planner eingeplant",
 "Agendamento no pet shop": "Termin im Tiersalon",
 "Agendar": "Planen",
 "Agendar no My Planner": "In My Planner einplanen",
 "Agendar no My Planner (dias e horários)": "In My Planner einplanen (Tage und Uhrzeiten)",
 "Agora não": "Nicht jetzt",
 "Agora o verso do documento.": "Jetzt die Rückseite des Dokuments.",
 "Agora, {hora}": "Jetzt, {hora}",
 "Agora: {ml}": "Aktuell: {ml}",
 "Aguardando o celular · {s}s": "Warte auf das Handy · {s} s",
 "Aguarde": "Bitte warten",
 "Aguarde um pouco": "Bitte kurz warten",
 "Aguarde...": "Bitte warten...",
 "Ainda a pagar no mês": "Diesen Monat noch zu zahlen",
 "Ainda a receber no mês": "Diesen Monat noch zu erhalten",
 "Ainda não confirmado": "Noch nicht bestätigt",
 "Ainda não disponível: falta configurar no servidor.": "Noch nicht verfügbar: Die Einrichtung auf dem Server fehlt.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "Diesen Monat hast du noch nichts gespart. Wie wäre es, {v} (10 % deiner Einnahmen) beiseitezulegen, sobald das Geld da ist?",
 "Ainda não há feriados deste país para este ano.": "Für dieses Land gibt es noch keine Feiertage für dieses Jahr.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "In diesem Tab gibt es noch nichts zu teilen. Erstelle es zuerst (z. B. die Reise) und komm dann hierher zurück.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "Noch keine anderen Personen in der Gruppe (oder du siehst die Mitgliederliste nicht).",
 "Ainda não marcado como feito. Toque para abrir.": "Noch nicht als erledigt markiert. Tippe zum Öffnen.",
 "Ainda não sincronizado": "Noch nicht synchronisiert",
 "Ainda sem chave neste dispositivo.": "Noch kein Schlüssel auf diesem Gerät.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking oder direkt: Buchungen, Reinigung beim Check-out, Einnahmen, Ausgaben und Monatsgewinn",
 "Ajuda na organização": "Hilft bei der Organisation",
 "Ajudante": "Helfer",
 "Ajustar": "Anpassen",
 "Ajustar a data final": "Enddatum anpassen",
 "Ajustar a folha": "Blatt anpassen",
 "Ajustar tamanho da página": "Seitengröße anpassen",
 "Ajuste visual": "Optische Anpassung",
 "Ajustes": "Einstellungen",
 "Alarme dos remédios": "Medikamenten-Alarm",
 "Alarme que insiste até marcar como tomado": "Alarm, der wiederholt, bis die Einnahme markiert ist",
 "Alemão": "Deutsch",
 "Alergia": "Allergie",
 "Alergias": "Allergien",
 "Alergias e alertas": "Allergien und Hinweise",
 "Alertas": "Alarme",
 "Alertas das tarefas": "Aufgaben-Alarme",
 "Alertas dos compromissos": "Terminerinnerungen",
 "Algo deu errado, mas o app continua aberto": "Etwas ist schiefgelaufen, aber die App bleibt geöffnet",
 "Alguns arquivos foram guardados em outro dispositivo.": "Einige Dateien wurden auf einem anderen Gerät gespeichert.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Manche Uhren (z. B. von Huawei) senden eventuell keine Daten an Health Connect. Gib die Werte dann manuell ein.",
 "Alguém": "Jemand",
 "Alguém indicou o app para você?": "Hat dir jemand die App empfohlen?",
 "Alimentação": "Essen",
 "Alimentação & Despensa": "Essen & Vorrat",
 "Alimentação {semana}": "Ernährung {semana}",
 "Alimento": "Lebensmittel",
 "Alinhamento e balanceamento": "Spur und Auswuchten",
 "Almoço": "Mittagessen",
 "Alongamento": "Dehnen",
 "Alta": "Hoch",
 "Alterado por último por {nome}": "Zuletzt geändert von {nome}",
 "Alterar metadados": "Metadaten ändern",
 "Alterar o valor pago": "Bezahlten Betrag ändern",
 "Alterações": "Änderungen",
 "Alto-falante": "Lautsprecher",
 "Aluga como": "Vermietet als",
 "Alugar a casa ou um cômodo": "Haus oder ein Zimmer vermieten",
 "Aluguel": "Vermietung",
 "Aluguel & Hospedagem": "Vermietung & Unterkunft",
 "Aluguel de carro": "Mietwagen",
 "Aluno": "Schüler",
 "Alunos": "Schüler",
 "Alvará ou licença": "Genehmigung oder Lizenz",
 "Alvenaria": "Mauerwerk",
 "Alvo": "Zielbetrag",
 "Alíquota do ISS (%)": "ISS-Satz (%)",
 "Alíquota do ISS deste serviço (%)": "ISS-Satz dieser Leistung (%)",
 "Amanhã": "Morgen",
 "Ambiente": "Umgebung",
 "Ameno": "Mild",
 "Amigos": "Freunde",
 "Amor": "Liebe",
 "Amortização": "Tilgung",
 "Ampliar a foto": "Foto vergrößern",
 "Amém": "Amen",
 "Analisar com IA": "Mit KI analysieren",
 "Anamnese e histórico (no cofre)": "Anamnese und Vorgeschichte (im Tresor)",
 "Anexar arquivos": "Dateien anhängen",
 "Anexar comprovante": "Beleg anhängen",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Dokumente anhängen, Kontoauszüge importieren und Berichte, PDFs und Backups speichern.",
 "Anexos": "Anhänge",
 "Anexos guardados aqui no dispositivo: {n}": "Nur auf diesem Gerät gespeicherte Anhänge: {n}",
 "Animais e natureza": "Tiere und Natur",
 "Animação": "Animation",
 "Anime": "Anime",
 "Aniversário": "Geburtstag",
 "Aniversário de Campo Grande": "Jahrestag von Campo Grande",
 "Aniversário de São Paulo": "Jahrestag von São Paulo",
 "Ano": "Baujahr",
 "Ano anterior": "Vorjahr",
 "Ano de lançamento": "Erscheinungsjahr",
 "Ano de {ano}": "Jahr {ano}",
 "Ano passado": "Letztes Jahr",
 "Anotar pela foto da página": "Per Foto der Seite notieren",
 "Anotação": "Notiz",
 "Anotação de {data}": "Notiz vom {data}",
 "Anotação do professor": "Notiz der Lehrkraft",
 "Anotação à mão": "Handschriftliche Notiz",
 "Anotações": "Notizen",
 "Anotações Rápidas": "Schnellnotizen",
 "Anotações arquivadas": "Archivierte Notizen",
 "Anotações arquivadas ({n})": "Archivierte Notizen ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Trage jede Buchung mit Daten, Herkunft und Beträgen ein. Die Reinigung beim Check-out kommt automatisch in die Reinigungsliste.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Halte den Alltag auf der Baustelle mit Fotos fest. Markiere Fotos als Vorher oder Nachher, um den Fortschritt zu sehen.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Notiere, was du verliehen oder geliehen hast, mit Foto und Frist. Die App erinnert dich am Rückgabetag.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Notiere die Orte, die du sehen möchtest. Suche sie in Google Maps oder Waze, plane eine Route durch alle und füge sie dem Tagesprogramm hinzu.",
 "Anteriores ({n})": "Frühere ({n})",
 "Antes": "Vorher",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Bevor es losgeht: Sieh dir an, was die App nutzt und warum. Du kannst alles später unter Einstellungen > Datenschutz und Bedingungen ändern.",
 "Antes de uma data": "Vor einem Datum",
 "Antes do início": "Vor dem Beginn",
 "Antes e depois": "Vorher und nachher",
 "Antes: {lista}": "Vorher: {lista}",
 "Antipulgas": "Flohschutz",
 "Anual": "Jährlich",
 "Ao ar livre": "Draußen",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "Beim Kündigen wird der Tab schwarz-weiß und die Verknüpfungen verschwinden aus den Aufgaben, aber nichts wird gelöscht.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "Mit dem Erstellen des Kontos oder der weiteren Nutzung der App stimmst du diesen Bedingungen und der Datenschutzerklärung unten zu.",
 "Ao fechar, a página é salva.": "Beim Schließen wird die Seite gespeichert.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "Beim Speichern legst du das Tresor-Passwort fest. Dieses Feld wird auf dem Gerät verschlüsselt.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "Wenn du in Lernen oder Dokumente auf \"Datei\" oder \"Foto\" tippst, zeigt die Auswahl deines Handys Google Drive, OneDrive und Dropbox an (wenn die Apps installiert sind). Wähle die Datei direkt dort aus.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Tippe auf eine angehängte Datei, um sie in der gewählten App des Handys zu öffnen (auf Android \"Nur einmal\" oder \"Immer\"). Was du dort bearbeitest, wird in der Datei selbst gespeichert.",
 "Apaga a conta e todos os vencimentos dela.": "Löscht die Rechnung und alle ihre Fälligkeiten.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Löscht die Fächer und Seiten dieses Ordners. Die Aufgaben im Planner bleiben erhalten.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Löscht die Seiten dieses Fachs. Die Lernzeit bleibt im Verlauf.",
 "Apaga o cartão e as compras dele.": "Löscht die Karte und ihre Käufe.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Löscht das Konto und alle Daten in der Cloud und auf diesem Gerät dauerhaft. Das lässt sich nicht rückgängig machen.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Löscht alle Aufgaben im Kalender, vergangene und künftige.",
 "Apaga todas as {n} parcelas.": "Löscht alle {n} Raten.",
 "Apaga todos os meses desta conta.": "Löscht alle Monate dieser Rechnung.",
 "Apagar": "Löschen",
 "Apagar \"{nome}\"?": "\"{nome}\" löschen?",
 "Apagar a caixa?": "Box löschen?",
 "Apagar a chave": "Schlüssel löschen",
 "Apagar a chave deste dispositivo?": "Schlüssel von diesem Gerät löschen?",
 "Apagar a conta?": "Konto löschen?",
 "Apagar a lista de erros?": "Fehlerliste löschen?",
 "Apagar a pasta (os documentos continuam)": "Ordner löschen (Dokumente bleiben erhalten)",
 "Apagar as da agenda": "Kalendertermine löschen",
 "Apagar caixa": "Box löschen",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Wirklich löschen (geschwärzte Seiten werden zu Bildern)",
 "Apagar de vez": "Endgültig löschen",
 "Apagar desenho": "Zeichnung löschen",
 "Apagar envio": "Sendung löschen",
 "Apagar lista": "Liste löschen",
 "Apagar minha conta": "Mein Konto löschen",
 "Apagar minha conta e todos os dados": "Mein Konto und alle Daten löschen",
 "Apagar o escritório": "Büro löschen",
 "Apagar o escritório?": "Büro löschen?",
 "Apagar o grupo": "Gruppe löschen",
 "Apagar o grupo?": "Gruppe löschen?",
 "Apagar o lançamento?": "Buchung löschen?",
 "Apagar para todos": "Für alle löschen",
 "Apagar tudo": "Alles löschen",
 "Apagar tudo antes de": "Alles löschen vor dem",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Lösche auf einmal die Aufgaben von heute, des Monats, eines Zeitraums oder nach Name. Vor dem Löschen zeigt die App, was entfernt wird, und fragt nach deinem Passwort.",
 "Aparece na barra quando estiver liberada": "Erscheint in der Leiste, sobald freigeschaltet",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Sie erscheinen im Planner, zusammen mit den optionalen Brückentagen (Karneval, Aschermittwoch und Fronleichnam).",
 "Aplicar": "Anwenden",
 "Aponte a câmera do celular para este QR Code.": "Richte die Handykamera auf diesen QR-Code.",
 "Aponte para o QR Code na tela do computador": "Richte die Kamera auf den QR-Code auf dem Computerbildschirm",
 "Apostila": "Skript",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Skripte, Aufgabenblätter, Folien, Videos, Links und Mitteilungen. Über ⋮ › An eine Gruppe senden bekommt jeder Schüler sie in seiner App.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "App für die Schaltfläche „Route“ bei Adressen (Aufgaben, Termine, Reiseplan, Bauprojekte, Schule...).",
 "Apple Saúde": "Apple Health",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: Sie speichert schon alles in der Health-App des iPhones. Du musst nichts tun.",
 "Apresentação": "Aufführung",
 "Aprovação": "Freigabe",
 "Aqui": "Hier",
 "Ar-condicionado": "Klimaanlage",
 "Arco-íris": "Regenbogen",
 "Arenoso": "Sandig",
 "Armazenamento": "Speicher",
 "Armário": "Schrank",
 "Arquivadas ({n})": "Archiviert ({n})",
 "Arquivados ({n})": "Archiviert ({n})",
 "Arquivar": "Archivieren",
 "Arquivar a caixa de anotações?": "Notizbox archivieren?",
 "Arquivar conversa": "Chat archivieren",
 "Arquivo": "Datei",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "Datei (Drive, OneDrive, Dropbox oder vom Gerät)",
 "Arquivo OFX ou CSV do banco": "OFX- oder CSV-Datei der Bank",
 "Arquivo adicionado": "Datei hinzugefügt",
 "Arquivo menor (para WhatsApp e e-mail)": "Kleinere Datei (für WhatsApp und E-Mail)",
 "Arquivo menor para WhatsApp e e-mail.": "Kleinere Datei für WhatsApp und E-Mail.",
 "Arquivo não encontrado.": "Datei nicht gefunden.",
 "Arquivo ou PDF": "Datei oder PDF",
 "Arquivo ou documento": "Datei oder Dokument",
 "Arquivos": "Dateien",
 "Arquivos (frente, verso, PDF)": "Dateien (Vorder-, Rückseite, PDF)",
 "Arquivos (importar e exportar)": "Dateien (Import und Export)",
 "Arquivos de {nome}": "Dateien von {nome}",
 "Arquivos na nuvem e cópias de segurança": "Dateien in der Cloud und Sicherungskopien",
 "Arrasou!": "Stark!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Ziehe die Punkte auf die 4 Ecken des Blatts. Die App schneidet die Seite zu und richtet sie gerade aus.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Zieh den Finger über das, was du verbergen willst. Tipp auf einen Balken, um ihn zu entfernen.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Nach rechts wischen zum Löschen, nach links zum Senden an einen anderen Tab.",
 "Arraste para a direita para excluir.": "Zum Löschen nach rechts wischen.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Ziehen zum Umsortieren, drehen, duplizieren, löschen und leere Seiten einfügen.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Ziehen, um den Rest des Boards zu sehen. Es wächst nach unten und nach rechts.",
 "Arraste um documento para a direita para excluir.": "Wische ein Dokument nach rechts, um es zu löschen.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Wische eine Box nach links, um sie zu archivieren, oder nach rechts, um sie zu löschen.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Wische eine Box nach links zum Archivieren oder nach rechts zum Löschen. Halte ⋮⋮ gedrückt, um die Reihenfolge zu ändern.",
 "Arroz": "Reis",
 "Artes": "Kunst",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Die Abos Claude Pro, ChatGPT Plus und Gemini Advanced können nicht von anderen Apps genutzt werden. Um die KI hier zu aktivieren, erstelle in deinem Konto einen API-Schlüssel (Gemini hat eine kostenlose Nutzung; Claude und ChatGPT rechnen nach Nutzung ab, wenige Cent pro Analyse).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "Anrufe wurden auf dem Server noch nicht aktiviert (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "Ihre Käufe werden auch aus den Finanzen entfernt.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "Ratenkäufe werden mit allen Raten erfasst: Die nächsten erscheinen schon in den folgenden Abrechnungen.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "Die Fotos dieses Dokuments sind auf dem Gerät, auf dem es gescannt wurde. Dort kannst du es bearbeiten, teilen und den Text lesen.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "Die Bilder gehen nur an die KI, die du gewählt hast, mit deinem eigenen Schlüssel.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "Die Reinigungen nach dem Check-out erscheinen hier automatisch, mit Checkliste und Vorher-Nachher-Fotos.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "Hier ausgestellte Rechnungen, bei der Suche gefundene und importierte XML erscheinen in dieser Liste.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "Die Raten erscheinen hier. Hänge bei jeder den Beleg an (Foto, PDF oder PIX-Screenshot).",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "Die Raten der nächsten 12 Monate sind schon im My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "Offene Raten werden mit dem aktuellen Betrag, Zins und der Laufzeit des Vertrags neu berechnet. Bezahlte bleiben unverändert.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "Die Seiten dieses Dokuments sind auf dem Gerät, auf dem es gescannt wurde. Öffne es dort oder nutze die Kopie in Drive oder OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "Die Seiten werden zu leichteren Bildern: ideal für gescannte PDFs. Der Text ist danach nicht mehr durchsuchbar (nutze bei Bedarf danach OCR).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "Die Seiten gehen nur an die KI, die du gewählt hast, mit deinem Schlüssel.",
 "As receitas do cardápio já têm tudo na despensa.": "Für die Rezepte im Speiseplan ist alles im Vorrat.",
 "As senhas novas não conferem.": "Die neuen Passwörter stimmen nicht überein.",
 "As senhas não conferem.": "Die Passwörter stimmen nicht überein.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "Die Aufgaben bleiben in My Planner. Möchtest du auch die aus dem Google Kalender löschen?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "Die Aufgaben des Zimmers bleiben in Mein Zuhause, ohne Zimmer.",
 "As tarefas vinculadas continuam no My Planner.": "Die verknüpften Aufgaben bleiben in My Planner.",
 "Aspirar e passar pano": "Staubsaugen und wischen",
 "Assinada": "Abonniert",
 "Assinar": "Unterschreiben",
 "Assinar (simulação de teste)": "Abonnieren (Testsimulation)",
 "Assinar o documento": "Dokument unterschreiben",
 "Assinatura": "Unterschrift",
 "Assinatura do profissional": "Unterschrift der Fachkraft",
 "Assinatura e segurança": "Signatur und Sicherheit",
 "Assinaturas (simulação de teste)": "Abos (Testsimulation)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Abonniere den Tab in den Einstellungen, um Notizen dorthin zu senden.",
 "Assine a aba em Ajustes para vincular.": "Abonniere den Tab in den Einstellungen, um ihn zu verknüpfen.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Abonniere den Tab unter Einstellungen › Käufe, um Notizen dorthin zu senden.",
 "Assine a aba em Ajustes › Compras para vincular.": "Abonniere den Tab unter Einstellungen › Käufe, um ihn zu verknüpfen.",
 "Assine a aba para abrir o vínculo.": "Abonniere den Tab, um die Verknüpfung zu öffnen.",
 "Assisti mais uma aula": "Noch eine Lektion geschaut",
 "Assistido": "Gesehen",
 "Assistindo": "Am Schauen",
 "Assistência técnica (nome)": "Kundendienst (Name)",
 "Assistência: {nome}": "Kundendienst: {nome}",
 "Assunto": "Thema",
 "Assunto (ex.: Reunião semanal)": "Betreff (z. B.: Wöchentliche Besprechung)",
 "Atender": "Annehmen",
 "Atendimento": "Termin",
 "Atendimentos": "Termine",
 "Ativar avisos": "Mitteilungen aktivieren",
 "Ativar monitor": "Monitor aktivieren",
 "Ativas": "Aktiv",
 "Atividade": "Tätigkeit",
 "Atividade do roteiro": "Programmpunkt",
 "Atividade hoje": "Aktivität heute",
 "Atividade: {blocos}": "Aktivität: {blocos}",
 "Atividades": "Aktivitäten",
 "Atividades de hoje": "Heutige Aktivitäten",
 "Atividades e materiais": "Aktivitäten und Material",
 "Atividades físicas e saúde": "Sport und Gesundheit",
 "Atrasada": "Überfällig",
 "Atrasada há {n} dia(s)": "Seit {n} Tag(en) überfällig",
 "Atrasadas": "Überfällig",
 "Atrasados": "Überfällig",
 "Atuais": "Aktuell",
 "Atualidades": "Aktuelles",
 "Atualizar": "Aktualisieren",
 "Atualizar agora": "Jetzt aktualisieren",
 "Atualizar alarmes no My Planner": "Alarme in My Planner aktualisieren",
 "Atualizar rega e adubo na agenda": "Gießen und Düngen im Kalender aktualisieren",
 "Atualização automática disponível no app instalado (APK).": "Automatisches Update in der installierten App (APK) verfügbar.",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Update heruntergeladen. Es wird beim Neustart der App oder beim Tippen auf den Hinweis übernommen.",
 "Atualização pronta": "Update bereit",
 "Atualizações": "Updates",
 "Até": "Bis",
 "Audiência": "Gerichtstermin",
 "Aula dada": "Unterricht gehalten",
 "Aula {a} de {n} ({p}%)": "Lektion {a} von {n} ({p}%)",
 "Aulas assistidas": "Geschaute Lektionen",
 "Autoajuda": "Selbsthilfe",
 "Autor": "Autor",
 "Avaliação": "Leistungsnachweis",
 "Avaliações e notas": "Leistungsnachweise und Noten",
 "Avançado": "Erweitert",
 "Aveia": "Haferflocken",
 "Avisar a hora de sair": "An Abfahrtszeit erinnern",
 "Avisar antes de vencer": "Vor Ablauf erinnern",
 "Avisar no celular quando alguém incluir algo": "Aufs Handy benachrichtigen, wenn jemand etwas hinzufügt",
 "Aviso": "Hinweis",
 "Aviso com as tarefas do dia": "Hinweis mit den Aufgaben des Tages",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Testbenachrichtigung vom Server gesendet. Sie kommt in wenigen Sekunden an; verlasse die App, um sie in der Benachrichtigungsleiste zu sehen.",
 "Aviso enviado": "Benachrichtigung gesendet",
 "Aviso {dias} dia(s) antes e no dia": "Erinnerung {dias} Tag(e) vorher und am Tag selbst",
 "Avisos no celular": "Handy-Benachrichtigungen",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Benachrichtigungen laufen über die Dienste von Expo, Google und Apple.",
 "Ação": "Action",
 "Ações": "Aktien",
 "BOLETO E DOCUMENTOS": "BOLETO UND DOKUMENTE",
 "Backup importado.": "Backup importiert.",
 "Bairro": "Stadtteil",
 "Baixa": "Niedrig",
 "Baixando atualização...": "Update wird heruntergeladen...",
 "Baixar": "Herunterladen",
 "Baixar a versão {v}": "Version {v} herunterladen",
 "Baixar agora": "Jetzt herunterladen",
 "Baixar o My Planner para Android": "My Planner für Android herunterladen",
 "Baixar o My Planner para Android (versão {v})": "My Planner für Android herunterladen (Version {v})",
 "Baixar o My Planner para iPhone": "My Planner für iPhone herunterladen",
 "Baixar o PDF da nota (DANFSe)": "PDF der Rechnung herunterladen (DANFSe)",
 "Baixar o PDF?": "PDF herunterladen?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Vollständiges XML herunterladen (bestätigt Kenntnisnahme bei der SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Lade die neueste Android-Version herunter: {apk}",
 "Baixe aqui a versão mais recente: {link}": "Lade hier die neueste Version herunter: {link}",
 "Balança": "Schaukeln",
 "Balanço e relatórios": "Bilanz und Berichte",
 "Banana": "Banane",
 "Banco": "Bank",
 "Banco, financeira ou pessoa": "Bank, Kreditinstitut oder Person",
 "Bandeiras": "Flaggen",
 "Banheiro": "Badezimmer",
 "Banho": "Baden",
 "Banho e tosa": "Baden und Scheren",
 "Barra": "Leiste",
 "Bateria": "Batterie",
 "Batimentos (média)": "Puls (Durchschnitt)",
 "Batizado": "Taufe",
 "Bebida": "Getränk",
 "Bebê": "Baby",
 "Beijo": "Kuss",
 "Bem": "Vermögenswert",
 "Bem clara": "Sehr hell",
 "Bem-Estar": "Wohlbefinden",
 "Bem-Estar · Cronograma alimentar": "Wohlbefinden · Ernährungsplan",
 "Bens": "Vermögen",
 "Bichos e diversão": "Tiere und Spaß",
 "Bicicleta": "Fahrrad",
 "Bicicleta ergométrica": "Ergometer",
 "Biografia": "Biografie",
 "Biologia": "Biologie",
 "Biometria (digital ou rosto)": "Biometrie (Fingerabdruck oder Gesicht)",
 "Biometria ({tipos})": "Biometrie ({tipos})",
 "Biometria não confirmada.": "Biometrie nicht bestätigt.",
 "Bloqueado": "Blockiert",
 "Bloquear": "Blockieren",
 "Bloquear agora": "Jetzt sperren",
 "Bloqueio": "Sperre",
 "Blusas de frio": "Pullover",
 "Boa noite": "Gute Nacht",
 "Boa sorte!": "Viel Glück!",
 "Boas-vindas ao My Planner": "Willkommen bei My Planner",
 "Boas-vindas pelo WhatsApp": "Begrüßung per WhatsApp",
 "Boleto": "Boleto",
 "Boleto anexado": "Boleto angehängt",
 "Boleto do banco {b}": "Boleto der Bank {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto und Dokumente (Foto, PDF oder Datei)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto oder Rechnung (Foto, PDF oder Datei)",
 "Boleto por foto": "Boleto per Foto",
 "Bolinha": "Kreis",
 "Bom dia": "Guten Morgen",
 "Bom dia!": "Guten Morgen!",
 "Bom dia! Seu dia no My Planner": "Guten Morgen! Dein Tag in My Planner",
 "Booking": "Booking",
 "Bora!": "Los geht's!",
 "Borboleta": "Schmetterling",
 "Borracha": "Radierer",
 "Botas para neve": "Schneestiefel",
 "Brasil": "Brasilien",
 "Braços acima da cabeça": "Arme über den Kopf",
 "Brilho": "Glitzern",
 "Brinquedo ou livro para a viagem": "Spielzeug oder Buch für die Reise",
 "Busca de notas": "Rechnungssuche",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Sucht den Namen in den von Querido Diário (Open Knowledge Brasil) gesammelten Amtsblättern der Gemeinden. Nicht alle Gemeinden sind enthalten, und die Amtsblätter gehören nicht zum DJEN.",
 "Buscando...": "Suche läuft...",
 "Buscar": "Suchen",
 "Buscar GIF (ex.: parabéns, bom dia)": "GIF suchen (z. B. Glückwunsch, guten Morgen)",
 "Buscar cidade, país ou GMT": "Stadt, Land oder GMT suchen",
 "Buscar conversa": "Chat suchen",
 "Buscar documento, titular ou órgão": "Dokument, Inhaber oder Behörde suchen",
 "Buscar em {nome}": "In {nome} suchen",
 "Buscar emoji (ex.: coração, risada)": "Emoji suchen (z. B. Herz, Lachen)",
 "Buscar figurinha": "Sticker suchen",
 "Buscar notas": "Rechnungen suchen",
 "Buscar ou digitar um alimento": "Lebensmittel suchen oder eingeben",
 "Buscar país": "Land suchen",
 "Buscar pelo nome ou pelo texto": "Nach Name oder Text suchen",
 "Buscar produto, loja ou observação": "Produkt, Geschäft oder Notiz suchen",
 "Buscar tarefas": "Aufgaben suchen",
 "Buscar: processo, parte, tribunal, palavra...": "Suche: Verfahren, Partei, Gericht, Wort...",
 "CAIXA {n}": "KARTON {n}",
 "CARDS DE ANOTAÇÕES": "NOTIZKARTEN",
 "CARTÕES": "KARTEN",
 "CEP": "CEP (PLZ)",
 "CID (se o paciente pedir na declaração)": "CID (falls der Patient es in der Bescheinigung wünscht)",
 "CID: {c}": "CID: {c}",
 "CNH": "Führerschein (CNH)",
 "CNPJ (se tiver)": "CNPJ (falls vorhanden)",
 "CNPJ ou CPF": "CNPJ oder CPF",
 "COMPROVANTE DE PAGAMENTO": "ZAHLUNGSBELEG",
 "COMPROVANTE DE RECEBIMENTO": "EINGANGSBELEG",
 "COMPROVANTES ANTERIORES": "FRÜHERE BELEGE",
 "CONTAS DO MÊS": "RECHNUNGEN DES MONATS",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Brasilien)",
 "CPF de quem paga": "CPF des Zahlers",
 "CPF do paciente": "CPF des Patienten",
 "CPF do pagador": "CPF des Zahlers",
 "CPF inválido": "Ungültige CPF",
 "CPF ou CNPJ de quem recebeu": "CPF oder CNPJ des Empfängers",
 "CPF ou senha incorretos.": "CPF oder Passwort falsch.",
 "CRIAR CÔMODO": "RAUM ERSTELLEN",
 "CRIAR UM GRUPO": "GRUPPE ERSTELLEN",
 "CRONOGRAMA ALIMENTAR": "ESSENSPLAN",
 "CUIDADOS PESSOAIS": "KÖRPERPFLEGE",
 "Cabeleireiro": "Friseur",
 "Cabelo": "Haare",
 "Cachorro": "Hund",
 "Cactos e suculentas": "Kakteen und Sukkulenten",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Jeder zusätzliche Tab: {n} Tage gratis; danach {preco} pro Jahr.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Jede fertige Datei landet in {nome}. Geöffnete PDFs bleiben auch auf diesem Gerät, in der Liste unten.",
 "Cada dia da semana": "Jeden Wochentag",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Jedes neue Dokument geht zu {nome}, wenn du es verlässt. Die Seitenfotos bleiben nur auf diesem Gerät.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Jede Person im Team erhält die Besprechung unter Erhalten und übernimmt sie mit einem Tippen samt Erinnerung in den Planner.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Jede Person in der Gruppe erhält es und entscheidet, ob sie es annimmt.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "Jede Seite enthält eine Zusammenfassung, Lektion oder ein Kapitel. Markiere sie als wiederholt, wenn du fertig bist.",
 "Cada página vira uma imagem JPG.": "Jede Seite wird ein JPG-Bild.",
 "Cada refeição se repete nos dias dela": "Jede Mahlzeit wiederholt sich an ihren Tagen",
 "Cadastrar": "Anlegen",
 "Cadastrar cartão de crédito": "Kreditkarte anlegen",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Per Foto erfassen (Kursseite, Zertifikat, Flyer)",
 "Cadastrar pela foto da capa": "Per Foto des Covers erfassen",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Fülle \"Meine Daten\" aus, damit Belege mit deinem Namen, deiner Kammer und Nummer erstellt werden.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Erfasse Ausweis, Führerschein, Reisepass, Verträge und Urkunden. Die App erinnert dich vor Ablauf und sendet das Dokument mit einem Tipp.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Erfasse das Unternehmen (oder dich als Selbstständigen) mit CNPJ oder CPF, Gemeinde und Steuerregime. Verbinde dann das A1-Zertifikat, um NFS-e nach dem Padrão Nacional auszustellen und ausgestellte und erhaltene Rechnungen zu suchen.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Lege das Bauprojekt an und darin die Bauabschnitte mit Budget, das Bautagebuch mit Fotos, die Handwerker und die Materiallieferungen.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Lege die Reise an und darin das Programm für jeden Tag, die Buchungen und den Koffer. Während der Reise erscheint das Programm in My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Trage nur deinen eigenen Namen und deine eigene OAB ein.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Lege die Kinder an: Prüfungen, Elternabende, Arzttermine und Impfungen liegen jeweils darin.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Lege jedes Haustier an: Impfpass, Wurmkuren, Medikamente und Tiersalon liegen darin.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Lege jede Pflanze mit Licht, Boden und Gieß- und Düngeintervall an. Die App erstellt den Kalender in der Agenda.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Lege jedes Fahrzeug an. Darin liegen die Wartungen (mit Erinnerung nach km und Datum) und die Fälligkeiten von IPVA, Zulassung und Versicherung.",
 "Cadastre digital ou rosto no aparelho para usar.": "Richte Fingerabdruck oder Gesicht auf dem Gerät ein, um das zu nutzen.",
 "Cadastre o cartão primeiro": "Lege zuerst die Karte an",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Erfasse die Finanzierung oder den Kredit mit Betrag, Zins und Anzahl der Raten. Die App berechnet Raten und Restschuld und erinnert an Fälligkeiten.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Erfasse die ganze Unterkunft oder jedes Zimmer, das du vermietest. Darin liegen Buchungen, Reinigung und Ausgaben.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Lege das Buch mit Gesamtseitenzahl und Tagesziel an. Tippe auf ⋮, um gelesene Seiten hinzuzufügen.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Lege das Medikament mit den Uhrzeiten an und tippe auf ⋮, um es mit Alarm in die Zeitleiste zu setzen.",
 "Cadastre os alunos da turma na aba Alunos.": "Lege die Schüler der Klasse im Tab Schüler an.",
 "Cadastre os clientes para separar as horas.": "Lege Kunden an, um die Stunden zu trennen.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Erfasse die Kunden, die deine Rechnungen erhalten. Die Adresse ist optional (wenn ausgefüllt, gib CEP, IBGE-Code, Straße, Hausnummer und Stadtteil an).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Erfasse die Leistungen, die du am häufigsten abrechnest, mit dem nationalen Steuercode. Beim Ausstellen genügt ein Tippen.",
 "Cadastre primeiro em {nome}.": "Lege es zuerst in {nome} an.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Trage deinen Namen, deine Kammer und Registriernummer ein. Sie erscheinen auf Belegen und Bescheinigungen.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Erfasse deine Kunden im Tab „Leistungsempfänger“ des Unternehmens, um sie hier auszuwählen.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Trage deine beruflichen Daten (Name, Kammer und Nummer) unter \"Meine Daten\" ein, damit sie im Dokument stehen.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Trage deine beruflichen Daten (Name, Kammer und Nummer) unter \"Meine Daten\" ein, damit sie auf dem Beleg stehen.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Erfasse deine Patienten. Darin liegen die Termine mit Verlauf, Verordnung, Zahlung, Beleg und Bescheinigung für die Krankenversicherung.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Lege dich selbst und jedes Familienmitglied an. Darin liegen Arzttermine, Untersuchungen, Impfungen und Medikamente. Sensible Daten kommen in den verschlüsselten Tresor.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Registrierung wartet auf Freigabe: Deaktiviere \"Confirm email\" in Supabase (siehe COMO RODAR).",
 "Cadastro recebido": "Registrierung erhalten",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Registrierung: Name, CPF oder E-Mail, Passwort (nur in geschützter Form gespeichert) und Kontakt-E-Mail.",
 "Cadastros": "Stammdaten",
 "Cadastros e comprovantes": "Stammdaten und Belege",
 "Cadeira extensora": "Beinstrecker",
 "Café": "Kaffee",
 "Café da manhã": "Frühstück",
 "Café ou bar": "Café oder Bar",
 "Café?": "Kaffee?",
 "Cafés": "Cafés",
 "Caixa": "Karton",
 "Caixa arquivada": "Archivierte Box",
 "Caixa com checklist, lista ou texto livre": "Box mit Checkliste, Liste oder freiem Text",
 "Caixa {n}": "Karton {n}",
 "Caixas": "Kartons",
 "Caixas e cronograma da mudança.": "Kartons und Umzugsplan.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Kartons pro Zimmer mit Etikett, Ummeldung von Wasser, Strom und Internet, Übergaben und der Zeitplan der Tage.",
 "Calculadora": "Taschenrechner",
 "Calculando...": "Wird berechnet...",
 "Calendário": "Kalender",
 "Calendário da planta": "Pflanzenkalender",
 "Calendário do imposto": "Steuerkalender",
 "Calendários": "Kalender",
 "Calorias em atividade": "Aktivitätskalorien",
 "Calorias gastas em atividade (kcal)": "Bei Aktivität verbrannte Kalorien (kcal)",
 "Calça térmica (segunda pele)": "Thermohose (Funktionsunterwäsche)",
 "Calças ou bermudas": "Hosen oder Shorts",
 "Cama": "Bett",
 "Caminhada": "Spaziergang",
 "Caminhão": "Lkw",
 "Camisetas": "T-Shirts",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "Formularfelder",
 "Cancelada": "Storniert",
 "Canceladas": "Storniert",
 "Cancelar": "Abbrechen",
 "Cancelar a NFS-e": "NFS-e stornieren",
 "Cancelar a NFS-e {n}?": "NFS-e {n} stornieren?",
 "Cancelar a nota": "Rechnung stornieren",
 "Cancelar a reunião \"{nome}\"?": "Besprechung \"{nome}\" absagen?",
 "Cancelar reunião": "Besprechung absagen",
 "Caneta": "Stift",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Automatischer Abruf durch den Server: alle 2 Stunden, von 08:00 bis 20:00 Uhr",
 "Captura automática: todos os dias às 08h e 12h": "Automatische Erfassung: täglich um 08:00 und 12:00 Uhr",
 "Card": "Karte",
 "Cardápio": "Speiseplan",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Wochenspeiseplan, Rezepte, automatische Einkaufsliste und Haltbarkeit im Vorrat.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Speiseplan nur für diesen Tag. Die anderen Tage behalten den Wochenplan.",
 "Carga (kg)": "Gewicht (kg)",
 "Carimbo": "Stempel",
 "Carnaval": "Karneval",
 "Carne magra": "Mageres Fleisch",
 "Carregando feriados...": "Feiertage werden geladen...",
 "Carregando...": "Wird geladen...",
 "Carro": "Auto",
 "Carta": "Letter",
 "Carteira": "Geldbörse",
 "Carteira de trabalho": "Arbeitsbuch",
 "Carteira profissional (OAB, CRC, CREA...)": "Berufsausweis (OAB, CRC, CREA...)",
 "Cartão": "Karte",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Kontaktkarte in Nachrichten: das Foto, die Telefonnummer, die E-Mail und der Status, die du selbst angeben möchtest. Nur Personen, die mit dir chatten, deine Freunde und Personen, die eine App-Gruppe mit dir teilen, sehen sie.",
 "Cartão de crédito": "Kreditkarte",
 "Cartão de débito": "Debitkarte",
 "Cartão parcelado": "Kreditkarte in Raten",
 "Cartões": "Karten",
 "Cartões de visita": "Visitenkarten",
 "Cartões e dinheiro": "Karten und Bargeld",
 "Casa": "Zuhause",
 "Casa e rotina": "Haus und Alltag",
 "Casa, família e veículos": "Haus, Familie und Fahrzeuge",
 "Casaco leve": "Leichte Jacke",
 "Casaco pesado": "Warmer Mantel",
 "Casamento": "Hochzeit",
 "Castanhas": "Nüsse",
 "Categoria": "Kategorie",
 "Categoria de \"{d}\"": "Kategorie von „{d}“",
 "Categorias": "Kategorien",
 "Caução": "Kaution",
 "Ceia": "Spätmahlzeit",
 "Celular": "Handy",
 "Celular confirmado": "Handy bestätigt",
 "Celular e carregador": "Handy und Ladegerät",
 "Certidão": "Urkunde",
 "Certificado digital": "Digitales Zertifikat",
 "Certificado digital A1": "Digitales Zertifikat A1",
 "Certificado ligado": "Zertifikat verbunden",
 "Chamada": "Anwesenheit",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Anwesenheit an diesem Tag noch nicht erfasst. Tippe auf Fehlende oder bestätige, dass alle da sind.",
 "Chamada, notas, planos de aula e materiais.": "Anwesenheit, Noten, Unterrichtspläne und Materialien.",
 "Chamadas": "Anrufe",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "Audio- und Videoanrufe laufen über die Server von LiveKit, nur während des Anrufs und ohne Aufzeichnung.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "Audio- und Videoanrufe laufen über die Server von LiveKit, nur für die Dauer des Anrufs. Aufgezeichnet wird nur in Büro-Besprechungen, wenn der Administrator aufzeichnet, und die Datei wird direkt im Speicher der App abgelegt.",
 "Chamando...": "Ruft an...",
 "Chapéu ou boné": "Hut oder Kappe",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "KI-Schlüssel auf diesem Gerät nicht eingerichtet (Einstellungen › Künstliche Intelligenz).",
 "Chave de acesso": "Zugriffsschlüssel",
 "Check-in": "Check-in",
 "Check-in: {d} a partir das {h}": "Check-in: {d} ab {h}",
 "Check-in: {h} · {e}": "Check-in: {h} · {e}",
 "Check-out": "Check-out",
 "Check-out: {d} até as {h}": "Check-out: {d} bis {h}",
 "Check-out: {h} · {e}": "Check-out: {h} · {e}",
 "Checklist": "Checkliste",
 "Chinelo": "Flip-Flops",
 "Chá de bebê": "Babyparty",
 "Cidade": "Stadt",
 "Cidade (para a data dos recibos)": "Stadt (für das Datum der Belege)",
 "Cidade de {nome}": "Stadt {nome}",
 "Cidades": "Städte",
 "Cifrão": "Dollarzeichen",
 "Cinza": "Grau",
 "Cirurgia": "Operation",
 "Ciências": "Naturwissenschaften",
 "Clara": "Hell",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Hellt gescannte PDFs auf: weißer, grauer oder schwarz-weißer Hintergrund.",
 "Claro": "Hell",
 "Classificar categorias com IA": "Kategorien mit KI zuordnen",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT oder Gemini",
 "Cliente": "Kunde",
 "Clientes": "Kunden",
 "Clima esperado": "Erwartetes Wetter",
 "Co-anfitrião": "Co-Gastgeber",
 "Cobrança": "Forderung",
 "Cobranças": "Forderungen",
 "Coelho": "Kaninchen",
 "Cofre (criptografia de ponta a ponta)": "Tresor (Ende-zu-Ende-Verschlüsselung)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Tresor offen (schließt nach 5 Minuten Inaktivität von selbst)",
 "Cofre ainda não criado": "Tresor noch nicht erstellt",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Verschlüsselter Tresor für Ausweis, Führerschein, Reisepass, Verträge und Urkunden, mit Countdown bis zum Ablauf und Versand mit einem Tipp.",
 "Cofre fechado": "Tresor geschlossen",
 "Cofrinho": "Sparschwein",
 "Cole aqui a chave ({ini}...)": "Schlüssel hier einfügen ({ini}...)",
 "Cole o link (https://...)": "Link einfügen (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Füge den Barcode (oder den Pix-Copy-&-Paste-Code) in das Codefeld ein oder tippe ihn ein: Die App berechnet Betrag und Fälligkeit selbst. Mit eingeschalteter KI liest sie alles vom Foto.",
 "Coloca arquivos dentro do PDF.": "Legt Dateien in das PDF.",
 "Colocar na agenda": "In den Kalender eintragen",
 "Colocar na linha do tempo com alarme": "Mit Alarm in die Zeitleiste setzen",
 "Colocar no My Planner": "In My Planner eintragen",
 "Colocar rega e adubo na agenda": "Gießen und Düngen in den Kalender eintragen",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Trage den Monatsbeitrag bei der Klasse (Bearbeiten) oder beim Schüler ein. Bereits vorhandene Forderungen dieses Monats werden nicht doppelt erstellt.",
 "Coluna": "Spalte",
 "Colágeno": "Kollagen",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "Ist die Biometrie aktiv, erscheint sie zuerst. Klappt es nicht, nutze das Muster oder das Passwort.",
 "Com convênio": "Mit Versicherung",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "Mit Länder- und Ortsvorwahl. Z. B.: +55 41 99999-0000",
 "Com outras pessoas": "Bei anderen",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "Mit Frist berechnet die App, wie viel du pro Monat sparen musst. Gespartes Geld zählt im Monat als \"Gespart\".",
 "Com quem": "Mit wem",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Wer bezahlt hat, Patient, Datum und Betrag jedes bezahlten Termins. Als Privatperson trage jeden in der App Receita Federal › Receita Saúde ein; mit CNPJ stelle eine Dienstleistungsrechnung aus.",
 "Com valor a receber": "Mit offenem Betrag",
 "Com vencimento": "Mit Fälligkeit",
 "Combinado": "Abgemacht",
 "Combinado 👍": "Abgemacht 👍",
 "Combustível": "Kraftstoff",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Lege zuerst die festen Kosten des Monats (Miete, Strom, Internet) und deine Karte an. Ich erinnere dich vor jeder Fälligkeit.",
 "Comecei em": "Begonnen am",
 "Comentários": "Kommentare",
 "Começa amanhã": "Beginnt morgen",
 "Começa às {hora} (em {m} min)": "Beginnt um {hora} (in {m} Min.)",
 "Começar": "Starten",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Mit der Vorlage beginnen: Frühstück, Snack, Mittagessen, Snack und Abendessen",
 "Começar em": "Beginnen bei",
 "Começar o teste grátis": "Gratis-Test starten",
 "Comi outros alimentos ou quantidades": "Ich habe andere Lebensmittel oder Mengen gegessen",
 "Comida": "Essen",
 "Comidas e bebidas": "Essen und Trinken",
 "Comido": "Gegessen",
 "Comido / alterações": "Gegessen / Änderungen",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "Gegessen zählt die als erledigt markierten Mahlzeiten (oder mit Änderungen) bis heute.",
 "Comigo": "Bei mir",
 "Comissão da plataforma": "Plattformgebühr",
 "Como apagar a sua conta e os seus dados": "So löschst du dein Konto und deine Daten",
 "Como chegar": "Anfahrt",
 "Como ela está": "Wie es ihr geht",
 "Como estou comparado ao mês passado?": "Wie stehe ich im Vergleich zum Vormonat da?",
 "Como funciona": "So funktioniert's",
 "Como planejado": "Wie geplant",
 "Compartilhado no grupo": "In der Gruppe geteilt",
 "Compartilhado no grupo · só leitura": "In der Gruppe geteilt · nur lesen",
 "Compartilhamento indisponível neste dispositivo.": "Teilen ist auf diesem Gerät nicht verfügbar.",
 "Compartilhar": "Teilen",
 "Compartilhar PDF": "PDF teilen",
 "Compartilhar a limpeza": "Reinigung teilen",
 "Compartilhar os dados": "Daten teilen",
 "Compartilhar os dados com a equipe": "Daten mit dem Team teilen",
 "Compartilhar os dados com o grupo?": "Daten mit der Gruppe teilen?",
 "Compartilhar texto": "Text teilen",
 "Competência (mês de referência)": "Leistungszeitraum (Bezugsmonat)",
 "Competência {d}": "Zeitraum {d}",
 "Complemento": "Zusatz",
 "Complete seus dados": "Vervollständige deine Daten",
 "Compra": "Kauf",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Kauf und Verkauf von Immobilien, Fahrzeugen und Aktien, absetzbare Belege und der Steuerkalender.",
 "Compra feita": "Gekauft",
 "Compra no cartão": "Kartenkauf",
 "Compras": "Käufe",
 "Compras da semana": "Wocheneinkauf",
 "Comprimir": "Komprimieren",
 "Compromisso": "Termin",
 "Compromisso da escola": "Schultermin",
 "Comprovante": "Beleg",
 "Comprovante guardado": "Beleg gespeichert",
 "Comprovantes": "Belege",
 "Computador": "Computer",
 "Comédia": "Komödie",
 "Concedi": "Verliehen",
 "Concluir": "Erledigen",
 "Concluir (esquerda)": "Erledigen (links)",
 "Concluída": "Abgeschlossen",
 "Concluído": "Erledigt",
 "Concluído (%)": "Fertig (%)",
 "Concluído!": "Erledigt!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Ich stimme zu, dass mein Name, meine CPF und meine E-Mail nur zur Identifizierung meines Kontos verwendet werden und dass meine Aufgaben und Notizen darin gespeichert werden. Ich kann das Konto und alle Daten jederzeit unter Einstellungen › Sicherheit löschen.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "Ich stimme zu, dass mein Name, meine CPF und meine E-Mail nur zur Identifizierung meines Kontos verwendet werden und dass meine Aufgaben und Notizen darin gespeichert werden. Ich kann das Konto und alle Daten jederzeit in den Einstellungen löschen.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Ich bin einverstanden, dass mein Name, mein Ausweisdokument und meine E-Mail nur zur Identifizierung meines Kontos verwendet werden und dass meine Aufgaben und Notizen darin gespeichert werden. Ich kann das Konto und alle Daten jederzeit unter Einstellungen › Sicherheit löschen.",
 "Concursos": "Beamtenprüfungen",
 "Condicionador": "Spülung",
 "Condomínio": "Nebenkosten",
 "Condomínio e IPTU": "Hausgeld und Grundsteuer",
 "Conectado": "Verbunden",
 "Conectando...": "Verbinde...",
 "Conectar": "Verbinden",
 "Conectar navegador": "Browser verbinden",
 "Conectar o {nome}": "{nome} verbinden",
 "Conectar relógio ou app de saúde": "Uhr oder Gesundheits-App verbinden",
 "Conectar {nome}": "{nome} verbinden",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Verbinde {nome} unter Einstellungen › Google Drive und OneDrive.",
 "Conferindo...": "Wird geprüft...",
 "Conferir controles, chaves e Wi-Fi": "Fernbedienungen, Schlüssel und WLAN prüfen",
 "Conferir o prazo no sistema oficial": "Frist im offiziellen System prüfen",
 "Confete": "Konfetti",
 "Configuração geral": "Allgemeine Einstellungen",
 "Confira a senha da sua conta e tente de novo.": "Prüfe das Passwort deines Kontos und versuche es erneut.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Prüfe die offiziellen Termine auf der Website der Receita Federal und passe sie bei Bedarf an.",
 "Confira o código. Ele tem 6 letras e números.": "Prüfe den Code. Er hat 6 Buchstaben und Ziffern.",
 "Confira o e-mail ou deixe em branco.": "Prüfe die E-Mail oder lass das Feld leer.",
 "Confira o e-mail.": "Prüfe die E-Mail-Adresse.",
 "Confira o prazo no sistema oficial.": "Prüfe die Frist im offiziellen System.",
 "Confira os 11 números.": "Prüfe die 11 Ziffern.",
 "Confira os campos antes de salvar.": "Prüfe die Felder vor dem Speichern.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Prüfe, ob dein Google-Konto auf dem Handy hinzugefügt ist und der Kalender synchronisiert wird.",
 "Confirmada": "Bestätigt",
 "Confirmado": "Zugesagt",
 "Confirmar": "Bestätigen",
 "Confirme a declaração sobre a empresa.": "Bestätige die Erklärung zum Unternehmen.",
 "Confirme o seu celular": "Bestätige dein Handy",
 "Confirme para ativar a biometria": "Bestätige, um die Biometrie zu aktivieren",
 "Confirme para excluir": "Zum Löschen bestätigen",
 "Confirme sua senha para sincronizar": "Bestätige dein Passwort zum Synchronisieren",
 "Confraternização": "Feier",
 "Confraternização Universal": "Neujahr",
 "Conselho": "Kammer",
 "Consignado": "Lohnkredit",
 "Consulta": "Arzttermin",
 "Consulta ou vacina": "Termin oder Impfung",
 "Consultas": "Arzttermine",
 "Consultório": "Praxis",
 "Consumo médio: {v} km/L": "Durchschnittsverbrauch: {v} km/L",
 "Conta": "Konto",
 "Conta a pagar": "Zu zahlende Rechnung",
 "Conta a receber": "Offene Forderung",
 "Conta de consumo ou tributo": "Versorgerrechnung oder Steuer",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Zählt die Tage, an denen jeder Eintrag geplant war (nach seinen Wochentagen), und die, an denen er als erledigt markiert wurde.",
 "Conta paga": "Rechnung bezahlt",
 "Conta recebida": "Forderung erhalten",
 "Conta vence hoje": "Rechnung heute fällig",
 "Conta vencendo": "Rechnung bald fällig",
 "Contabilidade": "Buchhaltung",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "Inklusive Begleitpersonen. Tippe auf den Status eines Gastes, um ihn zu ändern.",
 "Contando: {cliente}": "Läuft: {cliente}",
 "Contas": "Zahlungen",
 "Contas a pagar": "Zu zahlen",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Rechnungen und Forderungen, Ausgaben des Monats, Fälligkeitserinnerungen und MEI-Verwaltung (Mestre Achado).",
 "Contas a receber": "Forderungen",
 "Contas fixas": "Fixkosten",
 "Contato": "Kontakt",
 "Contato de emergência": "Notfallkontakt",
 "Contato do encarregado de dados:": "Kontakt des Datenschutzbeauftragten:",
 "Conte a sua ideia para o app ficar melhor.": "Erzähl uns deine Idee, wie die App besser werden kann.",
 "Conte o que está difícil ou não funciona como deveria.": "Erzähl uns, was schwierig ist oder nicht richtig funktioniert.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Beschreibe, was du gemacht hast, was du erwartet hast und was angezeigt wurde. Falls es eine Fehlermeldung gibt, kopiere sie hierher.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Melde uns Probleme, Fehler und Verbesserungsideen. Deine Nachricht geht direkt an das My Planner-Team.",
 "Conteúdo": "Inhalt",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Inhalte, die du erstellst: Aufgaben, Notizen, Finanzen, Dokumente, Fotos, Anhänge und Daten der Tabs.",
 "Conteúdo, matéria, tarefa de casa...": "Inhalt, Fach, Hausaufgaben...",
 "Continuar": "Weiter",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Nutze My Planner und Notizen weiter für {preco} pro Jahr. Deine Daten bleiben gespeichert.",
 "Contratado": "Gebucht",
 "Contratado: {v}": "Gebucht: {v}",
 "Contrato": "Vertrag",
 "Conversa": "Chat",
 "Conversa do grupo": "Gruppenchat",
 "Conversar": "Chatten",
 "Conversar com o Mestre (precisa da sua IA)": "Mit dem Mestre sprechen (braucht deine KI)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Chatte mit Freunden und Gruppen und führe Audio- und Videoanrufe.",
 "Converter de PDF": "Aus PDF umwandeln",
 "Converter para PDF": "In PDF umwandeln",
 "Convidado": "Gast",
 "Convidados": "Gäste",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Gäste mit Zu- und Absagen, Dienstleister und der Ablaufplan für den großen Tag.",
 "Convidados e cronograma do dia, sem os valores.": "Gäste und Tagesablauf, ohne Beträge.",
 "Convidar": "Einladen",
 "Convidar pelo WhatsApp": "Über WhatsApp einladen",
 "Convite": "Einladung",
 "Convite copiado. Cole onde quiser enviar.": "Einladung kopiert. Füge sie dort ein, wo du sie senden willst.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Ungültige oder vom Admin geänderte Einladung. Bitte um einen neuen Link.",
 "Convite para o My Planner": "Einladung zu My Planner",
 "Convênio": "Versicherung",
 "Copiar": "Kopieren",
 "Copiar a lista para uma tarefa": "Liste in eine Aufgabe kopieren",
 "Copiar o código": "Code kopieren",
 "Copiar para hoje": "Nach heute kopieren",
 "Copo de outro tamanho": "Glas in anderer Größe",
 "Copo {n}": "Glas {n}",
 "Cor": "Farbe",
 "Cor do fichário": "Ordnerfarbe",
 "Cor do tema": "Designfarbe",
 "Cor do tema de cada aba": "Themenfarbe jedes Tabs",
 "Coração": "Herz",
 "Corações": "Herzen",
 "Cores das abas": "Tab-Farben",
 "Cores das conversas": "Chat-Farben",
 "Cores e opções desta aba": "Farben und Optionen dieses Tabs",
 "Corpo": "Körper",
 "Corporativo": "Firmenfeier",
 "Corpus Christi": "Fronleichnam",
 "Corredor": "Flur",
 "Correia dentada": "Zahnriemen",
 "Corrida": "Laufen",
 "Corta as bordas em branco ou partes da página.": "Schneidet leere Ränder oder Teile der Seite ab.",
 "Cortesia": "Gratis",
 "Coxa e sobrecoxa": "Hähnchenschenkel",
 "Cozinha": "Küche",
 "Creatina": "Kreatin",
 "Criada em {data}": "Erstellt am {data}",
 "Criado com": "Erstellt mit",
 "Criado em": "Erstellt am",
 "Criança": "Kind",
 "Crianças": "Kinder",
 "Criar": "Erstellen",
 "Criar animada": "Animiert erstellen",
 "Criar conta": "Konto erstellen",
 "Criar do zero": "Neu erstellen",
 "Criar documento, planilha ou apresentação": "Dokument, Tabelle oder Präsentation erstellen",
 "Criar em outro app": "In anderer App erstellen",
 "Criar escritório": "Büro erstellen",
 "Criar fichário": "Ordner erstellen",
 "Criar figurinha": "Sticker erstellen",
 "Criar grupo": "Gruppe erstellen",
 "Criar grupo e convidar pessoas": "Gruppe erstellen und Leute einladen",
 "Criar minha chave de API": "Meinen API-Schlüssel erstellen",
 "Criar o cofre": "Tresor erstellen",
 "Criar o grupo e convidar": "Gruppe erstellen und einladen",
 "Criar os prazos do IR de {ano}": "IR-Fristen für {ano} anlegen",
 "Criar uma meta (viagem, reserva, carro...)": "Ziel erstellen (Reise, Rücklage, Auto...)",
 "Criar uma senha nova": "Neues Passwort erstellen",
 "Criar {n} tarefa(s)": "{n} Aufgabe(n) erstellen",
 "Criação do Estado de MS": "Gründung des Bundesstaats MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Lege den Umzug an, und die App erstellt die Liste der Ummeldungen (Strom, Wasser, Internet...). Danach legst du die Kartons pro Zimmer, die Übergaben und den Zeitplan der Tage an.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Lege für jeden Kunden einen Ordner an, lade den Kunden per Link ein (er sieht nur seinen Ordner) und tauscht Dokumente in beide Richtungen aus: Rechnungen, Zahlscheine, Lohnabrechnung, Auszüge, Verträge.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Erstelle die Klasse (oder Mentoring-, Trainingsgruppe, Kurs) und darin Schüler, Anwesenheit, Noten, Unterrichtspläne, Materialien und Forderungen.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Lege die Klasse an und darin die Schüler, die Anwesenheit, die Leistungsnachweise mit Noten und die Unterrichtspläne.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Lege Haushaltsaufgaben (Bad putzen, Bettwäsche wechseln...) mit ihrer Häufigkeit an. Die App sagt dir, wenn sie überfällig sind, ohne My Planner zu überfüllen.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Erstelle Karten mit Checkliste, Liste, Freitext oder Zeichnung für dieses Fach. Nach rechts wischen zum Löschen, nach links zum Archivieren.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Erstelle das Büro, hol dein Team dazu (App-Freunde oder Einladung per Link) und tauscht Nachrichten und Dokumente aus, plant Besprechungen und haltet Videobesprechungen ab. Als Admin kannst du die Besprechungen aufnehmen.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Lege das Event an und darin die Gästeliste mit Zu- und Absagen, die Dienstleister und den Ablaufplan des Tages.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Erstelle die Gruppe und schick den Link: Wer beitritt, erhält Datum, Ort, Hinweise und alles, was du sendest, und kann zusagen, bearbeiten oder absagen.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Erstelle die Gruppe und schick den Link: Wer beitritt, sieht und macht mit, je nach der Rolle, die du wählst. Nur Admins fügen Personen hinzu oder entfernen sie.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Erstelle die Gruppe und schick den Link: Wer beitritt, sieht alles hier drin und macht mit (fügt hinzu, bearbeitet, lädt Fotos hoch). Nur Admins fügen Personen hinzu oder entfernen sie.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Erstelle dein Konto. Deine Daten werden in der Cloud und auf diesem Gerät gespeichert.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Erstelle einen Ordner (z. B. Promotion, Englisch, Prüfung) und darin die Fächer und Seiten.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Erstelle eine Gruppe (Klasse, Patienten, Team, Gäste, Kunden), teile den Einladungslink und sende Termine, Materialien und Hinweise. Jede Person nimmt an, bearbeitet oder lehnt ab, was sie erhält.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Erstelle ein Profil mit Namen und, wenn du Anwalt bist, der OAB.",
 "Criptografado no cofre, só neste dispositivo": "Im Tresor verschlüsselt, nur auf diesem Gerät",
 "Criptomoedas": "Kryptowährungen",
 "Cronograma": "Zeitplan",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "Essensplan, Körperpflege Schritt für Schritt und Wasser des Tages.",
 "Cronograma do dia": "Ablaufplan des Tages",
 "Cronograma físico-financeiro": "Bau- und Kostenzeitplan",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Bau- und Kostenzeitplan pro Abschnitt, Bautagebuch mit Vorher und Nachher, Handwerker und Lieferungen.",
 "Cronômetro de horas": "Stundenzähler",
 "Crédito empresarial": "Firmenkredit",
 "Créditos": "Guthaben",
 "Cuida das reservas, da limpeza e das despesas.": "Kümmert sich um Buchungen, Reinigung und Ausgaben.",
 "Cuidado": "Pflege",
 "Cuidado pessoal": "Körperpflege",
 "Cuidados": "Pflege",
 "Cupom do mercado": "Kassenbon",
 "Cupom do mercado (foto)": "Kassenbon (Foto)",
 "Cupom lançado": "Kassenbon erfasst",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "Kurs",
 "Cursos": "Kurse",
 "Cursos livres e certificações": "Kurse und Zertifizierungen",
 "Cuscuz": "Maiscouscous",
 "CÓDIGO PARA PAGAR": "ZAHLUNGSCODE",
 "CÔMODOS": "RÄUME",
 "Câmera": "Kamera",
 "Câmera e galeria": "Kamera und Galerie",
 "Câmera não liberada": "Kamera nicht freigegeben",
 "Código IBGE do município": "IBGE-Code der Gemeinde",
 "Código IBGE do município (7 números)": "IBGE-Code der Gemeinde (7 Ziffern)",
 "Código NBS (9 números, opcional)": "NBS-Code (9 Ziffern, optional)",
 "Código copiado": "Code kopiert",
 "Código da reserva (localizador)": "Buchungscode",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Barcode, Zahlencode oder Pix Copy & Paste (optional)",
 "Código de indicação": "Empfehlungscode",
 "Código de indicação (opcional)": "Empfehlungscode (optional)",
 "Código de quem convidou você": "Code der Person, die dich eingeladen hat",
 "Código de tributação nacional (6 números)": "Nationaler Steuercode (6 Ziffern)",
 "Código de tributação nacional (6 números, ex.: 171901)": "Nationaler Steuercode (6 Ziffern, z. B. 171901)",
 "Código do amigo": "Code des Freundes",
 "Código do convite": "Einladungscode",
 "Código do procedimento (TUSS ou do plano)": "Leistungscode (TUSS oder der Versicherung)",
 "Código errado. Confira e tente de novo.": "Falscher Code. Prüfe ihn und versuche es erneut.",
 "Código não encontrado. Confira as letras e os números.": "Code nicht gefunden. Prüfe Buchstaben und Ziffern.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Code nicht erkannt. Prüfe die Ziffern (Boleto: 47 oder 48 Ziffern).",
 "Código: {c}": "Code: {c}",
 "Cópia automática toda semana": "Automatische Sicherung jede Woche",
 "Cópia criada.": "Kopie erstellt.",
 "Cópia de segurança": "Sicherungskopie",
 "Cópia feita": "Sicherung erstellt",
 "Cópia restaurada.": "Sicherung wiederhergestellt.",
 "Cômodo": "Zimmer",
 "Cômodo ou quarto": "Zimmer oder Raum",
 "Cômodos da casa e as tarefas de cada um.": "Räume des Hauses und die Aufgaben jedes Raums.",
 "DAS de {mes} pago": "DAS für {mes} bezahlt",
 "DAS de {mes}: vence dia {dia}": "DAS für {mes}: fällig am {dia}.",
 "DAS do MEI": "DAS des MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "BEHANDLUNGSBESCHEINIGUNG",
 "DICA DO MESTRE ACHADO": "TIPP VON MESTRE ACHADO",
 "DPS nº {n}, série {s}": "DPS Nr. {n}, Serie {s}",
 "Da galeria ou dos arquivos": "Aus Galerie oder Dateien",
 "Da meta de passos": "Vom Schrittziel",
 "Dados compartilhados": "Geteilte Daten",
 "Dados compartilhados com o grupo": "Mit der Gruppe geteilte Daten",
 "Dados compartilhados · seu papel: {p}": "Geteilte Daten · deine Rolle: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "Gesundheitsdaten, die du selbst einträgst, werden nur für dich und für die Personen verarbeitet, mit denen du sie teilst, mit deiner Einwilligung (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Gerätedaten: Sprache, Land und Zeitzone (für Datum, Feiertage und Währung), Gerätemodell und die Kennung für Benachrichtigungen.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "Uhr- und Gesundheitsdaten werden nie für Werbung genutzt oder an Dritte weitergegeben. Du kannst die Verbindung jederzeit trennen und die Berechtigung widerrufen.",
 "Dança": "Tanzen",
 "Dar ciência": "Kenntnisnahme bestätigen",
 "Dar ciência da operação?": "Kenntnisnahme des Vorgangs bestätigen?",
 "Data": "Datum",
 "Data (embarque ou check-in)": "Datum (Abflug oder Check-in)",
 "Data agendada": "Geplantes Datum",
 "Data da aplicação": "Datum der Gabe",
 "Data da compra": "Kaufdatum",
 "Data da entrega": "Lieferdatum",
 "Data da venda": "Verkaufsdatum",
 "Data de nascimento": "Geburtsdatum",
 "Data do empréstimo": "Datum des Verleihs",
 "Data do pagamento": "Zahlungsdatum",
 "Data em que foi feita": "Durchgeführt am",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Vorgeschlagenes Datum mit 2 Werktagen Puffer. Prüfe es im offiziellen System.",
 "De": "Von",
 "De uma foto": "Aus einem Foto",
 "De {de} para {para} ({p}% menor).": "Von {de} auf {para} ({p} % kleiner).",
 "Declaração": "Erklärung",
 "Declaração de atendimento": "Behandlungsbescheinigung",
 "Declaração para reembolso (PDF)": "Bescheinigung zur Erstattung (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "Ich erkläre, dass dieses Unternehmen mir gehört oder einem Kunden, der die Überwachung genehmigt hat.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "Ich bescheinige zum Zweck der Erstattung{conv}, dass der/die Patient(in) {nome}{cpf}{cart} am {data}{hora} von mir behandelt wurde, im Rahmen von: {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Lege das Lektionsziel pro Tag oder Woche unter Bearbeiten fest.",
 "Defina a meta de páginas por dia em Editar.": "Lege das Seitenziel pro Tag unter Bearbeiten fest.",
 "Defina um horário": "Lege eine Uhrzeit fest",
 "Defina um horário para usar pausas.": "Lege eine Uhrzeit fest, um Pausen zu nutzen.",
 "Demaquilante ou água micelar": "Make-up-Entferner oder Mizellenwasser",
 "Demolição": "Abriss",
 "Demonstração": "Demo",
 "Dentista": "Zahnarzt",
 "Dependentes": "Unterhaltsberechtigte",
 "Depois": "Nachher",
 "Depois da aula": "Nach dem Unterricht",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Gelöschte Aufgaben lassen sich nicht wiederherstellen. Gib zur Bestätigung das Passwort deines Kontos ein.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "Öffne die Datei nach dem Download und tippe auf Installieren. Falls dein Handy fragt, erlaube die Installation von Apps aus dieser Quelle.",
 "Depois de criar": "Nach dem Erstellen",
 "Depois de {nome}. Toque para pular.": "Nach {nome}. Tippe zum Überspringen.",
 "Depois é só ajustar horários e o que comer em cada um.": "Danach musst du nur noch die Zeiten und das Essen für jede Mahlzeit anpassen.",
 "Desarquivar": "Aus Archiv holen",
 "Desbloquear": "Entsperren",
 "Desbloquear com": "Entsperren mit",
 "Desbloquear com biometria": "Mit Biometrie entsperren",
 "Desbloquear o My Planner": "My Planner entsperren",
 "Desbloqueio do app": "App-Entsperrung",
 "Descanso": "Pause",
 "Descartadas": "Verworfen",
 "Descartar": "Verwerfen",
 "Descartar este tempo?": "Diese Zeit verwerfen?",
 "Descobrir lugares em {d}": "Orte entdecken in {d}",
 "Desconectar": "Trennen",
 "Desconectar o {nome}?": "{nome} trennen?",
 "Desconto": "Rabatt",
 "Desconto de {v}": "Rabatt von {v}",
 "Descontos obtidos": "Erhaltene Rabatte",
 "Descrição": "Beschreibung",
 "Descrição (cliente, nota fiscal...)": "Beschreibung (Kunde, Rechnung...)",
 "Descrição do serviço (sai na nota)": "Leistungsbeschreibung (erscheint auf der Rechnung)",
 "Descrição que sai na nota": "Beschreibung auf der Rechnung",
 "Desenhar a assinatura": "Unterschrift zeichnen",
 "Desenhar com caneta ou dedo": "Mit Stift oder Finger zeichnen",
 "Desenhe a assinatura e escolha a página e o lugar.": "Zeichne die Unterschrift und wähle Seite und Position.",
 "Desenhe a assinatura primeiro.": "Zeichne zuerst die Unterschrift.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Zeichne mit dem Finger oder einem Stift (S Pen, Apple Pencil oder Tablet-Stift).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Zeichne mit dem Finger oder dem Stift. Um das Board zu scrollen, tippe auf Verschieben.",
 "Desenhe de novo para confirmar.": "Zeichne es zur Bestätigung noch einmal.",
 "Desenhe o seu padrão": "Zeichne dein Muster",
 "Desenhe pelo menos uma tarja.": "Zeichne mindestens einen Balken.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Zeichne ein Muster, das mindestens 4 Punkte verbindet.",
 "Desenho": "Zeichnung",
 "Desenho com caneta ou dedo": "Zeichnung mit Stift oder Finger",
 "Desenho incorreto": "Falsches Muster",
 "Desenho padrão": "Entsperrmuster",
 "Desenho padrão salvo.": "Entsperrmuster gespeichert.",
 "Desenvolvimento": "Schulterdrücken",
 "Desfazer": "Rückgängig",
 "Desfazer amizade": "Freundschaft beenden",
 "Desligar": "Ausschalten",
 "Desligar a sincronização?": "Synchronisierung ausschalten?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Wische zur Seite, um andere Tage zu sehen (bis zu 60 Tage im Voraus). Tippe auf eine Mahlzeit, um den Speiseplan nur für diesen Tag zu planen. Nach rechts ziehen zum Löschen.",
 "Desmarcado": "Abgesagt",
 "Desmarcar como recebida": "Als nicht erhalten markieren",
 "Desmarcar feita hoje": "Heute erledigt aufheben",
 "Desmarcar grupo": "Gruppe abwählen",
 "Desmarcar pagamento": "Zahlung zurücknehmen",
 "Desodorante": "Deo",
 "Despensa": "Vorratskammer",
 "Despesa": "Ausgabe",
 "Despesas": "Ausgaben",
 "Destino": "Reiseziel",
 "Detalhes": "Details",
 "Devolver até": "Zurückgeben bis",
 "Devolver: {i} ({p})": "Zurückgeben: {i} ({p})",
 "Devolvido": "Zurückgegeben",
 "Devolvidos": "Zurückgegeben",
 "Dia": "Tag",
 "Dia a dia": "Tag für Tag",
 "Dia da mudança": "Umzugstag",
 "Dia de vencimento do DAS": "Fälligkeitstag des DAS",
 "Dia do Trabalho": "Tag der Arbeit",
 "Dia do vencimento": "Fälligkeitstag",
 "Dia em que a fatura fecha": "Tag des Abrechnungsschlusses",
 "Dia planejado": "Geplanter Tag",
 "Dia {d} de {total}": "Tag {d} von {total}",
 "Diagnóstico": "Diagnose",
 "Dias e horários": "Tage und Uhrzeiten",
 "Dias específicos": "Bestimmte Tage",
 "Dias úteis": "Werktage",
 "Dias: {dias}": "Tage: {dias}",
 "Dicas e observações": "Tipps und Hinweise",
 "Diesel": "Diesel",
 "Diferença": "Differenz",
 "Digitado": "Manuell",
 "Digitar": "Eingeben",
 "Digitar à mão": "Manuell eingeben",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Gib das Tresor-Passwort ein. Er schließt nach 5 Minuten Inaktivität von selbst.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Gib Minuten (90) oder Stunden und Minuten (1:30 oder 01:30) ein und tippe auf OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Gib die Zeit im Format HH:MM ein, zum Beispiel 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Gib den Code ein und erhalte 10 Tage mit allen Tabs freigeschaltet. Wenn du keinen hast, lass das Feld leer.",
 "Digite o nome da tarefa.": "Gib den Namen der Aufgabe ein.",
 "Dinheiro": "Geld",
 "Dinheiro e documentos": "Geld und Dokumente",
 "Direita": "Rechts",
 "Direito": "Recht",
 "Direito Administrativo": "Verwaltungsrecht",
 "Direito Civil": "Zivilrecht",
 "Direito Constitucional": "Verfassungsrecht",
 "Direito Empresarial": "Handelsrecht",
 "Direito Penal": "Strafrecht",
 "Direito Tributário": "Steuerrecht",
 "Direito do Trabalho": "Arbeitsrecht",
 "Direto": "Direkt",
 "Disciplina": "Fach",
 "Dispensar": "Ausblenden",
 "Dispensar o aviso": "Hinweis ausblenden",
 "Dispensar todas": "Alle ausblenden",
 "Disponibilizada em": "Veröffentlicht am",
 "Disponível no app novo": "Verfügbar in der neuen App",
 "Distância": "Strecke",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Teile den Kurs in Fächer oder Module. Markiere in jedem, bei welcher Lektion du bist, und erstelle Notizkarten.",
 "Dividir": "Teilen",
 "Dividir entre (nenhum marcado = todos)": "Aufteilen auf (keiner markiert = alle)",
 "Divisão das despesas": "Kostenaufteilung",
 "Diária": "Übernachtung",
 "Diária padrão": "Standardpreis pro Nacht",
 "Diário": "Tagebuch",
 "Diários municipais": "Amtsblätter der Gemeinden",
 "Do celular, do Google Drive ou do OneDrive": "Vom Handy, von Google Drive oder OneDrive",
 "Do cliente": "Vom Kunden",
 "Do escritório": "Von der Kanzlei",
 "Doações": "Spenden",
 "Docs": "Doks",
 "Documento": "Dokument",
 "Documento (fundo branco)": "Dokument (weißer Hintergrund)",
 "Documento do veículo (CRLV)": "Fahrzeugschein (CRLV)",
 "Documento pessoal": "Persönliches Dokument",
 "Documento vence hoje": "Dokument läuft heute ab",
 "Documento vencendo": "Dokument läuft bald ab",
 "Documento: {o}": "Dokument: {o}",
 "Documentos": "Dokumente",
 "Documentos (contrato, nota, recibo...)": "Dokumente (Vertrag, Rechnung, Quittung...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Dokumente (Reisepass, Ausweis, Führerschein)",
 "Documentos e autorização das crianças": "Dokumente und Vollmacht der Kinder",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "Geschützte Dokumente, Befunde, Krankengeschichte und andere Felder mit 🔒 werden hier auf dem Gerät (AES-256) mit dem Tresor-Passwort verschlüsselt. Nicht einmal der Support kann sie lesen. Ohne das Passwort lassen sich diese Daten nicht wiederherstellen.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Dokumente, Belege, Hefte und Tafeln, mit mehreren Seiten",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Dokumente, Besprechungen und Aufnahmen werden für alle gelöscht. Der Chat bleibt in Nachrichten erhalten.",
 "Documentário": "Doku",
 "Doenças, cirurgias e observações": "Krankheiten, Operationen und Anmerkungen",
 "Dois dedos ou toque duplo para ampliar": "Mit zwei Fingern oder Doppeltippen vergrößern",
 "Domingo": "Sonntag",
 "Dono da obra": "Bauherr",
 "Dose": "Dosis",
 "Dose (ex.: 1 cápsula, 5 g)": "Dosis (z. B. 1 Kapsel, 5 g)",
 "Dose única": "Einzeldosis",
 "Drama": "Drama",
 "Duplicar": "Duplizieren",
 "Duplicar tarefa": "Aufgabe duplizieren",
 "Duração": "Dauer",
 "Duração de cada sessão": "Dauer jeder Einheit",
 "Duração {dur}": "Dauer {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "Kann ich mir etwas für 3.000 in 10 Raten leisten?",
 "Débito automático": "Lastschrift",
 "Débito, Pix ou dinheiro": "Debit, Pix oder bar",
 "Dê um nome ao cartão.": "Gib der Karte einen Namen.",
 "Dê um nome ao cuidado.": "Gib der Pflege einen Namen.",
 "Dê um nome ao cômodo.": "Gib dem Raum einen Namen.",
 "Dê um nome ao fichário.": "Gib dem Ordner einen Namen.",
 "Dê um nome ao grupo.": "Gib der Gruppe einen Namen.",
 "Dê um nome ao suplemento.": "Gib dem Nahrungsergänzungsmittel einen Namen.",
 "Dê um nome ao treino.": "Gib dem Training einen Namen.",
 "Dê um nome à conta.": "Gib der Rechnung einen Namen.",
 "Dê um nome à matéria.": "Gib dem Fach einen Namen.",
 "Dê um nome à meta.": "Gib dem Ziel einen Namen.",
 "Dê um nome à refeição.": "Gib der Mahlzeit einen Namen.",
 "Dê um nome à tarefa.": "Gib der Aufgabe einen Namen.",
 "E-MAIL (OPCIONAL)": "E-MAIL (OPTIONAL)",
 "E-mail": "E-Mail",
 "E-mail (recebe a nota)": "E-Mail (erhält die Rechnung)",
 "E-mail de contato": "Kontakt-E-Mail",
 "E-mail do responsável": "E-Mail der Erziehungsberechtigten",
 "E-mail inválido": "Ungültige E-Mail",
 "E-mail inválido.": "Ungültige E-Mail.",
 "E-mail ou WhatsApp para resposta (opcional)": "E-Mail oder WhatsApp für die Antwort (optional)",
 "E-mail para contato (opcional)": "Kontakt-E-Mail (optional)",
 "E-mail salvo.": "E-Mail gespeichert.",
 "EM ATRASO": "ÜBERFÄLLIG",
 "ENTRAR COM UM CÓDIGO": "MIT CODE BEITRETEN",
 "ENVIADOS": "GESENDET",
 "ESCOLHA AS ATIVIDADES": "WÄHLE DIE AKTIVITÄTEN",
 "ESTA SEMANA": "DIESE WOCHE",
 "EXERCÍCIO FÍSICO": "SPORT",
 "Economia": "Wirtschaft",
 "Edita tudo": "Bearbeitet alles",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Bearbeitet alles: Bauabschnitte, Budget, Tagebuch und Lieferungen.",
 "Editar": "Bearbeiten",
 "Editar cartão": "Karte bearbeiten",
 "Editar compra": "Kauf bearbeiten",
 "Editar cômodo": "Raum bearbeiten",
 "Editar desenho": "Zeichnung bearbeiten",
 "Editar documento": "Dokument bearbeiten",
 "Editar fichário": "Ordner bearbeiten",
 "Editar garantia": "Garantie bearbeiten",
 "Editar matéria": "Fach bearbeiten",
 "Editar meta": "Ziel bearbeiten",
 "Editar perfil": "Profil bearbeiten",
 "Editar tarefa": "Aufgabe bearbeiten",
 "Editar {nome}": "{nome} bearbeiten",
 "Educação": "Bildung",
 "Educação Física": "Sport",
 "Efeito de scanner": "Scanner-Effekt",
 "Ela sai da lista e dos Recebidos da equipe.": "Sie verschwindet aus der Liste und aus Erhalten des Teams.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "Er wird auch unter \"Meine Sticker\" gespeichert, damit du ihn erneut senden kannst.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "Sie kommt aus dem Tab Kredite & Finanzierungen. Markiere sie hier als bezahlt oder öffne den Tab, um den Vertrag zu sehen.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "Sie kommt aus dem Tab Rechnungen. Markiere sie als erhalten, sobald das Geld eingeht.",
 "Eleitorais": "Wahlgerichte",
 "Eletrodoméstico": "Haushaltsgerät",
 "Eletrodomésticos": "Haushaltsgeräte",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Haushaltsgeräte, Elektronik und Möbel: Rechnung, Kundendienst und Erinnerung 15 Tage vor Garantieende.",
 "Eletrônico": "Elektronik",
 "Elétrica": "Elektrik",
 "Elétrico": "Elektro",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "Füge unter Bearbeiten den Kalenderlink (iCal) des Inserats ein. Bei Airbnb: Kalender › Verfügbarkeit › Kalender verbinden › Kalender exportieren. Bei Booking: Preise und Verfügbarkeit › Kalender synchronisieren.",
 "Em aberto": "Offen",
 "Em alta": "Angesagt",
 "Em andamento": "In Arbeit",
 "Em atraso": "Überfällig",
 "Em branco": "Leer",
 "Em casa": "Zu Hause",
 "Em cima": "Oben",
 "Em construção": "Im Aufbau",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "Aktuell. Verbesserungen kommen automatisch, wenn die App startet.",
 "Em limpeza": "In Reinigung",
 "Em quais páginas": "Auf welchen Seiten",
 "Em qual agenda criar os eventos:": "In welchem Kalender sollen Termine erstellt werden:",
 "Em qual página e onde": "Auf welcher Seite und wo",
 "Em tratamento": "In Behandlung",
 "Em um horário específico": "Zu einer bestimmten Uhrzeit",
 "Em uso: {ia}": "Aktiv: {ia}",
 "Em {n} dia(s)": "In {n} Tag(en)",
 "Embaixo": "Unten",
 "Embaixo à esquerda": "Unten links",
 "Emissão": "Ausstellung",
 "Emissão +": "Ausstellung +",
 "Emissão: {data}": "Ausgestellt: {data}",
 "Emitida": "Ausgestellt",
 "Emitida em {data}": "Ausgestellt am {data}",
 "Emitida ou recebida": "Ausgestellt oder erhalten",
 "Emitidas": "Ausgestellt",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Ausgestellt: {v} · Erhalten: {r} · {n} Rechnung(en)",
 "Emitir": "Ausstellen",
 "Emitir NFS-e": "NFS-e ausstellen",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "NFS-e nach dem Padrão Nacional mit dem A1-Zertifikat ausstellen, ausgestellte und erhaltene Rechnungen suchen und XML, Tabelle und PDF exportieren.",
 "Emitir a nota de verdade?": "Rechnung wirklich ausstellen?",
 "Emitir no ambiente de teste?": "In der Testumgebung ausstellen?",
 "Emojis": "Emojis",
 "Emojis animados": "Animierte Emojis",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Animierte Emojis: Noto von Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Emojis, GIFs und Sticker",
 "Empresa": "Unternehmen",
 "Empresa de mudança": "Umzugsfirma",
 "Empresa ou pessoa": "Firma oder Person",
 "Empresa, hotel ou voo": "Firma, Hotel oder Flug",
 "Empresas": "Unternehmen",
 "Emprestei": "Verliehen",
 "Empréstimo": "Verleih",
 "Empréstimo entre pessoas": "Privatdarlehen",
 "Empréstimo pessoal": "Privatkredit",
 "Empréstimos": "Verleih",
 "Empréstimos & Financiamentos": "Kredite & Finanzierungen",
 "Encaminhada para {nome}.": "An {nome} weitergeleitet.",
 "Encaminhar": "Weiterleiten",
 "Encaminhar para": "Weiterleiten an",
 "Encerrar e salvar": "Beenden und speichern",
 "Encontrada para {perfil}": "Gefunden für {perfil}",
 "Endereço": "Adresse",
 "Endereço (opcional)": "Adresse (optional)",
 "Endereço (se for presencial)": "Adresse (bei Präsenz)",
 "Endereço atual": "Aktuelle Adresse",
 "Endereço da escola": "Adresse der Schule",
 "Endereço da oficina": "Adresse der Werkstatt",
 "Endereço de quem está com o item": "Adresse der Person mit dem Gegenstand",
 "Endereço do consultório": "Praxisadresse",
 "Endereço do imóvel": "Adresse der Immobilie",
 "Endereço do laboratório": "Adresse des Labors",
 "Endereço do veterinário": "Adresse des Tierarztes",
 "Endereço no trabalho e na escola": "Adresse bei Arbeit und Schule",
 "Endereço nos Correios e entregas": "Adresse bei der Post und für Lieferungen",
 "Endereço nos bancos e cartões": "Adresse bei Banken und Karten",
 "Endereço novo": "Neue Adresse",
 "Endereço ou nome do lugar": "Adresse oder Ortsname",
 "Endereço ou terminal": "Adresse oder Terminal",
 "Energia": "Energie",
 "Enfermeiro": "Pfleger",
 "Engenharia": "Ingenieurwesen",
 "Engenheiro ou arquiteto": "Ingenieur oder Architekt",
 "Enquadre o documento e toque no botão": "Dokument im Rahmen ausrichten und auf den Knopf tippen",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Richte dein Gesicht aus und tippe auf den Knopf. 🔄 dreht die Kamera.",
 "Ensino Fundamental": "Grund- und Mittelstufe",
 "Ensino Médio e ENEM": "Oberstufe und ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "Ich habe verstanden und stimme zu, den Monitor unter diesen Bedingungen zu nutzen.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Landet direkt im Planner, mit Uhrzeit, Tagen und der Liste der Einträge. Ist die Uhrzeit schon belegt, entscheidest du: ersetzen, beide behalten oder abbrechen.",
 "Entrada": "Einnahme",
 "Entrada (imóvel novo)": "Einzug (neue Wohnung)",
 "Entrada de dinheiro": "Geldeingang",
 "Entrando...": "Anmeldung...",
 "Entrar": "Anmelden",
 "Entrar com CPF e senha": "Mit CPF und Passwort anmelden",
 "Entrar com outra conta": "Mit einem anderen Konto anmelden",
 "Entrar de novo": "Erneut anmelden",
 "Entrar na chamada": "Anruf beitreten",
 "Entrar na reunião": "Meeting beitreten",
 "Entrar na sala online": "Online-Raum betreten",
 "Entrar no grupo": "Gruppe beitreten",
 "Entrar no navegador?": "Im Browser anmelden?",
 "Entre com seu CPF e sua senha.": "Melde dich mit deiner CPF und deinem Passwort an.",
 "Entre com seu e-mail e sua senha.": "Melde dich mit deiner E-Mail und deinem Passwort an.",
 "Entre na sua conta de novo.": "Melde dich erneut an.",
 "Entre na sua conta para usar as notas fiscais.": "Melde dich an, um die Rechnungen zu nutzen.",
 "Entre no app com o seu e-mail e a senha nova.": "Melde dich mit deiner E-Mail und dem neuen Passwort in der App an.",
 "Entrega de material": "Materiallieferung",
 "Entrega prevista": "Geplante Lieferung",
 "Entregas": "Lieferungen",
 "Entregue": "Geliefert",
 "Entrou": "Rein",
 "Entrou no total da semana.": "Zur Wochensumme hinzugefügt.",
 "Enviada": "Gesendet",
 "Enviado": "Gesendet",
 "Enviado para o Planner": "An den Planner gesendet",
 "Enviado pelo cliente": "Vom Kunden gesendet",
 "Enviado pelo escritório": "Von der Kanzlei gesendet",
 "Enviado por {quem} no grupo {g}": "Gesendet von {quem} in der Gruppe {g}",
 "Enviando {f} de {n}...": "Hochladen {f} von {n}...",
 "Enviando...": "Wird gesendet...",
 "Enviar": "Senden",
 "Enviar \"{nome}\"": "„{nome}“ senden",
 "Enviar \"{nome}\" para…": "\"{nome}\" senden an…",
 "Enviar \"{titulo}\" para": "\"{titulo}\" senden an",
 "Enviar ao grupo": "An Gruppe senden",
 "Enviar convite": "Einladung senden",
 "Enviar convite para {nome}": "Einladung an {nome} senden",
 "Enviar convite pelo WhatsApp": "Einladung per WhatsApp senden",
 "Enviar documento": "Dokument senden",
 "Enviar instruções ao hóspede": "Anleitung an den Gast senden",
 "Enviar o convite": "Einladung senden",
 "Enviar ou copiar o código": "Code senden oder kopieren",
 "Enviar ou imprimir a etiqueta": "Etikett senden oder drucken",
 "Enviar para Estudos": "An Lernen senden",
 "Enviar para My Planner": "An My Planner senden",
 "Enviar para a equipe": "An das Team senden",
 "Enviar para o My Planner": "An My Planner senden",
 "Enviar para o Planner": "An den Planner senden",
 "Enviar para o grupo": "An die Gruppe senden",
 "Enviar para o grupo de estudos": "An die Lerngruppe senden",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Die {n} Datei(en) dieses Geräts an {nome} senden",
 "Enviar para um grupo": "An eine Gruppe senden",
 "Enviar para {g}": "An {g} senden",
 "Enviar para…": "Senden an…",
 "Enviar por e-mail": "Per E-Mail senden",
 "Enviar relatório": "Bericht senden",
 "Enviar relatório para a equipe": "Bericht an das Team senden",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Auch vorhandene Aufgaben senden (ab heute)",
 "Enviar tarefas do My Planner para a agenda": "Aufgaben aus My Planner an den Kalender senden",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Sende Zahlscheine, Rechnungen und Berichte an den Kunden oder sieh dir an, was er geschickt hat. Jedes Dokument kann Fotos, PDFs und Links enthalten.",
 "Enxaguante": "Mundspülung",
 "Episódio": "Folge",
 "Equipe": "Team",
 "Equipe ({n})": "Team ({n})",
 "Equipe de limpeza": "Reinigungsteam",
 "Equipe do consultório": "Praxisteam",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Team der Unterkunft (Reinigung und Co-Host)",
 "Erro": "Fehler",
 "Erro na emissão": "Fehler bei der Ausstellung",
 "Erro: {erro}": "Fehler: {erro}",
 "Erros registrados neste dispositivo ({n})": "Auf diesem Gerät erfasste Fehler ({n})",
 "Escanear documento": "Dokument scannen",
 "Escanear o verso": "Rückseite scannen",
 "Escanear para PDF": "Als PDF scannen",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Scanne Dokumente, Belege, Hefte und Tafeln: Ränder und Schatten korrigiert, mehrere Seiten, Ausweis Vorder- und Rückseite, Unterschrift und PDF gespeichert auf dem Handy, in Google Drive oder in OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Scanne, mach das Bild klarer, sortiere in Ordner und schick das PDF per WhatsApp, E-Mail oder Drive. Mit deiner KI aktiviert liest die App den Text, fasst ihn zusammen und beantwortet Fragen zum Dokument.",
 "Escola": "Schule",
 "Escolha a aba:": "Wähle den Tab:",
 "Escolha a data do compromisso.": "Wähle das Datum des Termins.",
 "Escolha a imagem.": "Wähle das Bild.",
 "Escolha a matéria": "Fach wählen",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Wähle den Ordner auf dem Handy (z. B. Dokumente). Die App speichert dort automatisch.",
 "Escolha a página": "Seite wählen",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Wähle mindestens ein Gericht oder markiere \"Alle Gerichte\".",
 "Escolha ao menos uma agenda.": "Wähle mindestens einen Kalender.",
 "Escolha o PDF": "PDF wählen",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Wähle die .pfx- (oder .p12-)Datei des A1-Zertifikats des Unternehmens und gib sein Passwort ein. Es wird verschlüsselt in deinem Tresor gespeichert.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Wähle die .xml-Datei der NFS-e, NF-e oder CT-e.",
 "Escolha o fichário": "Ordner wählen",
 "Escolha o grupo para enviar: {t}": "Wähle die Gruppe zum Senden: {t}",
 "Escolha os PDFs": "PDFs wählen",
 "Escolha os arquivos.": "Wähle die Dateien.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Wähle die Feiertage, die im Planner und unter 🎉 Feiertage erscheinen.",
 "Escolha para quem enviar.": "Wähle, an wen gesendet wird.",
 "Escolha pelo menos um dia.": "Wähle mindestens einen Tag.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Wähle mindestens eine Seite, die es im PDF gibt (z. B. 1-3, 5).",
 "Escolha quem participa:": "Wähle, wer teilnimmt:",
 "Escolher": "Wählen",
 "Escolher a imagem": "Bild wählen",
 "Escolher a pasta": "Ordner wählen",
 "Escolher agendas": "Kalender auswählen",
 "Escolher alimento": "Lebensmittel wählen",
 "Escolher arquivo": "Datei wählen",
 "Escolher arquivos": "Dateien wählen",
 "Escolher arquivos do Drive ou do OneDrive": "Dateien aus Drive oder OneDrive auswählen",
 "Escolher as imagens e criar o PDF": "Bilder wählen und PDF erstellen",
 "Escolher da galeria": "Aus Galerie wählen",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Aus Galerie oder Datei wählen (Foto oder PDF)",
 "Escolher data": "Datum wählen",
 "Escolher fuso": "Zeitzone wählen",
 "Escolher hora": "Uhrzeit wählen",
 "Escolher horário": "Uhrzeit wählen",
 "Escolher o certificado": "Zertifikat wählen",
 "Escolher outro": "Anderes wählen",
 "Escolher pessoas": "Personen auswählen",
 "Escolher tribunais": "Gerichte auswählen",
 "Escolher ícone": "Symbol wählen",
 "Esconder da equipe (só administradores)": "Vor dem Team verbergen (nur Admins)",
 "Esconder detalhes": "Details ausblenden",
 "Esconder o texto completo": "Volltext ausblenden",
 "Escondido de {n} pessoa(s)": "Verborgen vor {n} Person(en)",
 "Escondido de: {n}": "Verborgen vor: {n}",
 "Escondidos no Planner.": "Im Planner ausgeblendet.",
 "Escova e pasta de dente": "Zahnbürste und Zahnpasta",
 "Escovar os dentes": "Zähne putzen",
 "Escreva aqui": "Hier schreiben",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Schreiben und Enter drücken (z. B. Waschmaschine reinigen)",
 "Escreva em uma ou em todas as páginas.": "Schreib auf eine oder alle Seiten.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Schreib den Grund unter „Stornogrund“ in der Rechnungsakte (mindestens 15 Buchstaben) und tippe hier erneut.",
 "Escreva o resumo, tópicos, dúvidas...": "Schreib die Zusammenfassung, Themen, Fragen...",
 "Escreva o texto da marca d'água.": "Gib den Text für das Wasserzeichen ein.",
 "Escreva o texto.": "Gib den Text ein.",
 "Escreva o título.": "Gib den Titel ein.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Schreib oder füge den Text ein. Eine Zeile mit \"# \" am Anfang wird zur Überschrift.",
 "Escreva ou cole um texto e gere o PDF.": "Schreib oder füge einen Text ein und erstelle das PDF.",
 "Escritório": "Büro",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Büro: Dokumente und Besprechungen des Teams. Nur der Administrator des Büros kann eine Besprechung aufzeichnen, und alle Teilnehmenden sehen während der Aufzeichnung den Hinweis „Aufnahme läuft“. Die Aufzeichnung wird in den Dokumenten des Büros gespeichert und ist nur für den Administrator sichtbar, bis er sie für das Team freigibt.",
 "Escuro": "Dunkel",
 "Espanhol": "Spanisch",
 "Espaço": "Unterkunft",
 "Espaço livre, dados de cada aba e anexos": "Freier Speicher, Daten jedes Tabs und Anhänge",
 "Especialidade": "Fachrichtung",
 "Espécie": "Tierart",
 "Esquadro": "Geodreieck",
 "Esqueci a senha": "Passwort vergessen",
 "Esquerda": "Links",
 "Esse código é o seu.": "Das ist dein eigener Code.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "Das ist dein eigener Code. Nutze den Code der Person, die dir die App empfohlen hat.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "Diese Adresse hat nicht wie ein Rechnungsserver geantwortet. Prüfe sie und versuch es erneut.",
 "Esta aba ainda não está no seu plano.": "Dieser Tab ist noch nicht in deinem Plan.",
 "Esta e todas as futuras": "Diese und alle zukünftigen",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "Dieses Werkzeug muss die PDF-Seiten sehen, das kommt mit der neuen App (Version 0.50). Nutze den Browser oder installiere die neue APK.",
 "Esta imagem foi guardada em outro dispositivo.": "Dieses Bild wurde auf einem anderen Gerät gespeichert.",
 "Esta janela pode ser fechada.": "Du kannst dieses Fenster schließen.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "Diese Person hat ihre Kontaktkarte noch nicht ausgefüllt.",
 "Esta semana: {a} de {m} aulas ({p}%)": "Diese Woche: {a} von {m} Lektionen ({p}%)",
 "Esta senha é de outra conta.": "Dieses Passwort gehört zu einem anderen Konto.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "Diese Aufgabe hat keine Uhrzeit: \"Zu Beginn\" und \"Vor dem Beginn\" gelten nicht. Verwende \"Zu einer bestimmten Uhrzeit\".",
 "Esta tarefa se repete. O que excluir?": "Diese Aufgabe wiederholt sich. Was soll gelöscht werden?",
 "Esta tela teve um problema": "Dieser Bildschirm hatte ein Problem",
 "Estado (UF) do registro": "Bundesstaat (UF) der Registrierung",
 "Estado de Mato Grosso do Sul": "Bundesstaat Mato Grosso do Sul",
 "Estado de São Paulo": "Bundesstaat São Paulo",
 "Estado do Paraná": "Bundesstaat Paraná",
 "Estados": "Bundesstaaten",
 "Estaduais": "Landesgerichte",
 "Estadual": "Bundesstaat",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "Diese Tabs erscheinen unten in der Leiste, in dieser Reihenfolge. My Planner, Tabs und Einstellungen sind immer dabei. Die anderen bleiben hier im Bildschirm Tabs.",
 "Estatística": "Statistik",
 "Este CPF já tem cadastro. Use \"Entrar\".": "Diese CPF ist bereits registriert. Verwende \"Anmelden\".",
 "Este PDF está no dispositivo onde foi aberto.": "Dieses PDF ist auf dem Gerät, auf dem es geöffnet wurde.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "Dieses PDF ist auf dem Gerät, auf dem es geöffnet wurde. Öffne es dort oder öffne die in Drive oder OneDrive gespeicherte Kopie erneut.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "Dieses PDF ist passwortgeschützt. Entferne das Passwort in dem Programm, mit dem es erstellt wurde, und versuch es noch mal.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "Dieses PDF hat keine Formularfelder. Nutze \"Text hinzufügen\", um darauf zu schreiben.",
 "Este ano": "Dieses Jahr",
 "Este dispositivo": "Dieses Gerät",
 "Este dispositivo não consegue abrir o arquivo.": "Dieses Gerät kann die Datei nicht öffnen.",
 "Este dispositivo não consegue compartilhar arquivos.": "Dieses Gerät kann keine Dateien teilen.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "Dieses Gerät hat keine Gesundheitsdaten. Du kannst sie manuell eingeben.",
 "Este arquivo foi guardado em outro dispositivo.": "Diese Datei wurde auf einem anderen Gerät gespeichert.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "Diese Datei wurde auf dem Handy gespeichert. Öffne sie in der App auf dem Handy.",
 "Este arquivo não é um backup do My Planner.": "Diese Datei ist kein Backup von My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "Dieses Handy erhält bei geschlossener App noch keine Benachrichtigungen. Installiere die App {v} oder neuer (APK mit Server-Benachrichtigungen). Bei geöffneter App funktionieren die Benachrichtigungen bereits.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "Dieses Zertifikat gehört zu {doc}, nicht zur CNPJ/CPF des Unternehmens ({emp}).",
 "Este fichário ainda não tem matérias.": "Dieser Ordner hat noch keine Fächer.",
 "Este grupo já está cheio.": "Diese Gruppe ist bereits voll.",
 "Este mês": "Diesen Monat",
 "Este mês: emitidas {e} · recebidas {r}": "Diesen Monat: ausgestellt {e} · erhalten {r}",
 "Este mês: {h}": "Diesen Monat: {h}",
 "Este navegador": "Dieser Browser",
 "Este país só tem feriados nacionais.": "Dieses Land hat nur nationale Feiertage.",
 "Esteira": "Laufband",
 "Esteticista": "Kosmetikerin",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "Ich nutze My Planner, um meinen Kalender, meine Finanzen und vieles mehr zu organisieren. Lade die App herunter und nutze beim Erstellen deines Kontos meinen Code {codigo}, um 10 Tage mit allen Tabs freigeschaltet zu bekommen.",
 "Estratégia": "Strategie",
 "Estrela": "Stern",
 "Estudando": "Lerne gerade",
 "Estudar agora": "Jetzt lernen",
 "Estudar {nome}": "{nome} lernen",
 "Estudar: {c}": "Lernen: {c}",
 "Estudo": "Studium",
 "Estudos": "Lernen",
 "Estudos e exatas": "Lernen und Naturwissenschaften",
 "Estudos, lazer e viagens": "Lernen, Freizeit und Reisen",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "Liegt unter Vermögen & Einkommensteuer › Absetzbare Belege. Öffne es dort, um das Foto des Belegs und die CPF oder CNPJ des Empfängers anzuhängen.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "Sie ist auf der Seite \"{titulo}\" und unter \"Dateien ansehen\".",
 "Etanol": "Ethanol",
 "Etapa": "Abschnitt",
 "Etapa do cronograma": "Abschnitt im Zeitplan",
 "Etapas": "Abschnitte",
 "Evento": "Event",
 "Eventos": "Events",
 "Eventos & Celebrações": "Events & Feiern",
 "Evolução (no cofre)": "Verlauf (im Tresor)",
 "Ex.: 08:00 e 20:00": "Z. B.: 08:00 und 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "Z. B.: 08:00, 14:00 und 20:00",
 "Ex.: 09/2026": "z. B. 09/2026",
 "Ex.: 1 comprimido": "Z. B.: 1 Tablette",
 "Ex.: 1-3, 4-10, 11-": "Z. B. 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "Z. B. 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "z. B. 171901 (Beratung), 010101 (Programmierung)",
 "Ex.: 40 sacos de cimento": "Z. B.: 40 Sack Zement",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "z. B. 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "Z. B.: 8b",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "Z. B.: Lendendehnung, Diät 1.800 kcal",
 "Ex.: Aniversário de 30 anos da Ana": "Z. B.: Anas 30. Geburtstag",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "Z. B.: Strandwohnung, Suite 1, Nebengebäude",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "Z. B.: Wohnung in der Straße X, 100 Aktien PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "Z. B.: Wiederholungsstunde, Kontrolltermin",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "Z. B.: Catering, DJ, Deko, Fotograf",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "Z. B. VERTRAULICH, KOPIE, ENTWURF",
 "Ex.: Cardiologista": "Z. B.: Kardiologe",
 "Ex.: Consultoria mensal": "z. B. Monatliche Beratung",
 "Ex.: Costela-de-adão da sala": "Z. B.: Monstera im Wohnzimmer",
 "Ex.: DAS de setembro, Extrato do Itaú": "z. B. DAS September, Kontoauszug Itaú",
 "Ex.: Desmontar os móveis do quarto": "Z. B.: Schlafzimmermöbel abbauen",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "Z. B.: Verfügbar · Bis 18 Uhr im Unterricht · Ab in den Urlaub!",
 "Ex.: Eletricista, loja de material": "Z. B.: Elektriker, Baumarkt",
 "Ex.: Entrada dos noivos": "Z. B.: Einzug des Brautpaars",
 "Ex.: Financiamento do carro": "Z. B.: Autofinanzierung",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "Z. B.: Physiotherapeut, Ernährungsberater, Kardiologe",
 "Ex.: Furadeira, livro, R$ 200": "Z. B.: Bohrmaschine, Buch, 200 €",
 "Ex.: Hemograma": "Z. B.: Blutbild",
 "Ex.: IPVA 2027, parcela 1": "Z. B.: IPVA 2027, Rate 1",
 "Ex.: Lisboa, Portugal": "Z. B.: Lissabon, Portugal",
 "Ex.: Mala da Ana": "Z. B.: Anas Koffer",
 "Ex.: Mensalidade de outubro, material": "Z. B.: Monatsbeitrag Oktober, Material",
 "Ex.: Netflix, cinema": "Z. B.: Netflix, Kino",
 "Ex.: Notas de compra de setembro": "z. B. Einkaufsrechnungen September",
 "Ex.: Onix 2022": "Z. B.: Golf 2022",
 "Ex.: Prova 1, Trabalho em grupo": "Z. B.: Klassenarbeit 1, Gruppenarbeit",
 "Ex.: Prova de matemática": "Z. B.: Mathearbeit",
 "Ex.: Pôr do sol no Tejo": "z. B. Sonnenuntergang am Tejo",
 "Ex.: Reforma da cozinha": "Z. B.: Küchenrenovierung",
 "Ex.: TAP TP 108": "Z. B.: TAP TP 108",
 "Ex.: Torre de Belém": "Z. B.: Torre de Belém",
 "Ex.: Troca da fiação da sala": "Z. B.: Neue Leitungen im Wohnzimmer",
 "Ex.: V10, antirrábica": "Z. B.: SHPPi+L, Tollwut",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "Z. B.: Besuch im Hieronymus-Kloster",
 "Ex.: cerâmica 30 cm": "Z. B.: Fliesen 30 cm",
 "Ex.: kg, pacotes, latas": "Z. B.: kg, Packungen, Dosen",
 "Ex.: seg e qua, 07:30": "Z. B.: Mo und Mi, 07:30",
 "Ex.: troquei o arroz por batata doce": "Z. B. Reis gegen Süßkartoffel getauscht",
 "Ex.: varanda, sala": "Z. B.: Balkon, Wohnzimmer",
 "Exame": "Untersuchung",
 "Exame da OAB": "OAB-Prüfung",
 "Exames": "Untersuchungen",
 "Excel": "Excel",
 "Excluir": "Löschen",
 "Excluir \"{nome}\"?": "\"{nome}\" löschen?",
 "Excluir \"{titulo}\"?": "\"{titulo}\" löschen?",
 "Excluir a caixa?": "Box löschen?",
 "Excluir a compra": "Kauf löschen",
 "Excluir a compra?": "Kauf löschen?",
 "Excluir a meta \"{m}\"?": "Ziel \"{m}\" löschen?",
 "Excluir cartão": "Karte löschen",
 "Excluir conta": "Rechnung löschen",
 "Excluir cuidado": "Pflege löschen",
 "Excluir cômodo": "Raum löschen",
 "Excluir esta página?": "Diese Seite löschen?",
 "Excluir fichário": "Ordner löschen",
 "Excluir matéria": "Fach löschen",
 "Excluir o cartão \"{c}\"?": "Karte \"{c}\" löschen?",
 "Excluir o documento": "Dokument löschen",
 "Excluir o fichário {nome}": "Ordner {nome} löschen",
 "Excluir página": "Seite löschen",
 "Excluir refeição": "Mahlzeit löschen",
 "Excluir suplemento": "Nahrungsergänzung löschen",
 "Excluir tarefa": "Aufgabe löschen",
 "Excluir tarefa repetida": "Wiederkehrende Aufgabe löschen",
 "Excluir tarefa?": "Aufgabe löschen?",
 "Excluir treino": "Training löschen",
 "Excluir {nome}?": "{nome} löschen?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Werden 30 Tage nach dem Verwerfen endgültig gelöscht.",
 "Executivo e profissional": "Business und professionell",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Vertragserfüllung (art. 7º, V), um den Dienst bereitzustellen; Einwilligung (art. 7º, I) für Kamera, Galerie, Mikrofon und Standort; Erfüllung einer rechtlichen Verpflichtung (art. 7º, II); und berechtigtes Interesse (art. 7º, IX) für Sicherheit und Betrugsprävention.",
 "Exemplos: 13:30, 1330, 9:05": "Beispiele: 13:30, 1330, 9:05",
 "Exercício": "Training",
 "Exercício físico": "Sport",
 "Experimente grátis por {n} dias": "{n} Tage gratis testen",
 "Explique o motivo (para cancelar)": "Grund angeben (zum Stornieren)",
 "Exportar arquivo": "Datei exportieren",
 "Exportar para o contador": "Für den Steuerberater exportieren",
 "Extrair páginas": "Seiten extrahieren",
 "Extras (pet, check-in tardio...)": "Extras (Haustier, später Check-in...)",
 "Extrato": "Kontoauszug",
 "Extrato bancário": "Kontoauszug",
 "Extrato do banco (foto ou PDF)": "Kontoauszug (Foto oder PDF)",
 "Extrato importado": "Kontoauszug importiert",
 "Extrato por foto": "Kontoauszug per Foto",
 "FRASE": "STATUS",
 "FRÁGIL": "ZERBRECHLICH",
 "Fabricante ou estendida: {n} meses": "Hersteller- oder erweiterte Garantie: {n} Monate",
 "Facultativo": "Optional",
 "Falar com a limpeza": "Mit der Reinigung sprechen",
 "Fale conosco": "Kontakt",
 "Falta": "Fehlt",
 "Falta XML": "XML fehlt",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "Der Rechnungsserver ist noch nicht verbunden: Doppelklicke am Computer auf 13-LIGAR-NOTAS.bat und füge hier die angezeigte Adresse ein.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect fehlt, die Google-App, die Daten von Uhren und Gesundheits-Apps bündelt.",
 "Faltam": "Offen",
 "Faltam {ml} ({n} copo(s))": "Noch {ml} ({n} Glas/Gläser)",
 "Faltam {n} dia(s) do seu período grátis": "Noch {n} Tag(e) deines Gratis-Zeitraums",
 "Faltam {n} dias": "Noch {n} Tage",
 "Faltou": "Nicht erschienen",
 "Família": "Familie",
 "Fantasia": "Fantasy",
 "Fatura": "Abrechnung",
 "Fatura com vencimento em {d}.": "Abrechnung fällig am {d}.",
 "Fatura de {mes}": "Abrechnung {mes}",
 "Fatura de {mes}: vence {data}": "Abrechnung {mes}: fällig am {data}",
 "Fatura do cartão (foto ou PDF)": "Kartenabrechnung (Foto oder PDF)",
 "Fatura importada": "Abrechnung importiert",
 "Fatura paga (toque para desfazer)": "Abrechnung bezahlt (tippen zum Rückgängigmachen)",
 "Fatura {c}": "Abrechnung {c}",
 "Faturamento em {ano}: {v} de {lim}": "Umsatz {ano}: {v} von {lim}",
 "Faturas dos cartões": "Kartenabrechnungen",
 "Fazer agora, passo a passo": "Jetzt machen, Schritt für Schritt",
 "Fazer com este PDF": "Mit diesem PDF",
 "Fazer cópia agora": "Jetzt sichern",
 "Fecha dia {f} · vence dia {v}": "Abschluss am {f}. · fällig am {v}.",
 "Fecha {f} · vence {v}": "Schluss {f} · fällig {v}",
 "Fechar": "Schließen",
 "Fechar o cofre": "Tresor schließen",
 "Feche e abra o app de novo": "Schließe die App und öffne sie erneut",
 "Federais": "Bundesgerichte",
 "Feijão": "Bohnen",
 "Feita em {data}": "Erledigt am {data}",
 "Feita hoje": "Heute erledigt",
 "Feitas": "Erledigt",
 "Feitas (não se repetem) · {n}": "Erledigt (einmalig) · {n}",
 "Feito": "Erledigt",
 "Feito!": "Erledigt!",
 "Feliz aniversário": "Alles Gute zum Geburtstag",
 "Feminino": "Weiblich",
 "Feminino e suave": "Weiblich und sanft",
 "Feriado escolar": "Schulfrei",
 "Feriado estadual": "Landesfeiertag",
 "Feriado estadual: {nome}": "Feiertag im Bundesstaat: {nome}",
 "Feriado municipal": "Städtischer Feiertag",
 "Feriado municipal: {nome}": "Kommunaler Feiertag: {nome}",
 "Feriado nacional": "Nationaler Feiertag",
 "Feriado nacional: {nome}": "Nationaler Feiertag: {nome}",
 "Feriado regional": "Regionaler Feiertag",
 "Feriado regional: {nome}": "Regionaler Feiertag: {nome}",
 "Feriados": "Feiertage",
 "Feriados nacionais": "Nationale Feiertage",
 "Feriados no planner": "Feiertage im Planner",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Feiertage, Kurse, Vorschläge der künstlichen Intelligenz und automatisch gelesene Boletos und Rechnungen können Fehler enthalten. Prüfe sie vor der Verwendung.",
 "Ferramenta": "Werkzeug",
 "Ferramentas": "Werkzeug",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Steckbrief jeder Pflanze, Umtopfen und Gieß- und Düngekalender in der Agenda.",
 "Ficha preenchida": "Formular ausgefüllt",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Ordner, Fächer und Seiten, Lern-Stoppuhr und Wochenziele.",
 "Ficção": "Belletristik",
 "Figurinha": "Sticker",
 "Figurinhas": "Sticker",
 "Filme": "Film",
 "Filme ou série": "Film oder Serie",
 "Filmes e séries": "Filme und Serien",
 "Filosofia": "Philosophie",
 "Filtros": "Filter",
 "Fim": "Ende",
 "Fim (vazio = uso contínuo)": "Ende (leer = Dauereinnahme)",
 "Fim da garantia": "Ende der Garantie",
 "Fim da garantia:": "Garantieende:",
 "Fim da pausa. Continue: {tarefa}": "Pause vorbei. Weiter mit: {tarefa}",
 "Fim de semana": "Wochenende",
 "Fim previsto": "Geplantes Ende",
 "Fina": "Fein",
 "Finados": "Allerseelen",
 "Finalizador": "Finisher",
 "Financeiro": "Finanzen",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Finanziell: {gasto} von {orcado} ({p} %)",
 "Financiamento": "Finanzierung",
 "Financiamento de veículo": "Fahrzeugfinanzierung",
 "Financiamento imobiliário": "Immobilienfinanzierung",
 "Financiamentos": "Finanzierungen",
 "Financiamentos e empréstimos": "Finanzierungen und Kredite",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Finanzierungen und Kredite mit Raten, Zinsen, Restschuld und Belegen; verliehene Gegenstände mit Foto und Rückgabe-Erinnerung.",
 "Finanças": "Finanzen",
 "Finanças {p}": "Finanzen {p}",
 "Finanças · {p}": "Finanzen · {p}",
 "Fins de semana": "Wochenenden",
 "Fio dental": "Zahnseide",
 "Flex": "Flex",
 "Flexão de braço": "Liegestütze",
 "Flor": "Blume",
 "Flutua": "Schweben",
 "Foguete": "Rakete",
 "Fogão": "Herd",
 "Foi no cartão de crédito? Lançar como compra no cartão": "Mit Kreditkarte bezahlt? Als Kartenkauf erfassen",
 "Foi para {destino}.": "An {destino} gesendet.",
 "Foi para {destino}. Quer tirar daqui?": "An {destino} gesendet. Hier entfernen?",
 "Folha de pagamento": "Lohnabrechnung",
 "Fone": "Hörer",
 "Fone de ouvido": "Kopfhörer",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Quellen: Brasilien, in der App berechnet anhand der Bundesverordnung über Feiertage und der Gesetze jedes Bundesstaats. Andere Länder: öffentliche Datenbank Nager.Date (date.nager.at), aus dem Internet geladen und auf dem Gerät gespeichert.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Quellen: Brasilien, in der App berechnet anhand der bundesweiten Feiertagsverordnung, der Gesetze der einzelnen Bundesstaaten und der offiziellen Kalender der Hauptstädte. Andere Länder: öffentliche Datenbank Nager.Date (date.nager.at), aus dem Internet geladen und auf dem Gerät gespeichert.",
 "Forma": "Zahlart",
 "Forma das parcelas": "Ratenart",
 "Forma de pagamento": "Zahlungsart",
 "Forma de pagamento: {f}.": "Zahlungsart: {f}.",
 "Formas": "Formen",
 "Formato": "Format",
 "Formatos": "Formate",
 "Formatura": "Abschlussfeier",
 "Fornecedor": "Dienstleister",
 "Fornecedores": "Dienstleister",
 "Forte": "Stark",
 "Foto": "Foto",
 "Foto da galeria": "Foto aus der Galerie",
 "Foto do contato": "Kontaktfoto",
 "Foto inteira": "Ganzes Foto",
 "Foto ou PDF (lido pela sua IA)": "Foto oder PDF (von deiner KI gelesen)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Fotografiere jedes Zimmer bei der Auszugs- und der Einzugsübergabe. Die Fotos schützen dich bei der Rückgabe der Wohnung.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Fotografiere jeden Beleg von Arzt, Zahnarzt, Schule und Altersvorsorge gleich nach dem Bezahlen. Am Jahresende ist alles bereit.",
 "Fotos": "Fotos",
 "Fotos JPG, PNG e outras viram um PDF.": "JPG-, PNG- und andere Fotos werden zu einem PDF.",
 "Fotos de {d}": "Fotos vom {d}",
 "Fotos do espaço pronto": "Fotos der fertigen Unterkunft",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "Fotos und Dateien dieses Eintrags kommen auch in den Gruppenordner, damit die Mitglieder sie öffnen können.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "Fotos und Dateien werden nur auf diesem Gerät gespeichert. Die Dokumentdaten werden geschützt in deinem Konto gespeichert.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "Fotos und Dateien bleiben auf diesem Gerät (und in deinem Drive oder OneDrive, falls in den Einstellungen verbunden).",
 "Fotos e notas": "Fotos und Notizen",
 "Fotos e vídeos": "Fotos und Videos",
 "Fotos, arquivos e links": "Fotos, Dateien und Links",
 "Fraldas e lenços": "Windeln und Feuchttücher",
 "Francês": "Französisch",
 "Frango com osso": "Hähnchen mit Knochen",
 "Frango sem osso": "Hähnchen ohne Knochen",
 "Frase (opcional, ex.: Bom dia!)": "Spruch (optional, z. B. Guten Morgen!)",
 "Freelancer & Projetos": "Freelancer & Projekte",
 "Freezer": "Gefrierschrank",
 "Freios": "Bremsen",
 "Frente": "Vorderseite",
 "Frente do documento": "Vorderseite des Dokuments",
 "Frente e verso na mesma folha": "Vorder- und Rückseite auf einem Blatt",
 "Frente pronta": "Vorderseite fertig",
 "Frequência": "Häufigkeit",
 "Frio": "Kalt",
 "Fruta": "Obst",
 "Frágil": "Zerbrechlich",
 "Fundação e estrutura": "Fundament und Rohbau",
 "Fundo": "Hintergrund",
 "Fundos e renda fixa": "Fonds und Anleihen",
 "Fuso": "Zeitzone",
 "Fuso horário": "Zeitzone",
 "Fuso horário do destino": "Zeitzone am Reiseziel",
 "Futebol": "Fußball",
 "Física": "Physik",
 "Físico (obra pronta): {p}%": "Baufortschritt: {p} %",
 "GASTOS POR CATEGORIA": "AUSGABEN NACH KATEGORIE",
 "GIF guardado nos seus GIFs.": "GIF in deinen GIFs gespeichert.",
 "Garagem": "Garage",
 "Garantia": "Garantie",
 "Garantia até {data}.": "Garantie bis {data}.",
 "Garantia legal": "Gesetzliche Garantie",
 "Garantia vencendo": "Garantie läuft ab",
 "Garantias": "Garantien",
 "Garrafa de água": "Trinkflasche",
 "Gasolina": "Benzin",
 "Gasto": "Ausgabe",
 "Gasto até agora": "Bisher ausgegeben",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Ausgabe von {v} erfasst. {n} Preis(e) für deine Einkaufsliste gespeichert.",
 "Gasto neste mês: {v}": "Ausgaben diesen Monat: {v}",
 "Gasto: {v}": "Ausgegeben: {v}",
 "Gastos": "Ausgaben",
 "Gastos por categoria": "Ausgaben nach Kategorie",
 "Gato": "Katze",
 "Geladeira": "Kühlschrank",
 "Geografia": "Geografie",
 "Gerado por": "Erzeugt von",
 "Gerando QR Code...": "QR-Code wird erstellt...",
 "Gerar PDF": "PDF erstellen",
 "Gerar as cobranças do mês": "Monatsforderungen erstellen",
 "Gerar as parcelas": "Raten erstellen",
 "Gerar lista da mala": "Packliste erstellen",
 "Gerar pelo cardápio e pela despensa": "Aus Speiseplan und Vorrat erstellen",
 "Gesso e forro": "Trockenbau und Decken",
 "Gira todas as páginas ou só as escolhidas.": "Dreht alle Seiten oder nur die ausgewählten.",
 "Girar": "Drehen",
 "Google Drive e OneDrive": "Google Drive und OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive und Google Kalender: nur wenn du sie verbindest, und nur um deine Dateien und Termine zu speichern.",
 "Gorro, cachecol e luvas": "Mütze, Schal und Handschuhe",
 "Gota": "Tropfen",
 "Graduação e Pós": "Studium und Postgraduales",
 "Grande": "Groß",
 "Gravando": "Aufnahme läuft",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Erinnerungen und Notizen per Sprache aufnehmen, wenn du es möchtest. Das Mikrofon schaltet sich nur durch dein Tippen ein.",
 "Gravar reunião": "Besprechung aufnehmen",
 "Gravação de áudio": "Audioaufnahme",
 "Gravações das reuniões": "Aufnahmen der Besprechungen",
 "Grossa": "Dick",
 "Grupo": "Gruppe",
 "Grupo com convite (turma, equipe, convidados)": "Gruppe mit Einladung (Klasse, Team, Gäste)",
 "Grupo criado": "Gruppe erstellt",
 "Grupo da família": "Familiengruppe",
 "Grupo da mudança (família e ajudantes)": "Umzugsgruppe (Familie und Helfer)",
 "Grupo da obra (equipe)": "Baugruppe (Team)",
 "Grupo da turma (convidar alunos)": "Klassengruppe (Schüler einladen)",
 "Grupo da viagem (convidar quem vai)": "Reisegruppe (Mitreisende einladen)",
 "Grupo de cuidado (família ou profissional)": "Pflegegruppe (Familie oder Fachkraft)",
 "Grupo de estudos (convidar colegas)": "Lerngruppe (Mitlernende einladen)",
 "Grupo de leitura (convidar)": "Lesegruppe (einladen)",
 "Grupo do cliente": "Kundengruppe",
 "Grupo do evento (convidar)": "Eventgruppe (einladen)",
 "Grupos": "Gruppen",
 "Grupos de estudo": "Lerngruppen",
 "Grupos de {aba}": "Gruppen von {aba}",
 "Grupos desta aba: {n}": "Gruppen in diesem Tab: {n}",
 "Grupos e convites": "Gruppen & Einladungen",
 "Grátis no lançamento": "Kostenlos zum Start",
 "Guarda-chuva": "Regenschirm",
 "Guardada nas suas figurinhas.": "In deinen Stickern gespeichert.",
 "Guardado": "Gespart",
 "Guardado até agora: {v}": "Bisher gespart: {v}",
 "Guardado em outro dispositivo": "Auf anderem Gerät gespeichert",
 "Guardado na pasta \"{pasta}\" do celular.": "Im Ordner \"{pasta}\" auf dem Handy gespeichert.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Im Tresor gespeichert, mit Ende-zu-Ende-Verschlüsselung.",
 "Guardado no {nome}.": "In {nome} gespeichert.",
 "Guardado {onde} em {quando}": "Gespeichert {onde} am {quando}",
 "Guardando...": "Speichern...",
 "Guardar": "Sparen",
 "Guardar como recibo do IR": "Als Steuerbeleg (IR) speichern",
 "Guardar dinheiro": "Geld sparen",
 "Guardar e enviar": "Speichern und senden",
 "Guardar na meta": "Aufs Ziel sparen",
 "Guardar nas minhas figurinhas": "In meinen Stickern speichern",
 "Guardar nos meus GIFs": "In meinen GIFs speichern",
 "Guardar o PDF {onde}": "PDF {onde} speichern",
 "Guardar os PDFs em": "PDFs speichern in",
 "Guardar os arquivos prontos em": "Fertige Dateien speichern in",
 "Guardar sozinho cada arquivo pronto": "Jede fertige Datei automatisch speichern",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Speichere Verordnungen und Hinweise, die du oft nutzt. Tippe im Termin auf ⋮ › Vorlage verwenden.",
 "Guarde seus documentos num lugar só": "Bewahre deine Dokumente an einem Ort auf",
 "Guarde {v} por mês até {d}": "Spare {v} pro Monat bis {d}",
 "Guardou": "Gespart",
 "Guia de imposto": "Steuerzahlschein",
 "Gás": "Gas",
 "Gênero ou categoria": "Genre oder Kategorie",
 "HISTÓRICO DOS DADOS": "DATENVERLAUF",
 "HOJE": "HEUTE",
 "Hall de entrada": "Eingangsbereich",
 "Halteres": "Hanteln",
 "Hexágono": "Sechseck",
 "Hidratante": "Feuchtigkeitscreme",
 "Hidratante labial": "Lippenpflege",
 "Hidráulica": "Sanitär",
 "Higiene bucal": "Mundhygiene",
 "Higienizar": "Bereinigen",
 "História": "Geschichte",
 "Histórico": "Verlauf",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "Familienanamnese, geschützte Befunde, Impfungen, Arzttermine und Medikamenten-Alarm in der Zeitleiste.",
 "Hmm...": "Hmm...",
 "Hoje": "Heute",
 "Hoje: {a} de {m} aulas ({p}%)": "Heute: {a} von {m} Lektionen ({p}%)",
 "Hoje: {n} página(s)": "Heute: {n} Seite(n)",
 "Hora": "Uhrzeit",
 "Hora da pausa": "Pausenzeit",
 "Hora de voltar": "Zeit, zurückzukehren",
 "Hora de voltar!": "Zeit, zurückzukehren!",
 "Hora do check-in": "Check-in-Zeit",
 "Hora do check-out": "Check-out-Zeit",
 "Horas": "Stunden",
 "Horas de sono": "Schlafstunden",
 "Horário": "Uhrzeit",
 "Horário de check-in": "Check-in-Zeit",
 "Horário de check-out": "Check-out-Zeit",
 "Horário do lembrete": "Uhrzeit der Erinnerung",
 "Horário inválido": "Ungültige Uhrzeit",
 "Horário ocupado": "Uhrzeit belegt",
 "Horários": "Uhrzeiten",
 "Horários (remédio diário)": "Uhrzeiten (tägliches Medikament)",
 "Hospedados agora": "Gerade zu Gast",
 "Hospedagem": "Unterkunft",
 "Hospital ou pronto-socorro de referência": "Bevorzugtes Krankenhaus oder Notaufnahme",
 "Hotel": "Hotel",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "Eine neue Version von My Planner Web ist da. Neu laden, um sie zu nutzen.",
 "Híbrido": "Hybrid",
 "Hóspede": "Gast",
 "Hóspede ({c})": "Gast ({c})",
 "Hóspedes (máximo)": "Gäste (max.)",
 "IA ligada": "KI aktiv",
 "IA não ligada": "KI nicht aktiv",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "KI nicht aktiv. Aktiviere sie unter Einstellungen › Künstliche Intelligenz.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS vom Leistungsempfänger einbehalten",
 "Ida": "Hinreise",
 "Identidade": "Ausweis",
 "Idioma": "Sprache",
 "Idiomas": "Sprachen",
 "Ilimitados": "Unbegrenzt",
 "Imagem": "Bild",
 "Imagem escolhida (trocar)": "Bild gewählt (ändern)",
 "Imagem guardada no {nome}. Toque para abrir.": "Bild in {nome} gespeichert. Zum Öffnen tippen.",
 "Imagens para PDF": "Bilder in PDF",
 "Imagens {data}": "Bilder {data}",
 "Imperdíveis": "Must-sees",
 "Imperdível": "Must-see",
 "Importar": "Importieren",
 "Importar XML de nota": "Rechnungs-XML importieren",
 "Importar arquivo": "Datei importieren",
 "Importar backup?": "Backup importieren?",
 "Importar extrato": "Kontoauszug importieren",
 "Importar extrato do banco (OFX ou CSV)": "Kontoauszug importieren (OFX oder CSV)",
 "Importar fatura": "Abrechnung importieren",
 "Importar fotos": "Fotos importieren",
 "Importar reservas do Airbnb, Booking...": "Buchungen von Airbnb, Booking... importieren",
 "Importar {n} lançamento(s)": "{n} Buchung(en) importieren",
 "Imóveis e espaços": "Unterkünfte",
 "Imóvel": "Immobilie",
 "Imóvel inteiro": "Ganze Unterkunft",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Ganze Unterkunft oder einzelne Zimmer: Buchungen von Airbnb, Booking oder direkt, Reinigung beim Check-out, Ausgaben, Auslastung und Monatsgewinn.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Enthält {v} aus den im Tab Rechnungen ausgestellten Rechnungen.",
 "Independência do Brasil": "Brasilianischer Unabhängigkeitstag",
 "Indicação": "Empfehlung",
 "Indique e ganhe": "Empfehlen und profitieren",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Empfiehl My Planner Freunden und Familie. Wer mit deinem Code ein Konto erstellt, erhält 10 Tage mit allen Tabs freigeschaltet.",
 "Infantil": "Kinderbuch",
 "Informações do PDF": "PDF-Infos",
 "Informe a descrição e o valor.": "Gib Beschreibung und Betrag ein.",
 "Informe de quantos em quantos dias regar ou adubar.": "Gib an, alle wie viele Tage gegossen oder gedüngt wird.",
 "Informe o nome do produto.": "Gib den Produktnamen ein.",
 "Informe o rótulo e o nome.": "Gib die Bezeichnung und den Namen ein.",
 "Informe o total de aulas da matéria em Editar.": "Gib die Gesamtzahl der Lektionen des Fachs unter Bearbeiten ein.",
 "Informe o valor.": "Gib den Betrag ein.",
 "Informe os horários": "Gib die Uhrzeiten an",
 "Informe quanto quer juntar.": "Gib an, wie viel du sparen willst.",
 "Informe seu nome.": "Gib deinen Namen ein.",
 "Informática": "Informatik",
 "Inglês": "Englisch",
 "Ingredientes (um por linha)": "Zutaten (eine pro Zeile)",
 "Inscrição municipal (se tiver)": "Gemeindliche Steuernummer (falls vorhanden)",
 "Inspeção": "Hauptuntersuchung",
 "Instalar ou atualizar o Health Connect": "Health Connect installieren oder aktualisieren",
 "Instruções, receita, observações...": "Anleitung, Rezept, Notizen...",
 "Insumos (papel, sabonete, café)": "Verbrauchsmaterial (Papier, Seife, Kaffee)",
 "Inteligência artificial": "Künstliche Intelligenz",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Künstliche Intelligenz (Claude, ChatGPT oder Gemini): nur wenn du sie aktivierst, mit deinem eigenen Schlüssel, der nur auf dem Gerät bleibt. Der Text der Frage geht direkt an den gewählten Dienst.",
 "Intensidade": "Intensität",
 "Internação": "Krankenhausaufenthalt",
 "Internet": "Internet",
 "Intimação": "Zustellung",
 "Intimação com prazo": "Zustellung mit Frist",
 "Investimento": "Investition",
 "Investimentos": "Geldanlage",
 "Início": "Beginn",
 "Início {ini} · Fim {fim} · Duração {dur}": "Beginn {ini} · Ende {fim} · Dauer {dur}",
 "Iogurte": "Joghurt",
 "Ir para Ajustes (exportar meus dados)": "Zu den Einstellungen (meine Daten exportieren)",
 "Ir para hoje": "Zu heute",
 "Ir para o My Planner Web": "Zu My Planner Web",
 "Italiano": "Italienisch",
 "Item": "Eintrag",
 "Item da despensa": "Vorratsartikel",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Geschütztes Element: Fotos und Dateien werden im Tresor verschlüsselt, nur auf diesem Gerät (sie gehen nicht zu Drive oder OneDrive).",
 "Itens": "Artikel",
 "Itens de higiene (xampu, sabonete)": "Hygieneartikel (Shampoo, Seife)",
 "Jantar": "Abendessen",
 "Japonês": "Japanisch",
 "Jaqueta impermeável": "Regenjacke",
 "Jogo": "Spiel",
 "Jovem e divertido": "Jung und verspielt",
 "Juntar PDFs": "PDFs zusammenfügen",
 "Juros": "Zinsen",
 "Juros ainda por vir: {v}": "Noch anfallende Zinsen: {v}",
 "Juros ao mês": "Zins pro Monat",
 "JÁ RESPONDIDOS": "BEREITS BEANTWORTET",
 "Já aberta na casa nova": "In der neuen Wohnung schon geöffnet",
 "Já enviado para a turma": "Schon an die Klasse gesendet",
 "Já está compacto": "Schon kompakt",
 "Já está no Planner": "Schon im Planner",
 "Já está pago": "Schon bezahlt",
 "Já há horários deste item no My Planner": "Für dieses Element gibt es bereits Zeiten in My Planner",
 "Já pago: {v}": "Bereits bezahlt: {v}",
 "Já tenho o app: abrir nele": "Ich habe die App: darin öffnen",
 "Já tenho o app: abrir o convite nele": "Ich habe die App: Einladung darin öffnen",
 "Já visitei": "Schon besucht",
 "Kit de primeiros socorros": "Erste-Hilfe-Set",
 "Kkkk": "Haha",
 "Kkkkk": "Hahaha",
 "Km de hoje no painel": "Heutiger Kilometerstand",
 "Km no dia": "Km an dem Tag",
 "Km no painel": "Kilometerstand",
 "LANÇAMENTOS": "BUCHUNGEN",
 "LINHA DO TEMPO": "ZEITLEISTE",
 "Laboratório": "Labor",
 "Lanche": "Snack",
 "Lanche da manhã": "Vormittagssnack",
 "Lanche da tarde": "Nachmittagssnack",
 "Lanches e água": "Snacks und Wasser",
 "Lançamentos": "Buchungen",
 "Lavanderia": "Waschküche",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Wäscherei, Verbrauchsmaterial, Wartung, Rechnungen und Gebühren. Sie fließen in den Monatsgewinn ein.",
 "Lavar o rosto com sabonete facial": "Gesicht mit Gesichtsseife waschen",
 "Lazer": "Freizeit",
 "Leg press": "Beinpresse",
 "Legenda": "Bildunterschrift",
 "Legislação Específica": "Spezialgesetze",
 "Legumes": "Gemüse",
 "Leia hoje para começar uma sequência": "Lies heute, um eine Serie zu starten",
 "Leite": "Milch",
 "Leitura": "Lesen",
 "Leitura automática do texto": "Automatische Textauswertung",
 "Leitura da IA": "KI-Auswertung",
 "Leitura, Cursos & Mídia": "Lesen, Kurse & Medien",
 "Lembrete": "Erinnerung",
 "Lembrete de hoje": "Erinnerung für heute",
 "Lembrete de renovação no Planner": "Erinnerung zur Verlängerung im Planner",
 "Lembrete no Planner": "Erinnerung im Planner",
 "Lembrete no planner": "Erinnerung im Planner",
 "Lembrete pelo WhatsApp": "Erinnerung per WhatsApp",
 "Lembrete: começa às {hora}": "Erinnerung: beginnt um {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "Wir lesen alle Nachrichten. Falls nötig, antworten wir per E-Mail.",
 "Lendo": "Am Lesen",
 "Lendo a fatura...": "Abrechnung wird gelesen...",
 "Lendo a página": "Lese Seite",
 "Lendo o boleto...": "Boleto wird gelesen...",
 "Lendo o cupom...": "Kassenbon wird gelesen...",
 "Lendo o documento...": "Dokument wird gelesen...",
 "Lendo o extrato...": "Kontoauszug wird gelesen...",
 "Lendo o relógio...": "Uhr wird gelesen...",
 "Lendo o texto": "Text wird gelesen",
 "Ler a fatura": "Abrechnung lesen",
 "Ler a publicação inteira": "Die ganze Veröffentlichung lesen",
 "Ler com a minha IA": "Mit meiner KI lesen",
 "Ler de novo": "Neu lesen",
 "Ler de novo agora": "Jetzt neu lesen",
 "Ler o texto": "Text lesen",
 "Ler o texto completo": "Volltext lesen",
 "Ler publicação inteira": "Ganze Veröffentlichung lesen",
 "Ler sozinho as publicações novas": "Neue Veröffentlichungen automatisch lesen",
 "Leve": "Leicht",
 "Leve (sem perder qualidade)": "Leicht (ohne Qualitätsverlust)",
 "Li e aceito os termos e a política de privacidade": "Ich habe die Bedingungen und die Datenschutzerklärung gelesen und akzeptiere sie",
 "Li mais {n} páginas": "{n} Seiten mehr gelesen",
 "Liberada pelo suporte": "Vom Support freigeschaltet",
 "Liberar para a equipe": "Für das Team freigeben",
 "Liberar para a turma em": "Für die Klasse freigeben am",
 "Liberar para o grupo": "Für die Gruppe freigeben",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Freischaltungen und Guthaben sind an deine CPF gebunden. Aktualisiert sich beim Synchronisieren.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Erlaube My Planner in den Handy-Einstellungen den Kamerazugriff, um den QR-Code zu lesen.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Erlaube My Planner den Kamerazugriff in den Handy-Einstellungen.",
 "Libere outras abas em Ajustes › Compras.": "Schalte weitere Tabs unter Einstellungen › Käufe frei.",
 "Licenciamento": "Zulassung",
 "Lidas hoje": "Heute gelesen",
 "Lido": "Gelesen",
 "Ligando. Toque para atender.": "Anruf. Zum Annehmen tippen.",
 "Ligar": "Anrufen",
 "Ligar certificado": "Zertifikat verbinden",
 "Ligar para a assistência": "Kundendienst anrufen",
 "Ligar para {nome}": "{nome} anrufen",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Aktiviere deine KI unter Einstellungen › Künstliche Intelligenz (Claude, ChatGPT oder Gemini), um dieses Werkzeug zu nutzen.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Aktiviere deine KI unter Einstellungen › Künstliche Intelligenz, um den Text zu lesen, zusammenzufassen und Fragen zum Dokument zu stellen.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Aktiviere deine KI unter Einstellungen › Künstliche Intelligenz.",
 "Ligue o certificado A1 da empresa primeiro.": "Verbinde zuerst das A1-Zertifikat des Unternehmens.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Verbinde dein Google Drive oder OneDrive, um Fotos und Dateien zu speichern (die sich dann auf jedem Gerät öffnen lassen) und vollständige Sicherungskopien zu haben.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Schalte es ein, damit die Gruppe mit denselben Daten arbeitet (Baustelle, Reise, Klasse, Immobilie, Praxis), jede Person mit ihrer Rolle.",
 "Ligue pelo menos 4 pontos.": "Verbinde mindestens 4 Punkte.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Jahresgrenze änderbar unter Einstellungen › Tabs › Tab Finanzen. Prüfe sie immer mit deinem Steuerberater.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Abfragelimit erreicht. Versuch es in 1 Minute erneut.",
 "Limite de energia por dia": "Energielimit pro Tag",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "Jährliche Umsatzgrenze des MEI (prüfe den aktuellen Wert mit deinem Steuerberater).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Nachrichtenlimit für heute erreicht. Versuche es morgen.",
 "Limite diário": "Tageslimit",
 "Limite livre: {v} de {l}": "Freies Limit: {v} von {l}",
 "Limite total (opcional)": "Gesamtlimit (optional)",
 "Limpar": "Leeren",
 "Limpar a agenda": "Kalender leeren",
 "Limpar banheiro": "Bad putzen",
 "Limpar cozinha e louça": "Küche und Geschirr reinigen",
 "Limpar feitos": "Erledigte entfernen",
 "Limpeza": "Reinigung",
 "Limpeza após {h}": "Reinigung nach {h}",
 "Limpeza final": "Endreinigung",
 "Limpeza · {e}": "Reinigung · {e}",
 "Limpeza: {e}": "Reinigung: {e}",
 "Limpezas": "Reinigungen",
 "Linha do tempo, tarefas, energia e alertas.": "Zeitleiste, Aufgaben, Energie und Alarme.",
 "Link": "Link",
 "Link (Drive, OneDrive, Dropbox)": "Link (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Link kopiert. Füge ihn ein, wo du ihn senden möchtest.",
 "Link da aula ou reunião online (opcional)": "Link zur Stunde oder zum Online-Meeting (optional)",
 "Link da nota fiscal (Drive ou OneDrive)": "Link zur Rechnung (Drive oder OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Link zum Ordner in Drive oder OneDrive (optional)",
 "Link da reserva": "Buchungslink",
 "Link da sala online (Meet, Zoom...)": "Link zum Online-Raum (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Link eines anderen Kalenders (iCal)",
 "Link do calendário do Airbnb (iCal)": "Airbnb-Kalenderlink (iCal)",
 "Link do calendário do Booking (iCal)": "Booking-Kalenderlink (iCal)",
 "Link inválido": "Ungültiger Link",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Links zu Materialien (Drive, Videos, PDFs), einer pro Zeile",
 "Links: {n}": "Links: {n}",
 "Lista": "Liste",
 "Lista da mala": "Packliste",
 "Lista de compras": "Einkaufsliste",
 "Lista de exercícios": "Aufgabenblatt",
 "Lista rápida": "Schnellliste",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Schnelllisten und Boxen, die zu Aufgaben werden oder in einen anderen Tab wandern.",
 "Literatura": "Literatur",
 "Litros": "Liter",
 "Livre": "Frei",
 "Livro": "Buch",
 "Livros": "Bücher",
 "Local": "Ort",
 "Local ou endereço": "Ort oder Adresse",
 "Local: {l}": "Ort: {l}",
 "Localização (país e fuso horário)": "Standort (Land und Zeitzone)",
 "Logo, foto ou rubrica nas páginas.": "Logo, Foto oder Kürzel auf den Seiten.",
 "Loja (opcional)": "Geschäft (optional)",
 "Lote": "Charge",
 "Lua": "Mond",
 "Lugar": "Ort",
 "Lugar para visitar": "Sehenswerter Ort",
 "Lugares": "Orte",
 "Luz": "Strom",
 "Luz indireta": "Indirektes Licht",
 "Luz, água, gás e internet": "Strom, Wasser, Gas und Internet",
 "Lápis": "Bleistift",
 "Língua Portuguesa": "Portugiesisch",
 "MAIS ADIANTE": "SPÄTER",
 "MAIS USADOS": "AM HÄUFIGSTEN",
 "ME ou EPP do Simples": "ME oder EPP im Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: Umsatz {ano} von {v} (Grenze {l}).",
 "MEMBROS ({n})": "MITGLIEDER ({n})",
 "METAS": "ZIELE",
 "MS": "MS",
 "Mais": "Mehr",
 "Mais abas": "Weitere Tabs",
 "Mais cidades entram nas próximas versões.": "Weitere Städte kommen in den nächsten Versionen.",
 "Mais emojis": "Mehr Emojis",
 "Mais ferramentas": "Weitere Werkzeuge",
 "Mais figurinhas animadas (KLIPY)": "Mehr animierte Sticker (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "Weitere Optionen für diesen Tab kommen in den nächsten Versionen.",
 "Mais uma": "Noch eine",
 "Mala": "Koffer",
 "Mala ({clima}, {n} dias)": "Koffer ({clima}, {n} Tage)",
 "Mamadeiras e leite": "Fläschchen und Milch",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "Wir haben einen 6-stelligen Code an das WhatsApp der Nummer {tel} gesendet.",
 "Mandar as orientações pelo WhatsApp": "Hinweise per WhatsApp senden",
 "Mandar de novo": "Erneut senden",
 "Mandar e-mail": "E-Mail senden",
 "Mandar lembrete": "Erinnerung senden",
 "Mandar meu código": "Meinen Code senden",
 "Mandar o acerto para o grupo": "Abrechnung an die Gruppe senden",
 "Mandar para quem limpa (WhatsApp)": "An die Reinigungskraft senden (WhatsApp)",
 "Mandarim": "Mandarin",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Schicke eine E-Mail mit der Bitte um Löschung und der Ausweisnummer des Kontos. Wir antworten innerhalb von 15 Tagen.",
 "Manter": "Behalten",
 "Manter ambas": "Beide behalten",
 "Manter ambos": "Beide behalten",
 "Manter aqui também": "Auch hier behalten",
 "Manter tarefas": "Aufgaben behalten",
 "Manutenção": "Wartung",
 "Manutenções": "Wartungen",
 "Mapas (Apple)": "Apple Karten",
 "Marca d'água": "Wasserzeichen",
 "Marca-texto": "Textmarker",
 "Marcado": "Angehakt",
 "Marcado como feito hoje.": "Heute als erledigt markiert.",
 "Marcar como concluída ({dia})": "Als erledigt markieren ({dia})",
 "Marcar como devolvido": "Als zurückgegeben markieren",
 "Marcar como feita hoje": "Heute als erledigt markieren",
 "Marcar como lido": "Als gelesen markieren",
 "Marcar como paga": "Als bezahlt markieren",
 "Marcar como pago": "Als bezahlt markieren",
 "Marcar como quitado": "Als getilgt markieren",
 "Marcar como recebida": "Als erhalten markieren",
 "Marcar como recebida?": "Als erhalten markieren?",
 "Marcar como recebido": "Als erhalten markieren",
 "Marcar como visto": "Als gesehen markieren",
 "Marcar e avisar a equipe": "Planen und Team benachrichtigen",
 "Marcar esta conta como paga?": "Diese Rechnung als bezahlt markieren?",
 "Marcar fatura como paga": "Abrechnung als bezahlt markieren",
 "Marcar grupo": "Gruppe auswählen",
 "Marcar reunião": "Besprechung planen",
 "Marcenaria": "Schreinerei",
 "Margem": "Rand",
 "Marketing": "Marketing",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Markiere die Tagebuchfotos als Vorher oder Nachher, um die Galerie zu erstellen.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Markiere die Tage, an denen du lernst, und die Uhrzeit für jeden Tag. Jeder Tag wird zu einer Aufgabe, die sich jede Woche wiederholt und mit diesem Element verknüpft ist.",
 "Marque um ou mais estados.": "Wähle einen oder mehrere Bundesstaaten.",
 "Martelo": "Hammer",
 "Masculino": "Männlich",
 "Masculino e minimalista": "Männlich und minimalistisch",
 "Matemática": "Mathematik",
 "Materiais": "Materialien",
 "Material": "Material",
 "Matrícula, placa, código ou CNPJ": "Grundbuchnr., Kennzeichen, Code oder CNPJ",
 "Matéria ou material": "Fach oder Material",
 "Matéria ou módulo": "Fach oder Modul",
 "Matérias": "Fächer",
 "Meia-sombra": "Halbschatten",
 "Melhorando a imagem...": "Bild wird verbessert...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "Neue Verbesserungen wurden heruntergeladen. Das dauert nur ein paar Sekunden und deine Daten bleiben erhalten.",
 "Membros": "Mitglieder",
 "Menos de 1 minuto": "Weniger als 1 Minute",
 "Mensagem": "Nachricht",
 "Mensagem apagada": "Nachricht gelöscht",
 "Mensagem enviada. Obrigado!": "Nachricht gesendet. Danke!",
 "Mensagem ou observações": "Nachricht oder Anmerkungen",
 "Mensagens": "Nachrichten",
 "Mensagens que você envia em Fale conosco.": "Nachrichten, die du über Kontakt sendest.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Nachrichten: Deine Freundesliste, die Chats sowie gesendete Fotos und Dateien werden auf dem Server gespeichert, damit sie die anderen Geräte erreichen. Audio- und Videoanrufe werden nicht aufgezeichnet.",
 "Mensalidade de {m}": "Monatsbeitrag {m}",
 "Mensalidade ou valor por aluno": "Monatsbeitrag oder Betrag pro Schüler",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Monatsbeiträge, Einzelstunden und Materialien. Unter ⋮ der Klasse erstellt \"Monatsforderungen erstellen\" eine für jeden Schüler.",
 "Mercado": "Lebensmittel",
 "Mesa flexora": "Beinbeuger liegend",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Polier",
 "Meta": "Ziel",
 "Meta 100% batida": "Ziel zu 100 % erreicht",
 "Meta atingida": "Ziel erreicht",
 "Meta atingida!": "Ziel erreicht!",
 "Meta da semana: {dur}": "Wochenziel: {dur}",
 "Meta de aulas": "Lektionsziel",
 "Meta de aulas batida": "Lektionsziel erreicht",
 "Meta de copos por dia": "Ziel: Gläser pro Tag",
 "Meta de páginas por dia": "Seitenziel pro Tag",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Seitenziel, Fortschritt und Zusammenfassungen von Büchern, Filmen und Serien zum Ansehen und Lektionen der Kurse.",
 "Meta diária": "Tagesziel",
 "Meta por dia": "Tagesziel",
 "Meta por semana:": "Wochenziel:",
 "Meta {meta} · copo de {copo} · {n} copos": "Ziel {meta} · Glas mit {copo} · {n} Gläser",
 "Metas": "Ziele",
 "Metodologia Científica": "Wissenschaftliches Arbeiten",
 "Meu caderno": "Mein Notizbuch",
 "Meu cartão de contato": "Meine Kontaktkarte",
 "Meu plano": "Mein Tarif",
 "Meus GIFs ({n})": "Meine GIFs ({n})",
 "Meus PDFs": "Meine PDFs",
 "Meus dados": "Meine Daten",
 "Meus dados profissionais": "Meine beruflichen Daten",
 "Microchip": "Mikrochip",
 "Microfone": "Mikrofon",
 "Microscópio": "Mikroskop",
 "Militares estaduais": "Militärgerichte der Bundesstaaten",
 "Minha Casa": "Mein Zuhause",
 "Minha conta": "Mein Konto",
 "Minhas anotações do livro": "Meine Buchnotizen",
 "Minhas figurinhas": "Meine Sticker",
 "Minutos": "Minuten",
 "Minutos de exercício": "Trainingsminuten",
 "Mirante": "Aussichtspunkt",
 "Mirantes": "Aussichtspunkte",
 "Modelo": "Modell",
 "Modelo de prescrição": "Verordnungsvorlage",
 "Modelos": "Vorlagen",
 "Modificado em": "Geändert am",
 "Modo": "Modus",
 "Modo de preparo": "Zubereitung",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Abgesicherter Modus: automatische Aufgaben aus bis zum nächsten Öffnen",
 "Moeda": "Währung",
 "Moeda: {m}": "Währung: {m}",
 "Moedas": "Münzen",
 "Momento do evento": "Programmpunkt",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Monitor des elektronischen Justizblatts (DJEN) nach Name und OAB.",
 "Monitor ou co-professor": "Tutor oder Co-Lehrkraft",
 "Montando o PDF: página {n} de {total}...": "PDF wird erstellt: Seite {n} von {total}...",
 "Montar a mala pelo clima ({n} dias)": "Koffer nach Wetter packen ({n} Tage)",
 "Monte o cronograma alimentar para ver o relatório.": "Erstelle deinen Ernährungsplan, um den Bericht zu sehen.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Plane das Programm Tag für Tag. Während der Reise erscheint es in der Zeitleiste von My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Stell unten deinen Essensplan und deine Pflege zusammen. Was heute dran ist, erscheint hier zum Abhaken.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Richte unten deinen Ernährungsplan, Pflege, Trainings und Nahrungsergänzung ein. Was heute dran ist, erscheint hier zum Abhaken.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Stelle deine Trainings aus fertigen Aktivitäten zusammen: Geräte im Studio, Übungen zu Hause, Spazieren, Laufen, Yoga, Pilates...",
 "Mostrando as 120 mais recentes.": "Die 120 neuesten werden angezeigt.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "Nur das Reiseprogramm wird angezeigt. {n} Aufgabe(n) des Tages ausgeblendet.",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Datum, Uhrzeit, Währung und Feiertage passend zu deinem Ort anzeigen. Wir nutzen kein GPS.",
 "Mostrar menos": "Weniger anzeigen",
 "Mostrar só o roteiro durante a viagem": "Während der Reise nur das Reiseprogramm zeigen",
 "Motivo do cancelamento": "Stornogrund",
 "Moto": "Motorrad",
 "Mover": "Verschieben",
 "Mover para hoje": "Auf heute verschieben",
 "Mudança": "Umzug",
 "Mudança: {para}": "Umzug: {para}",
 "Mudanças": "Umzüge",
 "Mudar e-mail": "E-Mail ändern",
 "Mudar o nome": "Umbenennen",
 "Mudar senha": "Passwort ändern",
 "Mudo": "Stumm",
 "Muitas tentativas": "Zu viele Versuche",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Zu viele falsche Versuche. Versuche es in {s} Sekunden erneut.",
 "Muitas tentativas. Aguarde alguns minutos.": "Zu viele Versuche. Warte ein paar Minuten.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Sehr gut: Diesen Monat hast du schon {v} gespart. Regelmäßigkeit zählt mehr als hohe Beträge.",
 "Multa": "Bußgeld",
 "Multa e juros": "Mahngebühren und Zinsen",
 "Multa e juros de {v}": "Mahngebühren und Zinsen von {v}",
 "Multa e juros estimados: {v}": "Geschätzte Strafe und Zinsen: {v}",
 "Multas e juros pagos": "Gezahlte Mahngebühren und Zinsen",
 "Mundo": "Welt",
 "Municipal": "Kommunal",
 "Município da prestação (IBGE), se for outro": "Leistungsort (IBGE), falls abweichend",
 "Município da prestação (código IBGE, 7 números)": "Leistungsort (IBGE-Code, 7 Ziffern)",
 "Mural": "Pinnwand",
 "Museu": "Museum",
 "Museus": "Museen",
 "My Planner (vira tarefa)": "My Planner (wird zur Aufgabe)",
 "My Planner bloqueado": "My Planner gesperrt",
 "Máxima": "Maximal",
 "Média": "Mittel",
 "Média para aprovação": "Notenschnitt zum Bestehen",
 "Média · repouso {n}": "Durchschnitt · Ruhe {n}",
 "Médico": "Arzt",
 "Médico ou clínica": "Arzt oder Klinik",
 "Médio": "Mittel",
 "Mês": "Monat",
 "Mês a mês": "Monat für Monat",
 "Mês atual": "Aktueller Monat",
 "Mês passado": "Letzter Monat",
 "Móveis e enxoval": "Möbel und Wäsche",
 "Móvel": "Möbel",
 "Música": "Musik",
 "NAS ABAS": "IN DEN TABS",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: Die SEFAZ verlangt 1 Stunde zwischen Suchen. Nächste ab {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: Gib den Bundesstaat (UF) des Unternehmens an, um Warenrechnungen zu suchen.",
 "NFS-e emitida": "NFS-e ausgestellt",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "Am (optional):",
 "Na agenda": "Im Kalender",
 "Na agenda em {data}": "Im Kalender am {data}",
 "Na barra": "In der Leiste",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "In der Demo gibt es keinen Rechnungsserver. Nutze die App mit deinem Konto.",
 "Na hora": "Sofort",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "Zur Pausenzeit erscheint ein großer Hinweis auf dem Bildschirm, mit Countdown.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "In der Zeitleiste öffnet auch ein Tippen auf den Timer diese Seite.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "Im Ordner \"{pasta}\" auf dem Handy. Jede fertige Datei kommt dorthin.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "Im Ordner \"{pasta}\" auf dem Handy. Jedes neue Dokument landet dort, wenn du es verlässt.",
 "Na prévia de demonstração não há chamadas de verdade.": "In der Demo-Vorschau gibt es keine echten Anrufe.",
 "Na prévia de demonstração não há gravação de verdade.": "In der Demo-Vorschau gibt es keine echte Aufnahme.",
 "Na prévia de demonstração os arquivos não abrem.": "In der Demo-Vorschau lassen sich Dateien nicht öffnen.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "In der Store-Version erfolgt der Kauf über Google Play oder den App Store. Vorerst simuliert der Schalter das Abo für Tests.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "In der Store-Version öffnet diese Schaltfläche den Kauf über Google Play oder den App Store.",
 "Nacional": "National",
 "Nada a gerar": "Nichts zu erstellen",
 "Nada encontrado.": "Nichts gefunden.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Nichts landet ohne Erlaubnis in jemandes Kalender: Jede Person nimmt an, bearbeitet oder lehnt ab.",
 "Nada foi registrado.": "Nichts wurde erfasst.",
 "Nada lançado neste mês.": "Keine Buchungen in diesem Monat.",
 "Nada no mês": "Nichts in diesem Monat",
 "Nada no roteiro deste dia.": "Für diesen Tag ist nichts geplant.",
 "Nada para apagar com esse filtro.": "Mit diesem Filter gibt es nichts zu löschen.",
 "Nada para comprar": "Nichts zu kaufen",
 "Nada para enviar.": "Nichts zu senden.",
 "Nada planejado para este dia": "Nichts geplant für diesen Tag",
 "Nada planejado para hoje. Bom dia!": "Nichts geplant für heute. Guten Morgen!",
 "Nada por aqui.": "Hier ist nichts.",
 "Nada recebido ainda.": "Noch nichts erhalten.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "In Chats sieht jede Person deinen Namen und was du dort sendest. Du kannst eine Nachricht für alle löschen, eine Gruppe verlassen oder jemanden blockieren.",
 "Nascimento": "Geburt",
 "Natal": "Weihnachten",
 "Natação": "Schwimmen",
 "Navegador conectado": "Browser verbunden",
 "Negrito": "Fett",
 "Negócios": "Wirtschaft",
 "Nenhum": "Keine",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "Kein XML in diesem Zeitraum (oder auf einem anderen Gerät gespeichert).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "Keine Freunde zum Hinzufügen. Lade über WhatsApp ein oder füge Freunde in Nachrichten hinzu (Freundescode).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "Keine Dateien, Bilder oder Links auf den Seiten dieses Fachs.",
 "Nenhum arquivo.": "Keine Dateien.",
 "Nenhum atendimento pago neste mês.": "Keine bezahlten Termine in diesem Monat.",
 "Nenhum cartão": "Keine Karten",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "Noch keine Belege gespeichert. Wenn du eine Rechnung bezahlst, tippe darauf und hänge Foto, PDF oder Screenshot des Belegs an.",
 "Nenhum cômodo ainda": "Noch keine Räume",
 "Nenhum dia": "Kein Tag",
 "Nenhum documento ainda.": "Noch keine Dokumente.",
 "Nenhum documento neste filtro.": "Keine Dokumente in diesem Filter.",
 "Nenhum e-mail cadastrado": "Keine E-Mail hinterlegt",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "Keine Fehler erfasst. Wenn die App sich schließt oder ein Bildschirm ein Problem hat, erscheint der Fehler hier, damit du ihn ans Team senden kannst.",
 "Nenhum feriado neste ano.": "Keine Feiertage in diesem Jahr.",
 "Nenhum fichário ainda": "Noch keine Ordner",
 "Nenhum grupo ainda.": "Noch keine Gruppen.",
 "Nenhum item em {nome}": "Keine Einträge in {nome}",
 "Nenhum lançamento encontrado": "Keine Buchungen gefunden",
 "Nenhum país encontrado.": "Kein Land gefunden.",
 "Nenhum selecionado": "Nichts ausgewählt",
 "Nenhuma (plano gratuito)": "Keine (kostenloser Tarif)",
 "Nenhuma aba encontrada.": "Keine Tabs gefunden.",
 "Nenhuma aba fixada além do My Planner.": "Außer My Planner ist kein Tab angeheftet.",
 "Nenhuma aba liberada para receber": "Kein freigeschalteter Tab kann es empfangen",
 "Nenhuma agenda encontrada": "Kein Kalender gefunden",
 "Nenhuma agenda para trazer": "Kein Kalender zum Importieren",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "In dieser Veröffentlichung wurde kein Gerichtstermin und keine Frist gefunden.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "Keine archivierten Boxen. Wische eine Box nach links, um sie zu archivieren.",
 "Nenhuma compra encontrada": "Kein Kauf gefunden",
 "Nenhuma compra nesta fatura.": "Keine Käufe in dieser Abrechnung.",
 "Nenhuma conta a pagar cadastrada.": "Keine zu zahlenden Rechnungen angelegt.",
 "Nenhuma conta a receber cadastrada.": "Keine Forderungen angelegt.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "Keine Rechnungen in diesem Monat. Tippe auf +, um eine hinzuzufügen (Miete, Strom, Karte...).",
 "Nenhuma cópia de segurança ainda.": "Noch keine Sicherungskopie.",
 "Nenhuma cópia encontrada.": "Keine Sicherung gefunden.",
 "Nenhuma garantia ativa. Cadastre com o +.": "Keine aktive Garantie. Füge eine mit + hinzu.",
 "Nenhuma garantia vencida.": "Keine abgelaufene Garantie.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "Noch keine Nachrichten. Sag Hallo! 👋",
 "Nenhuma nota neste período.": "Keine Rechnung in diesem Zeitraum.",
 "Nenhuma opção ainda.": "Noch keine Optionen.",
 "Nenhuma publicação nova.": "Keine neue Veröffentlichung.",
 "Nenhuma refeição neste dia.": "Keine Mahlzeiten an diesem Tag.",
 "Nenhuma reunião marcada.": "Keine Besprechungen geplant.",
 "Nesse ritmo, termina em {d}": "In diesem Tempo bist du am {d} fertig",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "In dieser Startphase sind alle Tabs freigeschaltet und kostenlos.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "In dieser Testphase setzt der Support das Passwort zurück. Schreib an {email} und gib deine CPF oder E-Mail an.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "In dieser Testphase wird das Passwort vom Support zurückgesetzt. Schreib an {email} und gib deine CPF an.",
 "Neve": "Schnee",
 "Ninguém deve nada a ninguém.": "Niemand schuldet jemandem etwas.",
 "Ninguém entrou ainda. Envie o convite.": "Noch niemand beigetreten. Sende die Einladung.",
 "Ninguém usou o seu código ainda.": "Noch niemand hat deinen Code genutzt.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Auf Android speichert die App nur eine Verknüpfung zur gewählten Datei: Sie bleibt, wo sie ist (Drive, OneDrive, Downloads), und öffnet sich in der App des Handys. Nichts wird kopiert. Diese Option gilt für Fotos, die mit der Kamera aufgenommen werden.",
 "No Google Drive ou OneDrive: {n}": "In Google Drive oder OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "In Google Drive sieht die App nur die Dateien, die sie selbst im Ordner My Planner erstellt hat. Die Nutzung von Informationen aus Google APIs erfolgt gemäß der Richtlinie zu Nutzerdaten für Google API-Dienste, einschließlich der Anforderungen zur eingeschränkten Nutzung: Nichts wird verkauft, für Werbung verwendet oder von Personen gelesen, außer mit Ihrer Zustimmung oder aufgrund gesetzlicher Verpflichtung.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "Schalte in der App deiner Uhr (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...) die Option \"Health Connect\" oder \"Mit Health Connect synchronisieren\" ein.",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "In der neuen App (Version 0.49) findet das Handy die Blattränder selbst. In dieser Version passt du die 4 Ecken mit dem Finger an.",
 "No centro": "Mitte",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "Öffne am Computer {url}, tippe auf die Schaltfläche oben und richte die Kamera auf den QR-Code auf dem Bildschirm.",
 "No dia (opcional):": "Am Tag (optional):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "Auf dem iPhone öffnet die App \"In Dateien sichern\", damit du den Ordner wählen kannst (auch iCloud Drive).",
 "No início": "Zu Beginn",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "Im abgesicherten Modus öffnet die App ohne automatische Aufgaben (Hinweise, Google Kalender, Veröffentlichungen, Nachrichten und Uhr). Deine Daten ändern sich nicht, und beim nächsten Öffnen ist alles wieder normal.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "Im Browser bleiben die Seiten nur, solange diese Seite geöffnet ist.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "Füge im Browser den Link zur Datei aus Drive, OneDrive oder Dropbox ein (in Lernen oder Dokumente, Option Link). Auf dem Handy zeigt die Datei-Schaltfläche Drive und OneDrive bereits an.",
 "No navegador, o PDF é baixado para o computador.": "Im Browser wird das PDF auf den Computer heruntergeladen.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "Im Browser können nur kleine Bilder (bis 200 KB) gespeichert werden. Für andere Dateien füge einen Link von Drive, OneDrive oder Dropbox hinzu oder nutze die App auf dem Handy.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "Kopiere in der anderen App den Link der Datei (Teilen › Link kopieren) und füge ihn in den Link-Block auf dieser Seite ein.",
 "No ritmo atual, o ano fecha em {v}.": "Im aktuellen Tempo endet das Jahr bei {v}.",
 "No seu fuso: {hora}{dia}": "In deiner Zeitzone: {hora}{dia}",
 "Nome": "Name",
 "Nome (cliente ou fornecedor)": "Name (Kunde oder Lieferant)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Name (z. B.: Klasse 8b, Patienten der Praxis, Anas Geburtstag)",
 "Nome (ex.: Almoço)": "Name (z. B. Mittagessen)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Name (z. B. Mieteinnahme, Kunde X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Name (z. B. Miete, Strom, Internet)",
 "Nome (ex.: Doutorado UFPR)": "Name (z. B. Promotion UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Name (z. B. Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Name (z. B. Abend-Skincare)",
 "Nome (ex.: Treino A)": "Name (z. B. Training A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Name (z. B. Urlaubsreise, Notgroschen)",
 "Nome (ex.: Vitamina C)": "Name (z. B. Vitamin C)",
 "Nome (opcional)": "Name (optional)",
 "Nome (opcional, ex.: CNH do Walter)": "Name (optional, z. B. CNH von Walter)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Name (änderbar, z. B. \"Traubensaft\")",
 "Nome completo": "Vollständiger Name",
 "Nome curto": "Kurzname",
 "Nome da lista": "Name der Liste",
 "Nome da matéria": "Name des Fachs",
 "Nome da obra": "Name des Bauprojekts",
 "Nome da pasta (ex.: Recibos, Contratos)": "Ordnername (z. B. Belege, Verträge)",
 "Nome da tarefa": "Name der Aufgabe",
 "Nome da tarefa (ex.: Academia)": "Name der Aufgabe (z. B. Fitnessstudio)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Aufgabenname (z. B. Bad putzen)",
 "Nome do PDF (opcional)": "PDF-Name (optional)",
 "Nome do conselho": "Name der Kammer",
 "Nome do cômodo": "Name des Raums",
 "Nome do documento": "Dokumentname",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Name des Büros (z. B.: Ravasco Contabilidade)",
 "Nome do evento": "Name des Events",
 "Nome do grupo (ex.: Família)": "Gruppenname (z. B. Familie)",
 "Nome do modelo": "Name der Vorlage",
 "Nome ou modelo": "Name oder Modell",
 "Nome ou razão social": "Name oder Firmenname",
 "Nome, subtarefa ou anotação": "Name, Unteraufgabe oder Notiz",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "In Gruppen ist jede Person für das verantwortlich, was sie hinzufügt. Wer die Gruppe verwaltet, entscheidet, wer teilnimmt.",
 "Nossa Senhora Aparecida": "Unsere Liebe Frau von Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Nossa Senhora da Luz dos Pinhais",
 "Nota cancelada": "Rechnung storniert",
 "Nota fiscal": "Rechnung",
 "Nota fiscal emitida": "Rechnung ausgestellt",
 "Nota fiscal, certificado de garantia e fotos": "Rechnung, Garantieschein und Fotos",
 "Nota importada": "Rechnung importiert",
 "Notas": "Rechnungen",
 "Notas Fiscais": "Rechnungen",
 "Notebook e carregador": "Laptop und Ladegerät",
 "Nova avaliação": "Neuer Leistungsnachweis",
 "Nova caixa (ex.: Compras, Ideias)": "Neue Box (z. B. Einkäufe, Ideen)",
 "Nova conversa": "Neuer Chat",
 "Nova garantia": "Neue Garantie",
 "Nova matéria": "Neues Fach",
 "Nova meta": "Neues Ziel",
 "Nova pasta": "Neuer Ordner",
 "Nova página": "Neue Seite",
 "Nova página com esta caixa": "Neue Seite mit dieser Box",
 "Nova refeição": "Neue Mahlzeit",
 "Nova tarefa": "Neue Aufgabe",
 "Nova tarefa da casa": "Neue Haushaltsaufgabe",
 "Nova tarefa neste cômodo": "Neue Aufgabe in diesem Raum",
 "Novas": "Neu",
 "Novo": "Neu",
 "Novo alerta:": "Neuer Alarm:",
 "Novo cartão": "Neue Karte",
 "Novo cartão de crédito": "Neue Kreditkarte",
 "Novo cuidado": "Neue Pflege",
 "Novo documento": "Neues Dokument",
 "Novo e-mail": "Neue E-Mail",
 "Novo fichário": "Neuer Ordner",
 "Novo grupo": "Neue Gruppe",
 "Novo item": "Neuer Eintrag",
 "Novo perfil": "Neues Profil",
 "Novo suplemento": "Neue Nahrungsergänzung",
 "Novo treino": "Neues Training",
 "Novo: {nome}": "Neu: {nome}",
 "Novos": "Neu",
 "Num período": "In einem Zeitraum",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Nummeriere jeden Karton und gib Zimmer und Inhalt an. Mit der Suche findest du, wo was ist.",
 "Nº": "Nr.",
 "Não": "Nein",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "Ich habe den Gesamtbetrag auf dem Kassenbon nicht gefunden. Versuch ein schärferes Foto.",
 "Não consegue entrar?": "Du kannst dich nicht anmelden?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "\"{nome}\" konnte nicht geöffnet werden. Versuch das Werkzeug PDF reparieren.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "Der Anruf konnte nicht verbunden werden. Prüfe deine Internetverbindung und versuch es noch einmal.",
 "Não deu certo: {msg}": "Hat nicht geklappt: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "Dieses PDF lässt sich nicht weiter verkleinern ({tam}).",
 "Não dá para tirar todas as páginas.": "Du kannst nicht alle Seiten entfernen.",
 "Não encontrei texto neste PDF.": "Kein Text in diesem PDF gefunden.",
 "Não encontrei texto neste documento.": "Kein Text in diesem Dokument gefunden.",
 "Não foi possível": "Nicht möglich",
 "Não foi possível abrir": "Öffnen nicht möglich",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "Das gespeicherte Zertifikat konnte nicht geöffnet werden. Verbinde das Zertifikat erneut.",
 "Não foi possível abrir.": "Konnte nicht geöffnet werden.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "Die Feiertage dieses Landes konnten nicht geladen werden. Prüfe deine Internetverbindung.",
 "Não foi possível conectar": "Verbindung nicht möglich",
 "Não foi possível conectar o {nome}": "{nome} konnte nicht verbunden werden",
 "Não foi possível consultar o DJEN agora.": "Das DJEN kann gerade nicht abgefragt werden.",
 "Não foi possível continuar": "Fortfahren nicht möglich",
 "Não foi possível criar um evento na agenda: {msg}": "Termin konnte nicht im Kalender erstellt werden: {msg}",
 "Não foi possível entrar.": "Anmeldung nicht möglich.",
 "Não foi possível enviar": "Senden fehlgeschlagen",
 "Não foi possível enviar.": "Senden nicht möglich.",
 "Não foi possível guardar: {erro}": "Speichern nicht möglich: {erro}",
 "Não foi possível ler o arquivo.": "Die Datei konnte nicht gelesen werden.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "Der Kalender konnte nicht gelesen werden. Prüfe den Link unter Bearbeiten.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "Suche gerade nicht möglich. Es wird später automatisch erneut versucht.",
 "Não foi possível reiniciar sozinho.": "Automatischer Neustart nicht möglich.",
 "Não foi possível sincronizar com a agenda: {msg}": "Synchronisierung mit dem Kalender nicht möglich: {msg}",
 "Não foi possível trocar a foto": "Foto konnte nicht geändert werden",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "Bei geschlossener App ist ein Hinweis nicht garantiert. Die Prüfung erfolgt beim Öffnen der App (alle 6 Stunden) oder über \"Jetzt prüfen\".",
 "Não identificado": "Nicht erkannt",
 "Não marcada como feita": "Nicht als erledigt markiert",
 "Não optante pelo Simples": "Nicht im Simples",
 "Não se repete": "Wiederholt sich nicht",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "Nutze die App nicht für illegale Aktivitäten, zum Speichern fremder Inhalte ohne Erlaubnis oder für Versuche, auf Daten anderer Personen zuzugreifen.",
 "Não vai": "Kommt nicht",
 "Não vence": "Läuft nicht ab",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "Wir verkaufen deine Daten nicht und nutzen deine Inhalte nicht für Werbung.",
 "Não é possível adicionar esta pessoa.": "Diese Person kann nicht hinzugefügt werden.",
 "Não é um XML de nota fiscal": "Keine Rechnungs-XML",
 "Número": "Nummer",
 "Número (opcional)": "Nummer (optional)",
 "Número da OAB": "OAB-Nummer",
 "Número da caixa": "Kartonnummer",
 "Número da carteirinha": "Versichertennummer",
 "Número da guia do convênio": "Nummer der Versicherungsanweisung",
 "Número da parcela": "Ratennummer",
 "Número de hóspedes": "Anzahl der Gäste",
 "Número de parcelas": "Anzahl der Raten",
 "Número do contrato": "Vertragsnummer",
 "Número do registro": "Registriernummer",
 "Número na chamada": "Nummer in der Klassenliste",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Nummer {n}. Das XML wurde in der Rechnung gespeichert. Tippe darauf, um das PDF zu sehen.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "Nummer, ausstellende Behörde und Anmerkungen werden auf dem Gerät verschlüsselt (AES-256), bevor sie in die Cloud gehen.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Nummer, ausstellende Behörde, Notizen, Fotos und PDFs werden auf dem Gerät verschlüsselt (AES-256). Geschützte Dateien bleiben nur auf diesem Gerät.",
 "Número: {n}": "Nummer: {n}",
 "Números de página": "Seitenzahlen",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT kann hier kein PDF lesen. Mach ein Foto oder einen Screenshot der Seite oder nutze Claude oder Gemini unter Einstellungen › Künstliche Intelligenz.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "Der DAS ist am {dia}. fällig. Markiere ihn unter Finanzen als bezahlt.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "Das Büro ist auf dem Server noch nicht aktiviert. Führe auf dem Computer 29-SERVIDOR-0.45.bat aus (nur einmal).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achado kümmert sich um dein Geld: Zahlungen, Karten und Abrechnungen, Budget nach Kategorie, Ziele, Kontoauszug und Kassenbon per Foto, Bericht und MEI.",
 "O Mestre está pensando...": "Der Mestre denkt nach...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner erstellt den Ordner \"My Planner\" in deinem Drive und sieht nur, was es selbst dort gespeichert hat.",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner ist jetzt auf dem Computer geöffnet, mit deinen Daten.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner liest die Uhrdaten über {fonte}, wo die Uhr und die Gesundheits- und Fitness-Apps alles speichern.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner organisiert deinen Kalender, Aufgaben, Finanzen, Dokumente und andere Lebensbereiche. Anbieter ist Walter Ravasco da Costa, der Verantwortliche für die in der App verarbeiteten personenbezogenen Daten.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner verwendet nur den Ordner Apps › My Planner in deinem OneDrive.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "Das PDF und die Bilder werden von diesem Gerät und aus der Cloud entfernt.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "Das PDF ist größer als 15 MB. Wenn WhatsApp oder die E-Mail es ablehnt, aktiviere \"Kleinere Datei\".",
 "O QUE COMER": "WAS ESSEN",
 "O QUE OS MEMBROS PODEM": "WAS MITGLIEDER DÜRFEN",
 "O QUE VOCÊ MANDA": "WAS DU SENDEST",
 "O QUE VOCÊ RECEBE": "WAS DU EMPFÄNGST",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "Die Anmeldung erfolgt weiterhin über die CPF. Über die E-Mail kann dich der Support erreichen.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "Der Gruppen-Admin kann Termine, Materialien und Hinweise senden. Nichts landet in deinem Kalender, ohne dass du zustimmst.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "Der Alarm klingelt alle 2 Minuten erneut (bis zu 4-mal), solange das Medikament nicht als eingenommen markiert ist.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "Die App hilft beim Organisieren, ersetzt aber nicht den Rat von Ärzten, Anwälten, Steuerberatern oder anderen Fachleuten. Prüfe wichtige Fristen, Beträge und Termine.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "Die App erinnert dich 3 Tage vorher und am Fälligkeitstag um 9 Uhr.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "Die App fragt den öffentlichen Dienst des CNJ (DJEN) mit den Namen und der OAB ab, die du einträgst. Diese Daten werden bei jeder Prüfung an diesen Dienst gesendet.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "App und Server von My Planner fragen den öffentlichen Dienst des CNJ (DJEN) mit den Namen und OAB-Nummern ab, die du einträgst, und, wenn du es aktivierst, Querido Diário (kommunale Amtsblätter). Diese Daten werden bei jeder Prüfung an diese Dienste gesendet.",
 "O app fechou sozinho {n} vezes seguidas": "Die App hat sich {n}-mal hintereinander selbst geschlossen",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "Die auf diesem Gerät installierte App ist Version {v}. Für Audio- und Videoanrufe installiere die App 0.35 oder neuer (neue APK). Nachrichten funktionieren bereits.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "Die App wurde nicht geschlossen und deine Daten sind gespeichert. Versuche es erneut oder sende den Bericht, damit das Team es behebt.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "Die App verlangt die Entsperrung beim Öffnen und bei der Rückkehr aus dem Hintergrund.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "Die App verlangt beim Öffnen die Entsperrung. Ein kurzer Wechsel der App oder des Bildschirms verlangt sie nicht erneut; wird das Handy gesperrt oder bleibt die App länger als die Zeit unten außerhalb des Bildschirms, schon.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "Die App liest nur (Schritte, Strecke, Kalorien, Training, Puls und Schlaf) und ändert deine Gesundheitsdaten nie. Die Tagessummen werden in deinem Konto gespeichert, damit sie auch auf der Website und auf dem anderen Handy erscheinen.",
 "O app volta a pedir a senha para desbloquear.": "Die App verlangt zum Entsperren wieder das Passwort.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "Die App ist für Personen ab 18 Jahren gedacht. Daten von Kindern dürfen nur von Eltern oder Erziehungsberechtigten eingetragen werden.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "Die Datei ist nur auf diesem Gerät. Speichern in {nome} nicht möglich: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "Die Datei ist nicht mehr dort (gelöscht oder verschoben).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "Die Datei ist nicht mehr dort (gelöscht, verschoben oder ihre App hat die Berechtigung entzogen). Hänge sie erneut an.",
 "O arquivo passa de 15 MB.": "Die Datei ist größer als 15 MB.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "Die Datei ist größer als 15 MB. Aktiviere \"Kleinere Datei\" und versuch es noch einmal.",
 "O arquivo passa de 25 MB.": "Die Datei ist größer als 25 MB.",
 "O arquivo passa de 50 MB.": "Die Datei ist größer als 50 MB.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "Die Datei verlässt dieses Handy. Kopien, die du in Drive, OneDrive gespeichert oder verschickt hast, bleiben dort.",
 "O arquivo sai do escritório para todos.": "Die Datei wird für alle aus dem Büro entfernt.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "Die Erinnerung kommt um 9 Uhr und noch einmal am Ablauftag.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "Die Datenbank ist noch nicht eingerichtet. Führe die Datei supabase/schema.sql in Supabase aus.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "Die Karte {c} ist zu {p} % ausgeschöpft. Mach darauf vorerst keine neuen Ratenkäufe.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "Das Handy meldet der App nicht, wenn der Bildschirm gesperrt wird, deshalb zählt die App die Zeit außerhalb. Bei 1 Minute verlangt Sperren und späteres Zurückkehren die Biometrie; eine kurze Nachricht beantworten nicht.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "Das Handy dient nur zur Bestätigung, dass das Konto dir gehört (Code per WhatsApp bei der Registrierung und beim Nummernwechsel). Eine Nummer pro Konto.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "Das Teilen wurde auf dem Server noch nicht eingeschaltet. Öffne am Computer den Ordner C:\\MyPlanner und doppelklicke auf 12-LIGAR-COMPARTILHAMENTO.bat (nur einmal).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "Der Computer öffnet My Planner mit deinem Konto. Mach das nur auf vertrauenswürdigen Computern.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "Die Einladung enthält den Link zur App und zur neuesten APK. Wer über den Link beitritt, landet direkt im Büro.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "Der Empfehlungscode gilt nur in den ersten 30 Tagen des Kontos.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "Das Muster wird nur auf diesem Gerät geschützt gespeichert. Wenn du das Muster vergisst, gilt weiterhin das Passwort.",
 "O dinheiro gasto está à frente do andamento da obra.": "Die Ausgaben sind dem Baufortschritt voraus.",
 "O documento não tem páginas.": "Das Dokument hat keine Seiten.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "Der Kontoauszug wird hier auf dem Gerät gelesen. Offene Rechnungen mit gleichem Betrag und nahem Datum werden automatisch als bezahlt markiert.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "Der Kontoauszug wird hier auf dem Gerät gelesen. Offene Zahlungen mit gleichem Betrag und nahem Datum werden automatisch erledigt. Die Zahlung der Kartenabrechnung wird nicht doppelt gezählt.",
 "O governo recusou a nota": "Die Behörde hat die Rechnung abgelehnt",
 "O governo recusou a nota.": "Die Behörde hat die Rechnung abgelehnt.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "Die Sprache gilt für dieses Gerät. Die von dir eingegebenen Daten werden nicht übersetzt.",
 "O item vinculado foi apagado ou movido.": "Das verknüpfte Element wurde gelöscht oder verschoben.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "Das verknüpfte Element wurde gelöscht oder verschoben. Bearbeite die Aufgabe, um ein anderes zu wählen.",
 "O link antigo deixa de funcionar.": "Der alte Link funktioniert dann nicht mehr.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "Der alte Link funktioniert nicht mehr. Wer schon in der Gruppe ist, bleibt drin.",
 "O link deve começar com https://": "Der Link muss mit https:// beginnen",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "Der Browser kann die Kalender der Plattformen nicht lesen. Importiere über die App auf dem Handy.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "Der Basistarif und die Testphasen der Tabs folgen den Regeln unter Einstellungen > Käufe. Empfehlungsvorteile gelten einmal pro Konto.",
 "O que acontece": "Was passiert",
 "O que apagar": "Was löschen",
 "O que comprou": "Was du gekauft hast",
 "O que fazer": "Was zu tun ist",
 "O que foi comido:": "Was gegessen wurde:",
 "O que foi feito": "Was gemacht wurde",
 "O que foi visto": "Was gesehen wurde",
 "O que funcionou, o que ajustar, metodologias, resumos...": "Was funktioniert hat, was anzupassen ist, Methoden, Zusammenfassungen...",
 "O que já foi guardado continua nos lançamentos como investimento.": "Was schon gespart wurde, bleibt in den Buchungen als Investition.",
 "O que levar ou estudar": "Mitbringen oder lernen",
 "O que o app pode usar": "Was die App nutzen darf",
 "O que o médico disse": "Was der Arzt gesagt hat",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "Was deine Gruppen gesendet haben. Angenommene Termine kommen in My Planner; Materialien und Hinweise in Notizen.",
 "O que precisa": "Was benötigt wird",
 "O que tem dentro": "Was drin ist",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "Was du verliehen oder geliehen hast: Foto, wer es hat, und Erinnerung an die Rückgabe.",
 "O que é apagado": "Was gelöscht wird",
 "O quê": "Was",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "Die Auswahl zeigt Google Drive, OneDrive und Dropbox, wenn diese Apps auf dem Handy installiert sind. Die App speichert nur eine Verknüpfung: Die Datei bleibt, wo sie ist, und öffnet sich in der App des Handys.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "Die Auswahl zeigt Google Drive, OneDrive und Dropbox, wenn diese Apps auf dem Handy installiert sind. Die gewählte Datei wird auf diesem Gerät gespeichert.",
 "O servidor ainda não buscou para os seus perfis.": "Der Server hat für deine Profile noch nicht gesucht.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "Der Server ist noch nicht für Nachrichten bereit. Führe 17-LIGAR-MENSAGENS.bat aus.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "Der Server ist noch nicht für Empfehlungen bereit. Versuche es später erneut.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "Der Server ist noch nicht für die Kontaktkarte eingerichtet. Führe 19-LIGAR-CONTATO.bat aus.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Der Server ist noch nicht für gemeinsame Daten eingerichtet. Öffne am Computer den Ordner C:\\MyPlanner und doppelklicke auf 15-LIGAR-GRUPOS-COLABORATIVOS.bat (nur einmal).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "Der Server ist noch nicht für Drive und OneDrive eingerichtet (siehe COMO RODAR, Version 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "Der Server ist noch nicht für den Webzugriff eingerichtet (führe supabase/migracao-0.6.sql aus).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "Der Server hat die Funktion \"qr-login\" noch nicht. Siehe den Schritt zu Version 0.6 in COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "Der Anrufserver hat den LiveKit-Schlüssel abgelehnt. Führe auf dem Computer des Admins 30-CONSERTAR-CHAMADAS.bat aus.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "Der Rechnungsserver hat unerwartet geantwortet (HTTP {s}). Prüfe die Adresse.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Der Server ruft alle 2 Stunden automatisch ab, von 08:00 bis 20:00 Uhr (Brasília-Zeit), auch wenn die App geschlossen ist. Die abgerufenen Veröffentlichungen erscheinen, wenn du die App öffnest. Du kannst auch „Jetzt prüfen“ verwenden.",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Der Server führt die automatische Erfassung täglich um 08:00 und 12:00 Uhr (Brasília-Zeit) durch, auch wenn die App geschlossen ist. Erfasste Veröffentlichungen erscheinen, wenn du die App öffnest. Du kannst auch \"Jetzt prüfen\" verwenden.",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Der Server hat den Zugriff verweigert: Deaktiviere in der Supabase-Funktion „nuvem“ die Option „Verify JWT“ (32-LIGAR-DRIVE-ONEDRIVE.bat erledigt das bereits).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Der Server hat den Zugriff verweigert: Schalte in der Supabase-Funktion „nuvem“ „Verify JWT“ aus (9-LIGAR-DRIVE-ONEDRIVE.bat erledigt das bereits).",
 "O seu papel no grupo não permite incluir aqui.": "Deine Rolle in der Gruppe erlaubt hier kein Hinzufügen.",
 "O site deve começar com https://": "Die Website muss mit https:// beginnen",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "Die Standardgröße des Glases ({copo}) änderst du unter Anpassen im Wasser-Bereich.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "Das Thema ändert die Farben der Tabs (die Symbole bleiben gleich) und gilt im hellen und dunklen Modus. Danach kannst du die Farbe eines Tabs weiterhin unter Einstellungen > Tabs ändern.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "Der Timer füllt sich mit Farbe, während die Zeit der Aufgabe vergeht. Ein Tippen darauf öffnet die Verknüpfung der Aufgabe.",
 "O teste grátis terminou": "Der Gratis-Test ist beendet",
 "O texto": "Der Text",
 "O texto do PDF num arquivo .docx para editar.": "Der PDF-Text in einer .docx-Datei zum Bearbeiten.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "Der Text steckt auch unsichtbar im PDF: Du kannst ihn im PDF-Reader suchen und kopieren.",
 "O tom escolhido fica para os próximos emojis.": "Der gewählte Hautton bleibt für die nächsten Emojis.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "Die Summe erscheint oben in My Planner. Wenn sie das Limit überschreitet, wird der Blitz rot. Aufgaben mit \"Entspannen\" zählen 0.",
 "OAB (opcional, para advogados)": "OAB (optional, für Anwälte)",
 "OBS": "NOTIZEN",
 "OCR: texto pesquisável": "OCR: durchsuchbarer Text",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "ODER RAUM WÄHLEN…",
 "Objetivos": "Lernziele",
 "Objeto": "Gegenstand",
 "Objetos": "Objekte",
 "Objetos e valores": "Gegenstände und Geld",
 "Obra": "Bauprojekt",
 "Obras": "Bauprojekte",
 "Obras & Reformas": "Bau & Renovierung",
 "Obrigado": "Danke",
 "Obrigado!": "Danke!",
 "Observações": "Anmerkungen",
 "Observações (alergias, ração...)": "Anmerkungen (Allergien, Futter...)",
 "Observações (chave Pix, conta para depósito...)": "Notizen (Pix-Schlüssel, Konto für Einzahlung...)",
 "Observações (código de barras, chave Pix...)": "Notizen (Barcode, Pix-Schlüssel...)",
 "Observações (dados bancários, PIX...)": "Notizen (Bankdaten, PIX...)",
 "Observações (estado do item...)": "Anmerkungen (Zustand des Gegenstands...)",
 "Observações (garantia, seguro, CET...)": "Notizen (Sicherheit, Versicherung, Effektivzins...)",
 "Observações (nº de série, modelo...)": "Notizen (Seriennr., Modell...)",
 "Observações (onde está o original, categoria da CNH...)": "Notizen (wo das Original liegt, Führerscheinklasse...)",
 "Observações (recibo de entrega, número...)": "Anmerkungen (Lieferschein, Nummer...)",
 "Observações (restrição alimentar...)": "Anmerkungen (Ernährungseinschränkung...)",
 "Ocultar texto (tarja)": "Text schwärzen",
 "Ocupado": "Belegt",
 "Oficina": "Werkstatt",
 "Ofício": "Legal",
 "Oi!": "Hi!",
 "Oi! Tudo certo para sábado?": "Hi! Alles klar für Samstag?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "Hallo {pessoa}! Ich habe noch {coisa}, das du mir geliehen hast. Wann passt es dir, dass ich es zurückgebe?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "Hallo {pessoa}! Alles gut? Ich wollte dich nur an {coisa} erinnern, das ich dir am {data} geliehen habe. Kannst du es {quando} zurückgeben?",
 "Oi?!": "Hä?!",
 "Olá!": "Hallo!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "Hallo! Ich bin Mestre Achado. Frag mich nach deinen Ausgaben, Zahlungen, Karten und Zielen: Ich antworte mit deinen Zahlen.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "Hallo! Kurze Erinnerung an die Zahlung für {ref} ({v}), fällig am {d}. Danke!",
 "Olá! Preciso de assistência técnica para: {item}": "Hallo! Ich brauche technischen Support für: {item}",
 "Olá, {nome}!": "Hallo {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "Hallo, {nome}! Herzlich willkommen.",
 "Ombros: girar para trás": "Schultern: nach hinten kreisen",
 "Omelete": "Omelett",
 "Onde": "Wo",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Wo die KI hilft: Veröffentlichungen (Gerichtstermine und Fristen), Dokumente (Formular per Foto ausfüllen) und Notizen (eine Box in Aufgaben verwandeln).",
 "Onde assistir": "Wo ansehen",
 "Onde eu mais gastei este mês?": "Wofür habe ich diesen Monat am meisten ausgegeben?",
 "Onde fica": "Wo es ist",
 "Onde guardar fotos e arquivos novos": "Wo neue Fotos und Dateien gespeichert werden",
 "Onde na página": "Wo auf der Seite",
 "Ontem": "Gestern",
 "Organizar": "Organisieren",
 "Organizar barra": "Leiste anpassen",
 "Organizar com IA": "Mit KI ordnen",
 "Organizar com IA (vira tarefas)": "Mit KI ordnen (wird zu Aufgaben)",
 "Organizar páginas": "Seiten organisieren",
 "Orgulho e vibrante": "Stolz und lebendig",
 "Origem": "Herkunft",
 "Origem da reserva": "Buchungsquelle",
 "Original": "Original",
 "Orquídeas": "Orchideen",
 "Orçado": "Geplant",
 "Orçamento": "Budget",
 "Orçamento do mês": "Monatsbudget",
 "Orçamento por categoria": "Budget nach Kategorie",
 "Orçamento total": "Gesamtbudget",
 "Orçamento: {v}": "Budget: {v}",
 "Os alertas precisam de um horário.": "Alarme brauchen eine Uhrzeit.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Anhänge, die nur auf dem Gerät liegen, erscheinen nicht auf anderen Geräten und gehen bei einem Handywechsel verloren. Verbinde Google Drive oder OneDrive in den Einstellungen, um eine Kopie zu speichern.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "Dateien und Sicherungen, die schon dort sind, bleiben erhalten. My Planner speichert nur nichts Neues mehr.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "Die auf diesem Gerät gespeicherten Dateien werden ebenfalls gelöscht.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "Dateien in deinem Google Drive, OneDrive oder auf dem Handy bleiben bei dir. Aufzeichnungen, die gesetzlich aufbewahrt werden müssen (z. B. Zugriffsprotokolle), können für die gesetzliche Frist gespeichert und dann gelöscht werden.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Die Gruppenbenachrichtigungen sind auf dem Server noch nicht aktiviert. Doppelklicke am Computer auf 15-LIGAR-GRUPOS-COLABORATIVOS.bat (nur einmal).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "Benachrichtigungen sind für My Planner ausgeschaltet. Tippe auf Einstellungen öffnen und schalte die Benachrichtigungen ein.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "Handy-Benachrichtigungen funktionieren in der installierten App (Android oder iPhone).",
 "Os campos do formulário viram parte da página.": "Die Formularfelder werden Teil der Seite.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "Die aktuellen Daten werden durch die der Datei ersetzt, hier und in der Cloud.",
 "Os dados continuam salvos na nuvem.": "Die Daten bleiben in der Cloud gespeichert.",
 "Os dados da aba ainda são só seus": "Die Daten des Tabs gehören noch nur dir",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "Die Daten des Tabs {aba} werden für das Team sichtbar, jede Person je nach der Rolle, die du wählst.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "Die Daten dieser Gruppe sind noch nicht freigegeben. Bitte die Person, die die Gruppe erstellt hat, das aktualisierte My Planner zu öffnen: Die App gibt sie automatisch frei.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "Die Daten dieser Gruppe wurden noch nicht freigegeben. Bitte die Person, die die Gruppe erstellt hat, My Planner zu aktualisieren und die Gruppe zu öffnen: Dort erscheint die Schaltfläche zum Freigeben.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "Die Tresor-Daten werden hier auf dem Gerät verschlüsselt (AES-256), bevor sie in die Cloud gehen. Nicht einmal der Support kann sie lesen. Wenn du das Tresor-Passwort vergisst, lassen sich diese Daten nicht wiederherstellen.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "Die Daten bleiben gespeichert, solange das Konto besteht. Beim Löschen des Kontos werden die Daten gelöscht, außer was gesetzlich aufbewahrt werden muss.",
 "Os desenhos não conferem. Comece de novo.": "Die Muster stimmen nicht überein. Fang neu an.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "Die Tage findest du in der App oder auf der Kartenabrechnung. Käufe nach dem Abrechnungsschluss landen in der nächsten Abrechnung.",
 "Os emojis que você usar aparecem aqui.": "Emojis, die du nutzt, erscheinen hier.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "Die Gruppen sind auf dem Server noch nicht aktiviert. Öffne am Computer den Ordner C:\\MyPlanner und doppelklicke auf 11-LIGAR-GRUPOS.bat (nur einmal).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "Die Gruppen sind auf dem Server noch nicht aktiviert. Führe supabase\\migracao-0.21.sql in Supabase aus (siehe COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "Orte werden in Google Maps, Waze oder Karten geöffnet, wie in den Einstellungen gewählt.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "Mitglieder sehen immer die Admins und erhalten nur, was an sie gesendet wurde.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Die anderen Mitglieder sehen die Daten nicht mehr (die Kopie verschwindet von ihren Geräten). Alles bleibt bei dir.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "Die Profile und Ergebnisse bleiben in deinem My-Planner-Konto.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "Die Profile, OABs und Gerichte befinden sich im Tab Veröffentlichungen. Die automatische Suche läuft auf dem Server um 08:00 und 12:00 Uhr (Brasília-Zeit).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "Die Preise werden gespeichert und erscheinen in der Einkaufsliste des Tabs Essen & Vorrat als Preis des letzten Kaufs.",
 "Os resultados deste perfil também serão apagados.": "Die Ergebnisse dieses Profils werden ebenfalls gelöscht.",
 "Os termos foram atualizados": "Die Bedingungen wurden aktualisiert",
 "Ou digite (ex.: 2 ovos mexidos)": "Oder eingeben (z. B. 2 Rühreier)",
 "Ou escreva o prato": "Oder schreib das Gericht",
 "Ou escreva o seu": "Oder eigenen Text schreiben",
 "Outra": "Andere",
 "Outra aba…": "Anderer Tab…",
 "Outra atividade (digite e dê Enter)": "Andere Aktivität (eingeben und Enter drücken)",
 "Outro": "Sonstiges",
 "Outro (ml)": "Andere (ml)",
 "Outro valor": "Anderer Betrag",
 "Outros": "Sonstiges",
 "Outros países": "Andere Länder",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Andere Uhren (Garmin, Samsung, Xiaomi, Amazfit...): Schalte in der App der Uhr die Option ein, Daten an die Health-App (Apple Health) zu senden.",
 "Ovo": "Ei",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "BEZAHLT, ERHALTEN, VERTRAULICH, GENEHMIGT oder dein Text, mit Datum.",
 "PARA ACERTAR": "ZU BEGLEICHEN",
 "PARA QUEM": "AN WEN",
 "PARA {refeicao}": "FÜR {refeicao}",
 "PASSO A PASSO": "SCHRITT FÜR SCHRITT",
 "PASSO {n}": "SCHRITT {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF mit digitalem Text: sofort fertig im Browser. Gescanntes PDF (Foto): deine KI liest jede Seite.",
 "PDF grande": "Großes PDF",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF im Ordner \"{pasta}\" auf dem Handy gespeichert.",
 "PDF guardado no {nome}.": "PDF in {nome} gespeichert.",
 "PDF numa página só": "PDF auf einer Seite",
 "PDF para Word": "PDF in Word",
 "PDF para imagens": "PDF in Bilder",
 "PDF para texto": "PDF in Text",
 "PDFs arquivados ({n})": "Archivierte PDFs ({n})",
 "PDFs juntados {data}": "Zusammengefügte PDFs {data}",
 "PEDIDOS RECEBIDOS": "ERHALTENE ANFRAGEN",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX COPY & PASTE",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "NÄCHSTE ABRECHNUNGEN (BEREITS VERPLANT)",
 "Paciente": "Patient",
 "Paciente ou aluno": "Patient oder Schüler",
 "Pacientes": "Patienten",
 "Padrão": "Standard",
 "Padrão da aba": "Tab-Standard",
 "Paga": "Bezahlt",
 "Paga (toque para desfazer)": "Bezahlt (tippen zum Rückgängigmachen)",
 "Pagador": "Zahler",
 "Pagamento já contado": "Zahlung bereits gezählt",
 "Pagar": "Zahlen",
 "Pagar parcela {n}/{t} · {c}": "Rate {n}/{t} zahlen · {c}",
 "Pagas": "Bezahlt",
 "Pago": "Bezahlt",
 "Pago com": "Bezahlt mit",
 "Pago: {p} · Falta pagar: {f}": "Bezahlt: {p} · Offen: {f}",
 "Pagos": "Bezahlt",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "{v} bezahlt? Wenn du Rabatt, Mahngebühren oder Zinsen hattest, gib den bezahlten Betrag ein. Beleg jetzt speichern?",
 "Paguei outro valor (desconto, multa ou juros)": "Ich habe einen anderen Betrag bezahlt (Rabatt, Mahngebühren oder Zinsen)",
 "Paixão de Cristo": "Karfreitag",
 "Palavras-chave (separe com vírgula)": "Stichwörter (mit Komma trennen)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "Damit das Ziel \"{m}\" rechtzeitig erreicht wird, wären {v} pro Monat nötig. Verlängere lieber die Frist oder fang mit einem kleineren Betrag an.",
 "Para clareza, firmo o presente.": "Zur Bestätigung unterzeichne ich diese Erklärung.",
 "Para comprar": "Zum Kaufen",
 "Para continuar, digite a senha do app.": "Gib zum Fortfahren das App-Passwort ein.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Zum Chatten aktiviere deine KI unter Einstellungen › Künstliche Intelligenz (Claude, ChatGPT oder Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "Um Ausgaben aufzuteilen, trage unter \"Wer kommt mit\" die Namen durch Kommas getrennt ein (Reise bearbeiten).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "Um Rechnungen auszustellen und zu suchen, verbinde einmalig den Rechnungsserver: Doppelklicke am Computer auf 13-LIGAR-NOTAS.bat und füge hier die angezeigte Adresse ein (endet auf .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "Um deine Rechte auszuüben, nutze Kontakt in der App oder schreib an die E-Mail-Adresse unten. Wir antworten innerhalb von 15 Tagen.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "Für Audio- und Videoanrufe installiere die neue Version der App (0.35). Nachrichten funktionieren schon.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "Damit die App funktioniert: deine Daten speichern und zwischen Geräten synchronisieren, Erinnerungen senden, mit den von dir gewählten Gruppen teilen und Support leisten.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "Um PDFs in {nome} zu speichern, verbinde dein Konto unter Einstellungen › Google Drive und OneDrive.",
 "Para hoje": "Nach heute",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "Um Fotos oder PDFs zu lesen, aktiviere deine KI unter Einstellungen › Künstliche Intelligenz (Claude, ChatGPT oder Gemini). Kontoauszüge als OFX oder CSV funktionieren ohne KI.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "Um die Uhr automatisch zu lesen, installiere die neue App-Version (0.33). Bis dahin kannst du die Werte manuell eingeben.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "Um die Uhr zu lesen, verbinde sie über die App auf dem Handy. Die Werte erscheinen dann auch hier.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "Um die Uhr zu lesen, gib My Planner Zugriff auf die Aktivitätsdaten.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Um den Text zu lesen, zusammenzufassen und Fragen zu stellen, aktiviere deine KI unter Einstellungen › Künstliche Intelligenz (Claude, ChatGPT oder Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "Zum Einschalten nutze die App auf dem Handy (Einstellungen > Google Kalender). Danach erscheint alles auch hier.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "Zum Aktivieren nutze die App auf dem Handy (Einstellungen › Allgemeine Einstellungen › Google Kalender). Danach erscheint alles auch hier.",
 "Para monitorar a OAB, informe o número e a UF.": "Für die OAB-Überwachung gib die Nummer und den Bundesstaat (UF) an.",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "Damit nicht mehr gefragt wird, wähle die App unter Einstellungen › Allgemeine Einstellungen.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "Für Gesundheitsberufe: Patienten, Verlauf im Tresor, Verordnungen mit Vorlagen, Finanzen, Beleg und Erstattungsbescheinigung als PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "Für Gesundheitsberufe: Patienten, Verlauf, Verordnungen mit Vorlagen, Finanzen mit Versicherung, Beleg und Erstattungsbescheinigung.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "Zum Schutz deines Kontos bestätigen wir dein Handy einmalig mit einem Code per WhatsApp. Er wird nur erneut verlangt, wenn du die Nummer wechselst.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "Für alle, die eine Unterkunft oder ein Zimmer auf Zeit vermieten (Airbnb, Booking oder direkt): Buchungen, Reinigung, Ausgaben und der Gewinn jedes Monats.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "Um Ablauf, Ort und Hinweise des Termins auf dem Handy zu erhalten, tritt der Gruppe bei: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "Erlaube My Planner in den Einstellungen deines Handys den Zugriff auf den Kalender, um zu synchronisieren.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "Um eine bereits erteilte Systemberechtigung (Kamera, Fotos, Mikrofon) zu entziehen, nutze auch die Einstellungen des Handys.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "Für eine genauere Auswertung aktiviere deine KI unter Einstellungen › Künstliche Intelligenz.",
 "Parabéns": "Glückwunsch",
 "Parabéns!": "Glückwunsch!",
 "Parada": "Still",
 "Parar": "Beenden",
 "Parar de compartilhar?": "Teilen beenden?",
 "Parar e salvar": "Stoppen und speichern",
 "Parar gravação": "Aufnahme beenden",
 "Parcela": "Rate",
 "Parcela de financiamento": "Finanzierungsrate",
 "Parcela {n}/{t}": "Rate {n}/{t}",
 "Parcela {n}/{t} · {c}": "Rate {n}/{t} · {c}",
 "Parcelas": "Raten",
 "Parcelas a pagar nos próximos meses": "In den nächsten Monaten fällige Raten",
 "Parcelas recalculadas": "Raten neu berechnet",
 "Parece que foi impresso e escaneado.": "Sieht aus wie gedruckt und gescannt.",
 "Parei": "Abgebrochen",
 "Parei na aula": "Stehen geblieben bei Lektion",
 "Parei na aula...": "Stehen geblieben bei Lektion...",
 "Pares de meia": "Paar Socken",
 "Parque ou natureza": "Park oder Natur",
 "Parques": "Parks",
 "Parte": "Partei",
 "Partes": "Parteien",
 "Participa": "Mitglied",
 "Participantes": "Teilnehmer",
 "Participação em empresa": "Unternehmensbeteiligung",
 "Passa do limite do MEI: fale com seu contador.": "Über der MEI-Grenze: sprich mit deinem Steuerberater.",
 "Passaporte": "Reisepass",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Fahre mit dem Finger über die Zeichnung, um nur diesen Teil zu löschen.",
 "Passeio": "Ausflug",
 "Passeios": "Ausflüge",
 "Passo a passo": "Schritt für Schritt",
 "Passos": "Schritte",
 "Passos, exercício, calorias, batimentos e sono": "Schritte, Training, Kalorien, Puls und Schlaf",
 "Passou do orçamento": "Budget überschritten",
 "Passou do orçamento em {v}": "Budget um {v} überschritten",
 "Pasta": "Ordner",
 "Patrimônio": "Vermögen",
 "Patrimônio & Imposto de Renda": "Vermögen & Einkommensteuer",
 "Patrimônio pelo valor de compra: {v}": "Vermögen zum Kaufpreis: {v}",
 "Pausa (s)": "Pause (s)",
 "Pausa de {m} min": "Pause von {m} Min.",
 "Pausado": "Pausiert",
 "Pausar": "Pausieren",
 "Pausas": "Pausen",
 "Pausas de estudo": "Lernpausen",
 "Pauta (opcional)": "Tagesordnung (optional)",
 "Paz": "Frieden",
 "Pediatra": "Kinderarzt",
 "Pedido": "Anforderung",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Anfrage an {nome} gesendet. Sobald sie angenommen wird, könnt ihr chatten.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Anfrage gesendet. Sobald die Person annimmt, könnt ihr chatten.",
 "Pedidos de documentos": "Dokumentanforderungen",
 "Pedir de novo depois de": "Erneut fragen nach",
 "Peguei emprestado": "Geliehen",
 "Peito de frango": "Hähnchenbrust",
 "Peixe": "Fisch",
 "Pela última compra: cerca de {v}": "Laut letztem Kauf: etwa {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "Mit den Zahlungen, die diesen Monat noch fällig sind, fehlen dir {v}. Schau, was du verschieben oder streichen kannst, bevor du neue Ausgaben machst.",
 "Pendente": "Ausstehend",
 "Pensão alimentícia": "Unterhalt",
 "Pequena": "Klein",
 "Pequeno": "Klein",
 "Percentual de tributos do Simples (para sair na nota)": "Steueranteil im Simples (erscheint auf der Rechnung)",
 "Perguntar ao Mestre": "Den Mestre fragen",
 "Perguntar sempre": "Immer fragen",
 "Pergunte ao Mestre...": "Frag den Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Frag etwas zum Dokument (z. B. Wie lautet die Frist?)",
 "Permissões": "Berechtigungen",
 "Personalizado": "Benutzerdefiniert",
 "Perto do limite do orçamento": "Budgetgrenze fast erreicht",
 "Período": "Zeitraum",
 "Período da meta": "Zielzeitraum",
 "Pescoço: inclinar para os lados": "Nacken: zur Seite neigen",
 "Peso": "Gewicht",
 "Peso na média": "Gewichtung",
 "Pesquisar no mapa": "Auf der Karte suchen",
 "Pessoa": "Person",
 "Pessoa de contato": "Ansprechpartner",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "Personen in deinen Gruppen sehen nur, was in der Gruppe geteilt wird.",
 "Pet": "Haustier",
 "Pet & Família": "Haustier & Familie",
 "Pet shop": "Tiersalon",
 "Pet shop ou clínica": "Tiersalon oder Tierklinik",
 "Pets": "Haustiere",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Fordere Dokumente mit Frist beim Kunden an. Er erhält die Anfrage, hängt an und markiert sie als geliefert.",
 "Pijamas": "Schlafanzüge",
 "Pilates": "Pilates",
 "Pintura": "Malerarbeiten",
 "Pix copia e cola": "Pix Copy & Paste",
 "Placa": "Kennzeichen",
 "Planejado": "Geplant",
 "Planejado e comido": "Geplant und gegessen",
 "Planilha": "Tabelle",
 "Planilha (Excel)": "Tabelle (Excel)",
 "Planilha do mês para o Receita Saúde": "Monatstabelle für Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Basistarif: My Planner + Notizen",
 "Plano de aula": "Unterrichtsplan",
 "Plano de saúde": "Krankenversicherung",
 "Planos de aula": "Unterrichtspläne",
 "Planta": "Pflanze",
 "Plantas": "Pflanzen",
 "Plantas & Jardim": "Pflanzen & Garten",
 "Plataforma ou escola": "Plattform oder Schule",
 "Pneus novos": "Neue Reifen",
 "Podcast": "Podcast",
 "Pode confirmar sua presença respondendo esta mensagem?": "Kannst du deine Teilnahme bestätigen, indem du auf diese Nachricht antwortest?",
 "Polichinelo": "Hampelmänner",
 "Polo ativo": "Klägerseite",
 "Polo passivo": "Beklagtenseite",
 "Política de privacidade (LGPD)": "Datenschutzerklärung (LGPD)",
 "Política de privacidade, LGPD e permissões": "Datenschutzerklärung, LGPD und Berechtigungen",
 "Política de privacidade, LGPD e termos": "Datenschutzerklärung, LGPD und Bedingungen",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Leg hier die Fotos und Videos der Reise ab. In der Gruppe sehen alle sie und alle können ihre eigenen hinzufügen.",
 "Ponte de glúteos": "Glute Bridge",
 "Ponto facultativo": "Optionaler Feiertag",
 "Ponto facultativo: {nome}": "Optionaler Feiertag: {nome}",
 "Ponto turístico": "Sehenswürdigkeit",
 "Pontos turísticos": "Sehenswürdigkeiten",
 "Por dia": "Pro Tag",
 "Por faixas": "Nach Bereichen",
 "Por mês": "Pro Monat",
 "Por nome": "Nach Name",
 "Por semana": "Pro Woche",
 "Portal": "Portal",
 "Portal do Cliente": "Kundenportal",
 "Portal do cliente (convidar o cliente)": "Kundenportal (Kunden einladen)",
 "Português": "Portugiesisch",
 "Porão": "Keller",
 "Porções": "Portionen",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Wenig freier Speicher: neue Fotos und Anhänge werden eventuell nicht gespeichert. Gib Speicher frei oder speichere Anhänge in Google Drive oder OneDrive.",
 "Praia": "Strand",
 "Prancha": "Unterarmstütz",
 "Prato do cardápio": "Gericht aus dem Speiseplan",
 "Prato principal": "Hauptgericht",
 "Prazo": "Frist",
 "Prazo (pagamento ou entrega)": "Frist (Zahlung oder Abgabe)",
 "Prazo até {fim} · fazer em {dia}": "Frist bis {fim} · erledigen am {dia}",
 "Prazo final: {fim}": "Fristende: {fim}",
 "Prazo: {d}": "Frist: {d}",
 "Prazo: {t}": "Frist: {t}",
 "Prazos criados": "Fristen angelegt",
 "Precisa da sua IA": "Braucht deine KI",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Fülle Beschreibung, nationalen Steuercode (6 Ziffern) und Betrag aus.",
 "Preenche os campos do PDF e, se quiser, trava.": "Füllt die Felder des PDFs aus und sperrt sie auf Wunsch.",
 "Preencher formulário": "Formular ausfüllen",
 "Preencher pela foto com a minha IA": "Per Foto mit meiner KI ausfüllen",
 "Preencher pela nota fiscal com a minha IA": "Mit meiner KI aus der Rechnung ausfüllen",
 "Preparando a conversa da equipe...": "Team-Chat wird vorbereitet...",
 "Preparando a página {n} de {total}...": "Seite {n} von {total} wird vorbereitet...",
 "Preparando o arquivo": "Datei wird vorbereitet",
 "Prescrição, conduta e orientações": "Verordnung, Vorgehen und Hinweise",
 "Presente": "Anwesend",
 "Presença": "Anwesenheit",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Halte den Code gedrückt, um ihn zu kopieren, oder tippe auf Senden und wähle \"Kopieren\".",
 "Pressione e segure o código para copiar.": "Halte den Code gedrückt, um ihn zu kopieren.",
 "Pressione e segure um lançamento para apagar.": "Halte eine Buchung gedrückt, um sie zu löschen.",
 "Pressione e segure um perfil para removê-lo.": "Halte ein Profil gedrückt, um es zu entfernen.",
 "Preto e branco": "Schwarz-weiß",
 "Previdência privada": "Private Altersvorsorge",
 "Preço ou ingresso": "Preis oder Eintritt",
 "Price": "Annuität (Price)",
 "Primeira": "Erste",
 "Primeira cota ou cota única do IR": "Erste Rate oder Einmalzahlung der IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "Erste Rate in der Abrechnung {mes}, fällig am {data}.",
 "Prioridade": "Priorität",
 "Privacidade": "Datenschutz",
 "Privacidade e termos": "Datenschutz und Bedingungen",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Datenschutz: Der analysierte Text oder das Bild geht mit deinem Schlüssel direkt von diesem Gerät an den gewählten KI-Anbieter. My Planner speichert keine Kopie.",
 "Problema": "Problem",
 "Problemas, erros e sugestões": "Probleme, Fehler und Vorschläge",
 "Procedimento": "Behandlung",
 "Procedimento: {c}": "Leistung: {c}",
 "Processo": "Verfahren",
 "Processo Civil": "Zivilprozessrecht",
 "Processo Penal": "Strafprozessrecht",
 "Processo do Trabalho": "Arbeitsprozessrecht",
 "Processo não informado": "Verfahren nicht angegeben",
 "Proclamação da República": "Ausrufung der Republik",
 "Procurando a folha...": "Blatt wird gesucht...",
 "Procurando atualização...": "Suche nach Updates...",
 "Procurar aba": "Tab suchen",
 "Procurar atualização agora": "Jetzt nach Updates suchen",
 "Procurar documento": "Dokument suchen",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Werkzeug suchen (z. B. zusammenfügen, unterschreiben, komprimieren)",
 "Produto": "Produkt",
 "Produto (ex.: Geladeira)": "Produkt (z. B. Kühlschrank)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Produkte, Rechnungen, Kundendienst und Hinweis vor Ablauf.",
 "Produção (vale de verdade)": "Produktion (rechtsgültig)",
 "Produção restrita (teste)": "Eingeschränkte Produktion (Test)",
 "Produção restrita (teste, não vale)": "Eingeschränkte Produktion (Test, ungültig)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Eingeschränkte Produktion: Testumgebung der Behörde. Die Rechnungen sind ungültig. Teste hier alles, bevor du auf Produktion umstellst (unter Bearbeiten).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Produktion: Ausgestellte Rechnungen sind rechtsgültig und gehen an die Stadtverwaltung und die Receita.",
 "Produção: vale de verdade": "Produktion: rechtsgültig",
 "Professor": "Lehrer",
 "Professor & Mentoria": "Lehrer & Mentoring",
 "Professor(a)": "Lehrer(in)",
 "Profissionais": "Handwerker",
 "Profissional": "Handwerker",
 "Profissional assistente": "Assistenzkraft",
 "Profissional ou fornecedor": "Handwerker oder Lieferant",
 "Profissional ou local": "Fachkraft oder Ort",
 "Profissão ou especialidade": "Beruf oder Fachgebiet",
 "Profissões": "Berufe",
 "Programação": "Programmieren",
 "Progresso geral": "Gesamtfortschritt",
 "Projeto e licenças": "Planung und Genehmigungen",
 "Projetos": "Projekte",
 "Prontas": "Vorlagen",
 "Pronto": "Fertig",
 "Pronto! Todas as abas estão liberadas até {data}.": "Fertig! Alle Tabs sind bis {data} freigeschaltet.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "Fertig. Sperre den Bildschirm und warte 1 Minute: Die Benachrichtigung sollte mit Ton erscheinen.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Krankenakte, Verlauf und Verordnungen, ohne Finanzen.",
 "Protegendo a chave...": "Schlüssel wird geschützt...",
 "Proteger no cofre": "Im Tresor schützen",
 "Protegido": "Geschützt",
 "Protegido no cofre": "Im Tresor geschützt",
 "Protegidos pelo cofre: {n}": "Durch den Tresor geschützt: {n}",
 "Protetor solar": "Sonnenschutz",
 "Protocolo": "Vorgangsnummer",
 "Prova": "Klassenarbeit",
 "Próxima": "Nächste",
 "Próxima até a data": "Nächste bis Datum",
 "Próxima com quantos km": "Nächste bei km",
 "Próxima dose": "Nächste Dosis",
 "Próxima: {data}": "Nächste: {data}",
 "Próxima: {d} · {v}": "Nächste: {d} · {v}",
 "Próximas": "Anstehend",
 "Próximo": "Weiter",
 "Próximo ano": "Nächstes Jahr",
 "Próximo número da DPS": "Nächste DPS-Nummer",
 "Próximos 7 dias": "Nächste 7 Tage",
 "Próximos vencimentos ({n})": "Nächste Fälligkeiten ({n})",
 "Publicação": "Veröffentlichung",
 "Publicações": "Veröffentlichungen",
 "Pula": "Hüpfen",
 "Pulsa": "Pulsieren",
 "Punho": "Faust",
 "Puxada frontal": "Latziehen",
 "PÁGINAS": "SEITEN",
 "PÔR NA BARRA": "IN DIE LEISTE",
 "Pág. {n}": "S. {n}",
 "Página": "Seite",
 "Página 1": "Seite 1",
 "Página 1 de 10": "Seite 1 von 10",
 "Página em branco no fim": "Leere Seite am Ende",
 "Página em que estou": "Aktuelle Seite",
 "Página escaneada": "Seite gescannt",
 "Página inteira": "Ganze Seite",
 "Página {a} de {n}": "Seite {a} von {n}",
 "Página {n}": "Seite {n}",
 "Página {n} de {total}": "Seite {n} von {total}",
 "Página: {titulo}": "Seite: {titulo}",
 "Páginas": "Seiten",
 "Páginas, tamanho, autor, datas e campos.": "Seiten, Größe, Autor, Daten und Felder.",
 "Pássaro": "Vogel",
 "Pão francês": "Brötchen",
 "Pão integral": "Vollkornbrot",
 "Pôr a data de hoje": "Heutiges Datum einfügen",
 "Pôr as parcelas no My Planner": "Raten in den My Planner übernehmen",
 "Pôr na barra": "In die Leiste",
 "Pôr no roteiro da viagem": "Ins Reiseprogramm aufnehmen",
 "Pôr uma foto": "Foto hinzufügen",
 "Quadro": "Board",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Kanban-Board, Stundenzähler pro Kunde und Fristen in My Planner.",
 "Quais contas vencem nos próximos dias?": "Welche Zahlungen sind in den nächsten Tagen fällig?",
 "Quais páginas ficam no PDF novo": "Welche Seiten ins neue PDF kommen",
 "Quais páginas sair": "Welche Seiten entfernen",
 "Qual IA": "Welche KI",
 "Qualidade alta": "Hohe Qualität",
 "Qualidade boa (menor)": "Gute Qualität (kleiner)",
 "Quantidade": "Menge",
 "Quanto cortar de cada lado (% da página)": "Wie viel an jeder Seite abschneiden (% der Seite)",
 "Quanto já tem guardado (opcional)": "Bereits gespart (optional)",
 "Quanto paga por limpeza": "Betrag pro Reinigung",
 "Quanto preciso guardar por mês para as minhas metas?": "Wie viel muss ich pro Monat für meine Ziele sparen?",
 "Quanto quer juntar": "Wie viel du sparen willst",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "Wie viel du höchstens pro Monat in jeder Kategorie ausgeben willst. Leer lassen, um nicht zu kontrollieren.",
 "Quarta": "Mittwoch",
 "Quarta-feira de Cinzas (até 14h)": "Aschermittwoch (bis 14 Uhr)",
 "Quarto": "Schlafzimmer",
 "Quarto das crianças": "Kinderzimmer",
 "Quarto de casal": "Elternschlafzimmer",
 "Quarto de hóspedes": "Gästezimmer",
 "Quarto infantil": "Kinderzimmer",
 "Queijo": "Käse",
 "Queixa principal": "Hauptbeschwerde",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Wer den Link öffnet, lädt My Planner herunter (oder nutzt es im Browser), meldet sich an und wird Teil der Gruppe.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Wer mit deinem Code ein Konto erstellt, ist hier sofort dein Freund, ohne Anfrage.",
 "Quem enviou": "Absender",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Wer mit dir in einer App-Gruppe ist (Klasse, Familie, Reise...), kann schon ohne Freundschaft chatten. Halte einen Freund gedrückt, um die Freundschaft zu beenden oder ihn zu blockieren.",
 "Quem faz a limpeza": "Wer reinigt",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Wer zahlt, falls nicht der Patient (Mutter, Vater, Verantwortliche)",
 "Quem pagou": "Wer hat bezahlt",
 "Quem recebeu (médico, escola...)": "Empfänger (Arzt, Schule...)",
 "Quem vai": "Wer kommt mit",
 "Quem vai limpar": "Wer reinigt",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Wer sie sieht: nur Personen, die mit dir chatten, deine Freunde und Personen in einer App-Gruppe mit dir. Lass leer, was du nicht zeigen möchtest.",
 "Quente": "Warm",
 "Quer escanear mais uma página?": "Noch eine Seite scannen?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "Beleg jetzt speichern? Foto, PDF oder Screenshot vom Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "Willst du einen Screenshot schicken? Sende ihn per E-Mail als Anhang.",
 "Quer trocar pelos novos ou manter os dois?": "Durch die neuen ersetzen oder beide behalten?",
 "Quero assistir": "Will ich sehen",
 "Quero ir": "Will ich hin",
 "Quero ler": "Will ich lesen",
 "Quero ver": "Will ich sehen",
 "Quilometragem atual": "Aktueller Kilometerstand",
 "Quilometragem: {km}": "Kilometerstand: {km}",
 "Quinta": "Donnerstag",
 "Quintal": "Garten",
 "Quitado": "Getilgt",
 "Quitados": "Getilgt",
 "Química": "Chemie",
 "RECIBO": "BELEG",
 "RG / Carteira de identidade": "Personalausweis (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "Ausweis, Führerschein, Reisepass, Verträge und Urkunden, mit Erinnerung vor Ablauf und Senden mit einem Tipp.",
 "Raciocínio Lógico": "Logisches Denken",
 "Razão social ou nome": "Firmenname oder Name",
 "Razão social ou nome do consultório": "Firmenname oder Name der Praxis",
 "Razão social ou nome fantasia": "Firmenname oder Markenname",
 "Raça": "Rasse",
 "Realizado": "Durchgeführt",
 "Recado": "Nachricht",
 "Recalcular": "Neu berechnen",
 "Recalcular as parcelas em aberto": "Offene Raten neu berechnen",
 "Recalcular as parcelas?": "Raten neu berechnen?",
 "Receber": "Kassieren",
 "Receber de volta: {i} ({p})": "Zurückbekommen: {i} ({p})",
 "Receber o código no WhatsApp": "Code per WhatsApp erhalten",
 "Receber parcela {n}/{t} · {c}": "Rate {n}/{t} erhalten · {c}",
 "Recebeu um convite?": "Einladung erhalten?",
 "Recebeu um código?": "Code erhalten?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "Ich habe von {pagador}{doc} den Betrag von {valor}{extenso} erhalten, für: {tipo}, durchgeführt am {data}{paciente}.",
 "Recebi outro valor": "Ich habe einen anderen Betrag erhalten",
 "Recebida": "Erhalten",
 "Recebida (toque para desfazer)": "Erhalten (tippen zum Rückgängigmachen)",
 "Recebidas": "Erhalten",
 "Recebido": "Erhalten",
 "Recebido: {v}": "Erhalten: {v}",
 "Recebidos": "Erhalten",
 "Recebidos dos grupos": "Von Gruppen erhalten",
 "Recebimento": "Zahlungseingang",
 "Receita": "Rezept",
 "Receitas": "Rezepte",
 "Recibo": "Beleg",
 "Recibo em PDF": "Beleg als PDF",
 "Recibo emitido": "Beleg ausgestellt",
 "Recibo guardado": "Beleg gespeichert",
 "Recibos dedutíveis": "Absetzbare Belege",
 "Recomendada": "Empfohlen",
 "Recomeçar": "Neu beginnen",
 "Recortar": "Zuschneiden",
 "Recortar margens": "Ränder zuschneiden",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Zuschneiden, Drehen und Filter kommen mit der neuen App (Version 0.49).",
 "Recusada": "Abgelehnt",
 "Recusado": "Abgelehnt",
 "Recusar": "Ablehnen",
 "Redação": "Aufsatz",
 "Refazer": "Neu machen",
 "Refeição": "Mahlzeit",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Mahlzeiten, Übungen, Pflege und Nahrungsergänzungen für heute",
 "Referente a": "Betrifft",
 "Referência": "Referenz",
 "Reforço": "Auffrischung",
 "Regar a cada quantos dias": "Alle wie viele Tage gießen",
 "Regar hoje": "Heute gießen",
 "Regar: {p}": "Gießen: {p}",
 "Regional": "Regional",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Führt Tagebuch, Bauabschnitte und Lieferungen, ohne die Beträge zu sehen.",
 "Registrar venda/serviço do MEI": "MEI-Verkauf/-Leistung erfassen",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Erfasse jeden Termin: Der Verlauf liegt verschlüsselt im Tresor. Die Verordnung kann aus einer Vorlage kommen.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Erfasse Käufe und Verkäufe von Immobilien, Fahrzeugen und Geldanlagen mit den Belegen. Das hilft sehr bei der Steuer.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Trage ein, was vom Plan abwich (Lebensmittel getauscht, Mahlzeit geändert). Es fließt in den Wochenbericht ein.",
 "Registro": "Eintrag",
 "Registro clínico": "Klinischer Eintrag",
 "Registro de horas": "Stundeneintrag",
 "Registro do diário": "Tagebucheintrag",
 "Regiões com feriado próprio (marque as suas):": "Regionen mit eigenen Feiertagen (wähle deine):",
 "Regras da casa": "Hausregeln",
 "Regras da casa:": "Hausregeln:",
 "Reguei": "Gegossen",
 "Reguei hoje": "Heute gegossen",
 "Reiniciar": "Neu starten",
 "Reiniciar o app": "App neu starten",
 "Relatório": "Bericht",
 "Relatório da semana": "Wochenbericht",
 "Relatório em PDF ou Excel": "Bericht als PDF oder Excel",
 "Relatório enviado. Obrigado!": "Bericht gesendet. Danke!",
 "Relatórios": "Berichte",
 "Relatórios do Bem-Estar": "Wohlbefinden-Berichte",
 "Relatórios gerados ({n})": "Erstellte Berichte ({n})",
 "Relaxar": "Entspannen",
 "Religião": "Religion",
 "Relógio": "Uhr",
 "Relógio e apps de saúde": "Uhr und Gesundheits-Apps",
 "Remada baixa": "Rudern am Kabelzug",
 "Remover": "Entfernen",
 "Remover \"{nome}\"?": "\"{nome}\" entfernen?",
 "Remover anotações": "Anmerkungen entfernen",
 "Remover este bloco?": "Diesen Block entfernen?",
 "Remover páginas": "Seiten entfernen",
 "Remover vínculo": "Verknüpfung entfernen",
 "Remover {nome}?": "{nome} entfernen?",
 "Remédio": "Medikament",
 "Remédio contínuo": "Dauermedikation",
 "Remédio na linha do tempo": "Medikament in der Zeitleiste",
 "Remédios": "Medikamente",
 "Remédios de uso contínuo": "Dauermedikamente",
 "Renavam ou chassi": "Renavam oder Fahrgestellnummer",
 "Renegociado": "Umgeschuldet",
 "Renomear": "Umbenennen",
 "Renomear com IA": "Mit KI umbenennen",
 "Renomear ou trocar ícone": "Umbenennen oder Symbol ändern",
 "Renomear pasta": "Ordner umbenennen",
 "Renomear, ícone ou cor": "Umbenennen, Symbol oder Farbe",
 "Renovar: {nome}": "Verlängern: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Ordnet die Datei intern neu. Hilft wenig bei PDFs mit Fotos.",
 "Reparar PDF": "PDF reparieren",
 "Repelente": "Mückenschutz",
 "Repete": "Wiederholen",
 "Repetir a cada quantos dias": "Alle wie viele Tage wiederholen",
 "Repetições": "Wiederholungen",
 "Repita a senha": "Passwort wiederholen",
 "Repita a senha do cofre": "Tresor-Passwort wiederholen",
 "Repita a senha nova": "Neues Passwort wiederholen",
 "Replantio": "Umtopfen",
 "Replantios": "Umtopfungen",
 "Repor papel higiênico, sabonete e café": "Toilettenpapier, Seife und Kaffee auffüllen",
 "Representatividade": "Vielfalt",
 "Reserva": "Buchung",
 "Reservas": "Buchungen",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Buchungen, Reinigung, Einnahmen und Ausgaben im Tab Vermietung & Unterkunft",
 "Respirar fundo 5 vezes": "5-mal tief durchatmen",
 "Respondendo a {nome}": "Antwort an {nome}",
 "Responder": "Antworten",
 "Responsável": "Verantwortlich",
 "Responsável (imobiliária, vistoriador)": "Verantwortlich (Makler, Gutachter)",
 "Resposta da SEFAZ": "Antwort der SEFAZ",
 "Resta {tempo}": "Noch {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "Noch {ml} = {n} Glas/Gläser à {copo}",
 "Restaurante": "Restaurant",
 "Restaurantes": "Restaurants",
 "Restaurar": "Wiederherstellen",
 "Restaurar esta cópia?": "Diese Sicherung wiederherstellen?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "Beim Wiederherstellen werden ALLE aktuellen Daten durch die der Sicherung ersetzt, hier und in deinem Konto.",
 "Restaurar uma cópia": "Sicherung wiederherstellen",
 "Resultado": "Befund",
 "Resultado nas vendas: {v}": "Ergebnis der Verkäufe: {v}",
 "Resumir": "Zusammenfassen",
 "Resumir e perguntar": "Zusammenfassen und fragen",
 "Resumo": "Übersicht",
 "Resumo (falta o XML completo)": "Zusammenfassung (vollständiges XML fehlt)",
 "Resumo da manhã": "Morgenübersicht",
 "Resumo da pasta": "Ordnerübersicht",
 "Resumo e opinião": "Zusammenfassung und Meinung",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Übersicht, Ausgaben nach Kategorie, Zahlungen, Abrechnungen, Ziele und alle Buchungen. Gut für den Steuerberater oder als Unterlage für die Steuer (IR).",
 "Retirar": "Entnehmen",
 "Retirar da meta": "Vom Ziel entnehmen",
 "Retorno": "Kontrolltermin",
 "Reunião": "Elternabend",
 "Reunião agora": "Jetzt besprechen",
 "Reunião de equipe": "Teambesprechung",
 "Reuniões": "Besprechungen",
 "Revestimento e pisos": "Beläge und Böden",
 "Revisão": "Inspektion",
 "Revolução Constitucionalista": "Konstitutionalistische Revolution",
 "Rico em matéria orgânica": "Reich an organischem Material",
 "Rodízio de pneus": "Reifen tauschen",
 "Roedor": "Nagetier",
 "Romance": "Liebesroman",
 "Rosca direta": "Bizepscurls",
 "Rota": "Route",
 "Rota passando pelos {n} lugares que faltam": "Route durch die {n} offenen Orte",
 "Rotas e mapas": "Routen & Karten",
 "Roteiro": "Reiseprogramm",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Tagesprogramm in der Zeitleiste während der Reise, Koffer nach Wetter, Buchungen und Zeitzonen.",
 "Rotina": "Routine",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Routinen Schritt für Schritt: Skincare, Dehnen, Haare... Tippe auf \"+ Pflege\", um eine Vorlage zu wählen oder deine eigene zu erstellen.",
 "Roupa": "Kleidung",
 "Roupa social": "Festliche Kleidung",
 "Roupas de banho": "Badesachen",
 "Roupas extras das crianças": "Wechselkleidung für die Kinder",
 "Roupas íntimas": "Unterwäsche",
 "Rua": "Straße",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Straße, Hausnummer, Stadtteil, Stadt (oder Ortsname)",
 "Régua": "Lineal",
 "Réptil": "Reptil",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Bezeichnung (z. B. Mein Name, Firma des Kunden)",
 "SAC": "Ratentilgung (SAC)",
 "SEM HORÁRIO": "OHNE UHRZEIT",
 "SEU MÊS EM NÚMEROS": "DEIN MONAT IN ZAHLEN",
 "SEU TREINO": "DEIN TRAINING",
 "SEUS GRUPOS DO APP": "DEINE APP-GRUPPEN",
 "SP": "SP",
 "SUBTAREFA": "UNTERAUFGABE",
 "SUBTAREFAS": "UNTERAUFGABEN",
 "SUPLEMENTAÇÃO": "NAHRUNGSERGÄNZUNG",
 "Sabonete facial": "Gesichtsseife",
 "Sabão para lavar roupa": "Waschmittel",
 "Sacada": "Balkon",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Verschwindet nur aus der Liste dieser App. Die in Drive, OneDrive oder im Handyordner gespeicherte Kopie bleibt dort.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Nur aus der Liste entfernt. Die Datei bleibt, wo sie gespeichert wurde.",
 "Sair": "Abmelden",
 "Sair da conta?": "Vom Konto abmelden?",
 "Sair do escritório": "Büro verlassen",
 "Sair do escritório?": "Büro verlassen?",
 "Sair do grupo": "Gruppe verlassen",
 "Sair do grupo?": "Gruppe verlassen?",
 "Sair sem baixar": "Ohne Download verlassen",
 "Saiu": "Raus",
 "Sala": "Raum",
 "Sala de estar": "Wohnzimmer",
 "Sala de jantar": "Esszimmer",
 "Sala virtual": "Virtueller Raum",
 "Salada": "Salat",
 "Saldo": "Saldo",
 "Saldo depois desta parcela": "Restschuld nach dieser Rate",
 "Saldo devedor: {v}": "Restschuld: {v}",
 "Saldo do mês": "Monatssaldo",
 "Salvar": "Speichern",
 "Salvar backup do My Planner": "My-Planner-Backup speichern",
 "Salvar cuidado": "Pflege speichern",
 "Salvar cômodo": "Raum speichern",
 "Salvar e colocar no My Planner": "Speichern und in My Planner eintragen",
 "Salvar e sincronizar": "Speichern und synchronisieren",
 "Salvar e testar": "Speichern und testen",
 "Salvar endereço": "Adresse speichern",
 "Salvar no My Planner": "In My Planner speichern",
 "Salvar refeição": "Mahlzeit speichern",
 "Salvar suplemento": "Nahrungsergänzung speichern",
 "Salvar tarefa": "Aufgabe speichern",
 "Salvar treino": "Training speichern",
 "Sanduíche natural": "Leichtes Sandwich",
 "Santo Antônio": "Heiliger Antonius",
 "Sapato confortável": "Bequeme Schuhe",
 "Saudade": "Vermisse dich",
 "Saída (imóvel antigo)": "Auszug (alte Wohnung)",
 "Saída de praia": "Strandkleid",
 "Saúde": "Gesundheit",
 "Saúde & Prontuário": "Gesundheit & Patientenakte",
 "Saúde (médicos, dentistas, exames, plano)": "Gesundheit (Ärzte, Zahnärzte, Untersuchungen, Krankenversicherung)",
 "Saúde e bem-estar": "Gesundheit und Wohlbefinden",
 "Scanner": "Scanner",
 "Scanner PDF": "PDF-Scanner",
 "Sci-Fi": "Science-Fiction",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "Wenn etwas nicht reagiert, starte die App neu. Deine Daten sind gespeichert.",
 "Se der tempo": "Wenn Zeit bleibt",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "Wenn sich diese Erklärung wesentlich ändert, informiert dich die App und bittet erneut um deine Zustimmung.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "Wenn diese Benachrichtigung erschienen ist, funktionieren die Terminerinnerungen.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "Falls ein Konto mit {email} existiert, haben wir dir einen Link zum Erstellen eines neuen Passworts geschickt. Schau auch im Spam-Ordner nach.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "Wenn die Erinnerung zu spät oder gar nicht kommt: Lass in den App-Einstellungen die Benachrichtigungen an, stelle den Akku auf „Nicht eingeschränkt“ und erlaube „Wecker und Erinnerungen“.",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "Ist die Uhr verbunden, ersetzen ihre Werte die manuell eingegebenen, sobald sie die Daten hat.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "Wenn du die Uhr verbindest: Tagessummen von Schritten, Strecke, Kalorien, Training, Puls und Schlaf, gelesen aus Health Connect (Android) oder der Health-App (iPhone). Die App liest nur und ändert diese Daten nie.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "Falls du diesen Tab schon genutzt hast, wurde nichts gelöscht: Beim Abonnieren ist alles wieder wie vorher.",
 "Secretária ou recepção": "Sekretariat oder Empfang",
 "Seg a sex": "Mo–Fr",
 "Seguir": "Weiter",
 "Segunda": "Montag",
 "Segurança": "Sicherheit",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Halten und ziehen zum Umsortieren. ↻ dreht, ⧉ dupliziert und ✕ entfernt die Seite.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Halte ein GIF in einem Chat gedrückt und tippe auf \"Speichern\", damit es hier erscheint.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Halte ein Zimmer gedrückt, um es zu verschieben. Bei geöffnetem Zimmer halte eine Aufgabe gedrückt und lass sie auf einem anderen Zimmer los, um sie dorthin zu verschieben.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Halte einen Ordner, ein Fach oder eine Seite gedrückt, um die Reihenfolge zu ändern. Lass ein Fach auf einem anderen Ordner los, um es dorthin zu verschieben.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Halte einen Chat gedrückt, um ihn stummzuschalten oder zu archivieren. Archivierte Chats empfangen und senden weiter, aber ohne Benachrichtigung.",
 "Seguro": "Versicherung",
 "Seguro da casa": "Hausratversicherung",
 "Seguro viagem": "Reiseversicherung",
 "Selecionar": "Auswählen",
 "Sem": "Ohne",
 "Sem alerta": "Kein Alarm",
 "Sem categoria": "Ohne Kategorie",
 "Sem comprovante": "Ohne Beleg",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "Keine Verbindung zum Rechnungsserver. Prüfe das Internet und die Serveradresse.",
 "Sem conexão com o servidor. Confira a internet.": "Keine Verbindung zum Server. Prüfe das Internet.",
 "Sem conexão com os GIFs agora.": "Gerade keine Verbindung zu den GIFs.",
 "Sem cômodo": "Ohne Zimmer",
 "Sem data de fim": "Ohne Enddatum",
 "Sem exercícios": "Keine Übungen",
 "Sem fatura em {mes}": "Keine Abrechnung im {mes}",
 "Sem fim": "Ohne Ende",
 "Sem horário": "Ohne Uhrzeit",
 "Sem internet ou servidor ainda não preparado.": "Kein Internet oder Server noch nicht bereit.",
 "Sem internet. Envia quando voltar.": "Kein Internet. Wird gesendet, sobald es wieder da ist.",
 "Sem internet. Tente de novo.": "Keine Internetverbindung. Versuche es erneut.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Ohne das deckt der Balken nur ab: Der Text darunter bleibt in der Datei und lässt sich kopieren.",
 "Sem itens": "Keine Einträge",
 "Sem juros": "Zinsfrei",
 "Sem limite": "Ohne Limit",
 "Sem link de calendário": "Kein Kalenderlink",
 "Sem margem": "Ohne Rand",
 "Sem nome": "Ohne Namen",
 "Sem número na primeira página (capa)": "Keine Nummer auf der ersten Seite (Deckblatt)",
 "Sem pasta": "Ohne Ordner",
 "Sem pausas": "Keine Pausen",
 "Sem permissão": "Keine Berechtigung",
 "Sem prazo": "Ohne Frist",
 "Sem recibo": "Ohne Beleg",
 "Sem tarefas": "Keine Aufgaben",
 "Sem texto.": "Kein Text.",
 "Sem tomador identificado": "Kein Leistungsempfänger erkannt",
 "Sem título": "Ohne Titel",
 "Sem validade": "Ohne Ablaufdatum",
 "Semana": "Woche",
 "Semana completa": "Ganze Woche",
 "Semana de {de} a {ate}": "Woche vom {de} bis {ate}",
 "Semanal": "Wöchentlich",
 "Semanal · dias úteis": "Wöchentlich · Werktage",
 "Semanal · todos os dias": "Wöchentlich · jeden Tag",
 "Semanal · {dias}": "Wöchentlich · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Werden immer angezeigt, zusammen mit den optionalen Feiertagen (Karneval, Aschermittwoch und Fronleichnam).",
 "Senha": "Passwort",
 "Senha (8 caracteres ou mais)": "Passwort (8 oder mehr Zeichen)",
 "Senha alterada.": "Passwort geändert.",
 "Senha atual": "Aktuelles Passwort",
 "Senha atual do cofre": "Aktuelles Tresor-Passwort",
 "Senha da conta": "Konto-Passwort",
 "Senha do certificado": "Zertifikat-Passwort",
 "Senha do cofre": "Tresor-Passwort",
 "Senha do cofre alterada.": "Tresor-Passwort geändert.",
 "Senha do cofre incorreta.": "Tresor-Passwort falsch.",
 "Senha incorreta": "Falsches Passwort",
 "Senha incorreta.": "Falsches Passwort.",
 "Senha nova (8 caracteres ou mais)": "Neues Passwort (mindestens 8 Zeichen)",
 "Senha nova do cofre (6 caracteres ou mais)": "Neues Tresor-Passwort (mindestens 6 Zeichen)",
 "Senha, biometria, bloqueio e privacidade": "Passwort, Biometrie, Sperre und Datenschutz",
 "Senha, e-mail e formas de desbloquear": "Passwort, E-Mail und Entsperrmethoden",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Einkommensnachweise sammeln (Banken, Arbeitgeber, Broker)",
 "Servidor de notas": "Rechnungsserver",
 "Servidor não configurado (lib/config.ts).": "Server nicht konfiguriert (lib/config.ts).",
 "Servidor não configurado.": "Server nicht konfiguriert.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Server nicht konfiguriert: Die Supabase-Daten in lib/config.ts fehlen.",
 "Serviço": "Leistung",
 "Serviço não prestado": "Leistung nicht erbracht",
 "Serviços": "Leistungen",
 "Será excluída em 1 dia": "Wird in 1 Tag gelöscht",
 "Será excluída em {n} dias": "Wird in {n} Tagen gelöscht",
 "Será excluída hoje": "Wird heute gelöscht",
 "Sessão": "Sitzung",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "Dein Zugang muss noch freigeschaltet werden. Versuch gleich noch einmal, dich anzumelden.",
 "Seu código": "Dein Code",
 "Seu código de amigo": "Dein Freundescode",
 "Seu código para amigos ganharem 10 dias com todas as abas": "Dein Code, mit dem Freunde 10 Tage alle Tabs bekommen",
 "Seu nome": "Dein Name",
 "Seu papel: {p}": "Deine Rolle: {p}",
 "Seu papel: {p}. {d}": "Deine Rolle: {p}. {d}",
 "Seu scanner de bolso": "Dein Taschenscanner",
 "Seus dados continuam salvos na nuvem.": "Deine Daten bleiben in der Cloud gespeichert.",
 "Seus dados na nuvem do My Planner": "Deine Daten in der My-Planner-Cloud",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "Deine Daten gehören dir: Wir verkaufen sie nicht und nutzen sie nicht für Werbung. Du kannst jederzeit alles exportieren oder löschen.",
 "Seus {n} meses grátis terminaram": "Deine {n} Gratis-Monate sind vorbei",
 "Sexta": "Freitag",
 "Sextou": "Freitag",
 "Sextou!": "Endlich Freitag!",
 "Shampoo": "Shampoo",
 "Show ou passeio": "Show oder Ausflug",
 "Silenciar avisos": "Mitteilungen stummschalten",
 "Sim": "Ja",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Synchronisiert am {data}",
 "Sincronizando pelo dispositivo {nome}": "Synchronisierung über Gerät {nome}",
 "Sincronizando...": "Synchronisiere...",
 "Sincronizar agora": "Jetzt synchronisieren",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Synchronisierung angehalten: Bestätige dein Passwort. Nichts geht verloren.",
 "Site da assistência": "Website des Kundendiensts",
 "Site da assistência (https://...)": "Website des Kundendiensts (https://...)",
 "Site ou ingresso online": "Website oder Online-Ticket",
 "Situação": "Status",
 "Situação agora": "Aktueller Status",
 "Skincare da manhã": "Morgen-Skincare",
 "Skincare da noite": "Abend-Skincare",
 "Slides": "Folien",
 "Smileys e pessoas": "Smileys und Personen",
 "Sobremesa": "Dessert",
 "Sobrou no mês": "Übrig im Monat",
 "Sociologia": "Soziologie",
 "Sofá": "Sofa",
 "Sol": "Sonne",
 "Sol pleno": "Volle Sonne",
 "Solo ou substrato": "Boden oder Substrat",
 "Solte numa matéria para mover a página para lá:": "Auf einem Fach loslassen, um die Seite dorthin zu verschieben:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Addiert die gesetzliche und die Herstellergarantie. Prüfe den Garantieschein. Erinnert 15 und 3 Tage vorher.",
 "Sombra": "Schatten",
 "Somente esta tarefa": "Nur diese Aufgabe",
 "Sono": "Schlaf",
 "Sono da noite": "Schlaf der Nacht",
 "Sopa": "Suppe",
 "Sou MEI": "Ich bin MEI",
 "Status": "Status",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "Deine Cloud-Verbindung ist abgelaufen (das passiert, wenn die App lange nicht geöffnet wurde oder das Passwort auf einem anderen Gerät geändert wurde). Nichts geht verloren: Was hier ist, wird gesendet, sobald du bestätigst.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "Dein Team an einem Ort: Chat, Dokumente, Videobesprechungen mit Aufnahme und Einladung per Link.",
 "Sua rotina em um só lugar": "Dein Alltag an einem Ort",
 "Sua senha": "Dein Passwort",
 "Suas abas": "Deine Tabs",
 "Substituir": "Ersetzen",
 "Substrato usado": "Verwendetes Substrat",
 "Subtarefa {n}": "Unteraufgabe {n}",
 "Suco": "Saft",
 "Sugerir nome": "Namen vorschlagen",
 "Sugestão": "Vorschlag",
 "Sugestões de {categoria}": "Vorschläge für {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: speichert das Konto und die synchronisierten Daten als Auftragsverarbeiter. Die Server können außerhalb Brasiliens stehen, mit den Garantien von art. 33 LGPD.",
 "Superiores": "Obere Gerichte",
 "Supino reto": "Bankdrücken",
 "Suplemento": "Nahrungsergänzung",
 "Suspense": "Thriller",
 "Suíte": "Suite",
 "Sábado": "Samstag",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "Das sind mehr als 60 Dateien. Nutze \"Alle N Seiten\".",
 "Série": "Serie",
 "Série da DPS": "DPS-Serie",
 "Série e turma": "Jahrgang und Klasse",
 "Séries": "Sätze",
 "Sérum": "Serum",
 "Símbolos": "Symbole",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Nur das Team des Büros sieht das. Bis zu 50 MB pro Datei.",
 "Só acompanha": "Nur ansehen",
 "Só acompanha, sem valores": "Nur ansehen, ohne Beträge",
 "Só administradores": "Nur Admins",
 "Só em {data}": "Nur am {data}",
 "Só leitura": "Nur lesen",
 "Só mandar para a aba Estudos (sem escolher página)": "Nur an den Tab Lernen senden (ohne Seite zu wählen)",
 "Só neste dispositivo": "Nur auf diesem Gerät",
 "Só neste dispositivo: {n}": "Nur auf diesem Gerät: {n}",
 "Só o código": "Nur den Code",
 "Só o dia {data}": "Nur der {data}",
 "Só os dados (texto)": "Nur die Daten (Text)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "Nur die Summen aus den Finanzen gehen an deine KI. Keine Anlageempfehlung.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Nur für dich: Studium, didaktische Strategien und was in jeder Stunde funktioniert hat oder nicht. Die Schüler sehen es nicht.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "Nur ein Handy synchronisiert mit dem Kalender. Um zu diesem zu wechseln, tippe unten.",
 "Só uma vez": "Nur einmal",
 "Só uma vez (abrir a ficha da tarefa)": "Nur einmal (Aufgabenkarte öffnen)",
 "Só áudio": "Nur Audio",
 "Sótão": "Dachboden",
 "TAREFAS DA CASA": "HAUSHALTSAUFGABEN",
 "TELEFONE (OPCIONAL)": "TELEFON (OPTIONAL)",
 "TRAZER PARA O MY PLANNER": "IN MY PLANNER ÜBERNEHMEN",
 "TV por assinatura": "Pay-TV",
 "Tabela": "Tabelle",
 "Talvez": "Vielleicht",
 "Tamanho": "Größe",
 "Tamanho da foto": "Fotogröße",
 "Tamanho da página": "Seitengröße",
 "Tamanho das páginas": "Größe der Seiten",
 "Tamanho do arquivo": "Dateigröße",
 "Tamanho do copo": "Glasgröße",
 "Também procurar nos Diários Oficiais dos municípios": "Auch in den Amtsblättern der Gemeinden suchen",
 "Também serão excluídos {n} item(ns) dentro dele.": "Auch {n} Einträge darin werden gelöscht.",
 "Tapioca": "Tapioka-Fladen",
 "Tarefa": "Aufgabe",
 "Tarefa da casa": "Haushaltsaufgabe",
 "Tarefa de casa": "Hausaufgabe",
 "Tarefa duplicada": "Aufgabe dupliziert",
 "Tarefa ou entrega": "Aufgabe oder Abgabe",
 "Tarefa para {nome}": "Aufgabe für {nome}",
 "Tarefas da casa": "Haushaltsaufgaben",
 "Tarefas e itens de todas as abas": "Aufgaben und Einträge aus allen Tabs",
 "Tarefas novas do My Planner vão para: {agenda}": "Neue Aufgaben aus My Planner gehen an: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "Wiederkehrende Aufgaben, die über den Zeitraum hinausgehen, laufen an den anderen Tagen weiter; nur die gewählten Tage werden entfernt.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Schwarze Balken über CPF, Beträge und Namen. Löscht wirklich.",
 "Tartaruga": "Schildkröte",
 "Taxa de limpeza": "Reinigungsgebühr",
 "Taxa de limpeza cobrada do hóspede": "Reinigungsgebühr für den Gast",
 "Taxas e anúncios": "Gebühren und Inserate",
 "Te amo": "Ich liebe dich",
 "Tecnologia": "Technik",
 "Tela cheia": "Vollbild",
 "Teleconsulta": "Videosprechstunde",
 "Telefone": "Telefon",
 "Telefone da assistência": "Telefon des Kundendiensts",
 "Telefone da empresa": "Telefon der Firma",
 "Telefone da escola": "Telefon der Schule",
 "Telefone da limpeza": "Telefon der Reinigung",
 "Telefone de emergência": "Notfalltelefon",
 "Telefone do veterinário": "Telefon des Tierarztes",
 "Telhado": "Dach",
 "Tem anexos": "Hat Anhänge",
 "Tem certeza?": "Bist du sicher?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "Du hast {n} überfällige Zahlung(en) über insgesamt {v}. Bezahle zuerst die mit den höchsten Zinsen, wie Kreditkarte und Dispo.",
 "Tema": "Thema",
 "Tempo de preparo": "Zubereitungszeit",
 "Temporada": "Staffel",
 "Temporizador (direita)": "Timer (rechts)",
 "Tenta consertar um PDF que não abre direito.": "Versucht, ein PDF zu reparieren, das sich nicht richtig öffnet.",
 "Tentar de novo": "Erneut versuchen",
 "Tente uma foto mais nítida, com a página inteira.": "Versuch ein schärferes Foto mit der ganzen Seite.",
 "Termina às {hora}": "Endet um {hora}",
 "Terminar até": "Fertig bis",
 "Terminei em": "Beendet am",
 "Terminou": "Beendet",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Endete am {data}. Nichts wurde gelöscht: Mit einem Abo ist alles wieder wie vorher.",
 "Termos de uso": "Nutzungsbedingungen",
 "Termos de uso e privacidade": "Nutzungsbedingungen und Datenschutz",
 "Terror": "Horror",
 "Terça": "Dienstag",
 "Testando...": "Wird getestet...",
 "Testar alerta (1 minuto)": "Erinnerung testen (1 Minute)",
 "Testar aviso": "Benachrichtigung testen",
 "Teste de alerta do Planner": "Planner-Erinnerungstest",
 "Teste grátis até {data} ({n} dia(s))": "Gratis-Test bis {data} ({n} Tag(e))",
 "Teste grátis: {n} dia(s)": "Gratis-Test: {n} Tag(e)",
 "Teste terminado": "Test beendet",
 "Teste terminou em {data}": "Test endete am {data}",
 "Teste: aviso feito pelo próprio celular.": "Test: Benachrichtigung vom Handy selbst.",
 "Texto": "Text",
 "Texto completo": "Volltext",
 "Texto copiado. Cole onde quiser enviar.": "Text kopiert. Füge ihn ein, wo du ihn senden möchtest.",
 "Texto do documento": "Text des Dokuments",
 "Texto extra do convite (traje, presentes...)": "Zusätzlicher Einladungstext (Dresscode, Geschenke...)",
 "Texto livre": "Freitext",
 "Texto ou recado": "Text oder Mitteilung",
 "Texto para PDF": "Text in PDF",
 "Texto {data}": "Text {data}",
 "Tipo": "Typ",
 "Tipo sanguíneo": "Blutgruppe",
 "Tira as páginas que você não quer.": "Entfernt die Seiten, die du nicht willst.",
 "Tira autor, programas, comandos escondidos e anexos.": "Entfernt Autor, Programme, versteckte Befehle und Anhänge.",
 "Tira comentários, destaques e desenhos de outros programas.": "Entfernt Kommentare, Markierungen und Zeichnungen anderer Programme.",
 "Tira o texto do PDF (arquivo .txt).": "Holt den Text aus dem PDF (.txt-Datei).",
 "Tiradentes": "Tiradentes",
 "Tirar": "Entfernen",
 "Tirar a assinatura": "Unterschrift entfernen",
 "Tirar a foto": "Foto entfernen",
 "Tirar a foto agora": "Jetzt Foto aufnehmen",
 "Tirar admin": "Admin entziehen",
 "Tirar alarmes do My Planner": "Alarme aus My Planner entfernen",
 "Tirar arquivos anexados": "Angehängte Dateien entfernen",
 "Tirar comentários, destaques e links": "Kommentare, Markierungen und Links entfernen",
 "Tirar da agenda": "Aus dem Kalender entfernen",
 "Tirar da barra": "Aus der Leiste nehmen",
 "Tirar daqui": "Hier entfernen",
 "Tirar das minhas figurinhas?": "Aus meinen Stickern entfernen?",
 "Tirar de administrador": "Admin-Rechte entziehen",
 "Tirar do escritório": "Aus dem Büro entfernen",
 "Tirar dos meus GIFs?": "Aus meinen GIFs entfernen?",
 "Tirar este copo": "Dieses Glas entfernen",
 "Tirar foto": "Foto aufnehmen",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Boletos, Kassenbons und Dokumente fotografieren und Fotos und Videos aus der Galerie auswählen.",
 "Tirar o desenho padrão?": "Entsperrmuster entfernen?",
 "Tirar o lixo": "Müll rausbringen",
 "Tire a foto e a sua IA preenche a ficha": "Mach ein Foto und deine KI füllt die Akte aus",
 "Titular (de quem é o documento)": "Inhaber (wem das Dokument gehört)",
 "Titular: {nome}": "Inhaber: {nome}",
 "Toalha de praia": "Strandtuch",
 "Tocar os pés": "Zehen berühren",
 "Toda a agenda": "Gesamter Kalender",
 "Toda semana": "Jede Woche",
 "Todas": "Alle",
 "Todas (passadas, esta e futuras)": "Alle (vergangene, diese und zukünftige)",
 "Todas ({n})": "Alle ({n})",
 "Todas as abas liberadas até {data}.": "Alle Tabs freigeschaltet bis {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "Alle Hauptstädte. Wähle eine oder mehrere Städte.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "Alle PDF-Werkzeuge: zusammenfügen, teilen, organisieren, unterschreiben, Stempel, Schwärzen, Seitenzahlen, Formulare, komprimieren, umwandeln, OCR und KI. Speichert auf dem Handy, in Google Drive oder OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "Alle Werkzeuge sind auf dem Bildschirm des Tabs.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "Alle Fotos der Reise sind hier: die, die du ins Album legst, und die aus Reiseprogramm, Orten und Buchungen.",
 "Todas as plantas estão regadas.": "Alle Pflanzen sind gegossen.",
 "Todas as páginas, uma embaixo da outra.": "Alle Seiten, untereinander.",
 "Todo ano": "Jedes Jahr",
 "Todo dia": "Jeden Tag",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Jeden Tag zur gewählten Uhrzeit: wie viele Aufgaben der Tag hat, die erste und die Gesamtenergie.",
 "Todo mês": "Jeden Monat",
 "Todo mês · dia {d}": "Jeden Monat · am {d}.",
 "Todo o histórico": "Gesamter Verlauf",
 "Todos": "Alle",
 "Todos ({n})": "Alle ({n})",
 "Todos do grupo": "Ganze Gruppe",
 "Todos do grupo veem": "Für alle in der Gruppe sichtbar",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Alle in der Besprechung sehen den Hinweis \"Aufnahme läuft\". Die Datei landet in den Dokumenten des Büros und ist nur für dich sichtbar, bis du sie für das Team freigibst.",
 "Todos os cuidados": "Alle Pflegeroutinen",
 "Todos os dias": "Jeden Tag",
 "Todos os suplementos": "Alle Nahrungsergänzungen",
 "Todos os treinos": "Alle Trainings",
 "Todos os tribunais": "Alle Gerichte",
 "Todos presentes": "Alle anwesend",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Alle verlassen die Gruppe. Was jede Person schon angenommen hat, bleibt in ihrem Kalender.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Alle arbeiten mit denselben Daten, jeder je nach Rolle. Tippe unter Mitglieder auf die Rolle einer Person, um sie zu ändern.",
 "Tomador": "Leistungsempfänger",
 "Tomador (quem contratou)": "Leistungsempfänger (Auftraggeber)",
 "Tomadores": "Leistungsempfänger",
 "Tomei": "Geliehen",
 "Toque aqui ou no + para criar uma tarefa": "Tippe hier oder auf +, um eine Aufgabe zu erstellen",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Tippe auf \"Mein Konto und alle Daten löschen\" und bestätige.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Tippe auf + › Neue Kreditkarte und gib den Abrechnungs- und Fälligkeitstag an.",
 "Toque em Ajustes e depois em Segurança.": "Tippe auf Einstellungen und dann auf Sicherheit.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Tippe auf Verbinden und schalte auf dem Apple-Bildschirm die Elemente ein, die My Planner lesen darf.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Tippe auf Verbinden und erlaube My Planner auf dem Health-Connect-Bildschirm, die Daten zu lesen.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Tippe auf alle, die diesen Eintrag (und seinen Inhalt) NICHT sehen sollen. Z. B. das Überraschungsgeschenk.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Tippe auf einen Tab, um ihn zu öffnen. Gesperrte zeigen, wie du sie abonnierst.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Tippe auf einen Tab, um ihn zu öffnen. Jeden zusätzlichen Tab kannst du 10 Tage gratis testen.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Tippe auf einen Tab, um ihn zu öffnen. Tippe auf 📌, um den Tab unten in die Leiste zu setzen oder daraus zu entfernen. Jeder zusätzliche Tab kann 10 Tage lang kostenlos getestet werden.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Tippe auf einen Bereich, um ihn zu öffnen. Gesperrte zeigen, wie man sie abonniert.",
 "Toque no desenho para continuar desenhando.": "Tippe auf die Zeichnung, um weiterzuzeichnen.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Tippe auf das, was diese Gruppe teilen soll. Alles darin (Reiseprogramm, Fotos, Buchungen...) kommt mit und alle machen mit.",
 "Toque nos PDFs na ordem em que devem ficar.": "Tippe die PDFs in der Reihenfolge an, in der sie stehen sollen.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Tippe auf ein Glas, um die Menge zu ändern; halte + gedrückt für ein Glas in anderer Größe.",
 "Toque num feriado para adicioná-lo ao Planner.": "Tippe auf einen Feiertag, um ihn zum Planner hinzuzufügen.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Tippe auf eine Buchung, um die Kategorie zu ändern, den Beleg für die Steuer (IR) zu speichern oder sie zu löschen.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Tippe auf eine Buchung, um die Kategorie zu ändern. Gedrückt halten zum Löschen.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Tippe auf ein Profil, um es zu bearbeiten. Gedrückt halten, um es zu entfernen.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Tippe auf einen Text, eine Zeichnung oder eine Checkliste und ziehe sie an eine beliebige Stelle des Blatts.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Tippe auf eine Seite, um sie zuzuschneiden, zu drehen oder den Filter zu ändern. Halten und ziehen, um die Reihenfolge zu ändern.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Tippe auf eine Aufgabe, um sie nach heute zu kopieren oder zu verschieben.",
 "Toque onde quer a checklist.": "Tippe dorthin, wo die Checkliste hin soll.",
 "Toque onde quer escrever.": "Tippe dorthin, wo du schreiben möchtest.",
 "Toque para abrir": "Zum Öffnen tippen",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Tippe zum Öffnen in der App des Handys. Nach rechts wischen, um aus der Liste zu entfernen.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Tippen zum Öffnen, gedrückt halten zum Umbenennen. Nach links wischen zum Archivieren oder nach rechts zum Löschen.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Zum Öffnen tippen. Nach rechts wischen, um aus der Liste zu entfernen.",
 "Toque para aceitar ou recusar.": "Tippe zum Annehmen oder Ablehnen.",
 "Toque para aceitar, editar ou recusar.": "Tippe, um anzunehmen, zu bearbeiten oder abzulehnen.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Tippe, um es jetzt anzuwenden. Oder es wird beim Neustart der App automatisch übernommen.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Tippe, um es herunterzuladen und darüber zu installieren. Deine Daten bleiben erhalten.",
 "Toque para conversar": "Tippe zum Chatten",
 "Toque para enviar o emoji animado": "Tippen, um das animierte Emoji zu senden",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Tippen zum Senden. Gedrückt halten zum Speichern oder Entfernen.",
 "Toque para escolher": "Zum Auswählen tippen",
 "Toque para fechar": "Tippe zum Schließen",
 "Toque para gerar um novo QR Code": "Tippe, um einen neuen QR-Code zu erstellen",
 "Tornar admin": "Zum Admin machen",
 "Tornar administrador": "Zum Admin machen",
 "Tosa": "Scheren",
 "Totais por alimento": "Summen je Lebensmittel",
 "Total": "Summe",
 "Total bruto": "Bruttosumme",
 "Total das reservas: {v}": "Summe der Buchungen: {v}",
 "Total de aulas": "Lektionen gesamt",
 "Total de capítulos": "Kapitel gesamt",
 "Total de módulos": "Module gesamt",
 "Total de páginas": "Seiten gesamt",
 "Total de recibos: {v}": "Summe der Belege: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Gesamt: {n}. Jeder Tab kann bis zu {lim} Text haben (Fotos und Dateien zählen nicht: Sie liegen auf dem Gerät oder in deinem Drive).",
 "Total: {v}": "Gesamt: {v}",
 "Trabalhando...": "Wird bearbeitet...",
 "Trabalho": "Arbeitsgerichte",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Hol die Termine aus deinem Google Kalender in My Planner und bearbeite sie hier: Änderungen gehen zurück in den Kalender.",
 "Trans": "Trans",
 "Transferir: {s}": "Ummelden: {s}",
 "Transferência": "Ummeldung",
 "Transferências": "Ummeldungen",
 "Transporte": "Verkehr",
 "Tratamento": "Behandlung",
 "Travar depois de preencher": "Nach dem Ausfüllen sperren",
 "Trazer todas para hoje": "Alle nach heute holen",
 "Trazer tudo para hoje?": "Alles nach heute holen?",
 "Trecho ou ideia": "Zitat oder Idee",
 "Treino": "Training",
 "Trem ou ônibus": "Zug oder Bus",
 "Treme": "Zittern",
 "Tribunais": "Gerichte",
 "Trilha": "Wandern",
 "Triste": "Traurig",
 "Triângulo": "Dreieck",
 "Troca de óleo": "Ölwechsel",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Ölwechsel, Reifenwechsel, Inspektionen nach km, IPVA, Zulassung und Versicherung.",
 "Trocador portátil": "Reise-Wickelunterlage",
 "Trocar": "Ändern",
 "Trocar a categoria": "Kategorie ändern",
 "Trocar a foto": "Foto ändern",
 "Trocar a pasta": "Ordner wechseln",
 "Trocar a senha do cofre": "Tresor-Passwort ändern",
 "Trocar número": "Nummer ändern",
 "Trocar o certificado": "Zertifikat wechseln",
 "Trocar o código": "Code ändern",
 "Trocar o código?": "Code ändern?",
 "Trocar o desenho": "Muster ändern",
 "Trocar o emoji": "Emoji ändern",
 "Trocar o modelo": "Modell wechseln",
 "Trocar o número": "Die Nummer ändern",
 "Trocar o número do celular": "Handynummer ändern",
 "Trocar por:": "Ersetzen durch:",
 "Trocar roupa de cama e toalhas": "Bettwäsche und Handtücher wechseln",
 "Tríceps na polia": "Trizepsdrücken am Kabel",
 "Tubo de ensaio": "Reagenzglas",
 "Tudo": "Alles",
 "Tudo certo": "Alles in Ordnung",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "Alles im grünen Bereich. Erfasse deine Alltagsausgaben, damit ich sehe, wohin das Geld geht.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "Alles wird bereits in deinem Konto gespeichert. Die Datei ist eine zusätzliche Kopie, die du aufbewahren kannst, wo du willst.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Alles in \"{nome}\" wird für die Gruppe sichtbar, jede Person je nach der Rolle, die du wählst (Neue beginnen mit der eingeschränktesten Rolle).",
 "Tudo! Já comprei os ingressos.": "Klar! Ich habe die Tickets schon gekauft.",
 "Turma": "Klasse",
 "Turma (opcional)": "Klasse (optional)",
 "Turmas": "Klassen",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Klassen und Gruppen (Unterricht, Mentoring, Training): Schüler, Anwesenheit, Noten, Pläne, Materialien, Forderungen und dein Notizbuch.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Klassen, Schüler, Anwesenheit, Noten und Unterrichtspläne.",
 "Turmas, pacientes, equipes e convidados": "Klassen, Patienten, Teams und Gäste",
 "Técnico": "Fachbuch",
 "Título": "Titel",
 "Título (ex.: Capítulo 3)": "Titel (z. B. Kapitel 3)",
 "Título (opcional)": "Titel (optional)",
 "Título da caixa": "Titel der Box",
 "Título de eleitor": "Wählerausweis",
 "Título, autor, assunto e palavras-chave.": "Titel, Autor, Betreff und Stichwörter.",
 "Tô chegando": "Bin unterwegs",
 "Tônico": "Gesichtswasser",
 "UF": "UF",
 "Uau": "Wow",
 "Uhuul!": "Juhu!",
 "Um PDF novo só com as páginas escolhidas.": "Ein neues PDF nur mit den gewählten Seiten.",
 "Um texto clarinho na diagonal de todas as páginas.": "Ein heller Text diagonal über alle Seiten.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "Ein Ordner pro Kunde: Ihr tauscht Dokumente in beide Richtungen aus und jeder Kunde sieht nur seinen Ordner.",
 "Uma página por arquivo": "Eine Seite pro Datei",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "Eine Seite pro Datei, alle N Seiten oder nach Bereichen.",
 "Unicórnio": "Einhorn",
 "Unidade": "Einheit",
 "Universal": "Universal",
 "União": "Zusammenhalt",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Nutzt das Google-Konto, das schon auf dem Handy ist. My Planner fragt nie nach deinem Google-Passwort.",
 "Usado: {u} · livre: {v} · limite {l}": "Genutzt: {u} · frei: {v} · Limit {l}",
 "Usar": "Verwenden",
 "Usar \"{nome}\"": "\"{nome}\" verwenden",
 "Usar biometria": "Biometrie verwenden",
 "Usar desenho padrão": "Entsperrmuster verwenden",
 "Usar este celular": "Dieses Handy verwenden",
 "Usar este nome": "Diesen Namen verwenden",
 "Usar modelo: {m}": "Vorlage verwenden: {m}",
 "Usar no navegador (My Planner Web)": "Im Browser nutzen (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Bereits angehängte Datei verwenden ({nome})",
 "Usar o código": "Code verwenden",
 "Usar senha": "Passwort verwenden",
 "Usar {ia}": "{ia} nutzen",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Verwende das neue Passwort bei der nächsten Anmeldung, hier und im My Planner Web.",
 "Use a senha para desbloquear.": "Verwende das Passwort zum Entsperren.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Nutze deine eigene KI, um Veröffentlichungen, Dokumente und Notizen zu lesen und Termine vorzuschlagen. Du bestätigst immer, bevor etwas in den Planner kommt.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Gib diesen Code bei der Registrierung ein und erhalte 10 Tage mit allen Tabs freigeschaltet.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Nutze den Kontoauszug als OFX (empfohlen) oder CSV, heruntergeladen in der App oder auf der Website deiner Bank.",
 "Use o seu planner no computador, sincronizado com o celular.": "Nutze deinen Planner am Computer, synchronisiert mit dem Handy.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Verwende einen https-Link von Google Drive, Google Docs, OneDrive oder SharePoint.",
 "Uso": "Nutzung",
 "Uso próprio": "Eigennutzung",
 "VRBO": "VRBO",
 "Vacina": "Impfung",
 "Vacina {nome}: {pet}": "Impfung {nome}: {pet}",
 "Vacina: {nome}": "Impfung: {nome}",
 "Vacinas": "Impfungen",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Impfungen und Medikamente der Haustiere, Tiersalon sowie Schule und Gesundheit der Kinder.",
 "Vai na viagem": "Reist mit",
 "Vale até {d}": "Gültig bis {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "Gilt für Lernen und Dokumente. In der Cloud öffnet sich die Datei auf jedem Gerät und in My Planner Web (bis 15 MB pro Datei).",
 "Vale quantos pontos": "Wie viele Punkte",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Gilt nur für dich. Höchstens eine Benachrichtigung alle 3 Minuten pro Person, auch wenn sie mehrere Dinge hinzufügt.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Gilt einmal, in den ersten 30 Tagen deines Kontos.",
 "Validade": "Gültig bis",
 "Validade do certificado A1": "Gültigkeit des A1-Zertifikats",
 "Validade: {data}": "Gültig bis: {data}",
 "Valor": "Betrag",
 "Valor ({m})": "Betrag ({m})",
 "Valor a pagar": "Zu zahlender Betrag",
 "Valor combinado": "Vereinbarter Betrag",
 "Valor combinado por atendimento": "Vereinbarter Betrag pro Termin",
 "Valor da hora": "Stundensatz",
 "Valor da parcela (1ª)": "Ratenbetrag (1.)",
 "Valor da venda": "Verkaufspreis",
 "Valor de costume": "Üblicher Betrag",
 "Valor do atendimento: {v}{pago}.": "Betrag der Behandlung: {v}{pago}.",
 "Valor emprestado ou financiado": "Geliehener oder finanzierter Betrag",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Endpreis wird von Google Play oder dem App Store festgelegt, bereits in der Währung deines Landes.",
 "Valor maior que o guardado nesta meta.": "Betrag größer als das Gesparte in diesem Ziel.",
 "Valor padrão da consulta ou sessão": "Standardpreis für Termin oder Sitzung",
 "Valor pago": "Bezahlter Betrag",
 "Valor pago (com multa ou desconto)": "Gezahlter Betrag (mit Zuschlag oder Rabatt)",
 "Valor pago (opcional)": "Bezahlter Betrag (optional)",
 "Valor pago: {v}": "Bezahlter Betrag: {v}",
 "Valor que este aluno paga (se for diferente)": "Betrag, den dieser Schüler zahlt (falls abweichend)",
 "Valor recebido": "Erhaltener Betrag",
 "Valor recebido: {v}": "Erhaltener Betrag: {v}",
 "Valor total da compra": "Gesamtbetrag des Kaufs",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Beträge und klinische Daten sehen nur Personen, deren Rolle es erlaubt. Du kannst es jederzeit ausschalten: Die Daten bleiben bei dir.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Beträge mit deinem Steuerberater prüfen. Die Abzugsregeln ändern sich jedes Jahr.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "Wollen wir über My Planner chatten? Füge mich mit dem Code {codigo} als Freund hinzu (Tab Nachrichten > Freunde).",
 "Vaso": "Topf",
 "Veja os planos em Ajustes › Compras.": "Tarife findest du unter Einstellungen › Käufe.",
 "Vem da aba Empréstimos & Financiamentos": "Kommt aus dem Tab Kredite & Finanzierungen",
 "Vence em {data}.": "Läuft am {data} ab.",
 "Vence em {fim} (data informada na publicação).": "Fällig am {fim} (Datum laut Veröffentlichung).",
 "Vence em {n} dia(s)": "Läuft in {n} Tag(en) ab",
 "Vence hoje": "Läuft heute ab",
 "Vence {data}": "Fällig {data}",
 "Vencendo": "Läuft bald ab",
 "Venceu há {n} dia(s)": "Seit {n} Tag(en) abgelaufen",
 "Vencidas": "Abgelaufen",
 "Vencidos": "Abgelaufen",
 "Vencimento": "Fälligkeit",
 "Vencimento (guias e boletos)": "Fälligkeit (Zahlscheine und Boletos)",
 "Vencimento da 1ª parcela": "Fälligkeit der 1. Rate",
 "Vencimentos": "Fälligkeiten",
 "Venda": "Verkauf",
 "Venda/serviço do MEI": "MEI-Verkauf/-Leistung",
 "Vendidos": "Verkauft",
 "Ver": "Ansehen",
 "Ver a lista de membros": "Mitgliederliste sehen",
 "Ver a rota": "Route anzeigen",
 "Ver arquivos": "Dateien ansehen",
 "Ver detalhes do erro": "Fehlerdetails anzeigen",
 "Ver e editar": "Ansehen und bearbeiten",
 "Ver em Compras": "In Käufe ansehen",
 "Ver mais": "Mehr anzeigen",
 "Ver mais páginas": "Mehr Seiten anzeigen",
 "Ver no My Planner": "In My Planner ansehen",
 "Ver o dia": "Tag ansehen",
 "Ver os feriados do ano": "Feiertage des Jahres ansehen",
 "Ver participantes": "Teilnehmer anzeigen",
 "Ver páginas": "Seiten ansehen",
 "Ver todos": "Alle anzeigen",
 "Ver todos ({n})": "Alle anzeigen ({n})",
 "Ver {nome}": "{nome} ansehen",
 "Verificar agora": "Jetzt prüfen",
 "Vermífugo": "Wurmkur",
 "Vermífugo ou remédio": "Wurmkur oder Medikament",
 "Vermífugos e remédios": "Wurmkuren und Medikamente",
 "Verso": "Rückseite",
 "Verso do documento": "Rückseite des Dokuments",
 "Versão do PDF": "PDF-Version",
 "Versão instalada": "Installierte Version",
 "Versão {versao} disponível": "Version {versao} verfügbar",
 "Versão {v}": "Version {v}",
 "Veterinário": "Tierarzt",
 "Veterinário ou clínica": "Tierarzt oder Klinik",
 "Veículo": "Fahrzeug",
 "Veículo e acessórios": "Fahrzeug und Zubehör",
 "Veículos": "Fahrzeuge",
 "Veículos & Manutenção": "Fahrzeuge & Wartung",
 "Vi mais um episódio": "Noch eine Folge geschaut",
 "Viagem": "Reise",
 "Viagens": "Reisen",
 "Viagens & Lazer": "Reisen & Freizeit",
 "Viagens e lugares": "Reisen und Orte",
 "Vida noturna": "Nachtleben",
 "Vidros e esquadrias": "Fenster und Rahmen",
 "Vigente": "Laufend",
 "Vigentes": "Laufend",
 "Virar": "Drehen",
 "Virar a câmera": "Kamera drehen",
 "Virar tarefa (levar à assistência)": "Zur Aufgabe machen (zum Kundendienst bringen)",
 "Visita domiciliar": "Hausbesuch",
 "Visitados": "Besucht",
 "Visto": "Gesehen",
 "Vistoria": "Übergabe",
 "Vistoria: {i}": "Übergabe: {i}",
 "Vistorias": "Übergaben",
 "Visualizar feriados": "Feiertage anzeigen",
 "Vitamina": "Vitamin",
 "Vitamina D": "Vitamin D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Vitamine, Whey, Kreatin... jeweils mit eigener Häufigkeit. Was heute dran ist, erscheint unter \"Heute\" zum Abhaken.",
 "Você": "Du",
 "Você aceitou os termos em {data}.": "Du hast die Bedingungen am {data} akzeptiert.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "Du hast noch keine Freunde in der App. Füge sie per Code hinzu.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "Du hast noch keine Ordner. Erstelle einen im Tab Lernen.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "Du siehst den Chat, die Dokumente und die Besprechungen nicht mehr.",
 "Você deve: {v}": "Du schuldest: {v}",
 "Você entrou no grupo": "Du bist der Gruppe beigetreten",
 "Você entrou no grupo \"{nome}\".": "Du bist der Gruppe \"{nome}\" beigetreten.",
 "Você está convidado(a) para: {evento}": "Du bist eingeladen: {evento}",
 "Você foi convidado para o My Planner": "Du wurdest zu My Planner eingeladen",
 "Você foi convidado para o grupo": "Du wurdest in die Gruppe eingeladen",
 "Você juntou {v} para \"{m}\".": "Du hast {v} für \"{m}\" gespart.",
 "Você já tem todas as abas.": "Du hast bereits alle Tabs.",
 "Você já usou um código de indicação nesta conta.": "Du hast in diesem Konto bereits einen Empfehlungscode verwendet.",
 "Você ligou": "Du hast angerufen",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "Du kannst dein Konto jederzeit löschen, in der App auf dem Handy oder auf der Website:",
 "Você não tem permissão para isso neste grupo.": "Dafür hast du in dieser Gruppe keine Berechtigung.",
 "Você não vê os outros membros deste grupo.": "Du siehst die anderen Mitglieder dieser Gruppe nicht.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "Du kannst dein Konto jederzeit unter Einstellungen > Sicherheit löschen. Dadurch werden die Daten in der Cloud und auf dem Gerät endgültig gelöscht.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Du kannst: bestätigen lassen, ob wir deine Daten verarbeiten, darauf zugreifen, sie berichtigen, ihre Übertragung verlangen (Datei exportieren unter Einstellungen > Allgemeine Einstellungen), ihre Löschung verlangen, erfahren, mit wem wir sie teilen, deine Einwilligung widerrufen und dich bei der ANPD beschweren.",
 "Você recebe (líquido)": "Du erhältst (netto)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "Du bist für dein Passwort und alles, was in deinem Konto geschieht, verantwortlich. Gib bei der Registrierung wahre Daten an.",
 "Volta": "Rückreise",
 "Volta ou check-out": "Rückreise oder Check-out",
 "Volta às {hora}": "Zurück um {hora}",
 "Voltar": "Zurück",
 "Voltar ao cardápio da semana neste dia": "An diesem Tag zum Wochenplan zurückkehren",
 "Voltar ao cálculo": "Zurück zur Berechnung",
 "Voltar ao foco": "Zurück zum Fokus",
 "Voltar ao padrão": "Standard wiederherstellen",
 "Voltar ao planejado": "Zurück zum Plan",
 "Voltar para Anotações": "Zurück zu Notizen",
 "Voltar para as cores do My Planner": "Zurück zu den My Planner-Farben",
 "Voltar para novas": "Zurück zu Neu",
 "Voltar para o QR Code": "Zurück zum QR-Code",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Kehre zur My Planner-App auf dem Handy zurück. Die Einstellungen aktualisieren sich von selbst.",
 "Voo": "Flug",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Flüge, Hotels, Mietwagen und Ausflüge an einem Ort, mit Code und Beleg.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Geh zu Einstellungen und tippe auf \"Browser verbinden\".",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Geh zu Einstellungen › Allgemeine Einstellungen und tippe auf \"Browser verbinden\".",
 "Várias páginas por folha": "Mehrere Seiten pro Blatt",
 "Vários PDFs num só, na ordem que você escolher.": "Mehrere PDFs in einem, in der Reihenfolge deiner Wahl.",
 "Vê as aulas e os materiais liberados.": "Sieht die freigegebenen Unterrichtsstunden und Materialien.",
 "Vê as etapas e registra o diário.": "Sieht die Bauabschnitte und schreibt ins Tagebuch.",
 "Vê e altera tudo, inclusive os valores.": "Sieht und ändert alles, auch die Beträge.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Sieht und sendet die Dokumente im eigenen Ordner und beantwortet Anforderungen.",
 "Vê o andamento, sem os valores e sem alterar.": "Sieht den Fortschritt, ohne Beträge und ohne Änderungen.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Sieht Check-ins und Check-outs und hakt die Reinigung ab, ohne Beträge.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Sieht alles und trägt Ausgaben, Orte, Reiseplan und Gepäck ein.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Sieht alles, fügt hinzu, bearbeitet, kommentiert und lädt Fotos hoch. Kann nur keine Personen zur Gruppe hinzufügen oder entfernen.",
 "Vê tudo, inclusive os valores, sem alterar.": "Sieht alles, auch die Beträge, ohne zu ändern.",
 "Vídeo": "Video",
 "Vínculo": "Verknüpfung",
 "Vínculo perdido": "Verknüpfung verloren",
 "WhatsApp da assistência": "WhatsApp des Kundendienstes",
 "Whey": "Whey",
 "Wi-Fi (rede e senha)": "WLAN (Netz und Passwort)",
 "Yoga": "Yoga",
 "Zumbi e Consciência Negra": "Zumbi und Tag des Schwarzen Bewusstseins",
 "Zzz": "Zzz",
 "a cada {n} dias": "alle {n} Tage",
 "a pagar": "zu zahlen",
 "a receber": "offen",
 "a receber {v}": "ausstehend {v}",
 "a reserva": "die Buchung",
 "a última execução falhou; avise o suporte": "die letzte Ausführung ist fehlgeschlagen; wende dich an den Support",
 "abr": "Apr",
 "abril": "April",
 "acabou": "leer",
 "achatado": "reduziert",
 "administra": "Admin",
 "ago": "Aug",
 "agosto": "August",
 "ajustado": "angepasst",
 "algo novo": "etwas Neues",
 "alterou": "hat geändert",
 "amanhã": "morgen",
 "anual": "jährlich",
 "apagou": "hat gelöscht",
 "aplicada em {d}": "gegeben am {d}",
 "app {v} · atualização {p} de {data}": "App {v} · Update {p} vom {data}",
 "assinado": "unterschrieben",
 "atrasada": "überfällig",
 "atrasada há {n} dia(s)": "seit {n} Tag(en) überfällig",
 "até": "bis",
 "até {data}": "bis {data}",
 "até {d}": "bis {d}",
 "aula {a} de {n}": "Lektion {a} von {n}",
 "avisos silenciados": "Mitteilungen stumm",
 "caixa": "Box",
 "colher(es)": "Löffel",
 "coluna": "Spalte",
 "com anexos": "mit Anhängen",
 "com imagem": "mit Bild",
 "com tarjas": "geschwärzt",
 "com texto": "mit Text",
 "com {p}": "bei {p}",
 "como planejado": "wie geplant",
 "comprado em {data}": "gekauft am {data}",
 "comprado em {d} por {v}": "gekauft am {d} für {v}",
 "comprimido": "komprimiert",
 "comprovante": "Beleg",
 "concha(s)": "Kelle(n)",
 "confirmados": "zugesagt",
 "consulta recusada": "Abfrage abgelehnt",
 "contratado": "gebucht",
 "contínuo": "dauerhaft",
 "copo(s)": "Glas/Gläser",
 "corridos": "Kalendertage",
 "criou o grupo": "hat die Gruppe erstellt",
 "de": "von",
 "de Anotações": "aus Notizen",
 "de {meta} passos": "von {meta} Schritten",
 "de {n}": "von {n}",
 "de {p}": "von {p}",
 "dentro / fora do planejado": "im / außerhalb des Plans",
 "desconto {v}": "Rabatt {v}",
 "desfazer": "rückgängig",
 "destino": "Reiseziel",
 "deve {v}": "schuldet {v}",
 "devolvido em {d}": "zurückgegeben am {d}",
 "dez": "Dez",
 "dezembro": "Dezember",
 "dia": "Tag",
 "dias": "Tage",
 "dias com a meta batida": "Tage mit erreichtem Ziel",
 "dias com a meta de passos": "Tage mit erreichtem Schrittziel",
 "digital": "Fingerabdruck",
 "diária média": "Ø-Preis pro Nacht",
 "do cliente": "vom Kunden",
 "do escritório": "von der Kanzlei",
 "dom": "So",
 "domingo": "Sonntag",
 "e mais {n}": "und {n} weitere",
 "em aberto": "offen",
 "em atraso": "überfällig",
 "em {n} dias": "in {n} Tagen",
 "emitida": "ausgestellt",
 "entregue": "geliefert",
 "entrou no escritório": "ist dem Büro beigetreten",
 "enviado": "gesendet",
 "escaneado": "gescannt",
 "escolha": "wählen",
 "este": "dieses",
 "este dispositivo": "dieses Gerät",
 "este item": "diesen Eintrag",
 "exercícios concluídos": "erledigte Übungen",
 "falta {v}": "fehlt {v}",
 "faltam {km}": "noch {km}",
 "fatia(s)": "Scheibe(n)",
 "faturamento": "Umsatz",
 "feita em {d}": "gemacht am {d}",
 "feito {dur}": "erledigt {dur}",
 "fev": "Feb",
 "fevereiro": "Februar",
 "frequência {p}%": "Anwesenheit {p} %",
 "gasto {v}": "ausgegeben {v}",
 "girado": "gedreht",
 "guardado": "gespeichert",
 "higienizado": "bereinigt",
 "hoje": "heute",
 "hora fixa no dia": "feste Uhrzeit am Tag",
 "há {n} dias": "vor {n} Tagen",
 "iPhone ou computador: {link}": "iPhone oder Computer: {link}",
 "incluiu": "hat hinzugefügt",
 "jan": "Jan",
 "janeiro": "Januar",
 "jul": "Jul",
 "julho": "Juli",
 "jun": "Jun",
 "junho": "Juni",
 "já importado": "bereits importiert",
 "liberar em {d}": "freigeben am {d}",
 "ligou o compartilhamento": "hat das Teilen eingeschaltet",
 "linha": "Zeile",
 "lucro líquido": "Nettogewinn",
 "mai": "Mai",
 "maio": "Mai",
 "mar": "Mär",
 "marca d'água": "Wasserzeichen",
 "marcada por {nome}": "geplant von {nome}",
 "março": "März",
 "menos de 1 ano": "unter 1 Jahr",
 "mensalidade": "Monatsbeitrag",
 "meta batida!": "Ziel erreicht!",
 "metadados": "Metadaten",
 "min": "Min.",
 "min antes": "Min. vorher",
 "min antes do início": "Min. vor Beginn",
 "min · {de} às {ate}": "Min. · {de} bis {ate}",
 "multa e juros {v}": "Mahngebühren und Zinsen {v}",
 "média {m}": "Schnitt {m}",
 "mês(es)": "Monat(e)",
 "na nuvem": "in der Cloud",
 "na pasta \"{pasta}\"": "im Ordner \"{pasta}\"",
 "na pasta escolhida": "im gewählten Ordner",
 "neste dispositivo": "auf diesem Gerät",
 "neste celular": "auf diesem Handy",
 "no Planner": "im Planner",
 "no {nome}": "in {nome}",
 "nos próximos dias": "in den nächsten Tagen",
 "nov": "Nov",
 "novembro": "November",
 "numerado": "nummeriert",
 "nunca verificado": "nie geprüft",
 "não vão": "kommen nicht",
 "o documento mudou depois disso: guarde de novo": "das Dokument hat sich seitdem geändert: speichere es erneut",
 "ocupação": "Auslastung",
 "ontem": "gestern",
 "organizado": "organisiert",
 "orçando": "Angebot läuft",
 "out": "Okt",
 "outubro": "Oktober",
 "paga": "bezahlt",
 "paga em {d}": "bezahlt am {d}",
 "pago": "bezahlt",
 "pago em {d}": "bezahlt am {d}",
 "pago por {p}": "bezahlt von {p}",
 "pagou {v}": "hat {v} bezahlt",
 "parcela {a} de {n}": "Rate {a} von {n}",
 "parece já lançado": "scheint schon erfasst",
 "parte {n}": "Teil {n}",
 "passos por dia (média)": "Schritte pro Tag (Ø)",
 "passou {km}": "{km} überschritten",
 "pausa {p}": "Pause {p}",
 "pausado": "pausiert",
 "peso {n}": "Gewichtung {n}",
 "pesquisável": "durchsuchbar",
 "por dia": "pro Tag",
 "por dia (média)": "pro Tag (Ø)",
 "por dia disponível": "pro verfügbarem Tag",
 "por semana": "pro Woche",
 "por {p}": "von {p}",
 "porção(ões)": "Portion(en)",
 "preenchido": "ausgefüllt",
 "primeira às {hora}: {tarefa}": "erste um {hora}: {tarefa}",
 "produção": "Produktion",
 "próxima em {data}": "nächste am {data}",
 "próxima rega {d}": "nächstes Gießen {d}",
 "publicação": "Veröffentlichung",
 "página de estudo": "Lernseite",
 "página única": "einzelne Seite",
 "páginas": "Seiten",
 "páginas {p}": "Seiten {p}",
 "qua": "Mi",
 "quarta": "Mittwoch",
 "quarta-feira": "Mittwoch",
 "qui": "Do",
 "quinta": "Donnerstag",
 "quinta-feira": "Donnerstag",
 "quitada": "beglichen",
 "recebe {v}": "erhält {v}",
 "recebida": "erhalten",
 "reconhecimento facial": "Gesichtserkennung",
 "recortado": "zugeschnitten",
 "refeições feitas": "eingenommene Mahlzeiten",
 "rega a cada {n} dias": "alle {n} Tage gießen",
 "regar hoje": "heute gießen",
 "reparado": "repariert",
 "retorno {d}": "Kontrolle {d}",
 "saldo {v}": "Saldo {v}",
 "seg": "Mo",
 "segunda": "Montag",
 "segunda-feira": "Montag",
 "sem anotações": "ohne Anmerkungen",
 "sem as páginas {p}": "ohne Seiten {p}",
 "sem cliente": "ohne Kunde",
 "sem dias previstos": "keine Tage geplant",
 "sem horário": "ohne Uhrzeit",
 "sem meta": "kein Ziel",
 "sem resposta": "keine Antwort",
 "sem tempo": "ohne Zeit",
 "semana(s)": "Woche(n)",
 "set": "Sep",
 "setembro": "September",
 "seu@email.com": "du@email.com",
 "sex": "Fr",
 "sexta": "Freitag",
 "sexta-feira": "Freitag",
 "sáb": "Sa",
 "sábado": "Samstag",
 "talvez": "vielleicht",
 "tarefa da casa": "Haushaltsaufgabe",
 "tarefa: {t}": "Aufgabe: {t}",
 "taxas e despesas": "Gebühren und Ausgaben",
 "ter": "Di",
 "termina em {d}": "endet am {d}",
 "terça": "Dienstag",
 "terça-feira": "Dienstag",
 "teste": "Test",
 "todas": "alle",
 "todo ano em {d}": "jährlich am {d}",
 "todo dia {d}": "monatlich am {d}.",
 "todos": "alle",
 "toque para abrir": "zum Öffnen tippen",
 "toque para pausar": "zum Pausieren tippen",
 "toque para ver o contato": "tippen, um den Kontakt zu sehen",
 "toque para voltar a hoje": "tippen, um zu heute zurückzukehren",
 "treinos concluídos": "erledigte Trainings",
 "uma vez em {d}": "einmalig am {d}",
 "unidade(s)": "Stück",
 "vale {n}": "zählt {n}",
 "vence em {n} dias": "fällig in {n} Tagen",
 "vence {d}": "fällig {d}",
 "venceu em {data}": "abgelaufen am {data}",
 "vencido": "überfällig",
 "vendido com ganho de {v}": "mit {v} Gewinn verkauft",
 "vendido com perda de {v}": "mit {v} Verlust verkauft",
 "verificado {quando}": "geprüft {quando}",
 "você": "du",
 "você administra": "du bist Admin",
 "xícara(s)": "Tasse(n)",
 "{aba} bloqueada": "{aba} gesperrt",
 "{aba} está bloqueada": "{aba} ist gesperrt",
 "{aba}, em \"Anotações recebidas\"": "{aba}, unter \"Empfangene Notizen\"",
 "{a} aula(s) feita(s)": "{a} Lektion(en) erledigt",
 "{a} de {n} aulas": "{a} von {n} Lektionen",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} hat {p} % des Budgets erreicht ({g} von {l}).",
 "{c} confirmados de {n} convidados": "{c} Zusagen von {n} Gästen",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} liegt bei {p} % des Monatsbudgets. Bis Monatsende sind es noch {dias} Tag(e).",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} liegt schon {v} über dem gesamten Vormonat. Prüfe, ob etwas Ungewöhnliches dabei war.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} hat das Budget schon überschritten: {g} von {l}. Halte diese Ausgaben zurück, bis der neue Monat beginnt.",
 "{c} passou do orçamento: {g} de {l}.": "{c} hat das Budget überschritten: {g} von {l}.",
 "{de} paga {v} para {para}": "{de} zahlt {v} an {para}",
 "{de} às {ate}": "{de} bis {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {d}. {mes} {a}",
 "{dia}, {d} {mes}": "{dia}, {d}. {mes}",
 "{dia}, {d}/{m}": "{dia}, {d}.{m}.",
 "{dur} na semana": "{dur} in der Woche",
 "{dur} registrados": "{dur} erfasst",
 "{d}/{n} notas": "{d}/{n} Noten",
 "{feito} de {meta}": "{feito} von {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} von {n} erledigt",
 "{f}/{n} transferências feitas": "{f}/{n} Ummeldungen erledigt",
 "{hora} em {fuso}": "{hora} in {fuso}",
 "{h} este mês": "{h} diesen Monat",
 "{h} h": "{h} Std.",
 "{h} h {m} min": "{h} Std. {m} Min.",
 "{h} no seu relógio": "{h} auf deiner Uhr",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} verbunden. {n} Modell(e) in deinem Konto verfügbar.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: API-Schlüssel ungültig oder ohne Berechtigung.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: Nutzungslimit erreicht. Prüfe Guthaben oder Limit deines API-Kontos.",
 "{item}: em {n} dias ({data}).": "{item}: in {n} Tagen ({data}).",
 "{item}: hoje ({data}).": "{item}: heute ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: endet in {n} Tagen ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: läuft in {n} Tagen ab ({data}).",
 "{item}: vence hoje ({data}).": "{item}: läuft heute ab ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: war am {data} fällig und ist noch nicht als erledigt markiert.",
 "{livre} livres de {total}": "{livre} frei von {total}",
 "{m} min": "{m} Min.",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} ist jetzt dein Freund. Ihr könnt chatten.",
 "{nome} conectado!": "{nome} verbunden!",
 "{nome} ligou": "{nome} hat angerufen",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} neu, {atualizadas} aktualisiert, {enviadas} gesendet, {removidas} entfernt",
 "{n} ITEM(NS)": "{n} ARTIKEL",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} Tab(s) in deinem Plan · Farben und Optionen für jeden",
 "{n} aba(s) para comprar": "{n} Tab(s) zum Kaufen",
 "{n} adicionada(s)": "{n} hinzugefügt",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} Erinnerung(en) auf diesem Handy für die nächsten Tage geplant.",
 "{n} aluno(s)": "{n} Schüler",
 "{n} anexo(s)": "{n} Anhang/Anhänge",
 "{n} ano(s)": "{n} Jahr(e)",
 "{n} arquivo(s)": "{n} Datei(en)",
 "{n} atendimento(s)": "{n} Termin(e)",
 "{n} atrasada(s)": "{n} überfällig",
 "{n} atrasado(s)": "{n} überfällig",
 "{n} caixa(s)": "{n} Karton(s)",
 "{n} caixa(s) frágil(eis)": "{n} zerbrechliche(r) Karton(s)",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} Karton(s) · {a} in der neuen Wohnung schon geöffnet",
 "{n} cancelada(s).": "{n} storniert.",
 "{n} cartão(ões) abertos": "{n} offene Karte(n)",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{n} Forderung(en) erstellt, fällig am {d}.",
 "{n} com vencimento": "{n} mit Fälligkeit",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} Kauf/Käufe mit der Karte {c}. Die künftigen Raten erscheinen schon in den nächsten Abrechnungen.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} Rechnung(en) automatisch als bezahlt markiert.",
 "{n} copo(s), {ml} de {meta}": "{n} Glas/Gläser, {ml} von {meta}",
 "{n} de {meta} copos": "{n} von {meta} Gläsern",
 "{n} de {total}": "{n} von {total}",
 "{n} de {total} dias": "{n} von {total} Tagen",
 "{n} de {total} hoje": "{n} von {total} heute",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} von {t} Artikel(n) mit Preis, aus den in Finanzen gelesenen Kassenbons.",
 "{n} dia(s)": "{n} Tag(e)",
 "{n} dia(s) seguido(s) lendo": "{n} Tag(e) in Folge gelesen",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "{n} Tag(e) aus wiederkehrenden Aufgaben entfernt",
 "{n} dias": "{n} Tage",
 "{n} dias grátis": "{n} Tage gratis",
 "{n} dias grátis para testar": "{n} Tage gratis zum Testen",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} {tipo}: veröffentlicht am {pub}, Fristbeginn {ini}, Fristende {fim}.",
 "{n} documento(s)": "{n} Dokument(e)",
 "{n} em atraso": "{n} überfällig",
 "{n} etapa(s) atrasada(s)": "{n} Abschnitt(e) im Verzug",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} Löschung(en) warten auf die Synchronisierung des Handys.",
 "{n} falta(s)": "{n} Fehlzeit(en)",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "{n} Eintrag/Einträge in der Gruppe. Wähle unter Mitglieder die Rolle jeder Person.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} Foto(s) und Video(s) der Reise, von allen in der Gruppe. Fotos aus Reiseprogramm, Orten und Buchungen erscheinen ebenfalls hier.",
 "{n} item(ns) adicionado(s).": "{n} Eintrag/Einträge hinzugefügt.",
 "{n} item(ns) com outras pessoas": "{n} Gegenstand/Gegenstände bei anderen",
 "{n} item(ns) no Planner.": "{n} Eintrag/Einträge im Planner.",
 "{n} lançamento(s) encontrado(s)": "{n} Buchung(en) gefunden",
 "{n} lançamento(s) novo(s).": "{n} neue Buchung(en).",
 "{n} lembrete(s) colocado(s) no My Planner.": "{n} Erinnerung(en) in My Planner eingetragen.",
 "{n} livro(s) lido(s) este ano": "{n} Buch/Bücher dieses Jahr gelesen",
 "{n} marcado(s)": "{n} ausgewählt",
 "{n} matéria(s)": "{n} Fach/Fächer",
 "{n} membro(s) · abrir a conversa do grupo": "{n} Mitglied(er) · Gruppenchat öffnen",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} Monate gratis ab Kontoerstellung; danach {preco} pro Jahr.",
 "{n} min": "{n} Min.",
 "{n} min antes": "{n} Min. vorher",
 "{n} módulo(s)": "{n} Modul(e)",
 "{n} noite(s)": "{n} Nacht/Nächte",
 "{n} nota(s) nova(s).": "{n} neue Rechnung(en).",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "{n} Rechnung(en) ohne XML auf diesem Gerät wurden ausgelassen.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} Rechnung(en) · ausgestellt {e} · erhalten {r}",
 "{n} nova(s)": "{n} neu",
 "{n} novo(s) do cliente": "{n} neu vom Kunden",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} neu zum Annehmen, Bearbeiten oder Ablehnen.",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} Rate(n) in den My Planner übernommen.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} offene Rate(n) neu berechnet. Bezahlte bleiben unverändert.",
 "{n} parcela(s) em atraso": "{n} überfällige Rate(n)",
 "{n} parcela(s) em atraso: {v}": "{n} überfällige Rate(n): {v}",
 "{n} participantes · toque para ver": "{n} Teilnehmer · zum Ansehen tippen",
 "{n} passo(s)": "{n} Schritt(e)",
 "{n} pausa(s)": "{n} Pause(n)",
 "{n} pedido(s) de amizade": "{n} Freundschaftsanfrage(n)",
 "{n} pedido(s) em aberto": "{n} offene Anforderung(en)",
 "{n} pessoa(s)": "{n} Person(en)",
 "{n} pessoa(s) já entraram com o seu código.": "{n} Person(en) haben sich mit deinem Code angemeldet.",
 "{n} pessoas": "{n} Personen",
 "{n} por folha": "{n} pro Blatt",
 "{n} porções": "{n} Portionen",
 "{n} publicação(ões) nova(s).": "{n} neue Veröffentlichung(en).",
 "{n} publicações novas": "{n} neue Veröffentlichungen",
 "{n} página(s)": "{n} Seite(n)",
 "{n} página(s) · {r} revisada(s)": "{n} Seite(n) · {r} wiederholt",
 "{n} páginas": "{n} Seiten",
 "{n} recebido(s) dos seus grupos": "{n} von deinen Gruppen erhalten",
 "{n} recebido(s) para responder": "{n} erhalten, Antwort ausstehend",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} Mahlzeit(en), mit dem Speiseplan dieses Tages",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} neue oder geänderte Buchung(en).",
 "{n} resultado(s) em todas as publicações": "{n} Ergebnis(se) in allen Veröffentlichungen",
 "{n} selecionado(s): {lista}": "{n} ausgewählt: {lista}",
 "{n} tarefa(s)": "{n} Aufgabe(n)",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} Aufgabe(n) vollständig gelöscht",
 "{n} tarefa(s) criada(s)": "{n} Aufgabe(n) erstellt",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} Haushaltsaufgabe(n) wurden aus My Planner entfernt und sind jetzt nur noch in Mein Zuhause. Um eine davon in den Planner zu holen, öffne die Aufgabe und tippe auf \"An My Planner senden\".",
 "{n} tarefa(s) de ontem sem concluir": "{n} unerledigte Aufgabe(n) von gestern",
 "{n} tarefa(s) dos últimos dias sem concluir": "{n} unerledigte Aufgabe(n) der letzten Tage",
 "{n} tarefa(s) hoje": "{n} Aufgabe(n) heute",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} offene Aufgabe(n) kommen auf die Liste für heute.",
 "{n} tarjas no documento": "{n} Schwärzungen im Dokument",
 "{n} treino(s), cada um nos dias dele": "{n} Training(s), jedes an seinen Tagen",
 "{n} tribunais": "{n} Gerichte",
 "{n}x de {v}": "{n}× à {v}",
 "{n}º alerta": "{n}. Alarm",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} gesendet, {falhas} mit Fehler. Versuche es später noch einmal.",
 "{ok} enviado(s).": "{ok} gesendet.",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} von {d} Nächten belegt. Buchungen über einen Monatswechsel werden nach Nächten aufgeteilt.",
 "{preco} por ano": "{preco} pro Jahr",
 "{p} de {t} parcelas pagas ({pct}%)": "{p} von {t} Raten bezahlt ({pct}%)",
 "{p} presentes · {f} faltas": "{p} anwesend · {f} Fehlzeiten",
 "{p}% da meta de {m} páginas": "{p} % des Ziels von {m} Seiten",
 "{p}% feito": "{p} % erledigt",
 "{p}% ocupado no mês": "{p}% belegt im Monat",
 "{p}% pronta": "{p} % fertig",
 "{p}/{t} pagas": "{p}/{t} bezahlt",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} hat dich in die Gruppe „{grupo}“ in My Planner eingeladen. Tippe auf den Link, um beizutreten (die App ist zum Start kostenlos): {link}\nEinladungscode: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} und andere haben {n} Einträge zur Gruppe hinzugefügt.",
 "{quem} incluiu {item} no grupo.": "{quem} hat {item} zur Gruppe hinzugefügt.",
 "{servico} do veículo": "{servico} des Fahrzeugs",
 "{s} de {a}": "{s} von {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: zurück um {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (Kopie)",
 "{uso} usados de {total} reservados para o site": "{uso} von {total} für die Website reserviert belegt",
 "{v} · atualização de {data}": "{v} · Update vom {data}",
 "{v}/hora": "{v}/Stunde",
 "À direita": "Rechts",
 "À vista": "Einmalzahlung",
 "Às": "Um",
 "Às {hora}": "Um {hora}",
 "ÁGUA": "WASSER",
 "Ácido": "Sauer",
 "Água": "Wasser",
 "Água hoje": "Wasser heute",
 "Área externa": "Außenbereich",
 "Áreas": "Bereiche",
 "Áudio": "Audio",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "Es ist eine Hilfe und ersetzt nicht die Verfolgung der Zustellungen über die offiziellen Kanäle. Fristen müssen im offiziellen System geprüft werden.",
 "Ética Profissional": "Berufsethik",
 "Ícone e aba": "Symbol und Tab",
 "Óculos de sol": "Sonnenbrille",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Ausstellende Behörde (z. B. DETRAN-MS, Bundespolizei)",
 "Órgão emissor: {nome}": "Ausstellende Behörde: {nome}",
 "Ômega 3": "Omega-3",
 "Última": "Letzte",
 "Última adubação": "Letzte Düngung",
 "Última aplicação": "Letzte Gabe",
 "Última busca do servidor para você: {quando}": "Letzte Server-Suche für dich: {quando}",
 "Última cópia de segurança: {data}": "Letzte Sicherungskopie: {data}",
 "Última rega": "Letztes Gießen",
 "Última sincronização: {quando}": "Letzte Synchronisierung: {quando}",
 "Última: {data}": "Letzte: {data}",
 "Último dia para entregar a declaração do IR": "Letzter Tag für die Abgabe der IR-Erklärung",
 "Último erro: {m}": "Letzter Fehler: {m}",
 "Últimos 30 dias": "Letzte 30 Tage",
 "Últimos 7 dias": "Letzte 7 Tage",
 "íris": "Iris",
 "última vez em {data}": "zuletzt am {data}",
 "último em {d}": "zuletzt am {d}",
 "úteis": "Werktage",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ ist die Farbe von My Planner. Die Auswahl gilt für alle Chats auf diesem Gerät und in deinem Konto.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} ruft an (Video)",
 "📆 Conectar a agenda deste celular": "📆 Kalender dieses Handys verbinden",
 "📞 {nome} está ligando (áudio)": "📞 {nome} ruft an (Audio)",
 "Link bloqueado por segurança.": "Link aus Sicherheitsgründen blockiert.",
 "Este arquivo não é uma imagem válida.": "Diese Datei ist kein gültiges Bild.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "Die automatische Suche des Servers verfolgt die ersten 5 Profile. Die anderen werden geprüft, wenn du auf „Jetzt prüfen“ tippst.",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "Dieser Bildschirm zeigt die Zeitleiste der Reise mit den Aktivitäten und Orten, die einen festen Tag haben. Um die vollständigen Angaben eines Ortes hinzuzufügen oder zu bearbeiten, nutze den Tab Orte.",
 "Para a viagem {d}": "Für die Reise {d}",
 "sem nome": "ohne Namen",
 "Foi para a viagem {d}.": "In die Reise {d} verschoben.",
 "Orçamento total (se não for detalhar)": "Gesamtbudget (falls nicht aufgeschlüsselt)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Plane das Reiseprogramm Tag für Tag. Orte mit festem Tag erscheinen hier automatisch. Während der Reise erscheint das Reiseprogramm in der Zeitleiste von My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Lege beim Ort Tag und Uhrzeit fest, damit er automatisch im Reiseprogramm erscheint.",
 "No roteiro": "Im Reiseprogramm",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "„{nome}“ steht im Reiseprogramm am {data}. Um Tag oder Uhrzeit zu ändern, bearbeite den Ort.",
 "Para o roteiro desta viagem": "Für das Reiseprogramm dieser Reise",
 "Orçamento e gastos": "Budget und Ausgaben",
 "Parada (cidade)": "Station (Stadt)",
 "Item da categoria": "Posten der Kategorie",
 "Orçamento da viagem inteira": "Budget für die ganze Reise",
 "Orçamento geral da viagem": "Gesamtbudget der Reise",
 "Previsto {p} · gasto {g}": "Geplant {p} · ausgegeben {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Hier stehen die Reisekosten, die zu keiner Station gehören (z. B. Tickets, Versicherung). Jede Station hat ihr eigenes Budget.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Gib an, wie viel du in jeder Kategorie ausgeben willst. Beim Erfassen der Ausgaben zeigt die App, wie viel schon verbraucht ist.",
 "Orçamento por parada": "Budget pro Station",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "Besuchst du mehr als eine Stadt? Lege die Stationen an (Tab Stationen): Jede bekommt ihr eigenes Budget, und die Ausgaben dieser Tage werden ihr automatisch zugeordnet.",
 "Coloque o valor do gasto.": "Gib den Betrag der Ausgabe ein.",
 "Orçamento de {c}": "Budget für {c}",
 "Lançar um gasto nesta parada": "Ausgabe für diese Station erfassen",
 "Lançar gasto": "Ausgabe erfassen",
 "Orçamento e gastos da parada": "Budget und Ausgaben der Station",
 "Gastos lançados ({n})": "Erfasste Ausgaben ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "Um eine Ausgabe zu korrigieren oder zu löschen, nutze den Tab Budget und Ausgaben der Reise.",
 "Paradas": "Stationen",
 "Cidade ou lugar": "Stadt oder Ort",
 "Ex.: Porto": "Z. B.: Porto",
 "Chegada": "Ankunft",
 "Saída": "Abreise",
 "Onde vai ficar": "Unterkunft",
 "gasto {g} de {p}": "{g} von {p} ausgegeben",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "Besuchst du mehr als eine Stadt? Lege jede Station mit ihren Daten an. Jede bekommt ihr eigenes Budget (Unterkunft, Essen, Verkehr...) und die Ausgaben dieser Tage werden ihr automatisch zugeordnet.",
 "Café da tarde": "Kaffee am Nachmittag",
 "Outros / Lanches": "Sonstiges / Snacks",
 "Gasto {v}": "Ausgegeben {v}",
 "Gasto {g} de {p} · {a} acima": "{g} von {p} ausgegeben · {a} darüber",
 "Gasto {g} de {p}": "{g} von {p} ausgegeben",
 "Tirar \"{nome}\" do orçamento?": "„{nome}“ aus dem Budget entfernen?",
 "Os gastos já lançados nela continuam na lista de gastos.": "Bereits erfasste Ausgaben bleiben in der Ausgabenliste.",
 "Previsto para {nome}": "Geplant für {nome}",
 "Tirar {nome}": "{nome} entfernen",
 "Nome do item (ex.: Jantar especial)": "Name des Postens (z. B.: Besonderes Abendessen)",
 "Adicionar item": "Posten hinzufügen",
 "Detalhar em itens": "In Posten aufschlüsseln",
 "Nova categoria (ex.: Seguro, Presentes)": "Neue Kategorie (z. B.: Versicherung, Geschenke)",
 "Voltar às categorias sugeridas?": "Zu den vorgeschlagenen Kategorien zurückkehren?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "Die geplanten Beträge dieser Liste werden gelöscht. Erfasste Ausgaben bleiben erhalten.",
 "Voltar às categorias sugeridas": "Zu den vorgeschlagenen Kategorien zurück",
 "Previsto": "Geplant",
 "Ainda pode gastar": "Noch verfügbar",
 "Passou do previsto": "Über dem Plan",
 "Não foi possível buscar o câmbio": "Wechselkurs konnte nicht abgerufen werden",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "Kein Internet oder {m} ist nicht in der Tabelle. Bearbeite die Reise und gib den Kurs von Hand ein.",
 "Câmbio de {m} ainda não definido": "Wechselkurs für {m} noch nicht festgelegt",
 "Câmbio de hoje": "Heutiger Kurs",
 "Atualizado em {d}": "Aktualisiert am {d}",
 "Valor em {m}": "Betrag in {m}",
 "Moeda do destino": "Währung am Reiseziel",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Wechselkurs: wie viel 1 Einheit der Zielwährung in deiner Währung wert ist",
 "Sem dia marcado": "Kein Tag festgelegt",
 "Valor na moeda do destino": "Betrag in der Zielwährung",
 "Tirar só desta lista ou excluir de vez?": "Nur aus dieser Liste entfernen oder endgültig löschen?",
 "Excluir de vez": "Endgültig löschen",
 "Relatório da viagem (PDF)": "Reisebericht (PDF)",
 "Planilha da viagem (Excel)": "Reisetabelle (Excel)",
 "Geral da viagem": "Ganze Reise",
 "Viagem {d}": "Reise {d}",
 "Quem vai: {p}": "Wer fährt mit: {p}",
 "Outros gastos": "Sonstige Ausgaben",
 "Orçamento · {n}": "Budget · {n}",
 "Código": "Code",
 "Pagou": "Bezahlt von",
 "Permissão internacional para dirigir": "Internationaler Führerschein",
 "Vacina (certificado)": "Impfung (Nachweis)",
 "Autorização de viagem de menor": "Reisevollmacht für Minderjährige",
 "Vence antes da volta": "Läuft vor der Rückreise ab",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Läuft weniger als 6 Monate nach der Rückreise ab (viele Länder akzeptieren das nicht)",
 "A lista básica já está aqui.": "Die Basisliste ist schon da.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} Dokument(e) mit einer Gültigkeit, die die Reise gefährden kann",
 "Lista básica: passaporte de cada um e seguro viagem": "Basisliste: Reisepass für jede Person und Reiseversicherung",
 "Lista básica: identidade de cada um": "Basisliste: Ausweis für jede Person",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Trag die Gültigkeit jedes Dokuments ein: Die App erinnert dich vor dem Ablauf und prüft, ob der Reisepass noch 6 Monate nach der Rückreise gültig ist. Die Fotos der Dokumente sind im Tresor geschützt.",
 "De quem": "Von wem",
 "Número (protegido no cofre)": "Nummer (im Tresor geschützt)",
 "Está em mãos": "Liegt bereit",
 "Válido até {d}": "Gültig bis {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Reisepass, Visum, Reiseversicherung, Impfung, Vollmacht für Minderjährige... mit Gültigkeit und Foto. Markiere es, wenn du es bereit hast.",
 "acerto entre os viajantes (não entra no orçamento)": "Ausgleich zwischen Reisenden (nicht im Budget)",
 "Só gastos": "Nur Ausgaben",
 "Acertos": "Ausgleiche",
 "Marcar como pago?": "Als bezahlt markieren?",
 "{de} já pagou {v} para {para}?": "Hat {de} {para} schon {v} gezahlt?",
 "Já pagou": "Schon bezahlt",
 "Acerto: {de} pagou {para}": "Ausgleich: {de} hat {para} bezahlt",
 "Conferir minhas assinaturas": "Meine Abos prüfen",
 "Gerenciar ou cancelar assinaturas na loja": "Abos im Store verwalten oder kündigen",
 "Restaurar compras": "Käufe wiederherstellen",
 "Procurando...": "Suche...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} Abo(s) gefunden und freigeschaltet.",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Jahresabo, verlängert sich automatisch. Jederzeit in den Store-Abos kündbar, bis 24 Stunden vor der Verlängerung.",
 "Assinaturas da loja": "Store-Abos",
 "Gerenciar assinaturas (App Store)": "Abos verwalten (App Store)",
 "Gerenciar assinaturas (Google Play)": "Abos verwalten (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "Das Abo wird in der Handy-App abgeschlossen (Google Play oder App Store) und gilt auch hier auf der Website.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "Dieses Abo ist im Store noch nicht verfügbar. Bitte später erneut versuchen.",
 "Assinatura feita": "Abo abgeschlossen",
 "Já assinei no celular: conferir": "Ich habe schon auf dem Handy abonniert: prüfen",
 "Nenhuma assinatura encontrada nesta conta da loja.": "Kein Abo in diesem Store-Konto gefunden.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Internet prüfen und erneut versuchen. Es wurde nichts berechnet.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} freigeschaltet. Gilt auch auf deinen anderen Geräten und auf der Website.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "Zum Abonnieren My Planner über Google Play oder den App Store aktualisieren.",
 "Assinada, renova em {data}": "Abonniert, verlängert sich am {data}",
 "Não deu para assinar agora": "Abonnieren gerade nicht möglich",
 "Assinar por {preco} por ano": "Für {preco} pro Jahr abonnieren",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" ist jetzt auf der Pinnwand unter Erfolge.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" gehört jetzt zu deiner Routine. Es ist auf der Pinnwand unter Erfolge.",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" ist wieder an seinem Platz.",
 "1 ano": "1 Jahr",
 "1 mês": "1 Monat",
 "A IA não achou o valor no comprovante.": "Die KI hat den Betrag auf dem Beleg nicht gefunden.",
 "A cada {n} dias": "Alle {n} Tage",
 "A carta está vazia": "Der Brief ist leer",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "Der Brief bleibt bis {d} verschlossen. Bis dahin kannst du ihn weder lesen noch bearbeiten. Wenn du etwas ändern willst, schreib einen neuen Brief.",
 "A lixeira está vazia.": "Der Papierkorb ist leer.",
 "A mesma do app e do celular": "Dieselbe wie in der App und auf dem Handy",
 "A mesma forma de desbloqueio do app e do celular": "Dieselbe Entsperrmethode wie in der App und auf dem Handy",
 "A senha do diário precisa ter 6 caracteres ou mais.": "Das Tagebuch-Passwort muss mindestens 6 Zeichen haben.",
 "A senha precisa ter 6 caracteres ou mais.": "Das Passwort muss mindestens 6 Zeichen haben.",
 "A turma ainda não tem grupo": "Die Klasse hat noch keine Gruppe",
 "AS 4 BOLINHAS DE COR": "DIE 4 FARBPUNKTE",
 "Aberta em {d}": "Geöffnet am {d}",
 "Abra a aba para poder restaurar": "Öffne den Tab, um wiederherzustellen",
 "Abra o diário primeiro": "Öffne zuerst das Tagebuch",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "Öffnet sich mit Biometrie, Gesichtserkennung oder dem App-Passwort. Das Tagebuch-Passwort wird nur beim ersten Mal auf jedem Gerät abgefragt.",
 "Abre em {d}": "Öffnet am {d}",
 "Abrir carta para o futuro": "Brief an die Zukunft öffnen",
 "Abrir em {aba}": "In {aba} öffnen",
 "Abrir o Diário": "Tagebuch öffnen",
 "Abrir o diário": "Tagebuch öffnen",
 "Abrir {aba}": "{aba} öffnen",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Verfolgt die Immobilie, Buchungen, Auslastung, Ausgaben und Gewinn, ohne etwas zu ändern.",
 "Adicionar foto": "Foto hinzufügen",
 "Apaga tudo o que está no quadro desta página.": "Löscht alles, was auf der Tafel dieser Seite ist.",
 "Apagar o desenho?": "Zeichnung löschen?",
 "Apagar o diário": "Tagebuch löschen",
 "Apagar para todos?": "Für alle löschen?",
 "Aplicar a todas as páginas desta matéria": "Auf alle Seiten dieses Fachs anwenden",
 "Aplicar a todas as páginas desta pasta": "Auf alle Seiten dieses Ordners anwenden",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Skripte, Übungsblätter, Folien, Videos, Links und Mitteilungen. Über ⋮ › An die Klasse senden erhält jeder Schüler es in seiner App.",
 "Aquarela": "Aquarell",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Hier siehst du kostenlos, was Gruppen mit dir geteilt haben. Um den Tab mit deinen eigenen Daten zu nutzen, abonniere den Tab.",
 "Arquivados": "Archiviert",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Nach rechts wischen zum Löschen, nach links zum Archivieren.",
 "As cobranças desta aula extra já existem.": "Die Forderungen für diese Zusatzstunde gibt es schon.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "Die Noten gehen nur an den jeweiligen Schüler. Dafür muss der Name der Person in der Gruppe mit dem Namen des Schülers oder Erziehungsberechtigten im Profil übereinstimmen.",
 "Atestado": "Attest",
 "Atestados": "Atteste",
 "Até quando (opcional)": "Bis wann (optional)",
 "Até {d}": "Bis {d}",
 "Aula extra": "Zusatzstunde",
 "Aula extra (fora dos dias de aula)": "Zusatzstunde (außerhalb der Unterrichtstage)",
 "Aula extra de {d}": "Zusatzstunde vom {d}",
 "Avaliação de {d}": "Bewertung vom {d}",
 "Avaliação salva": "Bewertung gespeichert",
 "Avançar": "Weiter",
 "Aviso da revisão do mês": "Erinnerung zum Monatsrückblick",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Erinnerung am letzten Tag des Monats: \"Wie wär’s mit einem Rückblick auf deinen Monat? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Erinnerung ohne Tagebuchinhalt: \"Wie war dein Tag? ✍️\"",
 "Avulsa": "Einzeln",
 "Avulsas": "Einzelne",
 "Azul": "Blau",
 "Baixar na App Store": "Im App Store laden",
 "Baixar na Google Play": "Bei Google Play laden",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Lade My Planner im Store: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Biometrie, Gesichtserkennung oder das App-Passwort. Das Tagebuch-Passwort wird für das erste Mal auf jedem Gerät gespeichert.",
 "Branco": "Weiß",
 "Buscando o clima…": "Wetter wird abgerufen…",
 "Básicas": "Grundfarben",
 "COMO ESTOU": "WIE ES MIR GEHT",
 "COMO O DIÁRIO ABRE": "WIE DAS TAGEBUCH SICH ÖFFNET",
 "COR DA FOLHA": "BLATTFARBE",
 "Caixinha no My Planner": "Spardose in My Planner",
 "Caixinha {m}": "Spardose {m}",
 "Carta de {d}": "Brief vom {d}",
 "Carta guardada": "Brief gespeichert",
 "Carta para o futuro": "Brief an die Zukunft",
 "Carta trancada": "Verschlossener Brief",
 "Cartas abertas podem ser lidas, mas não editadas.": "Geöffnete Briefe können gelesen, aber nicht bearbeitet werden.",
 "Cartas para o Futuro": "Briefe an die Zukunft",
 "Cartões arquivados": "Archivierte Karten",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "Ein Brief von {nome} von vor {tempo} ist da 💌",
 "Chegou! Toque para abrir 💌": "Er ist da! Tippe zum Öffnen 💌",
 "Cinza-escuro": "Dunkelgrau",
 "Clara (segue o tema)": "Hell (folgt dem Design)",
 "Claras e pastel (boas para folha escura)": "Hell und pastell (gut für dunkles Blatt)",
 "Clima (toque para preencher)": "Wetter (tippen zum Ausfüllen)",
 "Clima automático": "Automatisches Wetter",
 "Clima do dia": "Wetter des Tages",
 "Cobrar a aula extra": "Zusatzstunde abrechnen",
 "Cobrar a aula extra dos presentes": "Zusatzstunde den Anwesenden berechnen",
 "Cobrar a turma toda": "Der ganzen Klasse berechnen",
 "Cole um link que comece com https://": "Füge einen Link ein, der mit https:// beginnt",
 "Coloque o valor da aula extra na turma (Editar).": "Trage den Preis der Zusatzstunde bei der Klasse ein (Bearbeiten).",
 "Coloque o valor.": "Gib den Betrag ein.",
 "Colunas": "Spalten",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "Mit eingeschalteter KI (Einstellungen › Künstliche Intelligenz) liest die App Betrag, Datum und Beschreibung aus dem Foto.",
 "Como cuidei de mim hoje?": "Wie habe ich heute für mich gesorgt?",
 "Como foi o seu dia? ✍️": "Wie war dein Tag? ✍️",
 "Compartilhar este projeto (convidar)": "Dieses Projekt teilen (einladen)",
 "Compartilhar o texto": "Text teilen",
 "Completa": "Vollständig",
 "Comprovante (foto, PDF ou print)": "Beleg (Foto, PDF oder Screenshot)",
 "Comprovante anexado": "Beleg angehängt",
 "Comprovante de pagamento (foto ou PDF)": "Zahlungsbeleg (Foto oder PDF)",
 "Concluído: hábito formado": "Abgeschlossen: Gewohnheit gefestigt",
 "Concluídos": "Abgeschlossen",
 "Configurar o Diário": "Tagebuch einrichten",
 "Confirmar pagamento": "Zahlung bestätigen",
 "Confirmar recebimento": "Eingang bestätigen",
 "Conquistas": "Erfolge",
 "Contas arquivadas": "Archivierte Zahlungen",
 "Continuar escrevendo": "Weiterschreiben",
 "Copiado ✓": "Kopiert ✓",
 "Copiar código": "Code kopieren",
 "Copiar link": "Link kopieren",
 "Cor atual": "Aktuelle Farbe",
 "Cor {n}": "Farbe {n}",
 "Creme": "Creme",
 "Criada em {d}": "Erstellt am {d}",
 "Criar as cobranças": "Forderungen erstellen",
 "Criar o grupo da turma": "Klassengruppe erstellen",
 "Criar o meu diário": "Mein Tagebuch erstellen",
 "Crie a senha do diário (6 ou mais)": "Erstelle das Tagebuch-Passwort (6 oder mehr)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Erstelle die Klassengruppe und schick den Schülern die Einladung. Danach geht der Versand direkt an sie.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Erstelle dein erstes Ziel, Vorhaben oder deinen ersten Traum mit dem +-Button unten.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Erstelle ein Projekt, lade die Beteiligten ein und teile die Schritte auf. Jede Person hakt ab, was sie erledigt hat.",
 "Crie uma senha nova para começar.": "Erstelle ein neues Passwort, um loszulegen.",
 "Cuidados arquivados": "Archivierte Pflege",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Tägliche Selbstpflege erledigt (Wohlbefinden)",
 "Curto prazo": "Kurzfristig",
 "Custos": "Kosten",
 "Céu estrelado": "Sternenhimmel",
 "Círculo": "Kreis",
 "Cômodos arquivados": "Archivierte Räume",
 "DIAS CUMPRIDOS": "ERFÜLLTE TAGE",
 "Data (opcional)": "Datum (optional)",
 "De {d}": "Vom {d}",
 "Desafixar do topo": "Oben lösen",
 "Desenho mais fraco ou mais forte": "Zeichnung schwächer oder stärker",
 "Desfazer \"Concluído\" ({d})": "\"Abgeschlossen\" rückgängig machen ({d})",
 "Desligado": "Aus",
 "Desmarcar": "Abwählen",
 "Desmarcar como paga?": "Als unbezahlt markieren?",
 "Desmarcar como recebida?": "Als nicht erhalten markieren?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Wähle ab, was du nicht nutzt: Es verschwindet vom Bildschirm und der Tab wird einfacher. Du kannst das später unter Einstellungen › Tabs › {aba} › Bereiche dieses Tabs ändern.",
 "Dias da semana": "Wochentage",
 "Dias de aula": "Unterrichtstage",
 "Dias de aula: {d}": "Unterrichtstage: {d}",
 "Dias escritos": "Geschriebene Tage",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Tipp: Zeichne die Form von Hand und halte den Finger am Ende des Strichs, damit sie perfekt wird.",
 "Ditado": "Diktat",
 "Ditar (falar para escrever)": "Diktieren (sprechen statt schreiben)",
 "Diário apagado": "Tagebuch gelöscht",
 "Diário protegido": "Geschütztes Tagebuch",
 "Dom": "So",
 "Dê um nome a ele na pasta Hábitos.": "Gib ihr im Ordner Gewohnheiten einen Namen.",
 "EVOLUÇÃO": "VERLAUF",
 "Editada em {d}": "Bearbeitet am {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "Er öffnet sich am {d} (in {n} Tagen). Bis dahin kannst du ihn weder lesen noch bearbeiten.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "Er öffnet sich am {d}. An diesem Tag bekommst du eine Benachrichtigung.",
 "Ela fica guardada com a data de hoje para comparar depois.": "Sie wird mit dem heutigen Datum gespeichert, um später zu vergleichen.",
 "Enorme": "Riesig",
 "Enviado ao paciente": "An den Patienten gesendet",
 "Enviado em": "Gesendet am",
 "Enviar \"{t}\" para todos do grupo {g}?": "\"{t}\" an alle in der Gruppe {g} senden?",
 "Enviar a nota para cada aluno": "Note an jeden Schüler senden",
 "Enviar as notas": "Noten senden",
 "Enviar o arquivo: {nome}": "Datei senden: {nome}",
 "Enviar o recado para a turma": "Mitteilung an die Klasse senden",
 "Enviar o título para outra aba": "Titel an einen anderen Tab senden",
 "Enviar para a turma": "An die Klasse senden",
 "Enviar para outra aba": "An einen anderen Tab senden",
 "Escolha a cor desta bolinha": "Wähle die Farbe dieses Punkts",
 "Escolha uma data no futuro": "Wähle ein Datum in der Zukunft",
 "Escolher qualquer cor": "Beliebige Farbe wählen",
 "Esconder a barra": "Leiste ausblenden",
 "Escreva a frase": "Schreib den Spruch",
 "Escreva a que se refere a cobrança.": "Schreib, worauf sich die Forderung bezieht.",
 "Escreva alguma coisa antes de guardar.": "Schreib etwas, bevor du speicherst.",
 "Escreva alguma coisa antes de salvar.": "Schreib etwas, bevor du speicherst.",
 "Escreva hoje, abra no futuro": "Heute schreiben, in der Zukunft öffnen",
 "Escreva o que você quer mudar a partir de hoje": "Schreib, was du ab heute ändern willst",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Schreib an dein zukünftiges Ich. Der Brief bleibt bis zum Öffnungstag verschlossen.",
 "Escrever uma carta": "Einen Brief schreiben",
 "Escrita em {e} · abre em {a}": "Geschrieben am {e} · öffnet am {a}",
 "Escuras (boas para folha clara)": "Dunkel (gut für helles Blatt)",
 "Esperado": "Erwartet",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Erwartet: {e} · Erledigt: {f} · Gefehlt: {fa}",
 "Esqueceu a senha do diário?": "Tagebuch-Passwort vergessen?",
 "Esqueci a senha do diário": "Ich habe das Tagebuch-Passwort vergessen",
 "Esta semana": "Diese Woche",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "Diese Buchung stammt aus einem anderen Bereich der App und kann hier nicht gelöscht werden.",
 "Estudo: {h}": "Lernen: {h}",
 "Esvaziar": "Leeren",
 "Esvaziar a lixeira": "Papierkorb leeren",
 "Esvaziar a lixeira?": "Papierkorb leeren?",
 "Ex.: Comer uma fruta por dia": "Z. B.: Jeden Tag ein Stück Obst essen",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "Z. B.: Hausaufgaben, Attest für 2 Tage",
 "Ex.: Reservar a pousada": "Z. B.: Die Pension buchen",
 "Ex.: Viagem em família, juntar para a festa": "Z. B.: Familienreise, für die Party sparen",
 "Excluir de vez?": "Endgültig löschen?",
 "Excluir esta avaliação?": "Diese Bewertung löschen?",
 "Excluir este bloco?": "Diesen Block löschen?",
 "Excluir este desenho?": "Diese Zeichnung löschen?",
 "Excluir este item?": "Diesen Eintrag löschen?",
 "Excluir {n} item(ns)?": "{n} Eintrag/Einträge löschen?",
 "Exportar como imagem": "Als Bild exportieren",
 "Exportar em PDF": "Als PDF exportieren",
 "FOTOS": "FOTOS",
 "FRASE DO DIA": "SPRUCH DES TAGES",
 "FREQUÊNCIA": "HÄUFIGKEIT",
 "Falta o valor": "Betrag fehlt",
 "Feriado": "Feiertag",
 "Feriado: {f}": "Feiertag: {f}",
 "Fica 30 dias na lixeira.": "Bleibt 30 Tage im Papierkorb.",
 "Ficam 30 dias na lixeira.": "Bleiben 30 Tage im Papierkorb.",
 "Fichários arquivados": "Archivierte Ordner",
 "Fixar no topo": "Oben anheften",
 "Floral": "Blumen",
 "Folha": "Blatt",
 "Folha, tema e cores das páginas com escrita": "Blatt, Design und Farben der Schreibseiten",
 "Folhas e plantas": "Blätter und Pflanzen",
 "Foto adicionada": "Foto hinzugefügt",
 "Foto do sonho": "Foto des Traums",
 "Fotos do dia": "Fotos des Tages",
 "Frase": "Spruch",
 "Frase do dia (aparece no topo do Meu Dia)": "Spruch des Tages (erscheint oben in Mein Tag)",
 "Frases, textos, vídeos e fotos que motivam": "Sprüche, Texte, Videos und Fotos, die motivieren",
 "Geométrico": "Geometrisch",
 "Gerar": "Erzeugen",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Erinnerungen und Notizen per Sprache aufnehmen und Texte diktieren (🎤), wenn du es möchtest. Das Mikrofon geht nur auf deinen Tipp an, und das Diktat-Audio wird nicht gespeichert.",
 "Guardar e trancar": "Speichern und verschließen",
 "Guardar e trancar?": "Speichern und verschließen?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Bewahre hier auf, was dich motiviert: Sprüche, eigene Texte, Videos und Fotos.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Bewahre dieses Passwort gut auf: Ohne es kann das Tagebuch nicht wiederhergestellt werden.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Heute ist Feiertag: {f}. Trotzdem erfassen?",
 "Humor do mês": "Stimmung des Monats",
 "Humor do período": "Stimmung im Zeitraum",
 "HÁBITOS LIGADOS": "VERKNÜPFTE GEWOHNHEITEN",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "In der Auswahl sind große Einträge. Sie können nur einzeln gelöscht werden, mit Bestätigung und Passwort.",
 "Há um ano": "Vor einem Jahr",
 "Há um mês": "Vor einem Monat",
 "Hábito": "Gewohnheit",
 "Hábito criado": "Gewohnheit erstellt",
 "Hábitos": "Gewohnheiten",
 "Hábitos cumpridos": "Erfüllte Gewohnheiten",
 "Hábitos cumpridos: {f} de {n}": "Erfüllte Gewohnheiten: {f} von {n}",
 "Hábitos formados": "Gefestigte Gewohnheiten",
 "INSPIRAÇÃO": "INSPIRATION",
 "Imagem adicionada": "Bild hinzugefügt",
 "Imagem não encontrada": "Bild nicht gefunden",
 "Incrível": "Großartig",
 "Informação nutricional": "Nährwertangaben",
 "Inserir": "Einfügen",
 "Inspiração": "Inspiration",
 "Item para o paciente": "Eintrag für den Patienten",
 "Itens grandes só se excluem um por um.": "Große Einträge können nur einzeln gelöscht werden.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Sammle Fotos von dem, was du erleben willst. Halten und ziehen zum Sortieren.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "MIT EINEM TRAUM AUS DEM LEBENSPROJEKT VERKNÜPFEN (OPTIONAL)",
 "LIGAR A UMA META (OPCIONAL)": "MIT EINEM ZIEL VERKNÜPFEN (OPTIONAL)",
 "LINKS DE VÍDEO": "VIDEO-LINKS",
 "Lance as notas antes de enviar.": "Trage die Noten ein, bevor du sendest.",
 "Lançamentos arquivados": "Archivierte Buchungen",
 "Legenda (opcional)": "Bildunterschrift (optional)",
 "Lembrete diário": "Tägliche Erinnerung",
 "Lendo o comprovante...": "Beleg wird gelesen...",
 "Ler o comprovante com a minha IA": "Beleg mit meiner KI lesen",
 "Ligado": "An",
 "Ligar um texto de motivação (Inspiração)": "Einen Motivationstext verknüpfen (Inspiration)",
 "Lilás": "Lila",
 "Limpar a folha inteira?": "Ganzes Blatt leeren?",
 "Linha reta": "Gerade Linie",
 "Linhas": "Linien",
 "Link do vídeo (YouTube, Instagram...)": "Video-Link (YouTube, Instagram...)",
 "Lisa": "Blanko",
 "Liste os passos do projeto e diga quem faz cada um.": "Liste die Schritte des Projekts auf und sag, wer was macht.",
 "Lixeira": "Papierkorb",
 "Longo prazo": "Langfristig",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "AUTOMATISCH ÜBER WOHLBEFINDEN ABHAKEN (OPTIONAL)",
 "META OU SONHO LIGADO (OPCIONAL)": "VERKNÜPFTES ZIEL ODER VERKNÜPFTER TRAUM (OPTIONAL)",
 "Mais opções": "Weitere Optionen",
 "Mal": "Schlecht",
 "Mandar ao paciente pelo WhatsApp": "Per WhatsApp an den Patienten senden",
 "Marque o que fez em cada dia": "Hake ab, was du an jedem Tag gemacht hast",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Markiere die Unterrichtstage bei der Klasse (Bearbeiten), damit die Anwesenheit nur diese Tage zeigt.",
 "Matérias arquivadas": "Archivierte Fächer",
 "Mensalidade": "Monatsbeitrag",
 "Meta de água do Bem-Estar": "Wasserziel aus Wohlbefinden",
 "Metas arquivadas": "Archivierte Ziele",
 "Metas e sonhos concluídos": "Erreichte Ziele und Träume",
 "Metas em andamento": "Laufende Ziele",
 "Metas que avançaram": "Ziele mit Fortschritt",
 "Metas, objetivos e sonhos, com passos e prazos": "Ziele, Vorhaben und Träume, mit Schritten und Fristen",
 "Meu Dia": "Mein Tag",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "Mein Tag mit freier Seite, Lebensprojekt, Gewohnheiten, Traumboard, Lebensrad, Briefen an die Zukunft und Erfolgen. Mit Passwort geschützt.",
 "Minimalista": "Minimalistisch",
 "Mostrar as contas antes do vencimento": "Rechnungen vor der Fälligkeit anzeigen",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Datum, Uhrzeit, Währung und Feiertage passend zu deinem Standort anzeigen. Der ungefähre Standort des Handys wird nur genutzt, wenn du im Tagebuch das Wetter des Tages abrufst, und wird nicht gespeichert.",
 "Muito bem": "Sehr gut",
 "Muito mal": "Sehr schlecht",
 "Mural de fotos dos seus sonhos": "Fotowand deiner Träume",
 "Mural, relatório e revisão do mês": "Pinnwand, Bericht und Monatsrückblick",
 "Médio prazo": "Mittelfristig",
 "N dias cumpridos no mês": "N erfüllte Tage im Monat",
 "N dias seguidos": "N Tage in Folge",
 "NESTE DIA": "AN DIESEM TAG",
 "Nada a enviar": "Nichts zu senden",
 "Nenhum estudo registrado nesta semana.": "Diese Woche wurde kein Lernen erfasst.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "Noch keine Gewohnheit. Z. B.: \"Jeden Tag ein Stück Obst essen\", \"2 L Wasser trinken\", \"Das Frühstück nicht auslassen\".",
 "Nenhum no período.": "Keine im Zeitraum.",
 "Nenhuma": "Keine",
 "Nenhuma carta ainda.": "Noch keine Briefe.",
 "Nenhuma foto ainda.": "Noch keine Fotos.",
 "Neutras e opacas": "Neutral und matt",
 "Ninguém encontrado no grupo": "Niemand in der Gruppe gefunden",
 "No computador: {link}": "Am Computer: {link}",
 "No navegador, a senha do diário é pedida sempre.": "Im Browser wird das Tagebuch-Passwort immer abgefragt.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Am letzten Tag des Monats: \"Wie wär’s mit einem Rückblick auf deinen Monat? ✨\"",
 "Nome da página (opcional)": "Seitenname (optional)",
 "Nome de quem faz este passo": "Name der Person, die diesen Schritt macht",
 "Nome do vídeo (opcional)": "Videoname (optional)",
 "Normal": "Normal",
 "Nota de 0 a 10 para cada área da vida": "Note von 0 bis 10 für jeden Lebensbereich",
 "Nota: {a}": "Note: {a}",
 "Nova caixa": "Neue Box",
 "Nova carta": "Neuer Brief",
 "Nova meta, objetivo ou sonho": "Neues Ziel, Vorhaben oder neuer Traum",
 "Nova senha (6 caracteres ou mais)": "Neues Passwort (6 oder mehr Zeichen)",
 "Nova área (ex.: Espiritualidade)": "Neuer Bereich (z. B.: Spiritualität)",
 "Novo cômodo": "Neuer Raum",
 "Novo hábito": "Neue Gewohnheit",
 "Não dá para excluir em grupo": "Gruppenweises Löschen nicht möglich",
 "Não enviados": "Nicht gesendet",
 "Não estão no grupo (ou com outro nome): {l}": "Nicht in der Gruppe (oder unter anderem Namen): {l}",
 "Não foi possível exportar": "Export nicht möglich",
 "Não foi possível ouvir agora ({erro}).": "Zuhören ist gerade nicht möglich ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "Fragt nicht nach dem Tagebuch-Passwort. Es ist der einzige Bereich, der geteilt werden kann.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "Kein Unterrichtstag dieser Klasse. Die Anwesenheit zählt als Nachholstunde oder Zusatzstunde.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "Die App erinnert dich {n} Tag(e) vorher und am Fälligkeitstag um 9 Uhr. Ändern kannst du das unter Einstellungen › Tabs › Finanzen.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "Das automatische Wetter nutzt den Standort des Handys. Ohne Erlaubnis kannst du es hier selbst eintragen.",
 "O conteúdo desta carta não foi encontrado.": "Der Inhalt dieses Briefs wurde nicht gefunden.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "Das Diktat kommt mit der neuen App-Version. Aktualisiere My Planner im Store (oder installiere die neue APK), um das Mikrofon zu nutzen.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "Das Tagebuch fragt jedes Mal nach dem Passwort, wenn du es öffnest, auch wenn die App entsperrt ist.",
 "O diário só abre com essa senha, sempre.": "Das Tagebuch öffnet sich immer nur mit diesem Passwort.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "Das Tagebuch ist verschlüsselt: Ohne das Passwort kann es niemand öffnen, auch nicht der Support. Wenn du willst, kannst du das Tagebuch löschen und ein neues anfangen (die Gruppenprojekte bleiben erhalten).",
 "O que aprendi hoje?": "Was habe ich heute gelernt?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "Was hat dich dieser Monat gelehrt? Was willst du in den nächsten mitnehmen?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "Was nicht angehakt ist, verschwindet vom Bildschirm. Die Daten bleiben gespeichert.",
 "O que foi bom hoje?": "Was war heute gut?",
 "O que foi excluído nos últimos 30 dias": "Was in den letzten 30 Tagen gelöscht wurde",
 "O que quero melhorar amanhã?": "Was will ich morgen besser machen?",
 "O que quero mudar agora": "Was ich jetzt ändern will",
 "O que você escreveu nesta carta vai se perder.": "Was du in diesem Brief geschrieben hast, geht verloren.",
 "O que você quer fazer com o arquivo?": "Was möchtest du mit der Datei machen?",
 "Objetivo": "Vorhaben",
 "Oculta": "Ausgeblendet",
 "Orientação": "Anleitung",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Anleitungen, Rezepte, Atteste und Materialien für den Patienten, mit Dateien. Nur was hier liegt, wird gesendet: Die Patientenakte verlässt diesen Ordner nie.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "Tage mit beschriebener Seite sind markiert. Tippe auf einen Tag, um ihn zu öffnen.",
 "Os itens saem de vez e não podem mais ser restaurados.": "Die Einträge werden endgültig entfernt und können nicht mehr wiederhergestellt werden.",
 "Outra data": "Anderes Datum",
 "Outras moedas": "Andere Währungen",
 "Ouvindo…": "Hört zu…",
 "PASSOS": "SCHRITTE",
 "PDF com seus dados e assinatura": "PDF mit deinen Daten und deiner Unterschrift",
 "POR DIA": "PRO TAG",
 "POR MATÉRIA": "PRO FACH",
 "PROGRESSO": "FORTSCHRITT",
 "Paciente: {nome}": "Patient: {nome}",
 "Para o paciente": "Für den Patienten",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "Um die Öffnungsart zu ändern, öffne das Tagebuch mit seinem Passwort und komm hierher zurück.",
 "Para {nome} de {tempo} depois": "An {nome}, {tempo} später",
 "Parar o ditado": "Diktat beenden",
 "Parcelado": "In Raten",
 "Partes desta aba": "Bereiche dieses Tabs",
 "Passo": "Schritt",
 "Pastas arquivadas": "Archivierte Ordner",
 "Pastas arquivadas ({n})": "Archivierte Ordner ({n})",
 "Pautada": "Liniert",
 "Pautada com margem": "Liniert mit Rand",
 "Pedido de exame": "Untersuchungsauftrag",
 "Pelo que sou grata hoje?": "Wofür bin ich heute dankbar?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Erlaube My Planner in den Einstellungen des Handys Mikrofon und Spracherkennung.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Anpassen: Art, Farbe und Design des Blatts und Farben der Punkte, nur für diesen Tab",
 "Pontilhada": "Gepunktet",
 "Posto": "Tankstelle",
 "Preenche o clima do Meu Dia pela localização do celular.": "Füllt das Wetter in Mein Tag über den Standort des Handys aus.",
 "Preencher pela foto do comprovante": "Aus dem Belegfoto ausfüllen",
 "Primeira vez neste aparelho: digite a senha do diário.": "Zum ersten Mal auf diesem Gerät: Gib das Tagebuch-Passwort ein.",
 "Projeto": "Projekt",
 "Projeto de Vida": "Lebensprojekt",
 "Projetos com amigos e família (compartilhados)": "Projekte mit Freunden und Familie (geteilt)",
 "Projetos em Grupo": "Gruppenprojekte",
 "Proprietário / Locador": "Eigentümer / Vermieter",
 "Páginas arquivadas": "Archivierte Seiten",
 "Páginas desta aba": "Seiten dieses Tabs",
 "QUANDO ELA ABRE": "WANN ER SICH ÖFFNET",
 "Qua": "Mi",
 "Quadriculada": "Kariert",
 "Quadro dos Sonhos": "Traumboard",
 "Quais partes você vai usar?": "Welche Bereiche wirst du nutzen?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "Wenn du ein Ziel erreichst oder eine Gewohnheit festigst, erscheint es hier zum Feiern. 🎉",
 "Quanto você pagou?": "Wie viel hast du bezahlt?",
 "Quanto você recebeu?": "Wie viel hast du erhalten?",
 "Que tal revisar o seu mês? ✨": "Wie wär’s mit einem Rückblick auf deinen Monat? ✨",
 "Quem faz": "Wer macht es",
 "Quem fez o meu dia melhor?": "Wer hat meinen Tag schöner gemacht?",
 "Quer guardar o comprovante agora?": "Möchtest du den Beleg jetzt speichern?",
 "Qui": "Do",
 "REFLEXÃO DO MÊS": "MONATSREFLEXION",
 "Recebeu {v} a mais": "{v} mehr erhalten",
 "Recebeu {v} a menos": "{v} weniger erhalten",
 "Receita médica": "Ärztliches Rezept",
 "Receitas médicas": "Ärztliche Rezepte",
 "Recolher": "Einklappen",
 "Refeições arquivadas": "Archivierte Mahlzeiten",
 "Refeições do cronograma feitas (Bem-Estar)": "Mahlzeiten aus dem Plan erledigt (Wohlbefinden)",
 "Referente a (ex.: material, passeio, inscrição)": "Bezieht sich auf (z. B.: Material, Ausflug, Anmeldung)",
 "Registrar": "Erfassen",
 "Relacionamentos": "Beziehungen",
 "Relatório de estudos": "Lernbericht",
 "Relatório de realizações": "Erfolgsbericht",
 "Relatório em PDF": "Bericht als PDF",
 "Renomear, adicionar ou tirar áreas": "Bereiche umbenennen, hinzufügen oder entfernen",
 "Reposição": "Nachholstunde",
 "Restaurado": "Wiederhergestellt",
 "Resumida": "Kompakt",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Kompakt: nur eine Zeile mit der Summe. Vollständig: zeigt die Einträge des Tages. Ausgeblendet: erscheint nicht. Aus diesem Tab wird nichts automatisch zur Aufgabe.",
 "Resumo de {nome}": "Übersicht von {nome}",
 "Resumo do dia": "Tagesübersicht",
 "Retângulo": "Rechteck",
 "Revisar antes": "Vorher prüfen",
 "Revisão do mês": "Monatsrückblick",
 "Roda da Vida": "Lebensrad",
 "Rosa": "Rosa",
 "Sair sem guardar?": "Ohne Speichern verlassen?",
 "Salvar avaliação de hoje": "Heutige Bewertung speichern",
 "Salvar ou enviar": "Speichern oder senden",
 "Seg": "Mo",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Halte und ziehe die Ordner, um die Reihenfolge zu ändern. Nach links wischen zum Archivieren.",
 "Sem chamada neste dia: cobra todos os alunos.": "Keine Anwesenheit an diesem Tag: Alle Schüler werden berechnet.",
 "Sem ideia do que escrever? Toque numa pergunta:": "Keine Idee, was du schreiben sollst? Tippe auf eine Frage:",
 "Sem registros de humor.": "Keine Stimmungseinträge.",
 "Sem tema": "Ohne Design",
 "Semana de {d}": "Woche vom {d}",
 "Senha atual do diário": "Aktuelles Tagebuch-Passwort",
 "Senha do diário": "Tagebuch-Passwort",
 "Senha do diário incorreta.": "Falsches Tagebuch-Passwort.",
 "Senha do diário trocada": "Tagebuch-Passwort geändert",
 "Senha própria só do diário": "Eigenes Passwort nur für das Tagebuch",
 "Sequência dos hábitos": "Gewohnheitsserie",
 "Seta": "Pfeil",
 "Seu diário, só seu": "Dein Tagebuch, nur für dich",
 "Seu texto de motivação": "Dein Motivationstext",
 "Sex": "Fr",
 "Sonho": "Traum",
 "Suplementos arquivados": "Archivierte Nahrungsergänzungen",
 "Sáb": "Sa",
 "Só abre com a senha do diário.": "Öffnet sich nur mit dem Tagebuch-Passwort.",
 "TEMA DECORATIVO": "DEKORATIVES DESIGN",
 "TIPO DE FOLHA": "BLATTART",
 "Tarefas arquivadas": "Archivierte Aufgaben",
 "Ter": "Di",
 "Texto para o paciente": "Text für den Patienten",
 "Tipo, cor e tema da folha": "Art, Farbe und Design des Blatts",
 "Tirar a área \"{a}\"?": "Bereich \"{a}\" entfernen?",
 "Tirar da frase do dia": "Als Spruch des Tages entfernen",
 "Tirar do arquivo": "Aus dem Archiv holen",
 "Tirar esta foto do quadro?": "Dieses Foto von der Tafel entfernen?",
 "Tirar esta pergunta?": "Diese Frage entfernen?",
 "Tirar este vídeo?": "Dieses Video entfernen?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Jeden Tag um {h}: \"Wie war dein Tag? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "Alle Schüler haben schon eine Forderung mit diesem Bezug.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Tippe noch einmal für \"Sonstiges\" (befreit, Attest...): zählt weder als Fehlen noch als Unterricht.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Tippe auf den Kreis, um abzuhaken, was du heute gemacht hast. Gewohnheiten gehen nicht automatisch in My Planner: Nutze Senden im Menü ⋮.",
 "Toque num dia para marcar ou desmarcar.": "Tippe auf einen Tag, um ihn an- oder abzuhaken.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Tippe auf einen Punkt, um die Farbe zu ändern. Auf der Seite bewirkt Halten des Punkts dasselbe.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Tippen zum Öffnen. Nach links wischen zum Archivieren oder Duplizieren, nach rechts zum Löschen.",
 "Treino do dia feito (Bem-Estar)": "Training des Tages erledigt (Wohlbefinden)",
 "Treinos arquivados": "Archivierte Trainings",
 "Trocar a senha do diário": "Tagebuch-Passwort ändern",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Alles, was du ins Tagebuch schreibst, wird auf diesem Gerät verschlüsselt, bevor es in dein Konto geht. Niemand sonst kann es lesen, auch nicht der Support.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Alles, was du löschst, bleibt 30 Tage hier. Danach wird es endgültig entfernt.",
 "Título (ex.: Ter uma boa alimentação)": "Titel (z. B.: Sich gut ernähren)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "Eine Einzelforderung für jeden der {n} Schüler. Um nur einem Schüler etwas zu berechnen, tippe auf +.",
 "Uma senha própria, só do diário": "Ein eigenes Passwort, nur für das Tagebuch",
 "Usar a senha do diário": "Tagebuch-Passwort verwenden",
 "Usar como frase do dia": "Als Spruch des Tages verwenden",
 "Usar este valor": "Diesen Betrag verwenden",
 "Usar o padrão do app": "App-Standard verwenden",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "Gilt für die Beträge aller Tabs (Finanzen, Vermietung, Monatsbeiträge...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "Gilt für alle Schreibseiten (Lernen, Notizen, Tagebuch, Dokumente...). Jeder Tab kann unter Einstellungen › Tabs einen eigenen Standard haben, und jede Seite kann das Blatt über ⋮ › Blatt ändern.",
 "Valor da aula extra (por aluno)": "Preis der Zusatzstunde (pro Schüler)",
 "Valor por aluno": "Betrag pro Schüler",
 "Valor previsto: {v}": "Geplanter Betrag: {v}",
 "Vencimento: {d}": "Fällig: {d}",
 "Ver o comprovante": "Beleg ansehen",
 "Verde": "Grün",
 "Visualizar": "Vorschau",
 "Você está como convidado": "Du bist als Gast hier",
 "Voltar a acompanhar este hábito": "Diese Gewohnheit wieder verfolgen",
 "Voltar ao início da folha": "Zum Anfang des Blatts",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Auf Anfangsstandard zurücksetzen (liniertes Blatt; Schwarz, Blau, Rot und Grün)",
 "Voltar para a nova avaliação": "Zurück zur neuen Bewertung",
 "Vídeos": "Videos",
 "X vezes por semana": "X-mal pro Woche",
 "abre em {n} dias": "öffnet in {n} Tagen",
 "agradável": "angenehm",
 "arquivo": "Archiv",
 "aula extra": "Zusatzstunde",
 "calor": "heiß",
 "chuva": "Regen",
 "concluído": "abgeschlossen",
 "céu limpo": "klarer Himmel",
 "de {n} planejados": "von {n} geplanten",
 "dentro de {p}": "in {p}",
 "enviado em {d}": "gesendet am {d}",
 "estudados na semana": "diese Woche gelernt",
 "excluído em {d}": "gelöscht am {d}",
 "falta 1 dia": "noch 1 Tag",
 "faltam {n} dias": "noch {n} Tage",
 "feito {dur} na semana": "{dur} diese Woche erledigt",
 "fresco": "kühl",
 "frio": "kalt",
 "garoa": "Nieselregen",
 "hoje não está planejado": "heute nicht geplant",
 "hábito formado ✨": "Gewohnheit gefestigt ✨",
 "incorreta": "falsch",
 "neblina": "Nebel",
 "neve": "Schnee",
 "nublado": "bewölkt",
 "não enviado": "nicht gesendet",
 "parcela {k}/{n}": "Rate {k}/{n}",
 "passou há {n} dias": "vor {n} Tagen vorbei",
 "pelo Bem-Estar": "über Wohlbefinden",
 "poucas nuvens": "leicht bewölkt",
 "reposição": "Nachholstunde",
 "sai de vez em {n} dia(s)": "wird in {n} Tag(en) endgültig gelöscht",
 "sem registros": "keine Einträge",
 "tempestade": "Gewitter",
 "tracejado: {d}": "gestrichelt: {d}",
 "ver mais": "mehr anzeigen",
 "ver menos": "weniger anzeigen",
 "{aluno}: {n} de {max}": "{aluno}: {n} von {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} ist ein Feiertag: {f}. Trotzdem erfassen?",
 "{f} de {n} passos feitos": "{f} von {n} Schritten erledigt",
 "{f}/{n} passos": "{f}/{n} Schritte",
 "{nome} daqui a 1 ano": "{nome} in 1 Jahr",
 "{nome} daqui a 10 anos": "{nome} in 10 Jahren",
 "{nome} daqui a 6 meses": "{nome} in 6 Monaten",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} Schüler erhalten nur ihre eigene Note für \"{a}\".",
 "{n} aluno(s) receberam a nota.": "{n} Schüler haben die Note erhalten.",
 "{n} aluno(s) · {v} cada": "{n} Schüler · je {v}",
 "{n} anos": "{n} Jahre",
 "{n} dia(s) antes": "{n} Tag(e) vorher",
 "{n} dia(s) cumprido(s) no mês": "{n} erfüllte(r) Tag(e) im Monat",
 "{n} dia(s) registrado(s) · média {e}": "{n} Tag(e) erfasst · Durchschnitt {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} Tag(e) erfasst, Durchschnitt {m} von 6",
 "{n} dia(s) seguido(s)": "{n} Tag(e) in Folge",
 "{n} dispensada(s) hoje": "{n} heute befreit",
 "{n} meses": "{n} Monate",
 "{n} outro(s)": "{n} weitere",
 "{n} selecionado(s)": "{n} ausgewählt",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} Aufgabe(n) in My Planner erledigt",
 "{n} vez(es) por semana": "{n}-mal pro Woche",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Wasser: {a} von {m} ml",
 "ÚLTIMAS 8 SEMANAS": "LETZTE 8 WOCHEN",
 "Última parcela em {d}": "Letzte Rate am {d}",
 "é hoje!": "ist heute!",
 "A mesma do app": "Dasselbe wie in der App",
 "Abrir com o código": "Mit dem Code öffnen",
 "Ainda não criado": "Noch nicht erstellt",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "Beim Erstellen zeigt die App einen Wiederherstellungscode, den du aufbewahren solltest.",
 "Apagar o diário e começar de novo": "Tagebuch löschen und neu beginnen",
 "Biometria ou código do dispositivo": "Biometrie oder Gerätecode",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Biometrie, Geräte-PIN oder das App-Passwort. Du musst kein weiteres Passwort erstellen.",
 "Bloquear o app": "App sperren",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Richte auf dem Gerät Fingerabdruck, Gesicht oder einen Sperrcode ein, um dies zu nutzen.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "Wenn die Biometrie aktiv ist, erscheint sie zuerst. Schlägt sie fehl, bietet dasselbe Fenster Code/PIN/Muster des Geräts an; das App-Passwort gilt weiterhin.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "Damit stellst du das Tagebuch wieder her, wenn du das Passwort vergisst oder das Gerät wechselst.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "Mit diesem Code stellst du das Tagebuch wieder her, wenn du das Passwort vergisst oder das Gerät wechselst. Bewahre ihn sicher auf und zeige ihn niemandem.",
 "Como funciona a Roda da Vida": "So funktioniert das Lebensrad",
 "Como o diário abre": "Wie das Tagebuch geöffnet wird",
 "Crie a senha que vai abrir o diário.": "Erstelle das Passwort, mit dem das Tagebuch geöffnet wird.",
 "Crie o PIN do diário (4 a 6 números)": "Tagebuch-PIN erstellen (4 bis 6 Ziffern)",
 "Crie o diário de novo para começar.": "Erstelle das Tagebuch neu, um zu beginnen.",
 "Código aceito. Crie uma senha nova para o diário.": "Code akzeptiert. Erstelle ein neues Passwort für das Tagebuch.",
 "Código de recuperação": "Wiederherstellungscode",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Wiederherstellungscode (z. B. ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Falscher Wiederherstellungscode.",
 "Cômodos": "Räume",
 "Depois de 1 minuto": "Nach 1 Minute",
 "Depois de {n} minutos": "Nach {n} Minuten",
 "Desenhe o padrão do diário": "Zeichne das Tagebuch-Muster",
 "Dias no mês": "Tage im Monat",
 "Dias seguidos": "Tage in Folge",
 "Digite o seu PIN": "Gib deine PIN ein",
 "Diário ainda não criado": "Tagebuch noch nicht erstellt",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Gib jedem Lebensbereich eine Note von 0 bis 10, wie du dich heute fühlst. Die Grafik zeigt, wo dein Leben im Gleichgewicht ist und wo es Aufmerksamkeit braucht. Speichere die Bewertung und wiederhole sie von Zeit zu Zeit (zum Beispiel jeden Monat), um zu vergleichen und deine Entwicklung zu sehen. Du kannst Bereiche umbenennen, hinzufügen oder entfernen.",
 "Entre na aba Diário para criar o seu diário.": "Öffne den Tab Tagebuch, um dein Tagebuch zu erstellen.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Öffne das Tagebuch (mit seinem Passwort oder der App-Entsperrung) und komm hierher zurück.",
 "Esconder a senha": "Passwort verbergen",
 "Gerar novo código": "Neuen Code erzeugen",
 "Gerar um código de recuperação novo?": "Neuen Wiederherstellungscode erzeugen?",
 "Guarde este código": "Bewahre diesen Code auf",
 "Já guardei": "Schon gespeichert",
 "Ligar um hábito que já existe": "Bestehende Gewohnheit verknüpfen",
 "Mostrar a senha": "Passwort anzeigen",
 "Mudar como o diário abre": "Ändern, wie das Tagebuch geöffnet wird",
 "My Planner · Código de recuperação do Diário": "My Planner · Wiederherstellungscode des Tagebuchs",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "Öffnen mit dem Schlüssel dieses Geräts nicht möglich. Verwende das Tagebuch-Passwort oder den Wiederherstellungscode.",
 "O Caps Lock parece estar ligado.": "Die Feststelltaste scheint aktiviert zu sein.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "Die PIN wird nur auf diesem Gerät geschützt gespeichert. Das Passwort gilt weiterhin, falls du die PIN vergisst.",
 "O PIN precisa ter de 4 a 6 números.": "Die PIN muss 4 bis 6 Ziffern haben.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "Der bisherige Code wird ungültig. Aus Sicherheitsgründen wird der Code nicht in der App gespeichert: Er ist nur beim Erzeugen sichtbar.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "Der Code wird nirgendwo gespeichert, wo der Support ihn sehen könnte. Ohne Passwort und ohne Code kann das Tagebuch nicht wiederhergestellt werden.",
 "O diário agora abre só com a senha dele.": "Das Tagebuch öffnet sich jetzt nur noch mit seinem Passwort.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "Die Gesichtserkennung dieses Geräts kann nicht von Apps genutzt werden. Verwende den Fingerabdruck oder den Code/die PIN des Geräts.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "Die Zeit läuft ab dem Moment, in dem die App den Bildschirm verlässt (andere App, Startbildschirm oder Bildschirm aus). Das Herunterziehen der Benachrichtigungen, das Biometrie-Fenster, eine Berechtigungsanfrage oder die Auswahl eines Fotos oder einer Datei zählen nicht.",
 "Os PINs não conferem.": "Die PINs stimmen nicht überein.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (4 bis 6 Ziffern)",
 "PIN (só números, 4 a 6)": "PIN (nur Ziffern, 4 bis 6)",
 "PIN do diário": "Tagebuch-PIN",
 "PIN incorreto": "Falsche PIN",
 "PIN salvo.": "PIN gespeichert.",
 "Padrão do app": "App-Standard",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "Bestätige das Löschen mit dem App-Passwort, Biometrie oder der Geräte-PIN. Dadurch werden Mein Tag, Ziele, Gewohnheiten, Briefe und Fotos des Tagebuchs gelöscht. Gruppenprojekte bleiben erhalten.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "Gib zum Fortfahren das App-Passwort ein oder nutze Biometrie/den Gerätecode.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "Um das Tagebuch wiederherzustellen, wenn du das Passwort vergisst oder das Gerät wechselst.",
 "Pastas": "Ordner",
 "Pedir a senha de novo": "Passwort erneut abfragen",
 "Personalizada": "Benutzerdefiniert",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "Zum ersten Mal auf diesem Gerät: Gib das Tagebuch-Passwort ein oder verwende den Wiederherstellungscode.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "Zum ersten Mal auf diesem Gerät: Gib den Wiederherstellungscode des Tagebuchs ein.",
 "Reconhecimento de rosto": "Gesichtserkennung",
 "Repita o PIN": "PIN wiederholen",
 "Salvar a senha nova": "Neues Passwort speichern",
 "Salvar em arquivo / no Drive": "In Datei / in Drive speichern",
 "Salvar o código de recuperação": "Wiederherstellungscode speichern",
 "Senha (letras e números)": "Passwort (Buchstaben und Zahlen)",
 "Senha do app": "App-Passwort",
 "Senha nova do diário": "Neues Tagebuch-Passwort",
 "Senha própria": "Eigenes Passwort",
 "Senha própria do diário": "Eigenes Tagebuch-Passwort",
 "Tarefas": "Aufgaben",
 "Trocar o PIN": "PIN ändern",
 "Usar a senha": "Passwort verwenden",
 "Usar o PIN": "PIN verwenden",
 "Usar o código de recuperação": "Wiederherstellungscode verwenden",
 "Usar o desbloqueio do app": "App-Entsperrung verwenden",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Verwende Biometrie oder Code/PIN/Muster des Geräts.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Verwende den Wiederherstellungscode, der beim Erstellen des Tagebuchs angezeigt wurde. Ohne Passwort und ohne Code kann niemand das Tagebuch öffnen, auch nicht der Support.",
 "Voltar a usar só a senha?": "Wieder nur das Passwort verwenden?",
 "incorreto": "falsch",
 "1 h": "1 Std.",
 "12 horas (2:30 PM)": "12 Stunden (2:30 PM)",
 "15 min": "15 Min.",
 "24 horas (14:30)": "24 Stunden (14:30)",
 "30 min": "30 Min.",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Der Papierkorb enthält große Elemente. Bestätige mit dem App-Passwort, der Biometrie oder dem Gerätecode.",
 "A semana começa na": "Die Woche beginnt am",
 "Abra o Diário primeiro": "Öffne zuerst das Tagebuch",
 "Abrir configurações do celular": "Handy-Einstellungen öffnen",
 "Agenda e mapas": "Kalender & Karten",
 "Agora: {m}": "Jetzt: {m}",
 "Ajuda e sobre": "Hilfe & Info",
 "Alarme (som)": "Alarm (Ton)",
 "Alarme ou vibração das pausas": "Alarm oder Vibration für Pausen",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Löscht das Konto und alle Daten in der Cloud und auf diesem Gerät dauerhaft. Vorher wird dein Passwort abgefragt.",
 "Apagar todas ({n})": "Alle löschen ({n})",
 "Apagar {n} selecionada(s)": "{n} ausgewählte löschen",
 "Aparência": "Darstellung",
 "App das rotas": "Routen-App",
 "Ardósia": "Schiefer",
 "Arrastar para a direita": "Nach rechts wischen",
 "Arrastar para a esquerda": "Nach links wischen",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "Rechnungen aus Finanzen erscheinen so viel früher in My Planner.",
 "Atualizações e sobre": "Updates & Info",
 "Avisar antes do vencimento": "Vor Fälligkeit erinnern",
 "Aviso marcado": "Erinnerung gesetzt",
 "Aviso no começo e no fim de cada pausa": "Hinweis zu Beginn und Ende jeder Pause",
 "Avisos desta aba": "Hinweise dieses Tabs",
 "Avisos e alarmes": "Hinweise & Alarme",
 "Avisos silenciosos": "Stille Hinweise",
 "Avisos: som e vibração": "Hinweise: Ton und Vibration",
 "Avisos: só som": "Hinweise: nur Ton",
 "Avisos: só vibração": "Hinweise: nur Vibration",
 "Azul elétrico": "Elektrisches Blau",
 "Azul-aço": "Stahlblau",
 "Azul-bebê": "Babyblau",
 "Azul-marinho": "Marineblau",
 "Baixar meus dados": "Meine Daten herunterladen",
 "Baixar todos os meus dados": "Alle meine Daten herunterladen",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Alle meine Daten herunterladen und Konto löschen (DSGVO)",
 "Biometria": "Biometrie",
 "Bissexual": "Bisexuell",
 "Brilhante": "Leuchtend",
 "Buscar abas": "Tabs suchen",
 "Buscar nos ajustes": "In den Einstellungen suchen",
 "Cancelar aviso": "Erinnerung abbrechen",
 "Cinza-chumbo": "Bleigrau",
 "Cofre": "Tresor",
 "Coloque pelo menos uma matéria.": "Füge mindestens ein Fach hinzu.",
 "Como usar": "Anleitung",
 "Conexões": "Verbindungen",
 "Cor da aba": "Tab-Farbe",
 "Cor de destaque": "Akzentfarbe",
 "Crie uma matéria primeiro": "Erstelle zuerst ein Fach",
 "Cítrico": "Zitrus",
 "Cópia de segurança em arquivo": "Sicherungskopie als Datei",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Patientendaten und Akte. Bestätige mit dem App-Passwort, der Biometrie oder dem Gerätecode.",
 "Desligadas": "Aus",
 "Digite a senha da sua conta para confirmar.": "Gib zur Bestätigung das Passwort deines Kontos ein.",
 "Duração padrão de uma tarefa nova": "Standarddauer einer neuen Aufgabe",
 "Editar sessão": "Sitzung bearbeiten",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "Sie wiederholt sich ohne Enddatum: Angezeigt werden die Termine bis {data}. Sind alle markiert, wird die ganze Aufgabe entfernt.",
 "Em atividade": "Aktiv",
 "Em pausa": "In Pause",
 "Emoji da pausa": "Pausen-Emoji",
 "Encerrar": "Beenden",
 "Encerrar a sessão?": "Sitzung beenden?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Wechselt in den Auswahlmodus, um mehrere Elemente auf einmal zu wählen.",
 "Escolha um horário no futuro.": "Wähle eine Uhrzeit in der Zukunft.",
 "Escolher a matéria": "Fach wählen",
 "Esconde os valores em dinheiro (R$ •••)": "Blendet Geldbeträge aus (R$ •••)",
 "Esconder o CPF": "CPF ausblenden",
 "Esconder os valores": "Beträge ausblenden",
 "Esta e as próximas": "Diese und folgende",
 "Esta tarefa se repete. Onde aplicar a mudança?": "Diese Aufgabe wiederholt sich. Wo soll die Änderung gelten?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Dieses Element enthält sehr viel. Bestätige mit dem App-Passwort, der Biometrie oder dem Gerätecode.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Löscht das Element (mit Bestätigung). Danach kannst du es rückgängig machen oder über den Papierkorb wiederherstellen.",
 "Excluir minha conta": "Mein Konto löschen",
 "Ficha protegida": "Geschützter Eintrag",
 "Formato da hora": "Uhrzeitformat",
 "Foto do Quadro dos Sonhos": "Foto vom Traumboard",
 "Geral": "Allgemein",
 "Gestos": "Gesten",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive und Sicherungsdatei",
 "Grafite": "Graphit",
 "Guardar em": "Speichern in",
 "Hábito do Diário": "Tagebuch-Gewohnheit",
 "Idioma e moeda": "Sprache & Währung",
 "Inspiração do Diário": "Tagebuch-Inspiration",
 "Intenso": "Intensiv",
 "Item arquivado": "Element archiviert",
 "Item excluído": "Element gelöscht",
 "Lavanda": "Lavendel",
 "Ligadas": "An",
 "Limite de energia": "Energielimit",
 "Lésbica": "Lesbisch",
 "Marque as vezes que vão ser apagadas.": "Markiere die Termine, die gelöscht werden sollen.",
 "Matéria": "Fach",
 "Me avise em…": "Erinnere mich in …",
 "Menta": "Minze",
 "Menu ⋮": "Menü ⋮",
 "Meta do Diário": "Tagebuch-Ziel",
 "Modo discreto": "Diskreter Modus",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Stell die Sitzung einmal zusammen (Fächer, Zeit für jedes und Pausen) und wiederhole sie an anderen Tagen mit einem Tipp auf Starten. Die Lernzeit wird automatisch zum Ziel gezählt.",
 "Mostra Arquivar e Duplicar.": "Zeigt Archivieren und Duplizieren.",
 "Mostrar feriados no topo": "Feiertage oben anzeigen",
 "Mostrar os valores": "Beträge anzeigen",
 "Muda a ordem dos itens.": "Ändert die Reihenfolge der Elemente.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Ändert nur die Farbe von My Planner. Die Akzentfarbe der App findest du unter Einstellungen > Darstellung. Jede Aufgabe kann im Detailblatt eine eigene Farbe haben.",
 "Nada encontrado nos ajustes.": "Nichts in den Einstellungen gefunden.",
 "Nenhuma sessão salva ainda.": "Noch keine Sitzung gespeichert.",
 "Neon": "Neon",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "In dieser Zeit klingelt und vibriert die App nicht. Die Hinweise kommen weiterhin an, lautlos.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "Im Menü ⋮ jedes Elements: Das Handy erinnert dich zur gewählten Zeit, ohne eine Aufgabe in My Planner zu erstellen.",
 "Nome (ex.: Sessão do mestrado)": "Name (z. B. Masterarbeit-Sitzung)",
 "Nova sessão": "Neue Sitzung",
 "Nuvem e cópias de segurança": "Cloud & Sicherungskopien",
 "Não perturbe": "Nicht stören",
 "Não perturbe {de}–{ate}": "Nicht stören {de}–{ate}",
 "Não-binário": "Nichtbinär",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "Die Schaltfläche 🎉 Feiertage oben in My Planner. Land und Feiertagsliste findest du unter Einstellungen > Feiertage.",
 "O celular avisa às {h}.": "Das Handy erinnert dich um {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "Was aus dem Tagebuch entfernt wird, bleibt verschlüsselt im Papierkorb. Öffne das Tagebuch und komm dann hierher zurück, um es wiederherzustellen.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "Was entfernt wird, bleibt 30 Tage im Papierkorb. Gib zur Bestätigung das Passwort deines Kontos ein.",
 "O que saiu fica na Lixeira por 30 dias.": "Was entfernt wurde, bleibt 30 Tage im Papierkorb.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "Das Thema ändert die Tab-Farben, die Akzentfarbe und einen leichten Hauch im Hintergrund, im hellen und dunklen Modus. Um nur die Farbe eines Tabs zu ändern, geh zu Einstellungen > Tabs.",
 "O tempo estudado até agora entra na meta.": "Die bisherige Lernzeit wird zum Ziel gezählt.",
 "Oliva": "Oliv",
 "Orgulho": "Pride",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Hinweise funktionieren in der installierten App mit aktivierten Benachrichtigungen.",
 "Os gestos do app": "Die Gesten der App",
 "Outro (escolher a hora)": "Andere (Uhrzeit wählen)",
 "Pansexual": "Pansexuell",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "Zum Aktivieren nutze die App auf dem Handy (Einstellungen › Kalender & Karten › Google Kalender). Danach erscheint alles auch hier.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "Damit nicht mehr gefragt wird, wähle die App unter Einstellungen › Kalender & Karten.",
 "Pausa": "Pause",
 "Petróleo": "Petrol",
 "Pink elétrico": "Elektrisches Pink",
 "Preto total": "Tiefschwarz",
 "Progresso": "Fortschritt",
 "Pêssego": "Pfirsich",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "Wie viele Tage vorher Rechnungen erscheinen, stellst du unter Einstellungen > Hinweise & Alarme ein.",
 "Rosa-chá": "Altrosa",
 "Roxo-profundo": "Tiefviolett",
 "Segurança e dados": "Sicherheit & Daten",
 "Segurar e arrastar": "Gedrückt halten und ziehen",
 "Segurar e soltar": "Gedrückt halten und loslassen",
 "Selecionar todas": "Alle auswählen",
 "Semana começa na {dia}": "Woche beginnt am {dia}",
 "Sessão de estudo": "Lernsitzung",
 "Sessão encerrada": "Sitzung beendet",
 "Sessão pausada": "Sitzung pausiert",
 "Som e vibração": "Ton & Vibration",
 "Suave": "Sanft",
 "Só esta semana": "Nur diese Woche",
 "Só hoje": "Nur heute",
 "Só neste dia ({data})": "Nur an diesem Tag ({data})",
 "Tamanho das caixas": "Kästchengröße",
 "Tamanho do texto": "Textgröße",
 "Tarefa nova": "Neue Aufgabe",
 "Tela inicial": "Startbildschirm",
 "Tema e cor de destaque": "Thema & Akzentfarbe",
 "Testar alerta": "Alarm testen",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Alarm testen, \"Nicht stören\" und die Handy-Einstellungen findest du unter Einstellungen > Hinweise & Alarme.",
 "Testar e conferir": "Testen & prüfen",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "Alle Optionen des Elements: bearbeiten, verschieben, teilen, archivieren, löschen ...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Tippe auf eine Farbe des Themas {tema}, um sie für Schaltflächen, die +-Schaltfläche und das ausgewählte Element zu verwenden.",
 "Total: {dur}": "Gesamt: {dur}",
 "Tropical": "Tropisch",
 "Turquesa": "Türkis",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "Eine Datei mit all deinen Daten aus My Planner, zum Aufbewahren oder Mitnehmen (Datenübertragbarkeit, DSGVO).",
 "Usar no computador, pelo navegador": "Am Computer im Browser nutzen",
 "Usar o padrão": "Standard verwenden",
 "Usar o padrão ({emoji})": "Standard verwenden ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Nutze die App auf dem Handy, um die Datei herunterzuladen.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "Gilt für alle Tabs. Jeder Tab kann unter Einstellungen > Tabs einen eigenen haben.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "Gelten für Aufgaben mit Pausen. Jede Aufgabe kann Alarm und Emoji im eigenen Detailblatt ändern.",
 "Ver lista": "Liste ansehen",
 "Ver o CPF inteiro": "Ganze CPF anzeigen",
 "Verde-floresta": "Waldgrün",
 "Verde-água": "Aquagrün",
 "Vibração": "Vibration",
 "Vinho": "Weinrot",
 "Você pediu para ser avisado agora.": "Du wolltest jetzt erinnert werden.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Du kannst: bestätigen lassen, ob wir deine Daten verarbeiten, darauf zugreifen, sie berichtigen, die Übertragbarkeit verlangen (deine Daten unter Einstellungen > Meine Daten herunterladen), die Löschung verlangen, erfahren, mit wem wir sie teilen, die Einwilligung widerrufen und dich bei der ANPD beschweren.",
 "Voltar ao filtro": "Zurück zum Filter",
 "Voltar à lista": "Zurück zur Liste",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Geh zu Einstellungen › My Planner Web und tippe auf \"Browser verbinden\".",
 "atividade {n} de {total}": "Aktivität {n} von {total}",
 "matéria {n} de {t}": "Fach {n} von {t}",
 "padrão": "Standard",
 "pausa em {n} min": "Pause in {n} Min.",
 "pausa {n} de {total}": "Pause {n} von {total}",
 "termina em {n} min": "endet in {n} Min.",
 "todas as vezes": "alle Termine",
 "troca em {n} min": "Wechsel in {n} Min.",
 "volta em {n} min": "zurück in {n} Min.",
 "{nome} · {n} dia(s)": "{nome} · {n} Tag(e)",
 "{n} de {total} vezes": "{n} von {total} Mal",
 "{n} itens arquivados": "{n} Elemente archiviert",
 "{n} itens excluídos": "{n} Elemente gelöscht",
 "{n} marcada(s)": "{n} markiert",
 "{n} vezes": "{n}-mal",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} Min. / {total}",
 "📔 Diário": "📔 Tagebuch",
 "Agendados": "Geplant",
 "Atrasado": "Überfällig",
 "Atrasado: {v}": "Überfällig: {v}",
 "Atualizar o a receber": "Ausstehende Beträge aktualisieren",
 "Até (fim do contrato, se houver)": "Bis (Vertragsende, falls vorhanden)",
 "Clínica": "Klinik",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Zählt jeden Tag mit erfasster Anwesenheit oder mit einem als \"Unterricht gehalten\" markierten Unterrichtsplan.",
 "Data do recebimento": "Eingangsdatum",
 "Data prevista do pagamento": "Voraussichtliches Zahlungsdatum",
 "Desmarcar como recebido": "Als nicht erhalten markieren",
 "Dia do pagamento": "Zahltag",
 "Diferença: {v} (juros/multa)": "Differenz: {v} (Zinsen/Strafe)",
 "Diferença: {v} (taxas/descontos)": "Differenz: {v} (Gebühren/Abzüge)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Schulen, Universitäten und Kurse, die dich bezahlen. Bei festem Gehalt erstellt die App jeden Monat den ausstehenden Betrag; pro Unterrichtsstunde summiert sie die gehaltenen Stunden in den mit der Einrichtung verknüpften Klassen.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Wähle die Zahlungsart (Bearbeiten), damit die App berechnet, was du zu bekommen hast.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "Dieser Betrag stammt aus dem Bereich \"Wo ich arbeite\" im Tab {aba}. Markiere ihn hier als erhalten oder öffne den Tab, um die Einrichtung zu sehen.",
 "Ex.: Colégio Estadual, Universidade Federal": "Z. B.: Staatliche Schule, Bundesuniversität",
 "Ex.: Hospital Santa Casa, Clínica Vida": "Z. B.: Krankenhaus Santa Casa, Klinik Vida",
 "Ex.: Salário de outubro, 13º, férias": "Z. B.: Oktobergehalt, 13. Monatsgehalt, Urlaubsgeld",
 "Feitos": "Erledigt",
 "Horas-aula de cada aula": "Unterrichtsstunden pro Stunde",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Krankenhäuser und Kliniken, die dich bezahlen. Bei festem Gehalt erstellt die App jeden Monat den ausstehenden Betrag; pro Schicht oder Termin markierst du die erledigten und die App rechnet.",
 "Hospital": "Krankenhaus",
 "Instituição": "Einrichtung",
 "Instituição (Onde trabalho)": "Einrichtung (Wo ich arbeite)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Verknüpfe die Klassen mit dieser Einrichtung (in der Klasse, Bearbeiten › Einrichtung), damit die App die gehaltenen Stunden summiert.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Markiere jede Schicht oder jeden Termin als erledigt: Die App summiert und berechnet den Monatsbetrag.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Markiere jede in dieser Einrichtung erledigte Schicht oder jeden Termin. Die App summiert und berechnet den ausstehenden Monatsbetrag.",
 "Nome da instituição": "Name der Einrichtung",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "Was die Einrichtung dir Monat für Monat zahlen muss. Markiere es als erhalten, wenn das Geld eingeht: Es wird auch in den Tab Finanzen übernommen.",
 "Onde trabalho": "Wo ich arbeite",
 "Plantão": "Schicht",
 "Plantão ou atendimento": "Schicht oder Termin",
 "Plantões e atendimentos": "Schichten und Termine",
 "Por atendimento ou procedimento": "Pro Termin oder Behandlung",
 "Por hora-aula": "Pro Unterrichtsstunde",
 "Por plantão": "Pro Schicht",
 "Previsto: {v}": "Erwartet: {v}",
 "Previsão do mês: {v}": "Monatsprognose: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Anzahl (Stunden, Schichten oder Termine)",
 "Recebe no mês seguinte ao trabalhado": "Zahlung im Folgemonat",
 "Receber: {t}": "Erhalten: {t}",
 "Recebimentos": "Zahlungseingänge",
 "Salário": "Gehalt",
 "Salário (valor do mês)": "Gehalt (Monatsbetrag)",
 "Salário fixo": "Festes Gehalt",
 "Telefone (RH ou financeiro)": "Telefon (Personal oder Buchhaltung)",
 "Tipo de pagamento": "Zahlungsart",
 "Universidade": "Universität",
 "Valor da hora-aula": "Satz pro Unterrichtsstunde",
 "Valor de cada um (se for diferente)": "Betrag pro Einheit (falls abweichend)",
 "Valor do plantão": "Betrag pro Schicht",
 "Valor por atendimento ou procedimento": "Betrag pro Termin oder Behandlung",
 "Valor previsto": "Erwarteter Betrag",
 "feito": "erledigt",
 "recebido em {d}": "erhalten am {d}",
 "{n} aula(s) dada(s)": "{n} Stunde(n) gehalten",
 "{n} hora(s)-aula": "{n} Unterrichtsstunde(n)",
 "{n} plantão(ões)": "{n} Schicht(en)",
 "Abas do My Planner Anne": "Tabs von My Planner Anne",
 "Acesso ao Não perturbe": "Zugriff auf „Nicht stören“",
 "Alarme dos remédios (mesmo no silencioso)": "Medikamentenalarm (auch im Lautlos-Modus)",
 "Algodão-doce": "Zuckerwatte",
 "Aplicar tema": "Design anwenden",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "Die eigenen Farben jedes Designs: rosa Blüten, grüne Blätter, blauer Himmel...",
 "Assim ficam as letras no app.": "So sieht die Schrift in der App aus.",
 "Automática": "Automatisch",
 "Baht tailandês": "Thailändischer Baht",
 "Boliviano": "Bolivianischer Boliviano",
 "Bolívar venezuelano": "Venezolanischer Bolívar",
 "Botão": "Schaltfläche",
 "Buscar moeda": "Währung suchen",
 "Cor do desenho": "Zeichenfarbe",
 "Coroa dinamarquesa": "Dänische Krone",
 "Coroa norueguesa": "Norwegische Krone",
 "Coroa sueca": "Schwedische Krone",
 "Coroa tcheca": "Tschechische Krone",
 "Crepúsculo": "Dämmerung",
 "Crescente": "Ansteigend",
 "Curta": "Kurz",
 "Despesas em outra moeda (fora do lucro): {v}": "Ausgaben in anderer Währung (nicht im Gewinn): {v}",
 "Dirham dos Emirados Árabes Unidos": "VAE-Dirham",
 "Dirham marroquino": "Marokkanischer Dirham",
 "Do seu país": "Aus deinem Land",
 "Dong vietnamita": "Vietnamesischer Dong",
 "Dupla": "Doppelt",
 "Dólar americano": "US-Dollar",
 "Dólar australiano": "Australischer Dollar",
 "Dólar canadense": "Kanadischer Dollar",
 "Dólar de Hong Kong": "Hongkong-Dollar",
 "Dólar de Singapura": "Singapur-Dollar",
 "Dólar neozelandês": "Neuseeland-Dollar",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Sendet alle Einträge dieser Liste, auch später neu erstellte.",
 "Enviar todos para a equipe": "Alle an das Team senden",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Wähle, ob der Alarm für dieses Medikament auch klingeln soll, wenn das Handy lautlos ist.",
 "Euro": "Euro",
 "Exemplo": "Beispiel",
 "Falta uma resposta": "Eine Antwort fehlt",
 "Folha, tema e cores da caneta e das letras": "Blatt, Design sowie Stift- und Schriftfarben",
 "Franco suíço": "Schweizer Franken",
 "Guarani paraguaio": "Paraguayischer Guaraní",
 "Hryvnia ucraniana": "Ukrainische Hrywnja",
 "Iene japonês": "Japanischer Yen",
 "Kwanza angolano": "Angolanischer Kwanza",
 "Libra egípcia": "Ägyptisches Pfund",
 "Libra esterlina": "Pfund Sterling",
 "Lira turca": "Türkische Lira",
 "Longa": "Lang",
 "Mais usadas": "Am häufigsten verwendet",
 "Metical moçambicano": "Mosambikanischer Metical",
 "Na página, segurar a bolinha faz o mesmo.": "Auf der Seite bewirkt langes Drücken auf den Punkt dasselbe.",
 "Naira nigeriana": "Nigerianischer Naira",
 "Nenhuma moeda encontrada": "Keine Währung gefunden",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Damit der Medikamentenalarm auf Android bei aktivem \"Nicht stören\" klingelt, muss das Handy My Planner den Zugriff auf \"Nicht stören\" erlauben. Tippe auf \"Einstellungen öffnen\", suche My Planner in der Liste und aktiviere die Berechtigung.",
 "No My Planner": "In My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Auf dem iPhone kann der Lautlos-Modus den Alarm verhindern. Lass das Handy im normalen Modus.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "Auf dem iPhone zeigt ▶ ungefähr, wie jeder Typ wirkt. Echte Hinweise nutzen die Standardvibration des iPhones.",
 "Novo dólar taiwanês": "Neuer Taiwan-Dollar",
 "Novo shekel israelense": "Neuer Israelischer Schekel",
 "Ouvir/Sentir": "Hören/Fühlen",
 "Peso argentino": "Argentinischer Peso",
 "Peso chileno": "Chilenischer Peso",
 "Peso colombiano": "Kolumbianischer Peso",
 "Peso filipino": "Philippinischer Peso",
 "Peso mexicano": "Mexikanischer Peso",
 "Peso uruguaio": "Uruguayischer Peso",
 "Política de privacidade": "Datenschutzerklärung",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "Fertig. Sperre den Bildschirm und warte 1 Minute: Der Hinweis sollte lautlos erscheinen.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "Fertig. Sperre den Bildschirm und warte 1 Minute: Der Hinweis sollte mit Vibration, ohne Ton erscheinen.",
 "Páginas e canetas": "Seiten und Stifte",
 "Pôr do sol": "Sonnenuntergang",
 "Rand sul-africano": "Südafrikanischer Rand",
 "Real brasileiro": "Brasilianischer Real",
 "Ringgit malaio": "Malaysischer Ringgit",
 "Riyal saudita": "Saudi-Riyal",
 "Rublo russo": "Russischer Rubel",
 "Rupia indiana": "Indische Rupie",
 "Rupia indonésia": "Indonesische Rupiah",
 "Rupia paquistanesa": "Pakistanische Rupie",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "Wenn My Planner nicht in der Liste erscheint, kommt diese Berechtigung mit der nächsten App-Version (über den Store aktualisieren).",
 "Sentir": "Fühlen",
 "Sol peruano": "Peruanischer Sol",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "Das sind die Schnellfarben für Stift und Schrift auf den Seiten. Die erste ist die Standardfarbe beim Öffnen einer Seite. Tippe auf einen Punkt, um seine Farbe zu ändern.",
 "Taka bengali": "Bangladesch-Taka",
 "Teste grátis por {n} dias": "{n} Tage kostenlos testen",
 "Tipo de vibração": "Vibrationsart",
 "Tirar do My Planner": "Aus My Planner entfernen",
 "Tocar mesmo no silencioso e no Não perturbe": "Auch bei Lautlos und „Nicht stören“ klingeln",
 "Tocar só se o celular estiver no normal": "Nur klingeln, wenn das Handy im normalen Modus ist",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "Alle Einträge dieser Liste erscheinen in My Planner, auch neue.",
 "Vaga-lume": "Glühwürmchen",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "Gilt für alle Hinweise mit Vibration (Vibration und Ton und Vibration).",
 "Won sul-coreano": "Südkoreanischer Won",
 "Xelim queniano": "Kenia-Schilling",
 "Yuan chinês": "Chinesischer Yuan",
 "Zloty polonês": "Polnischer Złoty",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 Soll der Alarm für dieses Medikament auch im Lautlos-Modus klingeln?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "Die Fotogalerie kommt mit der nächsten App-Version. Nutze bis dahin Dateien oder Foto aufnehmen.",
 "Abrir o fichário do grupo": "Ordner der Gruppe öffnen",
 "Arrastar a barra": "Leiste ziehen",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "Sobald der Ordner geteilt wird, erscheint er hier.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Symbol nach Namen suchen (z. B. Buch, Haus, Kaffee)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "Mit dem Tab Lernen erstellst du deine Ordner, nutzt den Timer, verfolgst deinen Bericht und vieles mehr. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "Mit dem Tab {aba} erstellst du deine eigenen Inhalte und nutzt alle Funktionen. ✨",
 "Conhecer a aba": "Tab entdecken",
 "Crie um fichário em Estudos e volte aqui.": "Erstelle einen Ordner unter Lernen und komm hierher zurück.",
 "Em sessão": "In Sitzung",
 "Encerrar e salvar o cronômetro e começar a sessão?": "Timer beenden und speichern und die Sitzung starten?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "Timer beenden und speichern und die Sitzung fortsetzen?",
 "Enquadre e toque no botão": "Ausrichten und auf die Taste tippen",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Wähle den Ordner, den deine Mitlernenden auf dem Bildschirm sehen (nur lesen).",
 "Esconder": "Ausblenden",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "Diese Datei ist nur auf dem Gerät oder im Drive der Person gespeichert, die sie geteilt hat, deshalb erscheint sie hier nicht.",
 "Fichário do grupo": "Gruppenordner",
 "Guia passo a passo do app e de cada aba": "Schritt-für-Schritt-Anleitung zur App und zu jedem Tab",
 "Há um cronômetro em andamento.": "Ein Timer läuft gerade.",
 "Há uma sessão em andamento.": "Eine Sitzung läuft gerade.",
 "Inserir imagem": "Bild einfügen",
 "Mais ícones": "Weitere Symbole",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "Kein Symbol mit diesem Namen. Versuche ein anderes Wort oder wähle eine Kategorie.",
 "Nenhuma matéria neste fichário ainda.": "Noch keine Fächer in diesem Ordner.",
 "Nenhuma página nesta matéria ainda.": "Noch keine Seiten in diesem Fach.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "In der Lerngruppe werden Bilder und PDFs hier auf dem Bildschirm geöffnet. Dieser Dateityp kann in der App nicht angezeigt werden.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "Konnte gerade nicht angezeigt werden. Prüfe deine Internetverbindung und versuche es erneut.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "Das Teilen von Ordnern wird noch vorbereitet. Schau gleich noch einmal vorbei.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "Der Ordner dieser Gruppe befindet sich auf einem anderen deiner Geräte. Er wird weiterhin von dort aus geteilt.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Tab entdecken · Abbrechen = Jetzt nicht",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "Deine Mitlernenden sehen den Ordner nicht mehr. Alles bleibt bei dir.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "Deine Mitlernenden sehen diesen Ordner auf dem Bildschirm, nur zum Lesen: Sie können ihn nicht bearbeiten, herunterladen, drucken oder teilen. Deine Ziele, der Timer und die wiederholten Seiten bleiben nur deine.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "Um PDFs hier auf dem Bildschirm zu sehen, installiere die neueste App-Version aus dem Store.",
 "Parar de compartilhar": "Teilen beenden",
 "Pausar a sessão": "Sitzung pausieren",
 "Pausar a sessão e estudar só esta?": "Sitzung pausieren und nur dieses lernen?",
 "Página em branco.": "Leere Seite.",
 "Quer estudar com tudo isso?": "Möchtest du mit all dem lernen?",
 "Quer usar tudo isso?": "Möchtest du all das nutzen?",
 "Selecionar todos": "Alle auswählen",
 "Trocar fichário": "Ordner wechseln",
 "Você está participando do grupo de {nome}": "Du nimmst an der Gruppe von {nome} teil",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "Du siehst auf dem Bildschirm, was in dieser Gruppe geteilt wurde, zum Lesen und Mitverfolgen.",
 "abacate, fruta": "Avocado, Obst",
 "academia, musculação, treino, peso": "Fitnessstudio, Krafttraining, Training, Gewichte",
 "acampamento, camping": "Zelten, Camping",
 "alfinete, fixar, importante": "Pinnnadel, anheften, wichtig",
 "almoço, arroz, prato": "Mittagessen, Reis, Teller",
 "alvo, meta, objetivo, foco": "Zielscheibe, Ziel, Vorhaben, Fokus",
 "aniversário, bolo": "Geburtstag, Kuchen",
 "anotação, nota, lista, escrever": "Notiz, Vermerk, Liste, schreiben",
 "arco-íris": "Regenbogen",
 "avião, viagem, voo": "Flugzeug, Reise, Flug",
 "balança, direito, justiça, lei, processo": "Waage, Recht, Justiz, Gesetz, Prozess",
 "balde, limpeza": "Eimer, Putzen",
 "banana, fruta": "Banane, Obst",
 "banheira, banho, banheiro": "Badewanne, Bad, Badezimmer",
 "barbear, barba, lâmina": "Rasieren, Bart, Rasierer",
 "bicicleta, pedalar, bike": "Fahrrad, Radfahren, Rad",
 "bolo, doce, sobremesa": "Kuchen, Süßes, Nachtisch",
 "brilho, mágica": "Glitzer, Magie",
 "cabelo, cabeleireiro, corte": "Haare, Friseur, Haarschnitt",
 "cachorro, cão, pet": "Hund, Haustier, Welpe",
 "caderno": "Heft",
 "caderno, fichário, amarelo": "Heft, Ordner, gelb",
 "café, xícara, pausa": "Kaffee, Tasse, Pause",
 "caixa, pacote, mudança, entrega": "Karton, Paket, Umzug, Lieferung",
 "calendário, agenda, data": "Kalender, Termine, Datum",
 "cama, quarto": "Bett, Schlafzimmer",
 "caminhada, caminhar, andar": "Spaziergang, gehen, wandern",
 "camisa, gravata, roupa, trabalho": "Hemd, Krawatte, Kleidung, Arbeit",
 "carne, churrasco": "Fleisch, Grillen",
 "carrinho, mercado, compras, supermercado": "Einkaufswagen, Markt, Einkaufen, Supermarkt",
 "carro, dirigir, veículo": "Auto, fahren, Fahrzeug",
 "certo, feito, visto": "Haken, erledigt, abgehakt",
 "cesto, roupa, lavanderia, lavar roupa": "Wäschekorb, Kleidung, Wäscherei, Wäsche waschen",
 "chave de fenda, ferramenta, conserto": "Schraubenzieher, Werkzeug, Reparatur",
 "chave, senha": "Schlüssel, Passwort",
 "chocolate, doce": "Schokolade, Süßes",
 "chuveiro, banho": "Dusche, duschen",
 "chá, xícara": "Tee, Tasse",
 "compras, sacolas, shopping": "Shopping, Tüten, Einkaufszentrum",
 "computador, monitor, tela": "Computer, Monitor, Bildschirm",
 "computador, notebook, informática": "Computer, Laptop, Informatik",
 "coração amarelo": "gelbes Herz",
 "coração azul": "blaues Herz",
 "coração branco": "weißes Herz",
 "coração laranja": "oranges Herz",
 "coração roxo": "lila Herz",
 "coração verde": "grünes Herz",
 "coração, amor, saúde, vermelho": "Herz, Liebe, Gesundheit, rot",
 "corrida, correr": "Laufen, joggen",
 "creme, hidratante, pele, skincare": "Creme, Feuchtigkeitscreme, Haut, Hautpflege",
 "croissant, pão, café da manhã": "Croissant, Brot, Frühstück",
 "câmera, foto, fotografia": "Kamera, Foto, Fotografie",
 "cérebro, mente, memória, pensar": "Gehirn, Geist, Gedächtnis, denken",
 "dado, jogo de tabuleiro": "Würfel, Brettspiel",
 "dente, dentista": "Zahn, Zahnarzt",
 "despertador, relógio, alarme, acordar": "Wecker, Uhr, Alarm, aufwachen",
 "diamante, joia": "Diamant, Schmuck",
 "dinheiro, pagar, conta, pagamento": "Geld, bezahlen, Rechnung, Zahlung",
 "dormir, sono, descanso": "schlafen, Schlaf, Erholung",
 "e-mail, mensagem, carta": "E-Mail, Nachricht, Brief",
 "escada": "Treppe",
 "escova de dentes, dentes": "Zahnbürste, Zähne",
 "escrever, redação, caneta": "schreiben, Aufsatz, Stift",
 "esponja, lavar louça": "Schwamm, abwaschen",
 "esquadro, régua, geometria, desenho técnico": "Geodreieck, Lineal, Geometrie, technisches Zeichnen",
 "estrela brilhante, destaque": "leuchtender Stern, Highlight",
 "estrela, favorito": "Stern, Favorit",
 "etiqueta, marcador": "Etikett, Markierung",
 "extintor, segurança, incêndio": "Feuerlöscher, Sicherheit, Brand",
 "falar, idioma, inglês, conversa": "sprechen, Sprache, Englisch, Gespräch",
 "feito, concluído, certo": "erledigt, abgeschlossen, Haken",
 "ferramenta, conserto, manutenção": "Werkzeug, Reparatur, Wartung",
 "festa, comemoração": "Party, Feier",
 "filme, cinema, série": "Film, Kino, Serie",
 "fogo, urgente, sequência": "Feuer, dringend, Serie",
 "folha, natureza, erva, chá": "Blatt, Natur, Kraut, Tee",
 "fone de ouvido, áudio, música, podcast": "Kopfhörer, Audio, Musik, Podcast",
 "formatura, capelo, faculdade, diploma, universidade": "Abschluss, Doktorhut, Hochschule, Diplom, Universität",
 "força, braço, músculo": "Kraft, Arm, Muskel",
 "frango, coxa": "Hähnchen, Keule",
 "frigideira, cozinhar, ovo, cozinha": "Pfanne, kochen, Ei, Küche",
 "futebol, bola, esporte": "Fußball, Ball, Sport",
 "gato, pet": "Katze, Haustier",
 "gelo, geladeira, congelador": "Eis, Kühlschrank, Gefrierschrank",
 "gráfico, planilha, finanças, relatório": "Diagramm, Tabelle, Finanzen, Bericht",
 "ingresso, show, evento": "Ticket, Konzert, Veranstaltung",
 "jogo, videogame, game": "Spiel, Videospiel, Gaming",
 "lancha, barco": "Motorboot, Boot",
 "leite, copo": "Milch, Glas",
 "letras, alfabeto, português": "Buchstaben, Alphabet, Deutsch",
 "link, corrente": "Link, Kette",
 "livro aberto, leitura, ler": "offenes Buch, Lektüre, lesen",
 "livro azul, caderno": "blaues Buch, Heft",
 "livro laranja, caderno": "oranges Buch, Heft",
 "livro verde, caderno": "grünes Buch, Heft",
 "livro vermelho, caderno": "rotes Buch, Heft",
 "livros, estudo, estudar, biblioteca": "Bücher, Lernen, studieren, Bibliothek",
 "lixo, lixeira": "Müll, Mülleimer",
 "lua, noite": "Mond, Nacht",
 "lâmpada, ideia, luz": "Glühbirne, Idee, Licht",
 "macarrão, massa": "Nudeln, Pasta",
 "maleta, trabalho, escritório, negócios": "Aktentasche, Arbeit, Büro, Geschäft",
 "massagem, relaxar": "Massage, entspannen",
 "maçã, fruta": "Apfel, Obst",
 "microfone, cantar, karaokê, palestra": "Mikrofon, singen, Karaoke, Vortrag",
 "microscópio, ciência, biologia": "Mikroskop, Wissenschaft, Biologie",
 "mochila, escola, filhos": "Rucksack, Schule, Kinder",
 "montanha, trilha": "Berg, Wanderweg",
 "mundo, planeta, geografia": "Welt, Planet, Geografie",
 "médico, consulta, exame, saúde": "Arzt, Termin, Untersuchung, Gesundheit",
 "música, nota musical": "Musik, Musiknote",
 "natação, nadar, piscina": "Schwimmen, schwimmen, Schwimmbad",
 "olho, visão, oftalmologista": "Auge, Sehen, Augenarzt",
 "oração, orar, gratidão, igreja": "Gebet, beten, Dankbarkeit, Kirche",
 "ovo": "Ei",
 "pastas, arquivo, fichário, divisórias": "Mappen, Ablage, Ordner, Trennblätter",
 "peixe": "Fisch",
 "pescaria, pescar": "Angeln, angeln",
 "pessoas, reunião, equipe, grupo": "Personen, Meeting, Team, Gruppe",
 "piano, teclado musical": "Klavier, Keyboard",
 "pintura, arte, desenho": "Malen, Kunst, Zeichnen",
 "pipa": "Drachen",
 "pipoca, cinema": "Popcorn, Kino",
 "pizza": "Pizza",
 "planta, vaso, regar": "Pflanze, Topf, gießen",
 "porta, entrada": "Tür, Eingang",
 "praia, férias": "Strand, Urlaub",
 "prato, refeição, louça, jantar": "Teller, Mahlzeit, Geschirr, Abendessen",
 "prédio, história, governo, tribunal": "Gebäude, Geschichte, Regierung, Gericht",
 "pão, padaria": "Brot, Bäckerei",
 "pé, podólogo": "Fuß, Fußpflege",
 "pôr do sol, amanhecer": "Sonnenuntergang, Sonnenaufgang",
 "quebra-cabeça, peça": "Puzzle, Teil",
 "queijo": "Käse",
 "raio, energia, rápido": "Blitz, Energie, schnell",
 "refrigerante, suco, bebida": "Limo, Saft, Getränk",
 "remédio, medicamento, vitamina, farmácia": "Medizin, Medikament, Vitamin, Apotheke",
 "sabão, sabonete, lavar": "Seife, Seifenstück, waschen",
 "salada, dieta, verdura": "Salat, Diät, Gemüse",
 "sanduíche, lanche": "Sandwich, Snack",
 "sino, aviso, lembrete": "Glocke, Hinweis, Erinnerung",
 "skate": "Skateboard",
 "sofá, sala": "Sofa, Wohnzimmer",
 "sol, manhã, dia": "Sonne, Morgen, Tag",
 "spa, sauna, autocuidado": "Spa, Sauna, Selbstfürsorge",
 "teatro, máscaras": "Theater, Masken",
 "telefone, ligação, ligar": "Telefon, Anruf, anrufen",
 "tigela, cereal, sopa, mingau": "Schüssel, Müsli, Suppe, Brei",
 "trevo, sorte": "Kleeblatt, Glück",
 "troféu, conquista, prêmio": "Pokal, Erfolg, Preis",
 "tubo de ensaio, química, laboratório": "Reagenzglas, Chemie, Labor",
 "tênis, esporte": "Turnschuhe, Sport",
 "unha, manicure": "Nagel, Maniküre",
 "vassoura, limpeza, faxina, varrer": "Besen, Putzen, Hausputz, fegen",
 "violão, guitarra": "Gitarre, Akustikgitarre",
 "yoga, meditação, alongamento": "Yoga, Meditation, Dehnen",
 "{n} selecionada": "{n} ausgewählt",
 "{n} selecionadas": "{n} ausgewählt",
 "{n} selecionado": "{n} ausgewählt",
 "{n} selecionados": "{n} ausgewählt",
 "ábaco, matemática, contas, cálculo, contabilidade": "Abakus, Mathe, Rechnen, Berechnung, Buchhaltung",
 "água, gota, hidratar": "Wasser, Tropfen, trinken",
 "árvore, jardim, quintal": "Baum, Garten, Hof",
 "ônibus, transporte": "Bus, Verkehrsmittel",
 "1 dia antes": "1 Tag vorher",
 "1 dia depois": "1 Tag danach",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "Das Abo wird in der App auf dem Handy über den App-Store abgeschlossen und gilt auch hier auf der Website.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "Der Schlüssel ist unvollständig (zu kurz). Kopiere ihn erneut über die Kopieren-Schaltfläche auf der Schlüsselseite.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "Der Schlüssel enthält Zeichen, die nicht zu einem Schlüssel gehören. Kopiere ihn erneut, nur den Schlüssel, ohne Text drumherum.",
 "A galeria chega na próxima atualização do app.": "Die Galerie kommt mit dem nächsten App-Update.",
 "ALERTAS": "BENACHRICHTIGUNGEN",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Öffne einen kostenpflichtigen Tab und starte den kostenlosen Test. Komm dann hierher zurück.",
 "Abrir a barra do editor": "Editorleiste öffnen",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "Gerade ist die „Nicht stören“-Zeit der App: Die Benachrichtigung kommt innerhalb von 5 Sekunden, ohne Ton und Vibration.",
 "Aguardando confirmação": "Warten auf Bestätigung",
 "Aguardando envio ao My Planner": "Wartet auf Senden an My Planner",
 "Alertas de cada fatura": "Benachrichtigungen für jede Rechnung",
 "Alertas do fim da garantia": "Benachrichtigungen zum Garantieende",
 "Alertas do vencimento": "Benachrichtigungen zur Fälligkeit",
 "Alertas: {campo}": "Benachrichtigungen: {campo}",
 "Alvorada": "Morgenröte",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "Beim Öffnen dieses Tabs verlangt die App dieselbe Entsperrung wie die App (Passwort, Biometrie oder PIN). Das kannst du unter Einstellungen > Tabs ändern.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Wenn du auf eine angehängte Datei tippst, öffnet sie sich in der App auf dem Handy, die du wählst (wenn das Handy fragt: „Nur einmal“ oder „Immer“). Was du dort bearbeitest, wird in der Datei selbst gespeichert.",
 "App instalado": "App installiert",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: Sie speichert bereits alles in der Health-App des Handys. Du musst nichts tun.",
 "Arquivados e fixados": "Archiviert und angeheftet",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "Datei zum Lesen und Aufbewahren, nach Tabs geordnet. Erstellt am {data}.",
 "As notificações do My Planner estão desligadas no celular.": "Die Benachrichtigungen von My Planner sind auf dem Handy ausgeschaltet.",
 "Atualização automática disponível no app instalado.": "Automatisches Update in der installierten App verfügbar.",
 "Aurora": "Polarlicht",
 "Avisos: alarme (som)": "Benachrichtigungen: Alarm (Ton)",
 "Baixar o app": "App herunterladen",
 "Baixar o arquivo técnico": "Technische Datei herunterladen",
 "Baixar para ler (PDF)": "Zum Lesen herunterladen (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Editorleiste (Stift, Textmarker, Text)",
 "Brisa": "Brise",
 "Campainha": "Türklingel",
 "Canal": "Kanal",
 "Cole a chave antes de testar.": "Füge den Schlüssel vor dem Testen ein.",
 "Começa em": "Beginnt am",
 "Como avisar": "Wie benachrichtigen",
 "Confira a chave": "Prüfe den Schlüssel",
 "Conta de teste de compras": "Testkonto für Käufe",
 "Conta vencida": "Rechnung überfällig",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Kopiere den Schlüssel sofort (er wird nur einmal angezeigt). Er beginnt mit „sk-“.",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Kopiere den Schlüssel sofort (er wird nur einmal angezeigt). Er beginnt mit „sk-ant-“.",
 "Cristal": "Kristall",
 "Daqui a 1 hora": "In 1 Stunde",
 "Daqui a 1 semana": "In 1 Woche",
 "Daqui a 3 dias": "In 3 Tagen",
 "Depois de 5 min fora": "Nach 5 Min. abwesend",
 "Depois de 5 minutos fora": "Nach 5 Minuten abwesend",
 "Desligar a senha desta aba": "Passwort für diesen Tab ausschalten",
 "Detalhes técnicos": "Technische Details",
 "Dia {n} de {t}": "Tag {n} von {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Tipp: Der Schlüssel ist wie ein Passwort. Schick ihn nicht per Nachricht und veröffentliche ihn nicht. Falls er bekannt wird, lösche ihn auf der Website und erstelle einen neuen.",
 "Documento vencido": "Dokument abgelaufen",
 "Ela abre em {d}.": "Er öffnet sich am {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "Er öffnet sich am {d}. Du erhältst Benachrichtigungen: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "Er öffnet sich am {d}. Du erhältst eine Benachrichtigung: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "Tippe unter „API keys“ auf „Create key“ (Schlüssel erstellen) und gib ihm einen Namen, zum Beispiel „My Planner“.",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "Füge unter „Billing“ (Abrechnung) eine Karte und ein paar Dollar Guthaben hinzu. Das ChatGPT-Plus-Abo gilt hier nicht.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "Kaufe unter „Billing“ (Abrechnung) Guthaben. Das Claude-Pro-Abo gilt hier nicht.",
 "Em breve": "Demnächst",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Melde dich mit demselben Konto wie bei ChatGPT an oder erstelle eines.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Melde dich mit deinem Google-Konto an (das Gmail-Konto funktioniert).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Melde dich an oder erstelle ein Konto (es kann dieselbe E-Mail wie bei Claude sein).",
 "Enviados para o My Planner": "An My Planner gesendet",
 "Enviar agora": "Jetzt senden",
 "Escolha hoje ou uma data futura.": "Wähle heute oder ein zukünftiges Datum.",
 "Escolhas lembradas": "Gespeicherte Auswahl",
 "Escolher a data": "Datum wählen",
 "Escolher células": "Zellen auswählen",
 "Escolher quando": "Zeitpunkt wählen",
 "Espessura": "Strichstärke",
 "Esquecer": "Vergessen",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "Dieser Schlüssel gehört zu einem anderen Dienst ({servico}). Hier funktionieren nur Schlüssel von Claude, ChatGPT oder Gemini.",
 "Esta chave é do {ia}, não do {escolhida}.": "Dieser Schlüssel ist für {ia}, nicht für {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "Dieses Konto sieht die App wie ein neues Konto, ohne freigeschaltete Tabs, um die Schlösser, den kostenlosen Test und den Kauf zu prüfen. Die anderen Konten ändern sich nicht.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "Dieses Werkzeug muss die PDF-Seiten sehen können, was mit der neuen App (Version 0.50) kommt. Nutze den Browser oder aktualisiere My Planner im Store.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "Das sieht nicht wie ein {ia}-Schlüssel aus. {ia}-Schlüssel beginnen mit {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "Diese Benachrichtigung steht auf „Aus“: Es wird nichts klingeln.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "Dieses Handy erhält noch keine Benachrichtigungen, wenn die App geschlossen ist. Aktualisiere My Planner im Store (Version {v} oder neuer). Bei geöffneter App funktionieren die Benachrichtigungen bereits.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "Diese Art von Benachrichtigung ist in den Benachrichtigungseinstellungen des Handys ausgeschaltet.",
 "Estudado": "Gelernt",
 "Estudado: {dur}": "Gelernt: {dur}",
 "Faltou: {dur}": "Fehlend: {dur}",
 "Fazer os testes terminarem agora": "Tests jetzt beenden lassen",
 "Fechar a barra do editor": "Editorleiste schließen",
 "Fichário": "Ordner",
 "Figurinhas e emojis": "Sticker und Emojis",
 "Garantia terminou": "Garantie abgelaufen",
 "Gerando…": "Wird erstellt…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Speichert Dokumente, Untersuchungsergebnisse und Gesundheitsverlauf mit einem eigenen Passwort. Nicht einmal der Support kann es lesen. Wenn du das Passwort vergisst, gibt es keine Möglichkeit, es wiederherzustellen.",
 "Harpa": "Harfe",
 "Horas por dia": "Stunden pro Tag",
 "Identificação": "Identifikation",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "Das sieht wie ein Link oder eine E-Mail aus, nicht wie ein Schlüssel. Kopiere den ganzen Schlüssel auf der Seite der API-Schlüssel.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "Das erscheint nur in My Planner, wenn du es sendest. Jetzt senden?",
 "Já dá para confirmar {titulo}?": "Kannst du {titulo} schon bestätigen?",
 "Lembrar minha escolha nesta aba": "Meine Auswahl in diesem Tab merken",
 "Lembrete para confirmar: {data}": "Erinnerung zum Bestätigen: {data}",
 "Marimba": "Marimba",
 "Marque pelo menos um dia da semana no plano.": "Markiere im Plan mindestens einen Wochentag.",
 "Me lembre de confirmar": "Erinnere mich ans Bestätigen",
 "Me lembre depois": "Später erinnern",
 "Menos": "Weniger",
 "Meta somada": "Gesamtziel",
 "Meta somada: {dur}": "Gesamtziel: {dur}",
 "Meus dados - My Planner {data}": "Meine Daten - My Planner {data}",
 "Meus dados do My Planner": "Meine Daten in My Planner",
 "Mostrar a barra": "Leiste anzeigen",
 "Mudar senha do diário": "Tagebuch-Passwort ändern",
 "Na primeira vez, aceite os termos de uso.": "Akzeptiere beim ersten Mal die Nutzungsbedingungen.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "In der Store-Version erfolgt der Kauf über den App-Store des Handys. Vorerst simuliert der Schlüssel das Abo zu Testzwecken.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Nichts aus anderen Tabs geht von selbst an My Planner. Diese Einträge haben ein Datum und wurden noch nicht gesendet.",
 "Nenhum estudo registrado neste mês.": "In diesem Monat wurde kein Lernen erfasst.",
 "Nenhum item aguardando envio.": "Keine Einträge warten auf das Senden.",
 "Nenhum teste começado": "Kein Test gestartet",
 "Nesta tela não há nada para adicionar.": "Auf diesem Bildschirm gibt es nichts hinzuzufügen.",
 "No dia": "Am selben Tag",
 "Nova nota rápida": "Neue Schnellnotiz",
 "Nova página do dia": "Neue Tagesseite",
 "Não deu certo": "Das hat nicht geklappt",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "Nicht enthalten: der Inhalt des Tagebuchs und die Felder des Tresors (sie bleiben durch das Passwort geschützt), Fotos und angehängte Dateien. Um die Daten in der App wiederherzustellen, verwende die technische Datei.",
 "Não foi possível gerar o PDF.": "Das PDF konnte nicht erstellt werden.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "Der Test ist gerade nicht möglich. Versuche es in ein paar Sekunden erneut.",
 "Não lembrar": "Nicht merken",
 "Não, obrigada": "Nein, danke",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "Das Tagebuch ist durch sein eigenes Passwort geschützt und nicht in dieser Datei enthalten.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "Die App öffnet „In Dateien sichern“, damit du den Ordner wählen kannst (z. B. iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Die App speichert nur die Verknüpfung zur gewählten Datei: Sie bleibt, wo sie ist (Drive, OneDrive, Downloads), und öffnet sich in der App auf dem Handy. Nichts wird kopiert. Diese Option gilt für Fotos, die mit der Kamera aufgenommen werden.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "Die auf diesem Gerät installierte App hat die Version {v}. Für Audio- und Videoanrufe aktualisiere My Planner im Store (Version 0.35 oder neuer). Nachrichten funktionieren bereits.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "Die Benachrichtigung kommt lautlos, direkt in die Benachrichtigungsliste: Schalte die Benachrichtigungen von My Planner in den Einstellungen des Handys ein.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "Die Benachrichtigung kommt ohne Ton: Der Ton für diese Art von Benachrichtigung wurde in den Einstellungen des Handys ausgeschaltet.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "Die Benachrichtigung kommt an, aber der Benachrichtigungston von My Planner ist auf dem Handy ausgeschaltet.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "Die Einladung enthält den Link zum Herunterladen der App. Wer über den Link beitritt, landet direkt im Büro.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "Die Diktierfunktion kommt mit der neuen App-Version. Aktualisiere My Planner im Store, um das Mikrofon zu nutzen.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "Dieselbe Entsperrung wie die App: Passwort, Biometrie oder PIN. Sie wird einmal beim Betreten abgefragt; innerhalb des Tabs nicht erneut. Das Öffnen der Galerie, der Kamera oder der Dateien zählt nicht als Verlassen. Große Einträge verlangen zum Löschen weiterhin das Passwort.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Der Lautlos-Modus des Handys kann den Alarm verhindern. Lass das Handy im normalen Modus.",
 "O plano fica só em Estudos (não vai para o My Planner).": "Der Plan bleibt nur in Lernen (er geht nicht an My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Optional: Frist, Stunden pro Tag und Wochentage.",
 "Os avisos do celular funcionam no app instalado.": "Benachrichtigungen auf dem Handy funktionieren in der installierten App.",
 "Os avisos no celular funcionam no app instalado.": "Die Benachrichtigungen auf dem Handy funktionieren in der installierten App.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "Die gestarteten Tests sind beendet. Öffne den Tab, um „Der kostenlose Test ist beendet“ zu sehen.",
 "Outros dados": "Weitere Daten",
 "Ouvir": "Anhören",
 "Pacote em uso": "Verwendetes Paket",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "Um ein Abo abzuschließen, aktualisiere My Planner im App-Store des Handys.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "Zum Lesen (PDF): nach Tabs geordnet, mit Titeln und Daten. Lässt sich auf jedem Gerät oder Computer öffnen.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Damit der Medikamentenalarm bei eingeschaltetem „Nicht stören“ klingelt, muss das Handy My Planner den Zugriff auf „Nicht stören“ erlauben. Tippe auf „Einstellungen öffnen“, suche My Planner in der Liste und schalte die Berechtigung ein.",
 "Passo a passo para criar a chave": "Schritt für Schritt zum Schlüssel",
 "Pedir de novo": "Erneut fragen",
 "Pedir senha ao abrir esta aba": "Beim Öffnen dieses Tabs nach Passwort fragen",
 "Plano com período": "Plan mit Zeitraum",
 "Plano começa em {d}": "Plan beginnt am {d}",
 "Por matéria": "Nach Fach",
 "Prolongar": "Verlängern",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "Fertig: Die Benachrichtigung kommt innerhalb von 5 Sekunden, mit Ton. Wenn nichts klingelt, prüfe, ob das Handy lautlos ist.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "Fertig: Die Benachrichtigung kommt innerhalb von 5 Sekunden, nur mit Vibration.",
 "Publicado em": "Veröffentlicht am",
 "Pulso": "Puls",
 "Quando o app bloquear": "Wenn die App sperrt",
 "Quer proteger esta aba com senha?": "Möchtest du diesen Tab mit einem Passwort schützen?",
 "Recolher ou arrastar a barra": "Leiste einklappen oder ziehen",
 "Recomeçar os testes grátis": "Kostenlose Tests neu starten",
 "Recomeçar os testes grátis?": "Kostenlose Tests neu starten?",
 "Rolar a folha para os lados": "Blatt seitlich scrollen",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "Wenn du die Uhr verbindest: Tagessummen von Schritten, Strecke, Kalorien, Training, Herzfrequenz und Schlaf, gelesen aus Health Connect oder der Health-App des Handys. Die App liest nur und ändert diese Daten nie.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "Kein Internet oder die Verbindung wurde unterbrochen. Prüfe WLAN oder mobile Daten und versuche es erneut.",
 "Senha desta aba": "Passwort für diesen Tab",
 "Seu plano terminou": "Dein Plan ist beendet",
 "Sino": "Glocke",
 "Som do alarme": "Alarmton",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Addiert die gesetzliche Gewährleistung und die Herstellergarantie. Prüfe es im Garantieschein.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "Es sind zwei Dateien mit deinen Daten aus My Planner (Datenübertragbarkeit, LGPD):",
 "Só quando o app bloquear": "Nur wenn die App sperrt",
 "Tamanho da borracha": "Radierergröße",
 "Tamanho da letra": "Schriftgröße",
 "Tempo": "Zeit",
 "Termina em": "Endet am",
 "Testar": "Testen",
 "Texto de exemplo": "Beispieltext",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Ertönt bei Benachrichtigungen mit „Alarm (Ton)“. „Ton und Vibration“ verwendet den Benachrichtigungston des Handys.",
 "Toda vez que sair": "Jedes Mal beim Verlassen",
 "Toda vez que sair da aba": "Jedes Mal beim Verlassen des Tabs",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "Alle Tabs kehren zu „{n} Tage kostenlos testen“ zurück, wie bei einem neuen Konto. Die simulierten Abos werden ausgeschaltet.",
 "Todos os fichários": "Alle Ordner",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Tippe auf „Create API key“ (API-Schlüssel erstellen). Wenn ein Projekt verlangt wird, wähle das angezeigte oder erstelle ein neues.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Tippe oben auf „Meinen API-Schlüssel erstellen“. Es öffnet sich die OpenAI-Plattform (nicht die ChatGPT-Website).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Tippe oben auf „Meinen API-Schlüssel erstellen“. Es öffnet sich die Anthropic Console (nicht die Claude-Website).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Tippe oben auf „Meinen API-Schlüssel erstellen“. Es öffnet sich Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Tippe auf Verbinden und schalte auf dem Bildschirm der Health-App die Einträge ein, die My Planner lesen darf.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Tippe auf das Kopieren-Symbol neben dem Schlüssel. Er beginnt mit „AIza“ oder „AQ.“.",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Tippe auf eine Tabellenzelle (oder auf „Zellen auswählen“), um ihre Schriftgröße zu ändern.",
 "Transparência": "Transparenz",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Technisch (zum Wiederherstellen): vollständige Kopie, die nur My Planner lesen kann. Zum Verwenden gehe zu Einstellungen › Cloud und Sicherungen › Datei importieren.",
 "Uma carta da {nome} abre em {n} dias 💌": "Ein Brief von {nome} öffnet sich in {n} Tagen 💌",
 "Usa a senha do app": "Verwendet das App-Passwort",
 "Usar no {ia}": "In {ia} verwenden",
 "Use o app no celular para baixar o arquivo técnico.": "Nutze die App auf dem Handy, um die technische Datei herunterzuladen.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Endpreis vom App-Store festgelegt, bereits in der Währung deines Landes.",
 "Você ainda não enviou {titulo} para o My Planner.": "Du hast {titulo} noch nicht an My Planner gesendet.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Komm hierher zurück, füge ihn in das Feld unten ein und tippe auf „Speichern und testen“.",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Geh zurück zu „API keys“ und tippe auf „Create new secret key“ (Schlüssel erstellen).",
 "atualização automática": "automatisches Update",
 "erro desconhecido": "unbekannter Fehler",
 "estudados no mês": "in diesem Monat gelernt",
 "faltou {dur}": "{dur} fehlen",
 "hoje {feito} de {meta}": "heute {feito} von {meta}",
 "hoje é folga": "heute ist frei",
 "login do Google (não é chave de API)": "Google-Anmeldung (kein API-Schlüssel)",
 "meta cumprida": "Ziel erreicht",
 "o que veio com a instalação": "was bei der Installation dabei war",
 "outro": "andere",
 "provisório": "vorläufig",
 "superou {dur}": "um {dur} übertroffen",
 "token de login (não é chave de API)": "Anmelde-Token (kein API-Schlüssel)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} hat zu lange gebraucht, um zu antworten. Versuche es gleich noch einmal.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} ist gerade nicht erreichbar oder überlastet. Das liegt nicht an deinem Schlüssel: Versuche es später erneut.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} hat den Test mit dem Modell {modelo} beantwortet. Du kannst es jetzt in den Tabs verwenden.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} hat sich geweigert, diesen Inhalt zu lesen (Sicherheitsfilter des Unternehmens).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: Der Schlüssel existiert, hat aber keine Berechtigung, die KI zu nutzen. Erstelle einen neuen Schlüssel auf der in der Anleitung angegebenen Seite.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: ungültiger Schlüssel. Prüfe, ob du den ganzen Schlüssel kopiert hast, oder erstelle einen neuen.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: Dieser Schlüssel wurde vom Unternehmen gesperrt, weil er im Internet veröffentlicht wurde. Lösche ihn und erstelle einen neuen.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: Nutzungslimit erreicht. Warte ein paar Minuten (oder bis morgen, beim kostenlosen Plan) und versuche es erneut.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: Das gewählte Modell ist für dein Konto nicht verfügbar. Wähle unter „Modell“ ein anderes.",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: Der Dienst ist in deiner Region oder für diese Kontoart nicht verfügbar.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: Dein API-Konto hat kein Guthaben oder keine Zahlungsmethode. Füge auf der Website des Unternehmens Guthaben hinzu.",
 "{item}: a garantia termina hoje ({data}).": "{item}: Die Garantie endet heute ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: Die Garantie endete am {data}.",
 "{item}: venceu em {data}.": "{item}: abgelaufen am {data}.",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} mit Passwort geschützt",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: Plan beenden oder mit einem neuen Enddatum verlängern? Es wird nichts gelöscht.",
 "{n} dias antes": "{n} Tage vorher",
 "{n} dias de estudo no plano · {dur} por dia": "{n} Lerntage im Plan · {dur} pro Tag",
 "{n} dias de plano": "{n} Tage Plan",
 "{n} dias depois": "{n} Tage danach",
 "{n} item(ns) aguardando envio ao My Planner": "{n} Eintrag/Einträge wartet/warten auf Senden an My Planner",
 "{n} itens aguardando envio": "{n} Einträge warten auf das Senden",
 "{quando} às {hora}": "{quando} um {hora}",
 "ÚLTIMOS 6 MESES": "LETZTE 6 MONATE",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Öffne My Planner Anne und melde dich mit deiner CPF oder E-Mail und deinem Passwort an.",
 "Anexo": "Anhang",
 "Assédio ou ameaça": "Belästigung oder Drohung",
 "Bloquear {nome}": "{nome} blockieren",
 "Conte mais (opcional)": "Erzähl uns mehr (optional)",
 "Conteúdo impróprio": "Unangemessene Inhalte",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "Beleidigende Inhalte und missbräuchliche Nutzer werden nicht toleriert. Meldungen werden von unserem Team innerhalb von 24 Stunden geprüft.",
 "Denunciar": "Melden",
 "Denunciar contato": "Kontakt melden",
 "Denunciar grupo": "Gruppe melden",
 "Denunciar mensagem": "Nachricht melden",
 "Denúncia enviada": "Meldung gesendet",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Meldungen, die du in Nachrichten machst: der Grund, wer gemeldet wurde und der Ausschnitt der gemeldeten Nachricht. Nur das My Planner-Team liest sie, um den Fall zu prüfen.",
 "Enviar denúncia": "Meldung senden",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Schick eine E-Mail mit der Bitte um Löschung, mit der CPF oder der E-Mail des Kontos. Wir antworten innerhalb von 15 Tagen.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "Wir tolerieren keine beleidigenden, illegalen oder unangemessenen Inhalte und keine missbräuchlichen Nutzer in Nachrichten und Gruppen. Jeder kann eine Nachricht, einen Kontakt oder eine Gruppe melden (Nachricht gedrückt halten oder auf ⋮ > Melden tippen) und blockieren, wen er möchte. Meldungen werden von unserem Team innerhalb von 24 Stunden geprüft: Der Inhalt kann entfernt und das Konto des Absenders gesperrt oder geschlossen werden.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Danke. Unser Team prüft das innerhalb von 24 Stunden.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "Bei Konten, die sich mit CPF anmelden, erstellt unser Support das neue Passwort, nachdem bestätigt wurde, dass das Konto dir gehört. Schreib an {email} und gib deine CPF oder die registrierte E-Mail an.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "Warum meldest du das? Die gemeldete Person erfährt nicht, wer sie gemeldet hat.",
 "Spam": "Spam",
 "{nome} não pode mais conversar com você.": "{nome} kann nicht mehr mit dir chatten.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nGültig bis {d}. Es wird verschlüsselt in deinem Tresor gespeichert, nur auf diesem Gerät und in deiner Cloud-Kopie.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. Öffnen Sie am Computer {url} und wählen Sie „Mit QR-Code anmelden\".",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Tippen Sie hier auf „Browser verbinden\" und richten Sie die Kamera auf den QR-Code am Computer.",
 "Abandonados": "Abgebrochen",
 "Bloquear o computador": "Computer sperren",
 "Cheguei na página...": "Ich bin auf Seite...",
 "Computador conectado": "Verbundener Computer",
 "Computador desconectado": "Computer getrennt",
 "Conectado em {d}": "Verbunden am {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Erstellen Sie die Gruppe und senden Sie den Link: Wer beitritt, sieht das Material zum Buch und verfolgt das Lesen. Admins fügen hinzu, bearbeiten und laden Fotos hoch und können das für Personen freigeben, die den Tab auch nutzen. Nur Admins fügen Personen hinzu oder entfernen sie.",
 "Depois de {n} minutos parado": "Nach {n} Minuten ohne Aktivität",
 "Desconectar o computador?": "Computer trennen?",
 "Difícil demais": "Zu schwierig",
 "Editar livro": "Buch bearbeiten",
 "Entrar com o QR Code": "Mit dem QR-Code anmelden",
 "Escreva (ex.: filosofia)": "Eingeben (z. B. Philosophie)",
 "Este computador": "Dieser Computer",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "Dieser Computer wurde getrennt (über das Handy oder weil sich ein anderer Computer angemeldet hat). Um ihn wieder zu nutzen, melden Sie sich mit dem QR-Code an.",
 "Já existe um computador conectado": "Es ist bereits ein Computer verbunden",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "Es ist bereits ein Computer verbunden. Zu diesem wechseln? Der andere wird getrennt.",
 "Navegador": "Browser",
 "Nenhum computador conectado": "Kein Computer verbunden",
 "Novo livro": "Neues Buch",
 "Não gostei": "Hat mir nicht gefallen",
 "Não, abandonei": "Nein, abgebrochen",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner wird am Computer geschlossen. Zum erneuten Nutzen einfach per QR-Code verbinden.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "Der QR-Code ändert sich alle 3 Minuten und gilt nur einmal. An einem gemeinsam genutzten Computer am Ende Einstellungen › Von diesem Computer abmelden wählen.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "Ihre Daten bleiben in der Cloud und auf dem Handy gespeichert. Zum erneuten Anmelden den QR-Code verwenden.",
 "Parei em": "Abgebrochen am",
 "Perdi o interesse": "Interesse verloren",
 "Por que parei": "Warum ich aufgehört habe",
 "Páginas e meta": "Seiten und Ziel",
 "Quero voltar a ler?": "Möchte ich weiterlesen?",
 "Sair deste computador": "Von diesem Computer abmelden",
 "Sair deste computador?": "Von diesem Computer abmelden?",
 "Se quiser, escreva com as suas palavras": "Wenn Sie möchten, schreiben Sie es in eigenen Worten",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "Wird Maus oder Tastatur so lange nicht benutzt, sperrt sich My Planner. Zum Fortfahren das Kontopasswort eingeben (oder erneut mit dem QR-Code anmelden).",
 "Sem tempo": "Keine Zeit",
 "Sim, depois": "Ja, später",
 "Só um computador pode ficar conectado por vez.": "Es kann immer nur ein Computer verbunden sein.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "Foto oder PDF des Zertifikats unter „Fotos, Dateien und Links\" ablegen und als Zertifikat markieren.",
 "ABNT copiada": "ABNT kopiert",
 "APA copiada": "APA kopiert",
 "Ano inválido": "Ungültiges Jahr",
 "Ano ou data de publicação": "Jahr oder Datum der Veröffentlichung",
 "Assisti em": "Gesehen am",
 "Buscando os dados...": "Daten werden gesucht...",
 "Calculado pelos módulos": "Aus den Modulen berechnet",
 "Carga horária (horas)": "Umfang (Stunden)",
 "Certificado": "Zertifikat",
 "Certificado emitido em": "Zertifikat ausgestellt am",
 "Cheguei na aula": "Ich bin bei Lektion",
 "Cheguei na aula...": "Ich bin bei Lektion...",
 "Cheguei na temporada": "Ich bin bei Staffel",
 "Cheguei no episódio": "Ich bin bei Folge",
 "Citação copiada": "Zitat kopiert",
 "Colocar em pasta": "In Ordner legen",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Legen Sie Bücher, Filme oder Kurse in diesen Ordner, um die Liste zu erstellen.",
 "Comentário": "Kommentar",
 "Copiar ABNT": "ABNT kopieren",
 "Copiar APA": "APA kopieren",
 "Copiar citação (ABNT)": "Zitat kopieren (ABNT)",
 "Copiar citação (APA)": "Zitat kopieren (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Erstellen Sie Karten mit Checkliste, Liste, freiem Text oder Zeichnung für dieses Fach. Nach rechts wischen zum Löschen, nach links zum Archivieren oder Duplizieren.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Erstellen Sie die Gruppe und senden Sie den Link: Wer beitritt, sieht die Liste und verfolgt sie. Admins fügen hinzu, bearbeiten und laden Fotos hoch und können das für Personen freigeben, die den Tab auch nutzen. Nur Admins fügen Personen hinzu oder entfernen sie.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Erstellen Sie die Gruppe und senden Sie den Link: Wer beitritt, sieht das Kursmaterial und verfolgt es. Admins fügen hinzu, bearbeiten und laden Fotos hoch und können das für Personen freigeben, die den Tab auch nutzen. Nur Admins fügen Personen hinzu oder entfernen sie.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Erstellen Sie zuerst einen Ordner im Bereich 📁 Ordner dieses Tabs.",
 "DOI (artigos)": "DOI (Artikel)",
 "Data de acesso": "Zugriffsdatum",
 "Deixar avulsas": "Einzeln lassen",
 "Descrição (objetivo)": "Beschreibung (Ziel)",
 "Digite o ano com 4 números (ex.: {a}).": "Jahr mit 4 Ziffern eingeben (z. B. {a}).",
 "Direção": "Regie",
 "Editar pasta": "Ordner bearbeiten",
 "Editora": "Verlag",
 "Edição": "Auflage",
 "Em 1 mês": "In 1 Monat",
 "Em {n} meses": "In {n} Monaten",
 "Episódios por temporada (opcional)": "Folgen pro Staffel (optional)",
 "Escreva o trecho na anotação para copiar a citação.": "Schreiben Sie die Textstelle in die Notiz, um das Zitat zu kopieren.",
 "Este item já está em todas as pastas.": "Dieses Element ist bereits in allen Ordnern.",
 "Ex.: 10.1590/...": "z. B. 10.1590/...",
 "Ex.: TCC — Ética e Direito": "z. B. Abschlussarbeit — Ethik und Recht",
 "Ex.: {a}": "z. B. {a}",
 "Fazendo": "Läuft",
 "Grupo de filmes e séries": "Film- und Seriengruppe",
 "Grupo de leitura": "Lesegruppe",
 "Grupo do curso": "Kursgruppe",
 "ISBN": "ISBN",
 "Ideia minha": "Eigene Idee",
 "Instrutor": "Dozent",
 "Itens da pasta": "Ordnerinhalte",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Sammeln Sie Bücher, Filme und Kurse in einem Ordner (z. B. „Abschlussarbeit\", „Nur Romane\"). Ein Element kann in mehreren Ordnern sein.",
 "Link (material online)": "Link (Online-Material)",
 "Lista copiada": "Liste kopiert",
 "Lista de referências": "Literaturliste",
 "Mais de um autor: separe com ponto e vírgula (;).": "Mehrere Autoren: mit Semikolon (;) trennen.",
 "Módulo": "Modul",
 "Nada novo": "Nichts Neues",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "Im ⋮ eines Buchs, Films oder Kurses auf „In Ordner legen\" tippen.",
 "Nome da pasta": "Ordnername",
 "Não achei dados novos para completar a ficha.": "Keine neuen Daten zum Ergänzen gefunden.",
 "Não foi possível preencher": "Ausfüllen nicht möglich",
 "O módulo não tem cards de anotações.": "Das Modul hat keine Notizkarten.",
 "Organizador": "Herausgeber",
 "Os dados vêm da ficha do livro (Editar › Referência).": "Die Daten stammen aus dem Buch (Bearbeiten › Literaturangabe).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "Bücher, Filme und Kurse im Ordner werden NICHT gelöscht: Sie bleiben im Tab.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "Auch die {n} Notizkarte(n) dieses Moduls kommen in den Papierkorb.",
 "Pasta vazia": "Leerer Ordner",
 "Preencha o título (e o que mais tiver) na ficha.": "Titel (und was Sie sonst haben) ausfüllen.",
 "Preencher pelo DOI": "Über DOI ausfüllen",
 "Preencher pelo link": "Über den Link ausfüllen",
 "Produtora ou país": "Produktion oder Land",
 "Quero fazer": "Möchte ich machen",
 "Quero voltar?": "Möchte ich weitermachen?",
 "Referência vazia": "Leere Angabe",
 "Referências": "Literatur",
 "Se deixar avulsas, elas continuam somando no total do curso.": "Einzeln gelassen zählen sie weiter zur Kurssumme.",
 "Subtítulo": "Untertitel",
 "Tirar da pasta": "Aus Ordner entfernen",
 "Total de episódios (opcional)": "Folgen insgesamt (optional)",
 "Total de temporadas (opcional)": "Staffeln insgesamt (optional)",
 "Tradutor": "Übersetzer",
 "Trecho (citação)": "Textstelle (Zitat)",
 "Trecho vazio": "Leere Textstelle",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "Sie haben schon {n} Lektion(en) gesehen. In welches Modul?",
 "Volume": "Band",
 "{n} item(ns)": "{n} Element(e)",
 "{n} referência(s) em ordem alfabética.": "{n} Angabe(n) in alphabetischer Reihenfolge.",
 "Ícone": "Symbol",
 "ASSISTIDOS POR DIA": "GESEHEN PRO TAG",
 "ASSISTIDOS POR MÊS": "GESEHEN PRO MONAT",
 "AULAS POR DIA": "LEKTIONEN PRO TAG",
 "AULAS POR MÊS": "LEKTIONEN PRO MONAT",
 "Apagar a meta": "Ziel löschen",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Gesehen {a} · Schaue gerade {b} · Abgebrochen {c} · Möchte sehen {d}",
 "Aulas": "Lektionen",
 "CURSOS": "KURSE",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Abgeschlossen {a} · Läuft {b} · Abgebrochen {c}",
 "Datas": "Daten",
 "Datas escolhidas": "Gewählte Daten",
 "Datas à escolha": "Eigene Daten",
 "Definir meta de {ano}": "Ziel für {ano} festlegen",
 "Definir meta do ano": "Jahresziel festlegen",
 "FILMES E SÉRIES": "FILME UND SERIEN",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "Noch {f} Kurs(e): etwa {m} pro Monat",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "Noch {f} Buch/Bücher: etwa {m} pro Monat",
 "Faltam {f} título(s): dá cerca de {m} por mês": "Noch {f} Titel: etwa {m} pro Monat",
 "Gênero": "Genre",
 "Incluir lista de referências no PDF": "Literaturliste ins PDF aufnehmen",
 "LIVROS": "BÜCHER",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Gelesen {a} · Abgebrochen {b} · Lese gerade {c}",
 "Meta de {ano}": "Ziel {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "Ziel {ano}: das von {antes} übernehmen ({n})?",
 "Meta do ano cumprida": "Jahresziel erreicht",
 "Mudar": "Ändern",
 "Nada neste período.": "Nichts in diesem Zeitraum.",
 "Nota": "Bewertung",
 "O PDF não leva as suas anotações, resumos e comentários.": "Das PDF enthält keine Notizen, Zusammenfassungen oder Kommentare.",
 "POR ITEM": "NACH ELEMENT",
 "Plataforma": "Plattform",
 "PÁGINAS POR DIA": "SEITEN PRO TAG",
 "PÁGINAS POR MÊS": "SEITEN PRO MONAT",
 "Quantos no ano?": "Wie viele im Jahr?",
 "Quero ler {a} · Abandonei {b}": "Möchte lesen {a} · Abgebrochen {b}",
 "Relatório de leitura e mídia": "Lese- und Medienbericht",
 "concluídos no período": "im Zeitraum abgeschlossen",
 "cursos concluídos no período": "Kurse im Zeitraum abgeschlossen",
 "livros lidos no período": "im Zeitraum gelesene Bücher",
 "pág. {a} de {n}": "S. {a} von {n}",
 "títulos assistidos no período": "im Zeitraum gesehene Titel",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} Lektion(en) im Zeitraum · {h} Stunde(n) abgeschlossener Kurse",
 "{a} de {n} aulas ({p}%)": "{a} von {n} Lektionen ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} von {n} Kurs(en) abgeschlossen in {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} von {n} Büchern in {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} von {n} Titeln gesehen in {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} Element(e) ohne Datum der Statusänderung: Erstellungsdatum verwendet.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} Seite(n) an {d} Tag(en) · beste Serie: {s} Tag(e)",
 "{p}% lido · falta {f}%": "{p}% gelesen · {f}% übrig",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "Dieser Tab ist geschützt. Entsperren Sie ihn zuerst, dann geht die Anleitung hier weiter.",
 "Abrir esta aba": "Diesen Tab öffnen",
 "Mostrar na tela": "Auf dem Bildschirm zeigen",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "Diese Stelle ist gerade nicht auf dem Bildschirm. Prüfen Sie, ob der richtige Bildschirm offen ist, und versuchen Sie es erneut.",
 "Primeiros passos": "Erste Schritte",
 "Buscar no guia": "In der Anleitung suchen",
 "Entendi": "Verstanden",
 "{n} de {total} passos feitos": "{n} von {total} Schritten erledigt",
 "Já fiz": "Erledigt",
 "Guia em construção": "Anleitung in Arbeit",
 "Limpar marcações": "Häkchen löschen",
 "Este ponto ainda não está marcado no app.": "Diese Stelle ist in der App noch nicht markiert.",
 "Dicas e atalhos": "Tipps und Abkürzungen",
 "Gestos do app": "Gesten der App",
 "Procurando na tela…": "Suche auf dem Bildschirm…",
 "Guia das abas": "Anleitung der Tabs",
 "Voltar ao guia": "Zurück zur Anleitung",
 "Para que serve": "Wofür es ist",
 "Disponível no app do celular.": "In der Handy-App verfügbar.",
 "Nada encontrado no guia.": "Nichts in der Anleitung gefunden.",
 "Recursos que valem para todas as abas": "Funktionen für alle Tabs",
 "Perguntas comuns": "Häufige Fragen",
 "Ligar e desligar partes": "Teile ein- und ausschalten",
 "Entrada cancelada. Este computador não foi conectado.": "Anmeldung abgebrochen. Dieser Computer wurde nicht verbunden.",
 "Alterações ainda não enviadas": "Änderungen noch nicht gesendet",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Einige Änderungen wurden noch nicht an den Server gesendet (kein Internet?). Wenn du dich jetzt abmeldest, gehen sie verloren. Trotzdem abmelden?",
 "Sair mesmo assim": "Trotzdem abmelden",
 "O seu papel no grupo não permite mudar aqui.": "Deine Rolle in der Gruppe erlaubt hier keine Änderungen.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "Der DOI konnte gerade nicht abgefragt werden (kein Internet?). Versuche es erneut.",
 "DOI inválido.": "Ungültiger DOI.",
 "DOI não encontrado.": "DOI nicht gefunden.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "Die Website ließ das Lesen der Daten von hier nicht zu (im Computer-Browser häufig). Versuche es mit der App auf dem Handy, nutze den DOI oder fülle die Felder aus.",
 "Atualizando...": "Wird aktualisiert...",
 "Banco de dados (Supabase, plano grátis)": "Datenbank (Supabase, kostenloser Tarif)",
 "Cadeado (HTTPS) até": "HTTPS-Schloss bis",
 "Dados das abas: {d}": "Daten der Bereiche: {d}",
 "Disco": "Festplatte",
 "Esta conta não tem acesso a estas informações.": "Dieses Konto hat keinen Zugriff auf diese Informationen.",
 "Ligado há": "Läuft seit",
 "Livre: {l} · site: {s}": "Frei: {l} · Website: {s}",
 "Maiores tabelas": "Größte Tabellen",
 "Memória em uso": "Belegter Arbeitsspeicher",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "Der Server hat seinen Bericht noch nicht gesendet. Er sendet ihn alle 10 Minuten nach 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "Der Server hat diese Funktion noch nicht. Führe 53-SERVIDOR-0.78.bat auf dem Computer aus.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "Das Serversystem verlangt einen Neustart (Sicherheitsupdate installiert).",
 "Processador": "Prozessor",
 "Relatório do servidor: {q}": "Serverbericht: {q}",
 "Servidor": "Server",
 "Servidor do site (Locaweb)": "Website-Server (Locaweb)",
 "Sistema": "System",
 "Só você vê este quadro.": "Nur du siehst diesen Bereich.",
 "Versão do site no ar": "Aktuelle Website-Version",
 "atrasado: confira se o servidor está ligado": "verspätet: prüfe, ob der Server läuft",
 "sem cadeado": "kein Schloss",
 "{a} ({n} guardadas)": "{a} ({n} aufbewahrt)",
 "{d} dia(s) e {h} h": "{d} Tag(e) und {h} Std.",
 "{n} núcleo(s) · carga {c}": "{n} Kern(e) · Last {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} neu und {ativas} aktiv in 7 Tagen",
 "{u} de {t} ({p}%)": "{u} von {t} ({p} %)",
 "Fechar teclado": "Tastatur schließen",
 "Mostrar as ferramentas": "Werkzeuge anzeigen",
 "Últimas cores usadas": "Zuletzt verwendete Farben",
 "Voltar ao topo": "Nach oben",
 "Topo": "Oben",
 "1 atividade do roteiro por fazer": "1 Reiseplan-Aktivität offen",
 "1 dia": "1 Tag",
 "1 item por pôr na mala": "1 Teil noch einzupacken",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 Reisen-Liste wurde komplett an My Planner gesendet und dort entfernt. Jetzt wird jeder Eintrag einzeln über sein ⋮ gesendet.",
 "1 lugar não visitado": "1 Ort nicht besucht",
 "1 reserva por confirmar": "1 Buchung zu bestätigen",
 "Abrir o bloco": "Abschnitt öffnen",
 "Adicionar pessoa": "Person hinzufügen",
 "Ainda pode gastar {v}": "Noch verfügbar: {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "Wenn aktiviert, wird der Betrag als bezahlt unter Ausgaben erfasst.",
 "Até (dd/mm/aaaa)": "Bis (TT/MM/JJJJ)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Trage die Personen unter \"Wer kommt mit\" ein (Reise bearbeiten).",
 "Como foi?": "Wie war's?",
 "Concluído em {d}": "Erledigt am {d}",
 "Confirmada em {d}": "Bestätigt am {d}",
 "Confirmadas": "Bestätigt",
 "Dia anterior": "Vorheriger Tag",
 "Dias": "Tage",
 "Dias × valor por dia": "Tage × Tagessatz",
 "Documentos (só o tipo e a validade)": "Dokumente (nur Art und Gültigkeit)",
 "EXIGÊNCIAS DO DESTINO": "ANFORDERUNGEN DES REISEZIELS",
 "Em mãos": "Vorhanden",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Notiere, was das Reiseziel verlangt (z. B. 2 leere Seiten im Reisepass, Impfnachweis). Prüfe die offizielle Website des Landes.",
 "Ex.: Lisboa (LIS)": "Z. B. Lissabon (LIS)",
 "Ex.: São Paulo (GRU)": "Z. B. São Paulo (GRU)",
 "Falta confirmar": "Zu bestätigen",
 "Falta pôr": "Noch einpacken",
 "Faltou ({n}): {l}": "Vergessen ({n}): {l}",
 "Foi ({n}): {l}": "Mitgenommen ({n}): {l}",
 "Fotos (lista das legendas)": "Fotos (Liste der Bildunterschriften)",
 "Gasto de {nome} em {d}": "Ausgabe von {nome} am {d}",
 "Gastos do dia": "Ausgaben des Tages",
 "Gastos em outras moedas (não convertidos): {v}": "Ausgaben in anderen Währungen (nicht umgerechnet): {v}",
 "Gastos por dia": "Ausgaben pro Tag",
 "Horário de chegada": "Ankunftszeit",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Orte (besucht, offen, Must-sees und Bewertung)",
 "Mala (o que foi e o que faltou)": "Gepäck (was mitkam und was fehlte)",
 "Marcar como acertado": "Als beglichen markieren",
 "Marcar como acertado?": "Als beglichen markieren?",
 "Na mala": "Eingepackt",
 "Nenhuma parada ainda": "Noch keine Stopps",
 "Nova exigência": "Neue Anforderung",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "Dokumentnummern und Inhalte des Tresors kommen nie in den Bericht. Beträge in verschiedenen Währungen werden getrennt angezeigt.",
 "O QUE AINDA FALTA": "WAS NOCH FEHLT",
 "O QUE INCLUIR": "WAS AUFNEHMEN",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Optional. Die App warnt, wenn der Reisepass vorher abläuft, gerechnet ab der Rückreise. Prüfe die Anforderung des Landes.",
 "Orçamento previsto × gasto por categoria": "Geplantes Budget × Ausgaben nach Kategorie",
 "Passou do previsto em {v}": "{v} über dem Budget",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Gib die Gültigkeit jedes Dokuments ein: Die App warnt vor dem Ablauf. Die Fotos der Dokumente bleiben im Tresor geschützt.",
 "Próximo dia": "Nächster Tag",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "Wer in der Reisegruppe ist, wird automatisch hinzugefügt. Nutze \"+ Person hinzufügen\" für alle ohne die App.",
 "Recolher o bloco": "Abschnitt einklappen",
 "Relatório da viagem": "Reisebericht",
 "Reserva confirmada": "Buchung bestätigt",
 "Resumo da viagem": "Reiseübersicht",
 "Resumo da viagem (datas, destino, pessoas)": "Reiseübersicht (Daten, Reiseziel, Personen)",
 "Roteiro por dia (feito e falta)": "Reiseplan pro Tag (erledigt und offen)",
 "Sem data": "Ohne Datum",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "Dein Reisepass wird eventuell nicht akzeptiert. Prüfe die Anforderung des Landes",
 "Subir": "Nach oben",
 "Total do dia: {v}": "Tagessumme: {v}",
 "Uma frase (opcional)": "Ein Satz (optional)",
 "Validade mínima exigida (meses)": "Erforderliche Mindestgültigkeit des Reisepasses (Monate)",
 "Validade: {d}": "Gültig bis: {d}",
 "Valor por dia": "Tagessatz",
 "Viagens no My Planner": "Reisen in My Planner",
 "Visitado": "Besucht",
 "Visitado em {d}": "Besucht am {d}",
 "Voltaria: {r}": "Würde wiederkommen: {r}",
 "Voltaria?": "Würdest du wiederkommen?",
 "confirmada": "bestätigt",
 "em mãos": "vorhanden",
 "gasto na viagem {d}": "Reiseausgabe {d}",
 "meses": "Monate",
 "outro gasto": "sonstige Ausgabe",
 "vence em {d}": "läuft am {d} ab",
 "{a} de {b} confirmadas": "{a} von {b} bestätigt",
 "{a} de {b} em mãos": "{a} von {b} vorhanden",
 "{a} de {b} feitos": "{a} von {b} erledigt",
 "{a} de {b} na mala": "{a} von {b} eingepackt",
 "{a} de {b} pagos": "{a} von {b} bezahlt",
 "{a} de {b} visitados": "{a} von {b} besucht",
 "{de} deve {v} a {para}": "{de} schuldet {para} {v}",
 "{g} de {p}": "{g} von {p}",
 "{n} atividades do roteiro por fazer": "{n} Reiseplan-Aktivitäten offen",
 "{n} item(ns) enviado(s).": "{n} Eintrag/Einträge gesendet.",
 "{n} itens por pôr na mala": "{n} Teile noch einzupacken",
 "{n} já estava(m) no My Planner.": "{n} bereits in My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} Reisen-Listen wurden komplett an My Planner gesendet und dort entfernt. Jetzt wird jeder Eintrag einzeln über sein ⋮ gesendet.",
 "{n} lugares não visitados": "{n} Orte nicht besucht",
 "{n} reservas por confirmar": "{n} Buchungen zu bestätigen",
 "{n} sem data (não foi).": "{n} ohne Datum (nicht gesendet).",
 "ARTIGOS E SITES": "ARTIKEL UND WEBSITES",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "Jetzt wird Eintrag für Eintrag gesendet (über ⋮ am Eintrag oder durch Auswahl mehrerer). Diese Listen wurden komplett gesendet und aus My Planner entfernt ({n} Eintrag/Einträge, nichts wurde gelöscht):",
 "Artigo científico": "Wissenschaftlicher Artikel",
 "Artigo de site ou blog": "Website- oder Blogartikel",
 "Artigo ou site": "Artikel oder Website",
 "Artigos e sites": "Artikel und Websites",
 "Autor(es)": "Autor(en)",
 "Cadastrar pela foto ou PDF": "Per Foto oder PDF erfassen",
 "Capítulo de livro": "Buchkapitel",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Erstelle die Gruppe und sende den Link: Wer beitritt, sieht die Artikel und verfolgt das Lesen. Admins fügen hinzu, bearbeiten und laden Fotos hoch und können das für Personen freigeben, die den Tab auch nutzen. Nur Admins fügen Personen hinzu oder entfernen sie.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Erscheinungsdatum oder -jahr",
 "Editar artigo ou site": "Artikel oder Website bearbeiten",
 "Enviar para o My Planner (lembrete de renovação)": "An My Planner senden (Verlängerungserinnerung)",
 "Envio para o My Planner": "Senden an My Planner",
 "Ex.: 2024 ou 12/03/2024": "z. B.: 2024 oder 12.03.2024",
 "Ex.: 45-60": "z. B.: 45-60",
 "Grupo de artigos": "Artikelgruppe",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Speichere Artikel, Nachrichten und Webseiten mit fertiger Quellenangabe (ABNT und APA). Per DOI oder Link ausfüllen.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Gelesen {a} · Lese gerade {b} · Abgebrochen {c} · Will lesen {d}",
 "Minhas anotações do artigo": "Meine Notizen zum Artikel",
 "Notícia": "Nachricht",
 "Novo artigo ou site": "Neuer Artikel oder neue Website",
 "Os dados vêm da ficha do artigo (Editar).": "Die Daten stammen aus dem Artikeleintrag (Bearbeiten).",
 "Páginas (opcional)": "Seiten (optional)",
 "Revista, site ou veículo": "Zeitschrift, Website oder Medium",
 "artigos e sites lidos no período": "im Zeitraum gelesene Artikel und Websites",
 "1 confirmado": "1 bestätigt",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 Gast mit Status „Ausstehend“ wurde zu „Einzuladen“ verschoben. Wenn du die Einladung über die App sendest, wechselt er automatisch zu „Eingeladen, keine Antwort“.",
 "1 extra": "1 zusätzlich",
 "1 talvez": "1 vielleicht",
 "A convidar": "Einzuladen",
 "Agendar na igreja": "Termin in der Kirche vereinbaren",
 "Agora": "Jetzt",
 "Agradeci": "Bedankt",
 "Agradeci em {d}": "Bedankt am {d}",
 "Agradecidos": "Bedankt",
 "Alianças": "Eheringe",
 "Aluguéis (mesas, cadeiras, louças)": "Mieten (Tische, Stühle, Geschirr)",
 "Avisar a data (save the date)": "Datum ankündigen (Save the Date)",
 "Bebidas": "Getränke",
 "Beca e cerimônia": "Talar und Zeremonie",
 "Bolo": "Torte",
 "Brincadeiras": "Spiele",
 "Brincadeiras e amigo secreto": "Spiele und Wichteln",
 "Brindes": "Werbegeschenke",
 "Buffet": "Catering",
 "Calculado sozinho: valor menos o sinal.": "Automatisch berechnet: Betrag minus Anzahlung.",
 "Calcular quantidades": "Mengen berechnen",
 "Categoria do orçamento": "Budgetkategorie",
 "Celebrante": "Trauredner",
 "Cerimônia": "Zeremonie",
 "Cerveja (adultos)": "Bier (Erwachsene)",
 "Checklist de preparação": "Vorbereitungs-Checkliste",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Lege das Datum der Veranstaltung fest (Veranstaltung bearbeiten), um die Fälligkeit jedes Punkts zu sehen.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Füge Personen unter „Personen der Veranstaltung“ hinzu (Veranstaltung bearbeiten).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Gib an, wie viel du pro Kategorie ausgeben willst. Mit ⊕ rechnest du pro Gast. Gebuchte Dienstleister werden automatisch der gewählten Kategorie zugeordnet.",
 "Combinado: {v}": "Vereinbart: {v}",
 "Comprado": "Gekauft",
 "Comprados": "Gekauft",
 "Comprar a decoração e as lembrancinhas": "Deko und Gastgeschenke kaufen",
 "Comprar as alianças": "Eheringe kaufen",
 "Comprar as lembrancinhas": "Gastgeschenke kaufen",
 "Comprar bebidas e gelo": "Getränke und Eis kaufen",
 "Comprar comida e bebidas": "Essen und Getränke kaufen",
 "Comprar o que falta": "Fehlendes kaufen",
 "Comprar ou alugar a roupa": "Outfit kaufen oder mieten",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Bestätigt inkl. Begleitpersonen. Ändert sich automatisch, wenn jemand zu- oder absagt.",
 "Confirmar a presença dos convidados": "Teilnahme der Gäste bestätigen",
 "Confirmar os fornecedores": "Dienstleister bestätigen",
 "Confirmar os fornecedores e os convidados": "Dienstleister und Gäste bestätigen",
 "Contratar a comida": "Essen buchen",
 "Contratar a comida e o bolo": "Essen und Torte buchen",
 "Contratar a decoração": "Deko buchen",
 "Contratar comida e bebidas": "Essen und Getränke buchen",
 "Contratar foto e vídeo": "Foto und Video buchen",
 "Contratar o buffet": "Catering buchen",
 "Convidado, sem resposta": "Eingeladen, keine Antwort",
 "Convidados (por situação, com acompanhantes)": "Gäste (nach Status, mit Begleitpersonen)",
 "Convidados que contam no ⊕": "Gäste, die bei ⊕ zählen",
 "Convites": "Einladungen",
 "Cronograma do dia (com responsáveis e situação)": "Tagesablauf (mit Verantwortlichen und Status)",
 "Data do restante": "Datum Restzahlung",
 "Data do sinal": "Datum Anzahlung",
 "Decoração": "Dekoration",
 "Definir a data e o orçamento": "Datum und Budget festlegen",
 "Definir a lista de convidados": "Gästeliste festlegen",
 "Doces": "Süßes",
 "Dá para mudar, tirar e incluir itens depois.": "Du kannst Punkte später ändern, entfernen und hinzufügen.",
 "Enviar os convites": "Einladungen verschicken",
 "Equipamentos (projetor, som)": "Technik (Beamer, Ton)",
 "Equipe (garçons, limpeza)": "Personal (Kellner, Reinigung)",
 "Escolha \"Outro\" para escrever o nome.": "Wähle „Andere“, um den Namen einzugeben.",
 "Escolher a roupa": "Outfit auswählen",
 "Escolher a roupa dos noivos": "Outfits des Brautpaars auswählen",
 "Escolher os padrinhos": "Trauzeugen bzw. Paten auswählen",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Schätzung für {n} Gäste. Ändere vor dem Übernehmen, was du willst.",
 "Eu faço": "Mache ich",
 "Ex.: 200 un.": "Z. B.: 200 Stk.",
 "Ex.: Copos descartáveis": "Z. B.: Einwegbecher",
 "Ex.: Jogo de panelas": "Z. B.: Topfset",
 "Ex.: Reservar o local": "Z. B.: Location buchen",
 "Ex.: em negociação": "Z. B.: in Verhandlung",
 "Extras de margem (quem aparece sem avisar)": "Puffer (wer unangemeldet kommt)",
 "Falta 1 dia": "Noch 1 Tag",
 "Falta agradecer": "Noch zu danken",
 "Falta comprar": "Noch zu kaufen",
 "Falta pagar": "Noch zu zahlen",
 "Fazer a lista de presentes": "Wunschliste erstellen",
 "Fazer o curso de batismo": "Taufkurs besuchen",
 "Fornecedores (contratado, pago, falta)": "Dienstleister (vereinbart, bezahlt, offen)",
 "Foto e vídeo": "Foto und Video",
 "Fraldas": "Windeln",
 "Frase curta (opcional)": "Kurzer Satz (optional)",
 "Hoje é o dia do evento!": "Heute ist der große Tag!",
 "Igreja e celebrante": "Kirche und Trauredner",
 "Incluir os Talvez": "„Vielleicht“ einbeziehen",
 "Incluir telefones": "Telefonnummern einbeziehen",
 "Item da lista de compras": "Eintrag der Einkaufsliste",
 "Item da preparação": "Vorbereitungspunkt",
 "Já deram: {d} · Falta: {f}": "Bereits gegeben: {d} · Fehlt: {f}",
 "Já deu": "Hat gegeben",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Trage hier die Ausgaben ein. Zahlungen an Dienstleister und abgehakte Einkäufe kommen automatisch hinzu.",
 "Lançar o gasto": "Ausgabe eintragen",
 "Lembrancinhas": "Gastgeschenke",
 "Levar para os itens": "Zu den Einträgen übernehmen",
 "Local / espaço": "Location / Raum",
 "Mais um extra": "Einer mehr",
 "Menos um extra": "Einer weniger",
 "Música / som / DJ": "Musik / Ton / DJ",
 "No dia do evento": "Am Tag der Veranstaltung",
 "O que comprar": "Was kaufen",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "Die Summe ändert sich automatisch, wenn jemand zu- oder absagt.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "Der Vertragsbetrag wird automatisch als geplant in dieser Kategorie eingetragen, Bezahltes kommt zu den Ausgaben.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "Der Betrag kommt zu den Ausgaben der Veranstaltung, in die Kategorie des Eintrags. Du kannst das auch überspringen.",
 "Onde comprar": "Wo kaufen",
 "Orçamento do evento": "Budget der Veranstaltung",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Markierte Einträge kommen mit ⊕ pro Gast in die Kategorie. Dann einfach ⊕ antippen und den Stückpreis eingeben.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "Telefonnummern der Gäste erscheinen nur im PDF, wenn du „Telefonnummern einbeziehen“ markierst. Beträge in verschiedenen Währungen werden getrennt angezeigt.",
 "Pago em {d}": "Bezahlt am {d}",
 "Parte da vaquinha": "Anteil an der Sammelkasse",
 "Pessoas do evento": "Personen der Veranstaltung",
 "Pessoas do evento: {p}": "Personen der Veranstaltung: {p}",
 "Preparar as brincadeiras": "Spiele vorbereiten",
 "Preparação": "Vorbereitung",
 "Presente recebido": "Geschenk erhalten",
 "Presentes": "Geschenke",
 "Prova final da roupa": "Letzte Anprobe",
 "Pular": "Überspringen",
 "Quantidade por convidado": "Menge pro Gast",
 "Quantidade por convidado × valor unitário": "Menge pro Gast × Stückpreis",
 "Quanto custou?": "Was hat es gekostet?",
 "Quanto já deu": "Bereits gegeben",
 "Quanto vai contribuir": "Geplanter Beitrag",
 "Quantos dias antes do evento": "Wie viele Tage vor der Veranstaltung",
 "Quem deu": "Von wem",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Wer in der Gruppe der Veranstaltung ist, wird automatisch hinzugefügt. Nutze „+ Person hinzufügen“ für Personen ohne App. Diese Liste wird für Ablauf, Ausgaben und Sammelkasse verwendet.",
 "Recreação e brinquedos": "Unterhaltung und Spielgeräte",
 "Refrigerante": "Softdrinks",
 "Relatório do evento": "Bericht zur Veranstaltung",
 "Relatório do evento (PDF)": "Bericht zur Veranstaltung (PDF)",
 "Reservar o local": "Location buchen",
 "Reservar o local da cerimônia e da festa": "Location für Zeremonie und Feier buchen",
 "Reservar o local ou a mesa da festa": "Location oder Tisch für die Feier reservieren",
 "Restante": "Restbetrag",
 "Restante pago": "Restbetrag bezahlt",
 "Resumo do evento": "Zusammenfassung der Veranstaltung",
 "Roupa e beleza": "Outfit und Styling",
 "Salgados": "Herzhafte Snacks",
 "Separar a roupa e o que levar": "Outfit und Mitzunehmendes bereitlegen",
 "Separar os documentos e as alianças": "Dokumente und Eheringe bereitlegen",
 "Separar os documentos e os ingressos": "Dokumente und Tickets bereitlegen",
 "Sinal": "Anzahlung",
 "Sinal pago": "Anzahlung bezahlt",
 "Sinal {v} pago": "Anzahlung {v} bezahlt",
 "Usar a lista pronta para {tipo}": "Fertige Liste für {tipo} verwenden",
 "Vai contribuir": "Beteiligt sich",
 "Valor unitário": "Stückpreis",
 "Vaquinha": "Sammelkasse",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "Du siehst alles Geteilte, immer aktuell. Um Aufgaben hinzuzufügen, zu bearbeiten und zu übernehmen, abonniere den Tab.",
 "agradeci": "bedankt",
 "atrasado": "überfällig",
 "completo": "vollständig",
 "deu {d} de {v}": "hat {d} von {v} gegeben",
 "em {l}": "bei {l}",
 "falta o valor": "Betrag fehlt",
 "falta {v} até {d}": "{v} offen bis {d}",
 "gasto em {e}": "ausgegeben für {e}",
 "kg": "kg",
 "o evento": "die Veranstaltung",
 "restante": "Restbetrag",
 "sinal": "Anzahlung",
 "total": "gesamt",
 "un.": "Stk.",
 "{n} confirmados": "{n} bestätigt",
 "{n} convidados contam no ⊕ por convidado.": "{n} Gäste zählen bei ⊕ pro Gast.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} Gäste mit Status „Ausstehend“ wurden zu „Einzuladen“ verschoben. Wenn du die Einladung über die App sendest, wechseln sie automatisch zu „Eingeladen, keine Antwort“.",
 "{n} extras": "{n} zusätzlich",
 "{n} talvez": "{n} vielleicht",
 "{q} por convidado": "{q} pro Gast",
 "{v} por convidado": "{v} pro Gast",
 "Item completo": "Vollständiger Eintrag",
 "Nota rápida": "Schnelle Notiz",
 "📝 Nota rápida": "📝 Schnelle Notiz",
 "Conteúdo da nota": "Inhalt der Notiz",
 "{c} confirmado(s) de {n} convidado(s)": "{c} von {n} Gästen bestätigt",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "Für alle gelöscht werden: die Dokumente, geplanten Besprechungen und Aufnahmen des Büros „{nome}“. Der Chat bleibt in Nachrichten.",
 "Confirme para apagar o escritório": "Bestätige, um das Büro zu löschen",
 "Escreva o assunto da reunião para poder marcar.": "Gib das Thema der Besprechung ein, um sie zu planen.",
 "{n} min (marcada para {m} min)": "{n} Min. (geplant: {m} Min.)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "Die Datei konnte gerade nicht geladen werden. Prüfe das Internet und versuche es erneut.",
 "Meus clientes": "Meine Kunden",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "Eine einzige Kundenliste für alle Arbeits-Tabs: Kontakt, Adresse, Tags, Notizen und Dateien.",
 "Copiar para Meus clientes": "In Meine Kunden kopieren",
 "Ver ou mudar": "Ansehen oder ändern",
 "Ver o documento completo": "Vollständiges Dokument ansehen",
 "CEP incompleto": "CEP unvollständig",
 "O CEP tem 8 números.": "Der CEP hat 8 Ziffern.",
 "CEP não encontrado": "CEP nicht gefunden",
 "Confira os números ou preencha o endereço à mão.": "Prüfe die Ziffern oder gib die Adresse von Hand ein.",
 "Não foi possível buscar o CEP": "CEP konnte nicht abgerufen werden",
 "Confira a internet ou preencha o endereço à mão.": "Prüfe deine Internetverbindung oder gib die Adresse von Hand ein.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "In dieser E-Mail-Adresse scheint etwas zu fehlen (z. B. name@site.com).",
 "opcional": "optional",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Deine Kunden stehen jetzt in einer einzigen Liste, die alle Arbeits-Tabs nutzen.",
 "Portal do Cliente: {n} cliente(s).": "Kundenportal: {n} Kunde(n).",
 "Freelancer & Projetos: {n} cliente(s).": "Freelancer & Projekte: {n} Kunde(n).",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} waren derselbe Kunde in mehreren Tabs und wurden zu einem Eintrag zusammengefasst.",
 "Nenhum cliente repetido.": "Keine doppelten Kunden.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "Nichts wurde gelöscht: Dokumente, Aufträge, Karten und Stunden bleiben, wo sie waren.",
 "Já está em Meus clientes": "Bereits in Meine Kunden",
 "{nome} já está na lista.": "{nome} ist bereits in der Liste.",
 "Copiado para Meus clientes": "In Meine Kunden kopiert",
 "Só o nome e o contato foram copiados.": "Nur Name und Kontakt wurden kopiert.",
 "Aniversário hoje!": "Heute Geburtstag!",
 "Fechar tudo": "Alle zuklappen",
 "Abrir tudo": "Alle aufklappen",
 "Quem é": "Wer ist das",
 "Razão social": "Firmenname",
 "Nome fantasia": "Handelsname",
 "Data de abertura": "Gründungsdatum",
 "Inscrição estadual / municipal": "Staatliche / kommunale Registrierung",
 "Outras pessoas de contato": "Weitere Ansprechpartner",
 "Como chamar": "Rufname",
 "Cliente desde": "Kunde seit",
 "Outro telefone": "Weitere Telefonnummer",
 "Site": "Website",
 "Melhor jeito de falar": "Am besten erreichbar über",
 "Autorizou receber mensagens": "Hat dem Erhalt von Nachrichten zugestimmt",
 "Outros endereços": "Weitere Adressen",
 "Relacionamento": "Beziehung",
 "Como me conheceu": "Wie er/sie mich gefunden hat",
 "Etiquetas": "Tags",
 "Nada anotado ainda.": "Noch keine Notizen.",
 "Bloco da aba {aba}": "Bereich des Tabs {aba}",
 "Abrir na aba {aba}": "Im Tab {aba} öffnen",
 "Uma lista só, usada por todas as abas de trabalho.": "Eine einzige Liste für alle Arbeits-Tabs.",
 "Escreva o nome do cliente.": "Gib den Namen des Kunden ein.",
 "Telefone / WhatsApp": "Telefon / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Nur der Name ist Pflicht. Öffne die Bereiche, die du ausfüllen möchtest.",
 "Como chamar (apelido)": "Rufname (Spitzname)",
 "Inscrição estadual / municipal (opcional)": "Staatliche / kommunale Registrierung (optional)",
 "Cargo": "Position",
 "Telefone da pessoa de contato": "Telefon des Ansprechpartners",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Weitere Ansprechpartner (einer pro Zeile: Name, Position, Telefon)",
 "O telefone principal é WhatsApp": "Haupttelefon ist WhatsApp",
 "O outro telefone é WhatsApp": "Weitere Telefonnummer ist WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "z. B. @name",
 "Ex.: WhatsApp, à tarde": "z. B. WhatsApp, nachmittags",
 "Estado (UF)": "Bundesstaat (UF)",
 "Endereço (como estava escrito)": "Adresse (wie sie eingetragen war)",
 "Outros endereços (trabalho, entrega...)": "Weitere Adressen (Arbeit, Lieferung...)",
 "Google": "Google",
 "Passou na frente": "Ist vorbeigekommen",
 "Indicado por": "Empfohlen von",
 "Criar etiqueta": "Tag erstellen",
 "Ex.: VIP, Mensal, Atacado": "z. B. VIP, Monatlich, Großhandel",
 "Ativo": "Aktiv",
 "Inativo": "Inaktiv",
 "Em negociação": "In Verhandlung",
 "O cliente autorizou receber mensagens?": "Hat der Kunde dem Erhalt von Nachrichten zugestimmt?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Ohne Zustimmung keine Geburtstagsnachrichten, automatischen Zahlungserinnerungen oder Angebote für diesen Kunden.",
 "aniversário hoje": "heute Geburtstag",
 "contato: {n}": "Kontakt: {n}",
 "com esse telefone": "mit dieser Telefonnummer",
 "com esse e-mail": "mit dieser E-Mail-Adresse",
 "com esse documento": "mit dieser Nummer",
 "com esse nome": "mit diesem Namen",
 "Cliente parecido": "Ähnlicher Kunde",
 "Já existe {nome} {por}. Abrir?": "{nome} existiert bereits {por}. Öffnen?",
 "Cadastrar mesmo assim": "Trotzdem anlegen",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "Gelöscht werden: Eintrag, Notizen und Dateien dieses Kunden.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "Auch in den Tabs: {abas} (mit den dortigen Dokumenten, Aufträgen, Karten und Stunden).",
 "Juntar com outra ficha": "Mit anderem Eintrag zusammenführen",
 "Juntar fichas": "Einträge zusammenführen",
 "Não há outra ficha para juntar.": "Kein weiterer Eintrag zum Zusammenführen.",
 "Juntar \"{nome}\" com:": "„{nome}“ zusammenführen mit:",
 "Juntar as duas fichas?": "Beide Einträge zusammenführen?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "„{a}“ übernimmt alles von „{b}“ (Daten, Notizen, Dateien und Verknüpfungen mit den Tabs). Der Eintrag „{b}“ wird entfernt.",
 "Juntar": "Zusammenführen",
 "Confirme para juntar as fichas": "Bestätige, um die Einträge zusammenzuführen",
 "Aniversariantes do mês": "Geburtstage diesen Monat",
 "Ativos": "Aktiv",
 "Inativos": "Inaktiv",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Lege jeden Kunden nur einmal an: Er erscheint in allen Arbeits-Tabs, die du nutzt.",
 "Novo cliente": "Neuer Kunde",
 "Editar cliente": "Kunden bearbeiten",
 "Linha do tempo": "Verlauf",
 "{n} registro(s)": "{n} Einträge",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Noch nichts. Verkäufe, Zahlungen, Dokumente und Stunden erscheinen hier.",
 "Me deve": "Schuldet mir",
 "Total pago": "Insgesamt bezahlt",
 "Última compra ou atendimento": "Letzter Kauf oder Termin",
 "Próximo compromisso": "Nächster Termin",
 "na entrega": "bei Lieferung",
 "Passou do limite de fiado ({v}).": "Kreditlimit überschritten ({v}).",
 "Recebeu {v} ({p})": "{v} erhalten ({p})",
 "Hoje é aniversário de {n}.": "Heute hat {n} Geburtstag.",
 "Mandar parabéns": "Gratulieren",
 "{n}: parcela de {v} atrasada.": "{n}: Rate über {v} überfällig.",
 "Cobrar": "Erinnern",
 "{n} não compra há {d} dias.": "{n} hat seit {d} Tagen nichts gekauft.",
 "Chamar de volta": "Wieder melden",
 "🟢 em dia · 🟡 sumido": "🟢 aktuell · 🟡 lange nicht gesehen",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 aktuell · 🟡 bald fällig oder lange nicht gesehen · 🔴 überfällig",
 "Limite de fiado (opcional)": "Kreditlimit (optional)",
 "Avisa quando o que ele deve passar deste valor.": "Warnt, wenn die Schulden diesen Betrag übersteigen.",
 "A prazo": "In Raten",
 "parcela atrasada": "überfällige Rate",
 "falta na entrega": "Rest bei Lieferung",
 "Sumidos": "Lange nicht gesehen",
 "Sinal pago, falta o resto": "Anzahlung bezahlt, Rest offen",
 "Pagou {a} de {b}": "{a} von {b} bezahlt",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "Diese Rate stammt aus Meine Kunden. Markiere sie hier als erhalten oder öffne den Kunden, um zu erinnern und die Quittung zu erstellen.",
 "Sinal + restante": "Anzahlung + Rest",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Kreditkarte, Einmalzahlung",
 "Cartão de crédito parcelado": "Kreditkarte, Raten",
 "Fiado / a prazo": "Anschreiben / in Raten",
 "Parcela única": "Einmalzahlung",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "Hallo {nome}! Alles Gute zum Geburtstag! 🎉 Ich wünsche dir einen wunderschönen Tag. Liebe Grüße!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "Hallo {nome}! Wir haben lange nichts voneinander gehört. Kann ich dir mit etwas helfen? Ich freue mich, wieder für dich da zu sein!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "Hallo {nome}! Nur eine kurze Erinnerung an die Rate über {v}, die am {d} fällig war. Melde dich gern bei Fragen. Danke!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "Hallo {nome}! Nur eine kurze Erinnerung an die Rate über {v}{d}. Melde dich gern bei Fragen. Danke!",
 "que vence dia {d}": "fällig am {d}",
 "Quanto recebeu?": "Wie viel hast du erhalten?",
 "Falta {v}. Pode ser só uma parte.": "Offen: {v}. Auch eine Teilzahlung ist möglich.",
 "(seu nome ou sua marca, em Como você recebe?)": "(dein Name oder deine Marke, unter Wie wirst du bezahlt?)",
 "Recibo {c}": "Quittung {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "Ich habe von {c} den Betrag von {v} für {o} erhalten.",
 "{v} no {f} → recebe {l}": "{v} per {f} → du erhältst {l}",
 "Pagou {a} de {b}, faltam {c}": "{a} von {b} bezahlt, {c} offen",
 "Recebido em {d}": "Erhalten am {d}",
 "Cobrar pelo WhatsApp": "Per WhatsApp erinnern",
 "Sem autorização": "Keine Zustimmung",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "Dieser Kunde hat dem Erhalt von Nachrichten nicht zugestimmt (Kundenprofil › Beziehung).",
 "Sem telefone": "Keine Telefonnummer",
 "Coloque o telefone na ficha do cliente.": "Trage die Telefonnummer im Kundenprofil ein.",
 "Gerar recibo": "Quittung erstellen",
 "Como você recebe?": "Wie wirst du bezahlt?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Nur \"Sofort\": übersichtlicher Bildschirm, ohne Raten und ohne Rot.",
 "Taxa da maquininha (%)": "Kartenterminal-Gebühr (%)",
 "Taxa {k}": "Gebühr {k}",
 "Cliente sumido depois de (dias sem comprar)": "Kunde gilt als inaktiv nach (Tage ohne Kauf)",
 "Dias para considerar sumido": "Tage bis inaktiv",
 "Lembretes de cobrança por parcela atrasada": "Zahlungserinnerungen bei überfälligen Raten",
 "Nome ou marca no recibo": "Name oder Marke auf der Quittung",
 "Ex.: Ana Beatriz Doces": "z. B. Ana Beatriz Süßes",
 "Venda ou serviço": "Verkauf oder Leistung",
 "O que foi vendido ou feito": "Was verkauft oder erledigt wurde",
 "Ex.: Bolo de aniversário": "z. B. Geburtstagskuchen",
 "Como paga": "Zahlungsart",
 "Sinal (%)": "Anzahlung (%)",
 "Ou escreva o valor do sinal logo abaixo.": "Oder gib den Anzahlungsbetrag direkt darunter ein.",
 "Sinal (valor)": "Anzahlung (Betrag)",
 "Restante na entrega": "Rest bei Lieferung",
 "Próximo vencimento": "Nächste Fälligkeit",
 "Sinal a receber": "Anzahlung ausstehend",
 "falta {v}{q}": "offen: {v}{q}",
 "quitado": "beglichen",
 "Parcelas mantidas": "Raten beibehalten",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "Es ist bereits eine Zahlung erfasst: Die Raten wurden nicht neu erstellt. Um sie zu ändern, mach zuerst die Zahlungen rückgängig.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Erfasse, was der Kunde gekauft hat oder welche Leistung du erbracht hast, und wie er bezahlt.",
 "Débito": "Debitkarte",
 "Crédito à vista": "Kredit, Einmalzahlung",
 "Crédito 2x": "Kredit, 2 Raten",
 "Crédito 3x": "Kredit, 3 Raten",
 "Crédito 4x": "Kredit, 4 Raten",
 "Crédito 5x": "Kredit, 5 Raten",
 "Crédito 6x": "Kredit, 6 Raten",
 "Crédito 7x": "Kredit, 7 Raten",
 "Crédito 8x": "Kredit, 8 Raten",
 "Crédito 9x": "Kredit, 9 Raten",
 "Crédito 10x": "Kredit, 10 Raten",
 "Crédito 11x": "Kredit, 11 Raten",
 "Crédito 12x": "Kredit, 12 Raten",
 "ATRASADOS": "ÜBERFÄLLIG",
 "Atrasado (hoje): {v}": "Überfällig (heute): {v}",
 "Buscar um cliente": "Kunden suchen",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "Vollständige CPF/CNPJ, vollständige Adresse und Geburtsdatum. Fragt nach dem App-Passwort.",
 "Cliente cadastrado": "Kunde hinzugefügt",
 "Com documentos: guarde o arquivo em lugar seguro.": "Mit Dokumenten: Bewahre die Datei sicher auf.",
 "Como pagou": "Zahlungsart",
 "Esse contato não tem nome.": "Dieser Kontakt hat keinen Namen.",
 "Exportar planilha": "Tabelle exportieren",
 "Falta receber": "Noch offen",
 "Falta receber (hoje): {v}": "Noch offen (heute): {v}",
 "Importar dos contatos": "Aus Kontakten importieren",
 "Importar dos contatos do celular": "Aus Handykontakten importieren",
 "Incluir documentos": "Dokumente einschließen",
 "Incluir documentos no relatório": "Dokumente in den Bericht aufnehmen",
 "MELHORES CLIENTES": "TOP-KUNDEN",
 "Melhores clientes": "Top-Kunden",
 "Não foi possível gerar a planilha.": "Die Tabelle konnte nicht erstellt werden.",
 "O que foi": "Was",
 "Pago em": "Bezahlt am",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "Um Kunden aus deinen Handykontakten zu übernehmen, aktualisiere My Planner im App Store.",
 "RECEBIDO POR DIA": "ERHALTEN PRO TAG",
 "RECEBIDO POR MÊS": "ERHALTEN PRO MONAT",
 "Recebeu": "Erhalten",
 "Recebeu no período": "Im Zeitraum erhalten",
 "Recebeu no período: {v}": "Im Zeitraum erhalten: {v}",
 "Recebido no período": "Im Zeitraum erhalten",
 "Relatório de clientes": "Kundenbericht",
 "Relatório deste cliente": "Bericht zu diesem Kunden",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Ohne Kontaktberechtigung kannst du keinen Kontakt auswählen. Du kannst sie in den Handy-Einstellungen erlauben.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Ohne Dokumente: Die CPF/CNPJ zeigt nur die letzten 2 Ziffern. Notizen werden nie aufgenommen.",
 "Todos os clientes": "Alle Kunden",
 "Trabalha em: {e}": "Arbeitet bei: {e}",
 "Trazer outro": "Weiteren hinzufügen",
 "VENDAS E ATENDIMENTOS": "VERKÄUFE UND TERMINE",
 "Vence": "Fällig",
 "Venceu": "Fällig gewesen",
 "Vendas e atendimentos": "Verkäufe und Termine",
 "Vendeu": "Verkauft",
 "Vendeu no período": "Im Zeitraum verkauft",
 "Vendeu no período: {v}": "Im Zeitraum verkauft: {v}",
 "venceu {d}": "fällig seit {d}",
 "vendido no período": "im Zeitraum verkauft",
 "{nome} comprou no período": "{nome} hat im Zeitraum gekauft",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} wurde zu Meine Kunden hinzugefügt. Prüfe die Angaben und markiere, ob Nachrichten erlaubt sind.",
 "{n} compra(s)": "Käufe: {n}",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Wische eine Box nach links zum Archivieren oder nach rechts zum Löschen. Halte eine freie Stelle der Box gedrückt und ziehe, um die Reihenfolge zu ändern.",
 "Bloco": "Block",
 "Confirme para apagar o grupo": "Bestätige, um die Gruppe zu löschen",
 "Descer": "Nach unten",
 "Opções do bloco": "Block-Optionen",
 "Exigências do destino": "Anforderungen des Reiseziels",
 "{n} para acertar": "{n} offen",
 "{n} parada(s)": "{n} Stopp(s)",
 "Cor do item selecionado": "Farbe des ausgewählten Elements",
 "Abrir o grupo": "Gruppe öffnen",
 "Recolher o grupo": "Gruppe einklappen",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Wische eine Box nach rechts zum Löschen oder nach links zum Archivieren. Halten und ziehen, um die Reihenfolge zu ändern.",
 "Editar subtítulo": "Untertitel bearbeiten",
 "Início da caixa": "Anfang der Box",
 "Mover para…": "Verschieben nach…",
 "Mover {n} item(ns) para": "{n} Element(e) verschieben nach",
 "Opções do item": "Element-Optionen",
 "Transformar em subtítulo": "In Untertitel umwandeln",
 "Transformar em texto": "In Text umwandeln",
 "esta caixa": "diese Box",
 "{a} de {n} feitos": "{a} von {n} erledigt",
 "1 documento pedido atrasado": "1 angefordertes Dokument überfällig",
 "1 pedido vence logo": "1 Anfrage bald fällig",
 "A lista vem de \"Meus clientes\".": "Die Liste kommt aus „Meine Kunden“.",
 "Abrir Meus clientes": "Meine Kunden öffnen",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "Die Tabs Büro und Kundenportal sind jetzt ein einziger Tab.",
 "Clientes com pendência": "Kunden mit offenen Punkten",
 "Com pendência ({n})": "Offen ({n})",
 "Conversa da equipe": "Team-Chat",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Erstelle dein Büro und lade dein Team ein (App-Freunde oder Einladungslink): Chat, Videomeetings und interne Dokumente. Du arbeitest allein? Nutze nur Kunden.",
 "Documentos internos": "Interne Dokumente",
 "Entrar com um código de convite": "Mit Einladungscode beitreten",
 "Escritório & Clientes": "Büro & Kunden",
 "Escritórios: {n}": "Büros: {n}",
 "Esta parte é para quem trabalha com equipe": "Dieser Bereich ist für Leute, die im Team arbeiten",
 "Guias vencendo": "Fällige Steuerbelege",
 "Minhas tarefas": "Meine Aufgaben",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "Nichts wurde gelöscht: Team, Chat, Meetings, Dokumente und eingeladene Kunden sind unverändert da.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "Noch keine Kunden. Lege einen in „Meine Kunden“ an – er erscheint sofort hier.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "Für alle, die mit Kunden arbeiten, allein oder im Team: ein Ordner pro Kunde (Dokumente, Anfragen, Steuerbelege), Team, Chat, Meetings und interne Dokumente.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Kundenordner im Portal: {c} (mit {d} Dokumenten und {p} Anfragen)",
 "Pessoa física": "Privatperson",
 "Procurar por nome, CNPJ ou CPF": "Nach Name, CNPJ oder CPF suchen",
 "Reuniões hoje": "Meetings heute",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "Kein Büro (Team). Tippe, um eines zu erstellen oder mit Code beizutreten.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Nur das Team sieht das. Kunden sehen diesen Bereich nie.",
 "Tudo em dia": "Alles aktuell",
 "Vencendo ({n})": "Bald fällig ({n})",
 "chega na próxima versão": "kommt in der nächsten Version",
 "nos próximos 7 dias": "in den nächsten 7 Tagen",
 "vence amanhã": "morgen fällig",
 "vence hoje": "heute fällig",
 "{doc} venceu em {d}": "{doc} war am {d} fällig",
 "{n} documentos pedidos atrasados": "{n} angeforderte Dokumente überfällig",
 "{n} pedidos vencem logo": "{n} Anfragen bald fällig",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 aktuell · 🟡 bald etwas fällig · 🔴 Anfrage oder Steuerbeleg überfällig",
 "Acesso ao gov.br": "Zugang zu gov.br",
 "Alvará": "Betriebserlaubnis",
 "Até o dia (do mês)": "Bis zum Tag (im Monat)",
 "CCMEI (certificado do MEI)": "CCMEI (MEI-Zertifikat)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Hinterlege die Telefonnummer des Kunden, um per WhatsApp zu erinnern.",
 "Cartão CNPJ": "CNPJ-Nachweis",
 "Checklist criado": "Checkliste erstellt",
 "Checklist de cliente novo": "Checkliste für Neukunden",
 "Cliente viu {doc}": "Kunde hat {doc} angesehen",
 "Cole no app do banco, em Pix copia e cola.": "In der Bank-App unter Pix Copy & Paste einfügen.",
 "Cole no app do banco.": "In der Bank-App einfügen.",
 "Comprovante de endereço": "Adressnachweis",
 "Contrato social e alterações": "Gesellschaftsvertrag und Änderungen",
 "Copiado": "Kopiert",
 "Copiar Pix": "Pix kopieren",
 "Copiar código de barras": "Barcode kopieren",
 "Código de barras (linha digitável)": "Barcode (Zahlenzeile)",
 "Dados bancários": "Bankdaten",
 "Escreva o recado.": "Schreib die Nachricht.",
 "Escritório enviou {doc}": "Kanzlei hat {doc} gesendet",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "Dieser Kunde hat dem Empfang von Nachrichten nicht zugestimmt (Profil unter Meine Kunden).",
 "Extratos bancários": "Kontoauszüge",
 "Ficha completa": "Vollständiges Profil",
 "Guia": "Steuerzahlschein",
 "Guias a pagar": "Offene Steuerzahlscheine",
 "Honorário": "Honorar",
 "Honorário por": "Honorar pro",
 "Informes de rendimentos": "Einkommensbescheinigungen",
 "Lembrar pelo WhatsApp": "Per WhatsApp erinnern",
 "Ler a guia ou o boleto com a minha IA": "Steuerzahlschein oder Boleto mit meiner KI lesen",
 "Lucro presumido": "Pauschalierter Gewinn",
 "Lucro real": "Tatsächlicher Gewinn",
 "Nada ainda.": "Noch nichts.",
 "Nenhum pedido em aberto.": "Keine offenen Anfragen.",
 "Notas fiscais emitidas": "Ausgestellte Rechnungen",
 "O cliente": "Der Kunde",
 "O pedido entrou em Pedidos de documentos.": "Die Anfrage wurde zu Dokumentanfragen hinzugefügt.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "Hallo {nome}! Es fehlt noch: {itens}. Kannst du es hier schicken?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "Hallo {nome}! Es fehlen noch: {itens}. Kannst du sie hier schicken?",
 "Oi, {nome}! Tudo certo por aí?": "Hallo {nome}! Alles in Ordnung bei dir?",
 "Pedido criado": "Anfrage erstellt",
 "Pedido feito: {o}": "Anfrage gesendet: {o}",
 "Pedido recebido: {o}": "Anfrage erhalten: {o}",
 "Pedidos pendentes": "Offene Anfragen",
 "Pedir de novo todo mês": "Jeden Monat erneut anfragen",
 "Pedir nova ({c})": "Neu anfragen ({c})",
 "Pendentes": "Offen",
 "Que tipo de cliente?": "Welche Art von Kunde?",
 "RG e CPF": "RG und CPF",
 "RG e CPF do titular": "RG und CPF des Inhabers",
 "RG e CPF dos sócios": "RG und CPF der Gesellschafter",
 "Recados": "Nachrichten",
 "Recados entre você e o cliente, presos à pasta dele.": "Nachrichten zwischen dir und dem Kunden, in seinem Ordner abgelegt.",
 "Responde ao pedido": "Beantwortet die Anfrage",
 "Tipo / regime": "Art / Steuerregime",
 "Visto pelo cliente em {d}": "Vom Kunden angesehen am {d}",
 "Válido até": "Gültig bis",
 "ano": "Jahr",
 "código Pix copia e cola, se houver": "Pix-Copy-&-Paste-Code, falls vorhanden",
 "data de vencimento": "Fälligkeitsdatum",
 "documento": "Dokument",
 "linha digitável do boleto ou da guia, só números": "Zahlenzeile des Boletos oder Steuerzahlscheins, nur Ziffern",
 "mês": "Monat",
 "novo": "neu",
 "todo mês, até o dia {n}": "jeden Monat, bis zum {n}.",
 "valor a pagar": "zu zahlender Betrag",
 "válido até {d}": "gültig bis {d}",
 "{c} nova": "Neu: {c}",
 "{doc} pago": "{doc} bezahlt",
 "{n} a pagar": "{n} offen",
 "{n} enviou {doc}": "{n} hat {doc} gesendet",
 "{n} novo(s)": "{n} neu",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n} Dokumentanfrage(n) erstellt, Frist 7 Tage.",
 "{n} vencida(s)": "{n} überfällig",
 "Última declaração do Imposto de Renda": "Letzte Einkommensteuererklärung",
 "Últimas guias pagas": "Zuletzt bezahlte Steuerzahlscheine",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "Dieser Teil des Büros ist noch nicht mit dem Server verbunden. Führen Sie auf dem Computer 56-SERVIDOR-0.96.bat aus (nur einmal).",
 "Só vê": "Nur ansehen",
 "Nova versão": "Neue Version",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "Es gab bereits eine Datei mit diesem Namen: die vorherige wird als Version {n} gespeichert.",
 "Visto por e comentários": "Gesehen von & Kommentare",
 "Arquivar (só neste aparelho)": "Archivieren (nur auf diesem Gerät)",
 "Tirar do topo": "Oben lösen",
 "Fixar no topo (para todos)": "Oben anheften (für alle)",
 "Mover para a pasta…": "In Ordner verschieben…",
 "versão {n}": "Version {n}",
 "visto por {n}": "gesehen von {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "Bis zu 50 MB pro Datei. Wird eine Datei mit demselben Namen hochgeladen, bleibt die vorherige als Version erhalten.",
 "Procurar documento ou pasta": "Dokument oder Ordner suchen",
 "Fixados": "Angeheftet",
 "Abrir o documento": "Dokument öffnen",
 "enviado por {nome}": "hochgeladen von {nome}",
 "Versões ({n})": "Versionen ({n})",
 "Versão {n} (atual)": "Version {n} (aktuell)",
 "Versão {n}": "Version {n}",
 "Visto por ({n})": "Gesehen von ({n})",
 "Ninguém da equipe abriu ainda.": "Noch hat niemand im Team es geöffnet.",
 "{nome} em {d}": "{nome} am {d}",
 "Comentários ({n})": "Kommentare ({n})",
 "Escreva um comentário": "Kommentar schreiben",
 "Contratos": "Verträge",
 "Financeiro do escritório": "Büro-Finanzen",
 "RH": "Personal",
 "Mover para a pasta": "In Ordner verschieben",
 "Ou escreva o nome de uma pasta nova": "Oder geben Sie den Namen eines neuen Ordners ein",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "Sie wiederholt sich jede Woche: Beim Absagen verschwindet sie aus allen Wochen, aus der Liste und aus dem Eingang des Teams.",
 "a equipe toda": "das ganze Team",
 "Com {quem}": "Mit {quem}",
 "toda semana": "jede Woche",
 "Vão: {n}": "Dabei: {n}",
 "Não vão: {n}": "Nicht dabei: {n}",
 "Vou": "Ich komme",
 "Não vou": "Ich komme nicht",
 "Pauta": "Tagesordnung",
 "Ata": "Protokoll",
 "Escrever a ata": "Protokoll schreiben",
 "Abrir o link": "Link öffnen",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Jede eingeladene Person erhält die Besprechung im Eingang und übernimmt sie mit einem Tipp samt Erinnerung in den Planner.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "Schreiben Sie zuerst die Notizen zur Besprechung (was gesagt und beschlossen wurde); die KI ordnet sie zu einem Protokoll.",
 "Ata: {nome}": "Protokoll: {nome}",
 "Gerando...": "Wird erstellt...",
 "Gerar ata com a minha IA": "Protokoll mit meiner KI erstellen",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "Die KI ordnet Tagesordnung und Ihre Notizen zu einem Protokoll. Vor dem Speichern prüfen.",
 "Ainda sem ata.": "Noch kein Protokoll.",
 "Tarefas da reunião ({n})": "Aufgaben der Besprechung ({n})",
 "Tarefa da reunião": "Aufgabe der Besprechung",
 "Salvar a ata": "Protokoll speichern",
 "Repetir toda semana ({dia})": "Jede Woche wiederholen ({dia})",
 "Quem participa": "Wer nimmt teil",
 "A equipe toda": "Das ganze Team",
 "Link externo (opcional: Meet, Zoom, Teams)": "Externer Link (optional: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "Der Link muss mit https:// beginnen",
 "Marcar e avisar quem participa": "Termin anlegen und Teilnehmer benachrichtigen",
 "Cargo e papel": "Position und Rolle",
 "Passar o Admin": "Admin übertragen",
 "Passar o Admin para {nome}?": "Admin an {nome} übertragen?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} übernimmt die Verwaltung des Büros (und kann es löschen). Sie bleiben als Administrator im Team (der neue Admin kann das später ändern).",
 "Passar": "Übertragen",
 "{nome} agora cuida do escritório.": "{nome} verwaltet das Büro jetzt.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "Ihre Rolle hier ist „Nur ansehen“: Sie verfolgen Mitteilungen, Aufgaben, Besprechungen und Dokumente.",
 "Edita": "Bearbeitet",
 "Incluir": "Hinzufügen",
 "Novo aviso no mural": "Neue Mitteilung am Schwarzen Brett",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "Sie können dieses Büro nur ansehen: Der Administrator hat Ihnen die Rolle „Nur ansehen“ zugewiesen. Bitten Sie ihn bei Bedarf, sie zu ändern.",
 "Quem viu": "Wer es gesehen hat",
 "Apagar aviso": "Mitteilung löschen",
 "Mural de avisos": "Schwarzes Brett",
 "Novo aviso": "Neue Mitteilung",
 "Ex.: Feriado na sexta: escritório fechado": "Z. B.: Feiertag am Freitag: Büro geschlossen",
 "Fixar no mural": "An das Brett anheften",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "Keine Mitteilungen. Mitteilungen bleiben hier für das ganze Team angeheftet.",
 "visto por {n} de {m}": "gesehen von {n} von {m}",
 "sem responsável": "ohne Zuständigen",
 "atrasada desde {d}": "überfällig seit {d}",
 "prazo {d}": "Frist {d}",
 "Comecei": "Begonnen",
 "Terminei": "Erledigt",
 "Reabrir": "Wieder öffnen",
 "Tarefas da equipe": "Teamaufgaben",
 "1 aberta": "1 offen",
 "{n} abertas": "{n} offen",
 "Minhas tarefas ({n})": "Meine Aufgaben ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "Keine offenen Aufgaben von Ihnen. Tippen Sie bei einer Teamaufgabe auf „Ich mache es“.",
 "Nenhuma tarefa aberta.": "Keine offenen Aufgaben.",
 "Feitas ({n})": "Erledigt ({n})",
 "Apagar a tarefa?": "Aufgabe löschen?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "Was ist zu tun? (z. B.: DAS für März berechnen)",
 "Cliente (opcional)": "Mandant (optional)",
 "Prazo (opcional)": "Frist (optional)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Zuständig (optional; sonst tippt jemand auf „Ich mache es“)",
 "Escreva a tarefa para poder salvar.": "Schreiben Sie die Aufgabe, um speichern zu können.",
 "Membro": "Mitglied",
 "Cargo (livre)": "Position (frei)",
 "Ex.: Advogada, Assistente, Estagiário": "Z. B.: Anwältin, Assistentin, Praktikant",
 "Papel": "Rolle",
 "Admin: pode tudo no escritório.": "Admin: darf alles im Büro.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Bearbeitet: fügt Aufgaben, Mitteilungen, Dokumente und Besprechungen hinzu",
 "Só vê: acompanha tudo, sem incluir nem mudar": "Nur ansehen: verfolgt alles, ohne hinzuzufügen oder zu ändern",
 "Proposta": "Angebot",
 "Documento sensível (pede a senha do app para abrir)": "Vertrauliches Dokument (zum Öffnen wird das App-Passwort verlangt)",
 "Li e concordo: {d}": "Gelesen und zugestimmt: {d}",
 "Li e concordo": "Gelesen und einverstanden",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "Wenn du auf „Einverstanden“ tippst, speichert die App Datum und Uhrzeit, zu denen du „{doc}“ gelesen und zugestimmt hast. Das ist eine einfache Zustimmung und ersetzt keine offizielle digitale Signatur.",
 "Concordo": "Einverstanden",
 "Fotos (escolha quais entram)": "Fotos (wähle aus, welche)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 Foto konnte auf diesem Gerät nicht gelesen werden und fehlt.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} Fotos konnten auf diesem Gerät nicht gelesen werden und fehlen.",
 "Nenhuma foto no álbum desta viagem.": "Keine Fotos im Album dieser Reise.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Tippe auf die Fotos, um sie aus- oder abzuwählen. Sie werden verkleinert, damit die PDF leicht bleibt.",
 "Sugerir até 12": "Bis zu 12 vorschlagen",
 "1 foto marcada": "1 Foto ausgewählt",
 "{n} fotos marcadas": "{n} Fotos ausgewählt",
 "Com mais de 12 fotos o PDF fica mais pesado.": "Mit mehr als 12 Fotos wird die PDF größer.",
 "Confirme para abrir este documento": "Bestätige, um dieses Dokument zu öffnen",
 "Como usar esta aba": "So nutzt du diesen Bereich",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 Kunde war in mehreren Bereichen und ist jetzt ein einziger Eintrag.",
 "Juntar {n} fotos num PDF?": "{n} Fotos zu einem PDF zusammenfügen?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "Die Fotos werden in der Reihenfolge der Liste zu den Seiten eines einzigen PDFs. Die einzelnen Fotos werden aus dieser Akte entfernt.",
 "Não foi possível ler as fotos neste dispositivo.": "Die Fotos konnten auf diesem Gerät nicht gelesen werden.",
 "PDF criado": "PDF erstellt",
 "Montando o PDF...": "PDF wird erstellt...",
 "Juntar as {n} fotos num PDF": "Die {n} Fotos zu einem PDF zusammenfügen",
 "Baixar o mês": "Monat herunterladen",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "Die Dateien dieses Monats befinden sich auf einem anderen Gerät und konnten hier nicht gelesen werden.",
 "Os documentos deste mês não têm arquivos.": "Die Dokumente dieses Monats enthalten keine Dateien.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 Datei befindet sich auf einem anderen Gerät und wurde ausgelassen.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} Dateien befinden sich auf einem anderen Gerät und wurden ausgelassen.",
 "Conversa sobre este documento": "Unterhaltung zu diesem Dokument",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Stellen Sie eine Frage oder antworten Sie zu diesem Dokument. Büro und Kunde sehen es.",
 "Escreva a mensagem": "Nachricht schreiben",
 "Usar um modelo de pedido ({n})": "Anfragevorlage verwenden ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "{nome} per WhatsApp erinnern: {o}",
 "Sem honorário": "Kein Honorar",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Tragen Sie die Höhe des Honorars im Block „Büro“ der Kundenakte unter „Meine Kunden“ ein.",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "Von {c} den Betrag von {v} erhalten, für die Honorare des Abrechnungszeitraums {m}.",
 "Recibo honorário {m} {c}": "Honorarquittung {m} {c}",
 "Recibo do honorário {m}": "Honorarquittung {m}",
 "Recibo criado": "Quittung erstellt",
 "O recibo entrou em Documentos, na competência {m}.": "Die Quittung wurde unter Dokumente im Zeitraum {m} abgelegt.",
 "Vendo como o cliente": "Ansicht als Kunde",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "So sieht der Kunde seinen Ordner: ohne die internen Notizen und ohne das, was nur für das Team bestimmt ist. In diesem Modus kann nichts geändert werden.",
 "Voltar a ver como escritório": "Zurück zur Büro-Ansicht",
 "Ver como o cliente": "Als Kunde ansehen",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Interne Notizen (der Kunde sieht sie nie)",
 "Recibo do honorário…": "Honorarquittung…",
 "Competência do recibo": "Zeitraum der Quittung",
 "⬇️ Baixar o mês": "⬇️ Monat herunterladen",
 "Me avisar para lembrar o cliente": "Mich erinnern, den Kunden zu erinnern",
 "Guardar como modelo": "Als Vorlage speichern",
 "Modelo guardado": "Vorlage gespeichert",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "Wenn Sie eine Anfrage für einen beliebigen Kunden erstellen, tippen Sie auf „Anfragevorlage verwenden“.",
 "Relatório do mês": "Monatsbericht",
 "Notas rápidas": "Kurznotizen",
 "Item completo: {o}": "Vollständiger Eintrag: {o}",
 "Reuniões do mês": "Besprechungen des Monats",
 "Tarefas feitas e pendentes": "Erledigte und offene Aufgaben",
 "Documentos internos enviados": "Gesendete interne Dokumente",
 "Documentos enviados e recebidos dos clientes": "An Kunden gesendete und von Kunden erhaltene Dokumente",
 "Documentos da competência": "Dokumente des Zeitraums",
 "Guias pagas e vencidas": "Bezahlte und überfällige Zahlungsscheine",
 "Honorários": "Honorare",
 "Relatório do mês · {m}": "Monatsbericht · {m}",
 "Reuniões ({n})": "Besprechungen ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Aufgaben: {f} im Monat erledigt · {p} offen",
 "Quem fez": "Erledigt von",
 "Feita em": "Erledigt am",
 "Documentos internos enviados ({n})": "Gesendete interne Dokumente ({n})",
 "Documentos trocados com os clientes": "Mit Kunden ausgetauschte Dokumente",
 "Enviados pelo escritório": "Vom Büro gesendet",
 "Recebidos do cliente": "Vom Kunden erhalten",
 "Nenhum documento trocado neste mês.": "Diesen Monat wurden keine Dokumente ausgetauscht.",
 "Clientes com pendência ({n})": "Kunden mit offenen Punkten ({n})",
 "Pendência": "Offener Punkt",
 "Nenhum cliente com pendência.": "Keine Kunden mit offenen Punkten.",
 "Documentos da competência {m} ({n})": "Dokumente des Zeitraums {m} ({n})",
 "Pedidos de documentos ({n})": "Dokumentenanfragen ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Zahlungsscheine des Monats: {p} bezahlt · {v} überfällig",
 "Vencida": "Überfällig",
 "Recebido no mês": "Im Monat erhalten",
 "Relatório {m} {q}": "Bericht {m} {q}",
 "MÊS": "MONAT",
 "DE QUEM": "VON WEM",
 "O escritório": "Das Büro",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Besprechungen, Aufgaben und interne Dokumente werden aufgenommen, wenn es ein Büro (Team) gibt.",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, interne Notizen und Unterhaltungen gelangen nie in den Bericht.",
 "Anotações recebidas": "Erhaltene Notizen",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "Die offenen Beträge dieser Liste erscheinen im My Planner, auch neue.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "Sendet nur die offenen Beträge dieser Liste (Termine gehen schon von selbst), auch neue.",
 "Acrescentar": "Hinzufügen",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "Die {n} Boxen sind in {aba}, unter „Erhaltene Notizen“.",
 "Enviadas": "Gesendet",
 "Enviar para": "Senden an",
 "Excluir 1 item?": "1 Element löschen?",
 "Excluir {n} itens?": "{n} Elemente löschen?",
 "Inserir abaixo": "Darunter einfügen",
 "Mover para": "Verschieben nach",
 "Mover {n} selecionados para": "{n} ausgewählte verschieben nach",
 "adicionar aqui": "hier hinzufügen",
 "continue segurando para selecionar": "weiter halten zum Auswählen"
}
